var e = 1e3, t = 1001, n = 1002, r = 1003, i = 1006, a = 1008, o = 1009, s = 1012, c = 1014, l = 1015, u = 1016, d = 1017, f = 1018, p = 1020, m = 1023, h = 1026, g = 1027, _ = 1029, v = 1030, y = 1031, b = 1033, x = 2300, S = 2301, C = 2302, w = 2303, T = 2400, E = 2401, D = 2402, O = "srgb", k = "srgb-linear", A = "linear", j = "srgb", M = 7680, N = 35044, ee = 2e3;
function P(e) {
	for (let t = e.length - 1; t >= 0; --t) if (e[t] >= 65535) return !0;
	return !1;
}
function F(e) {
	return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function te(e) {
	return document.createElementNS("http://www.w3.org/1999/xhtml", e);
}
function ne() {
	let e = te("canvas");
	return e.style.display = "block", e;
}
var I = {};
function re(...e) {
	let t = "THREE." + e.shift();
	console.log(t, ...e);
}
function ie(e) {
	let t = e[0];
	if (typeof t == "string" && t.startsWith("TSL:")) {
		let t = e[1];
		t && t.isStackTrace ? e[0] += " " + t.getLocation() : e[1] = "Stack trace not available. Enable \"THREE.Node.captureStackTrace\" to capture stack traces.";
	}
	return e;
}
function L(...e) {
	e = ie(e);
	let t = "THREE." + e.shift();
	{
		let n = e[0];
		n && n.isStackTrace ? console.warn(n.getError(t)) : console.warn(t, ...e);
	}
}
function R(...e) {
	e = ie(e);
	let t = "THREE." + e.shift();
	{
		let n = e[0];
		n && n.isStackTrace ? console.error(n.getError(t)) : console.error(t, ...e);
	}
}
function ae(...e) {
	let t = e.join(" ");
	t in I || (I[t] = !0, L(...e));
}
function oe(e, t, n) {
	return new Promise(function(r, i) {
		function a() {
			switch (e.clientWaitSync(t, e.SYNC_FLUSH_COMMANDS_BIT, 0)) {
				case e.WAIT_FAILED:
					i();
					break;
				case e.TIMEOUT_EXPIRED:
					setTimeout(a, n);
					break;
				default: r();
			}
		}
		setTimeout(a, n);
	});
}
var se = {
	0: 1,
	2: 6,
	4: 7,
	3: 5,
	1: 0,
	6: 2,
	7: 4,
	5: 3
}, ce = class {
	addEventListener(e, t) {
		this._listeners === void 0 && (this._listeners = {});
		let n = this._listeners;
		n[e] === void 0 && (n[e] = []), n[e].indexOf(t) === -1 && n[e].push(t);
	}
	hasEventListener(e, t) {
		let n = this._listeners;
		return n !== void 0 && n[e] !== void 0 && n[e].indexOf(t) !== -1;
	}
	removeEventListener(e, t) {
		let n = this._listeners;
		if (n === void 0) return;
		let r = n[e];
		if (r !== void 0) {
			let e = r.indexOf(t);
			e !== -1 && r.splice(e, 1);
		}
	}
	dispatchEvent(e) {
		let t = this._listeners;
		if (t === void 0) return;
		let n = t[e.type];
		if (n !== void 0) {
			e.target = this;
			let t = n.slice(0);
			for (let n = 0, r = t.length; n < r; n++) t[n].call(this, e);
			e.target = null;
		}
	}
}, le = /* @__PURE__ */ "00.01.02.03.04.05.06.07.08.09.0a.0b.0c.0d.0e.0f.10.11.12.13.14.15.16.17.18.19.1a.1b.1c.1d.1e.1f.20.21.22.23.24.25.26.27.28.29.2a.2b.2c.2d.2e.2f.30.31.32.33.34.35.36.37.38.39.3a.3b.3c.3d.3e.3f.40.41.42.43.44.45.46.47.48.49.4a.4b.4c.4d.4e.4f.50.51.52.53.54.55.56.57.58.59.5a.5b.5c.5d.5e.5f.60.61.62.63.64.65.66.67.68.69.6a.6b.6c.6d.6e.6f.70.71.72.73.74.75.76.77.78.79.7a.7b.7c.7d.7e.7f.80.81.82.83.84.85.86.87.88.89.8a.8b.8c.8d.8e.8f.90.91.92.93.94.95.96.97.98.99.9a.9b.9c.9d.9e.9f.a0.a1.a2.a3.a4.a5.a6.a7.a8.a9.aa.ab.ac.ad.ae.af.b0.b1.b2.b3.b4.b5.b6.b7.b8.b9.ba.bb.bc.bd.be.bf.c0.c1.c2.c3.c4.c5.c6.c7.c8.c9.ca.cb.cc.cd.ce.cf.d0.d1.d2.d3.d4.d5.d6.d7.d8.d9.da.db.dc.dd.de.df.e0.e1.e2.e3.e4.e5.e6.e7.e8.e9.ea.eb.ec.ed.ee.ef.f0.f1.f2.f3.f4.f5.f6.f7.f8.f9.fa.fb.fc.fd.fe.ff".split("."), ue = 1234567, de = Math.PI / 180, z = 180 / Math.PI;
function B() {
	let e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0, r = Math.random() * 4294967295 | 0;
	return (le[e & 255] + le[e >> 8 & 255] + le[e >> 16 & 255] + le[e >> 24 & 255] + "-" + le[t & 255] + le[t >> 8 & 255] + "-" + le[t >> 16 & 15 | 64] + le[t >> 24 & 255] + "-" + le[n & 63 | 128] + le[n >> 8 & 255] + "-" + le[n >> 16 & 255] + le[n >> 24 & 255] + le[r & 255] + le[r >> 8 & 255] + le[r >> 16 & 255] + le[r >> 24 & 255]).toLowerCase();
}
function V(e, t, n) {
	return Math.max(t, Math.min(n, e));
}
function fe(e, t) {
	return (e % t + t) % t;
}
function pe(e, t, n, r, i) {
	return r + (e - t) * (i - r) / (n - t);
}
function me(e, t, n) {
	return e === t ? 0 : (n - e) / (t - e);
}
function he(e, t, n) {
	return (1 - n) * e + n * t;
}
function ge(e, t, n, r) {
	return he(e, t, 1 - Math.exp(-n * r));
}
function _e(e, t = 1) {
	return t - Math.abs(fe(e, t * 2) - t);
}
function ve(e, t, n) {
	return e <= t ? 0 : e >= n ? 1 : (e = (e - t) / (n - t), e * e * (3 - 2 * e));
}
function ye(e, t, n) {
	return e <= t ? 0 : e >= n ? 1 : (e = (e - t) / (n - t), e * e * e * (e * (e * 6 - 15) + 10));
}
function be(e, t) {
	return e + Math.floor(Math.random() * (t - e + 1));
}
function xe(e, t) {
	return e + Math.random() * (t - e);
}
function Se(e) {
	return e * (.5 - Math.random());
}
function Ce(e) {
	e !== void 0 && (ue = e);
	let t = ue += 1831565813;
	return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function we(e) {
	return e * de;
}
function Te(e) {
	return e * z;
}
function Ee(e) {
	return (e & e - 1) == 0 && e !== 0;
}
function De(e) {
	return 2 ** Math.ceil(Math.log(e) / Math.LN2);
}
function Oe(e) {
	return 2 ** Math.floor(Math.log(e) / Math.LN2);
}
function ke(e, t, n, r, i) {
	let a = Math.cos, o = Math.sin, s = a(n / 2), c = o(n / 2), l = a((t + r) / 2), u = o((t + r) / 2), d = a((t - r) / 2), f = o((t - r) / 2), p = a((r - t) / 2), m = o((r - t) / 2);
	switch (i) {
		case "XYX":
			e.set(s * u, c * d, c * f, s * l);
			break;
		case "YZY":
			e.set(c * f, s * u, c * d, s * l);
			break;
		case "ZXZ":
			e.set(c * d, c * f, s * u, s * l);
			break;
		case "XZX":
			e.set(s * u, c * m, c * p, s * l);
			break;
		case "YXY":
			e.set(c * p, s * u, c * m, s * l);
			break;
		case "ZYZ":
			e.set(c * m, c * p, s * u, s * l);
			break;
		default: L("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
	}
}
function Ae(e, t) {
	switch (t.constructor) {
		case Float32Array: return e;
		case Uint32Array: return e / 4294967295;
		case Uint16Array: return e / 65535;
		case Uint8Array: return e / 255;
		case Int32Array: return Math.max(e / 2147483647, -1);
		case Int16Array: return Math.max(e / 32767, -1);
		case Int8Array: return Math.max(e / 127, -1);
		default: throw Error("THREE.MathUtils: Invalid component type.");
	}
}
function H(e, t) {
	switch (t.constructor) {
		case Float32Array: return e;
		case Uint32Array: return Math.round(e * 4294967295);
		case Uint16Array: return Math.round(e * 65535);
		case Uint8Array: return Math.round(e * 255);
		case Int32Array: return Math.round(e * 2147483647);
		case Int16Array: return Math.round(e * 32767);
		case Int8Array: return Math.round(e * 127);
		default: throw Error("THREE.MathUtils: Invalid component type.");
	}
}
var je = {
	DEG2RAD: de,
	RAD2DEG: z,
	generateUUID: B,
	clamp: V,
	euclideanModulo: fe,
	mapLinear: pe,
	inverseLerp: me,
	lerp: he,
	damp: ge,
	pingpong: _e,
	smoothstep: ve,
	smootherstep: ye,
	randInt: be,
	randFloat: xe,
	randFloatSpread: Se,
	seededRandom: Ce,
	degToRad: we,
	radToDeg: Te,
	isPowerOfTwo: Ee,
	ceilPowerOfTwo: De,
	floorPowerOfTwo: Oe,
	setQuaternionFromProperEuler: ke,
	normalize: H,
	denormalize: Ae
}, U = class e {
	static {
		e.prototype.isVector2 = !0;
	}
	constructor(e = 0, t = 0) {
		this.x = e, this.y = t;
	}
	get width() {
		return this.x;
	}
	set width(e) {
		this.x = e;
	}
	get height() {
		return this.y;
	}
	set height(e) {
		this.y = e;
	}
	set(e, t) {
		return this.x = e, this.y = t, this;
	}
	setScalar(e) {
		return this.x = e, this.y = e, this;
	}
	setX(e) {
		return this.x = e, this;
	}
	setY(e) {
		return this.y = e, this;
	}
	setComponent(e, t) {
		switch (e) {
			case 0:
				this.x = t;
				break;
			case 1:
				this.y = t;
				break;
			default: throw Error("THREE.Vector2: index is out of range: " + e);
		}
		return this;
	}
	getComponent(e) {
		switch (e) {
			case 0: return this.x;
			case 1: return this.y;
			default: throw Error("THREE.Vector2: index is out of range: " + e);
		}
	}
	clone() {
		return new this.constructor(this.x, this.y);
	}
	copy(e) {
		return this.x = e.x, this.y = e.y, this;
	}
	add(e) {
		return this.x += e.x, this.y += e.y, this;
	}
	addScalar(e) {
		return this.x += e, this.y += e, this;
	}
	addVectors(e, t) {
		return this.x = e.x + t.x, this.y = e.y + t.y, this;
	}
	addScaledVector(e, t) {
		return this.x += e.x * t, this.y += e.y * t, this;
	}
	sub(e) {
		return this.x -= e.x, this.y -= e.y, this;
	}
	subScalar(e) {
		return this.x -= e, this.y -= e, this;
	}
	subVectors(e, t) {
		return this.x = e.x - t.x, this.y = e.y - t.y, this;
	}
	multiply(e) {
		return this.x *= e.x, this.y *= e.y, this;
	}
	multiplyScalar(e) {
		return this.x *= e, this.y *= e, this;
	}
	divide(e) {
		return this.x /= e.x, this.y /= e.y, this;
	}
	divideScalar(e) {
		return this.multiplyScalar(1 / e);
	}
	applyMatrix3(e) {
		let t = this.x, n = this.y, r = e.elements;
		return this.x = r[0] * t + r[3] * n + r[6], this.y = r[1] * t + r[4] * n + r[7], this;
	}
	min(e) {
		return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
	}
	max(e) {
		return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
	}
	clamp(e, t) {
		return this.x = V(this.x, e.x, t.x), this.y = V(this.y, e.y, t.y), this;
	}
	clampScalar(e, t) {
		return this.x = V(this.x, e, t), this.y = V(this.y, e, t), this;
	}
	clampLength(e, t) {
		let n = this.length();
		return this.divideScalar(n || 1).multiplyScalar(V(n, e, t));
	}
	floor() {
		return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
	}
	ceil() {
		return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
	}
	round() {
		return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
	}
	roundToZero() {
		return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
	}
	negate() {
		return this.x = -this.x, this.y = -this.y, this;
	}
	dot(e) {
		return this.x * e.x + this.y * e.y;
	}
	cross(e) {
		return this.x * e.y - this.y * e.x;
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y;
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y);
	}
	manhattanLength() {
		return Math.abs(this.x) + Math.abs(this.y);
	}
	normalize() {
		return this.divideScalar(this.length() || 1);
	}
	angle() {
		return Math.atan2(-this.y, -this.x) + Math.PI;
	}
	angleTo(e) {
		let t = Math.sqrt(this.lengthSq() * e.lengthSq());
		if (t === 0) return Math.PI / 2;
		let n = this.dot(e) / t;
		return Math.acos(V(n, -1, 1));
	}
	distanceTo(e) {
		return Math.sqrt(this.distanceToSquared(e));
	}
	distanceToSquared(e) {
		let t = this.x - e.x, n = this.y - e.y;
		return t * t + n * n;
	}
	manhattanDistanceTo(e) {
		return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
	}
	setLength(e) {
		return this.normalize().multiplyScalar(e);
	}
	lerp(e, t) {
		return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
	}
	lerpVectors(e, t, n) {
		return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this;
	}
	equals(e) {
		return e.x === this.x && e.y === this.y;
	}
	fromArray(e, t = 0) {
		return this.x = e[t], this.y = e[t + 1], this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this.x, e[t + 1] = this.y, e;
	}
	fromBufferAttribute(e, t) {
		return this.x = e.getX(t), this.y = e.getY(t), this;
	}
	rotateAround(e, t) {
		let n = Math.cos(t), r = Math.sin(t), i = this.x - e.x, a = this.y - e.y;
		return this.x = i * n - a * r + e.x, this.y = i * r + a * n + e.y, this;
	}
	random() {
		return this.x = Math.random(), this.y = Math.random(), this;
	}
	*[Symbol.iterator]() {
		yield this.x, yield this.y;
	}
}, W = class {
	constructor(e = 0, t = 0, n = 0, r = 1) {
		this.isQuaternion = !0, this._x = e, this._y = t, this._z = n, this._w = r;
	}
	static slerpFlat(e, t, n, r, i, a, o) {
		let s = n[r + 0], c = n[r + 1], l = n[r + 2], u = n[r + 3], d = i[a + 0], f = i[a + 1], p = i[a + 2], m = i[a + 3];
		if (u !== m || s !== d || c !== f || l !== p) {
			let e = s * d + c * f + l * p + u * m;
			e < 0 && (d = -d, f = -f, p = -p, m = -m, e = -e);
			let t = 1 - o;
			if (e < .9995) {
				let n = Math.acos(e), r = Math.sin(n);
				t = Math.sin(t * n) / r, o = Math.sin(o * n) / r, s = s * t + d * o, c = c * t + f * o, l = l * t + p * o, u = u * t + m * o;
			} else {
				s = s * t + d * o, c = c * t + f * o, l = l * t + p * o, u = u * t + m * o;
				let e = 1 / Math.sqrt(s * s + c * c + l * l + u * u);
				s *= e, c *= e, l *= e, u *= e;
			}
		}
		e[t] = s, e[t + 1] = c, e[t + 2] = l, e[t + 3] = u;
	}
	static multiplyQuaternionsFlat(e, t, n, r, i, a) {
		let o = n[r], s = n[r + 1], c = n[r + 2], l = n[r + 3], u = i[a], d = i[a + 1], f = i[a + 2], p = i[a + 3];
		return e[t] = o * p + l * u + s * f - c * d, e[t + 1] = s * p + l * d + c * u - o * f, e[t + 2] = c * p + l * f + o * d - s * u, e[t + 3] = l * p - o * u - s * d - c * f, e;
	}
	get x() {
		return this._x;
	}
	set x(e) {
		this._x = e, this._onChangeCallback();
	}
	get y() {
		return this._y;
	}
	set y(e) {
		this._y = e, this._onChangeCallback();
	}
	get z() {
		return this._z;
	}
	set z(e) {
		this._z = e, this._onChangeCallback();
	}
	get w() {
		return this._w;
	}
	set w(e) {
		this._w = e, this._onChangeCallback();
	}
	set(e, t, n, r) {
		return this._x = e, this._y = t, this._z = n, this._w = r, this._onChangeCallback(), this;
	}
	clone() {
		return new this.constructor(this._x, this._y, this._z, this._w);
	}
	copy(e) {
		return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
	}
	setFromEuler(e, t = !0) {
		let n = e._x, r = e._y, i = e._z, a = e._order, o = Math.cos, s = Math.sin, c = o(n / 2), l = o(r / 2), u = o(i / 2), d = s(n / 2), f = s(r / 2), p = s(i / 2);
		switch (a) {
			case "XYZ":
				this._x = d * l * u + c * f * p, this._y = c * f * u - d * l * p, this._z = c * l * p + d * f * u, this._w = c * l * u - d * f * p;
				break;
			case "YXZ":
				this._x = d * l * u + c * f * p, this._y = c * f * u - d * l * p, this._z = c * l * p - d * f * u, this._w = c * l * u + d * f * p;
				break;
			case "ZXY":
				this._x = d * l * u - c * f * p, this._y = c * f * u + d * l * p, this._z = c * l * p + d * f * u, this._w = c * l * u - d * f * p;
				break;
			case "ZYX":
				this._x = d * l * u - c * f * p, this._y = c * f * u + d * l * p, this._z = c * l * p - d * f * u, this._w = c * l * u + d * f * p;
				break;
			case "YZX":
				this._x = d * l * u + c * f * p, this._y = c * f * u + d * l * p, this._z = c * l * p - d * f * u, this._w = c * l * u - d * f * p;
				break;
			case "XZY":
				this._x = d * l * u - c * f * p, this._y = c * f * u - d * l * p, this._z = c * l * p + d * f * u, this._w = c * l * u + d * f * p;
				break;
			default: L("Quaternion: .setFromEuler() encountered an unknown order: " + a);
		}
		return t === !0 && this._onChangeCallback(), this;
	}
	setFromAxisAngle(e, t) {
		let n = t / 2, r = Math.sin(n);
		return this._x = e.x * r, this._y = e.y * r, this._z = e.z * r, this._w = Math.cos(n), this._onChangeCallback(), this;
	}
	setFromRotationMatrix(e) {
		let t = e.elements, n = t[0], r = t[4], i = t[8], a = t[1], o = t[5], s = t[9], c = t[2], l = t[6], u = t[10], d = n + o + u;
		if (d > 0) {
			let e = .5 / Math.sqrt(d + 1);
			this._w = .25 / e, this._x = (l - s) * e, this._y = (i - c) * e, this._z = (a - r) * e;
		} else if (n > o && n > u) {
			let e = 2 * Math.sqrt(1 + n - o - u);
			this._w = (l - s) / e, this._x = .25 * e, this._y = (r + a) / e, this._z = (i + c) / e;
		} else if (o > u) {
			let e = 2 * Math.sqrt(1 + o - n - u);
			this._w = (i - c) / e, this._x = (r + a) / e, this._y = .25 * e, this._z = (s + l) / e;
		} else {
			let e = 2 * Math.sqrt(1 + u - n - o);
			this._w = (a - r) / e, this._x = (i + c) / e, this._y = (s + l) / e, this._z = .25 * e;
		}
		return this._onChangeCallback(), this;
	}
	setFromUnitVectors(e, t) {
		let n = e.dot(t) + 1;
		return n < 1e-8 ? (n = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = n)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = n), this.normalize();
	}
	angleTo(e) {
		return 2 * Math.acos(Math.abs(V(this.dot(e), -1, 1)));
	}
	rotateTowards(e, t) {
		let n = this.angleTo(e);
		if (n === 0) return this;
		let r = Math.min(1, t / n);
		return this.slerp(e, r), this;
	}
	identity() {
		return this.set(0, 0, 0, 1);
	}
	invert() {
		return this.conjugate();
	}
	conjugate() {
		return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
	}
	dot(e) {
		return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
	}
	lengthSq() {
		return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
	}
	length() {
		return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
	}
	normalize() {
		let e = this.length();
		return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x *= e, this._y *= e, this._z *= e, this._w *= e), this._onChangeCallback(), this;
	}
	multiply(e) {
		return this.multiplyQuaternions(this, e);
	}
	premultiply(e) {
		return this.multiplyQuaternions(e, this);
	}
	multiplyQuaternions(e, t) {
		let n = e._x, r = e._y, i = e._z, a = e._w, o = t._x, s = t._y, c = t._z, l = t._w;
		return this._x = n * l + a * o + r * c - i * s, this._y = r * l + a * s + i * o - n * c, this._z = i * l + a * c + n * s - r * o, this._w = a * l - n * o - r * s - i * c, this._onChangeCallback(), this;
	}
	slerp(e, t) {
		let n = e._x, r = e._y, i = e._z, a = e._w, o = this.dot(e);
		o < 0 && (n = -n, r = -r, i = -i, a = -a, o = -o);
		let s = 1 - t;
		if (o < .9995) {
			let e = Math.acos(o), c = Math.sin(e);
			s = Math.sin(s * e) / c, t = Math.sin(t * e) / c, this._x = this._x * s + n * t, this._y = this._y * s + r * t, this._z = this._z * s + i * t, this._w = this._w * s + a * t, this._onChangeCallback();
		} else this._x = this._x * s + n * t, this._y = this._y * s + r * t, this._z = this._z * s + i * t, this._w = this._w * s + a * t, this.normalize();
		return this;
	}
	slerpQuaternions(e, t, n) {
		return this.copy(e).slerp(t, n);
	}
	random() {
		let e = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), n = Math.random(), r = Math.sqrt(1 - n), i = Math.sqrt(n);
		return this.set(r * Math.sin(e), r * Math.cos(e), i * Math.sin(t), i * Math.cos(t));
	}
	equals(e) {
		return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
	}
	fromArray(e, t = 0) {
		return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
	}
	fromBufferAttribute(e, t) {
		return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this._onChangeCallback(), this;
	}
	toJSON() {
		return this.toArray();
	}
	_onChange(e) {
		return this._onChangeCallback = e, this;
	}
	_onChangeCallback() {}
	*[Symbol.iterator]() {
		yield this._x, yield this._y, yield this._z, yield this._w;
	}
}, G = class e {
	static {
		e.prototype.isVector3 = !0;
	}
	constructor(e = 0, t = 0, n = 0) {
		this.x = e, this.y = t, this.z = n;
	}
	set(e, t, n) {
		return n === void 0 && (n = this.z), this.x = e, this.y = t, this.z = n, this;
	}
	setScalar(e) {
		return this.x = e, this.y = e, this.z = e, this;
	}
	setX(e) {
		return this.x = e, this;
	}
	setY(e) {
		return this.y = e, this;
	}
	setZ(e) {
		return this.z = e, this;
	}
	setComponent(e, t) {
		switch (e) {
			case 0:
				this.x = t;
				break;
			case 1:
				this.y = t;
				break;
			case 2:
				this.z = t;
				break;
			default: throw Error("THREE.Vector3: index is out of range: " + e);
		}
		return this;
	}
	getComponent(e) {
		switch (e) {
			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			default: throw Error("THREE.Vector3: index is out of range: " + e);
		}
	}
	clone() {
		return new this.constructor(this.x, this.y, this.z);
	}
	copy(e) {
		return this.x = e.x, this.y = e.y, this.z = e.z, this;
	}
	add(e) {
		return this.x += e.x, this.y += e.y, this.z += e.z, this;
	}
	addScalar(e) {
		return this.x += e, this.y += e, this.z += e, this;
	}
	addVectors(e, t) {
		return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
	}
	addScaledVector(e, t) {
		return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
	}
	sub(e) {
		return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
	}
	subScalar(e) {
		return this.x -= e, this.y -= e, this.z -= e, this;
	}
	subVectors(e, t) {
		return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
	}
	multiply(e) {
		return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
	}
	multiplyScalar(e) {
		return this.x *= e, this.y *= e, this.z *= e, this;
	}
	multiplyVectors(e, t) {
		return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
	}
	applyEuler(e) {
		return this.applyQuaternion(Ne.setFromEuler(e));
	}
	applyAxisAngle(e, t) {
		return this.applyQuaternion(Ne.setFromAxisAngle(e, t));
	}
	applyMatrix3(e) {
		let t = this.x, n = this.y, r = this.z, i = e.elements;
		return this.x = i[0] * t + i[3] * n + i[6] * r, this.y = i[1] * t + i[4] * n + i[7] * r, this.z = i[2] * t + i[5] * n + i[8] * r, this;
	}
	applyNormalMatrix(e) {
		return this.applyMatrix3(e).normalize();
	}
	applyMatrix4(e) {
		let t = this.x, n = this.y, r = this.z, i = e.elements, a = 1 / (i[3] * t + i[7] * n + i[11] * r + i[15]);
		return this.x = (i[0] * t + i[4] * n + i[8] * r + i[12]) * a, this.y = (i[1] * t + i[5] * n + i[9] * r + i[13]) * a, this.z = (i[2] * t + i[6] * n + i[10] * r + i[14]) * a, this;
	}
	applyQuaternion(e) {
		let t = this.x, n = this.y, r = this.z, i = e.x, a = e.y, o = e.z, s = e.w, c = 2 * (a * r - o * n), l = 2 * (o * t - i * r), u = 2 * (i * n - a * t);
		return this.x = t + s * c + a * u - o * l, this.y = n + s * l + o * c - i * u, this.z = r + s * u + i * l - a * c, this;
	}
	project(e) {
		return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
	}
	unproject(e) {
		return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
	}
	transformDirection(e) {
		let t = this.x, n = this.y, r = this.z, i = e.elements;
		return this.x = i[0] * t + i[4] * n + i[8] * r, this.y = i[1] * t + i[5] * n + i[9] * r, this.z = i[2] * t + i[6] * n + i[10] * r, this.normalize();
	}
	divide(e) {
		return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
	}
	divideScalar(e) {
		return this.multiplyScalar(1 / e);
	}
	min(e) {
		return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
	}
	max(e) {
		return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
	}
	clamp(e, t) {
		return this.x = V(this.x, e.x, t.x), this.y = V(this.y, e.y, t.y), this.z = V(this.z, e.z, t.z), this;
	}
	clampScalar(e, t) {
		return this.x = V(this.x, e, t), this.y = V(this.y, e, t), this.z = V(this.z, e, t), this;
	}
	clampLength(e, t) {
		let n = this.length();
		return this.divideScalar(n || 1).multiplyScalar(V(n, e, t));
	}
	floor() {
		return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
	}
	ceil() {
		return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
	}
	round() {
		return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
	}
	roundToZero() {
		return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
	}
	negate() {
		return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
	}
	dot(e) {
		return this.x * e.x + this.y * e.y + this.z * e.z;
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y + this.z * this.z;
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
	}
	manhattanLength() {
		return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
	}
	normalize() {
		return this.divideScalar(this.length() || 1);
	}
	setLength(e) {
		return this.normalize().multiplyScalar(e);
	}
	lerp(e, t) {
		return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
	}
	lerpVectors(e, t, n) {
		return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this;
	}
	cross(e) {
		return this.crossVectors(this, e);
	}
	crossVectors(e, t) {
		let n = e.x, r = e.y, i = e.z, a = t.x, o = t.y, s = t.z;
		return this.x = r * s - i * o, this.y = i * a - n * s, this.z = n * o - r * a, this;
	}
	projectOnVector(e) {
		let t = e.lengthSq();
		if (t === 0) return this.set(0, 0, 0);
		let n = e.dot(this) / t;
		return this.copy(e).multiplyScalar(n);
	}
	projectOnPlane(e) {
		return Me.copy(this).projectOnVector(e), this.sub(Me);
	}
	reflect(e) {
		return this.sub(Me.copy(e).multiplyScalar(2 * this.dot(e)));
	}
	angleTo(e) {
		let t = Math.sqrt(this.lengthSq() * e.lengthSq());
		if (t === 0) return Math.PI / 2;
		let n = this.dot(e) / t;
		return Math.acos(V(n, -1, 1));
	}
	distanceTo(e) {
		return Math.sqrt(this.distanceToSquared(e));
	}
	distanceToSquared(e) {
		let t = this.x - e.x, n = this.y - e.y, r = this.z - e.z;
		return t * t + n * n + r * r;
	}
	manhattanDistanceTo(e) {
		return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
	}
	setFromSpherical(e) {
		return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
	}
	setFromSphericalCoords(e, t, n) {
		let r = Math.sin(t) * e;
		return this.x = r * Math.sin(n), this.y = Math.cos(t) * e, this.z = r * Math.cos(n), this;
	}
	setFromCylindrical(e) {
		return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
	}
	setFromCylindricalCoords(e, t, n) {
		return this.x = e * Math.sin(t), this.y = n, this.z = e * Math.cos(t), this;
	}
	setFromMatrixPosition(e) {
		let t = e.elements;
		return this.x = t[12], this.y = t[13], this.z = t[14], this;
	}
	setFromMatrixScale(e) {
		let t = this.setFromMatrixColumn(e, 0).length(), n = this.setFromMatrixColumn(e, 1).length(), r = this.setFromMatrixColumn(e, 2).length();
		return this.x = t, this.y = n, this.z = r, this;
	}
	setFromMatrixColumn(e, t) {
		return this.fromArray(e.elements, t * 4);
	}
	setFromMatrix3Column(e, t) {
		return this.fromArray(e.elements, t * 3);
	}
	setFromEuler(e) {
		return this.x = e._x, this.y = e._y, this.z = e._z, this;
	}
	setFromColor(e) {
		return this.x = e.r, this.y = e.g, this.z = e.b, this;
	}
	equals(e) {
		return e.x === this.x && e.y === this.y && e.z === this.z;
	}
	fromArray(e, t = 0) {
		return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
	}
	fromBufferAttribute(e, t) {
		return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
	}
	random() {
		return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
	}
	randomDirection() {
		let e = Math.random() * Math.PI * 2, t = Math.random() * 2 - 1, n = Math.sqrt(1 - t * t);
		return this.x = n * Math.cos(e), this.y = t, this.z = n * Math.sin(e), this;
	}
	*[Symbol.iterator]() {
		yield this.x, yield this.y, yield this.z;
	}
}, Me = /*@__PURE__*/ new G(), Ne = /*@__PURE__*/ new W(), K = class e {
	static {
		e.prototype.isMatrix3 = !0;
	}
	constructor(e, t, n, r, i, a, o, s, c) {
		this.elements = [
			1,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			1
		], e !== void 0 && this.set(e, t, n, r, i, a, o, s, c);
	}
	set(e, t, n, r, i, a, o, s, c) {
		let l = this.elements;
		return l[0] = e, l[1] = r, l[2] = o, l[3] = t, l[4] = i, l[5] = s, l[6] = n, l[7] = a, l[8] = c, this;
	}
	identity() {
		return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
	}
	copy(e) {
		let t = this.elements, n = e.elements;
		return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
	}
	extractBasis(e, t, n) {
		return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
	}
	setFromMatrix4(e) {
		let t = e.elements;
		return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
	}
	multiply(e) {
		return this.multiplyMatrices(this, e);
	}
	premultiply(e) {
		return this.multiplyMatrices(e, this);
	}
	multiplyMatrices(e, t) {
		let n = e.elements, r = t.elements, i = this.elements, a = n[0], o = n[3], s = n[6], c = n[1], l = n[4], u = n[7], d = n[2], f = n[5], p = n[8], m = r[0], h = r[3], g = r[6], _ = r[1], v = r[4], y = r[7], b = r[2], x = r[5], S = r[8];
		return i[0] = a * m + o * _ + s * b, i[3] = a * h + o * v + s * x, i[6] = a * g + o * y + s * S, i[1] = c * m + l * _ + u * b, i[4] = c * h + l * v + u * x, i[7] = c * g + l * y + u * S, i[2] = d * m + f * _ + p * b, i[5] = d * h + f * v + p * x, i[8] = d * g + f * y + p * S, this;
	}
	multiplyScalar(e) {
		let t = this.elements;
		return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
	}
	determinant() {
		let e = this.elements, t = e[0], n = e[1], r = e[2], i = e[3], a = e[4], o = e[5], s = e[6], c = e[7], l = e[8];
		return t * a * l - t * o * c - n * i * l + n * o * s + r * i * c - r * a * s;
	}
	invert() {
		let e = this.elements, t = e[0], n = e[1], r = e[2], i = e[3], a = e[4], o = e[5], s = e[6], c = e[7], l = e[8], u = l * a - o * c, d = o * s - l * i, f = c * i - a * s, p = t * u + n * d + r * f;
		if (p === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
		let m = 1 / p;
		return e[0] = u * m, e[1] = (r * c - l * n) * m, e[2] = (o * n - r * a) * m, e[3] = d * m, e[4] = (l * t - r * s) * m, e[5] = (r * i - o * t) * m, e[6] = f * m, e[7] = (n * s - c * t) * m, e[8] = (a * t - n * i) * m, this;
	}
	transpose() {
		let e, t = this.elements;
		return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
	}
	getNormalMatrix(e) {
		return this.setFromMatrix4(e).invert().transpose();
	}
	transposeIntoArray(e) {
		let t = this.elements;
		return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
	}
	setUvTransform(e, t, n, r, i, a, o) {
		let s = Math.cos(i), c = Math.sin(i);
		return this.set(n * s, n * c, -n * (s * a + c * o) + a + e, -r * c, r * s, -r * (-c * a + s * o) + o + t, 0, 0, 1), this;
	}
	scale(e, t) {
		return ae("Matrix3: .scale() is deprecated. Use .makeScale() instead."), this.premultiply(q.makeScale(e, t)), this;
	}
	rotate(e) {
		return ae("Matrix3: .rotate() is deprecated. Use .makeRotation() instead."), this.premultiply(q.makeRotation(-e)), this;
	}
	translate(e, t) {
		return ae("Matrix3: .translate() is deprecated. Use .makeTranslation() instead."), this.premultiply(q.makeTranslation(e, t)), this;
	}
	makeTranslation(e, t) {
		return e.isVector2 ? this.set(1, 0, e.x, 0, 1, e.y, 0, 0, 1) : this.set(1, 0, e, 0, 1, t, 0, 0, 1), this;
	}
	makeRotation(e) {
		let t = Math.cos(e), n = Math.sin(e);
		return this.set(t, -n, 0, n, t, 0, 0, 0, 1), this;
	}
	makeScale(e, t) {
		return this.set(e, 0, 0, 0, t, 0, 0, 0, 1), this;
	}
	equals(e) {
		let t = this.elements, n = e.elements;
		for (let e = 0; e < 9; e++) if (t[e] !== n[e]) return !1;
		return !0;
	}
	fromArray(e, t = 0) {
		for (let n = 0; n < 9; n++) this.elements[n] = e[n + t];
		return this;
	}
	toArray(e = [], t = 0) {
		let n = this.elements;
		return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e;
	}
	clone() {
		return new this.constructor().fromArray(this.elements);
	}
}, q = /*@__PURE__*/ new K(), Pe = /*@__PURE__*/ new K().set(.4123908, .3575843, .1804808, .212639, .7151687, .0721923, .0193308, .1191948, .9505322), J = /*@__PURE__*/ new K().set(3.2409699, -1.5373832, -.4986108, -.9692436, 1.8759675, .0415551, .0556301, -.203977, 1.0569715);
function Y() {
	let e = {
		enabled: !0,
		workingColorSpace: k,
		spaces: {},
		convert: function(e, t, n) {
			return this.enabled === !1 || t === n || !t || !n ? e : (this.spaces[t].transfer === "srgb" && (e.r = Fe(e.r), e.g = Fe(e.g), e.b = Fe(e.b)), this.spaces[t].primaries !== this.spaces[n].primaries && (e.applyMatrix3(this.spaces[t].toXYZ), e.applyMatrix3(this.spaces[n].fromXYZ)), this.spaces[n].transfer === "srgb" && (e.r = Ie(e.r), e.g = Ie(e.g), e.b = Ie(e.b)), e);
		},
		workingToColorSpace: function(e, t) {
			return this.convert(e, this.workingColorSpace, t);
		},
		colorSpaceToWorking: function(e, t) {
			return this.convert(e, t, this.workingColorSpace);
		},
		getPrimaries: function(e) {
			return this.spaces[e].primaries;
		},
		getTransfer: function(e) {
			return e === "" ? A : this.spaces[e].transfer;
		},
		getToneMappingMode: function(e) {
			return this.spaces[e].outputColorSpaceConfig.toneMappingMode || "standard";
		},
		getLuminanceCoefficients: function(e, t = this.workingColorSpace) {
			return e.fromArray(this.spaces[t].luminanceCoefficients);
		},
		define: function(e) {
			Object.assign(this.spaces, e);
		},
		_getMatrix: function(e, t, n) {
			return e.copy(this.spaces[t].toXYZ).multiply(this.spaces[n].fromXYZ);
		},
		_getDrawingBufferColorSpace: function(e) {
			return this.spaces[e].outputColorSpaceConfig.drawingBufferColorSpace;
		},
		_getUnpackColorSpace: function(e = this.workingColorSpace) {
			return this.spaces[e].workingColorSpaceConfig.unpackColorSpace;
		},
		fromWorkingColorSpace: function(t, n) {
			return ae("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), e.workingToColorSpace(t, n);
		},
		toWorkingColorSpace: function(t, n) {
			return ae("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), e.colorSpaceToWorking(t, n);
		}
	}, t = [
		.64,
		.33,
		.3,
		.6,
		.15,
		.06
	], n = [
		.2126,
		.7152,
		.0722
	], r = [.3127, .329];
	return e.define({
		[k]: {
			primaries: t,
			whitePoint: r,
			transfer: A,
			toXYZ: Pe,
			fromXYZ: J,
			luminanceCoefficients: n,
			workingColorSpaceConfig: { unpackColorSpace: O },
			outputColorSpaceConfig: { drawingBufferColorSpace: O }
		},
		[O]: {
			primaries: t,
			whitePoint: r,
			transfer: j,
			toXYZ: Pe,
			fromXYZ: J,
			luminanceCoefficients: n,
			outputColorSpaceConfig: { drawingBufferColorSpace: O }
		}
	}), e;
}
var X = /*@__PURE__*/ Y();
function Fe(e) {
	return e < .04045 ? e * .0773993808 : (e * .9478672986 + .0521327014) ** 2.4;
}
function Ie(e) {
	return e < .0031308 ? e * 12.92 : 1.055 * e ** .41666 - .055;
}
var Le, Re = class {
	static getDataURL(e, t = "image/png") {
		if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u") return e.src;
		let n;
		if (e instanceof HTMLCanvasElement) n = e;
		else {
			Le === void 0 && (Le = te("canvas")), Le.width = e.width, Le.height = e.height;
			let t = Le.getContext("2d");
			e instanceof ImageData ? t.putImageData(e, 0, 0) : t.drawImage(e, 0, 0, e.width, e.height), n = Le;
		}
		return n.toDataURL(t);
	}
	static sRGBToLinear(e) {
		if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
			let t = te("canvas");
			t.width = e.width, t.height = e.height;
			let n = t.getContext("2d");
			n.drawImage(e, 0, 0, e.width, e.height);
			let r = n.getImageData(0, 0, e.width, e.height), i = r.data;
			for (let e = 0; e < i.length; e++) i[e] = Fe(i[e] / 255) * 255;
			return n.putImageData(r, 0, 0), t;
		} else if (e.data) {
			let t = e.data.slice(0);
			for (let e = 0; e < t.length; e++) t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[e] = Math.floor(Fe(t[e] / 255) * 255) : t[e] = Fe(t[e]);
			return {
				data: t,
				width: e.width,
				height: e.height
			};
		} else return L("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
	}
}, ze = 0, Be = class {
	constructor(e = null) {
		this.isSource = !0, Object.defineProperty(this, "id", { value: ze++ }), this.uuid = B(), this.data = e, this.dataReady = !0, this.version = 0;
	}
	getSize(e) {
		let t = this.data;
		return typeof HTMLVideoElement < "u" && t instanceof HTMLVideoElement ? e.set(t.videoWidth, t.videoHeight, 0) : typeof VideoFrame < "u" && t instanceof VideoFrame ? e.set(t.displayWidth, t.displayHeight, 0) : t === null ? e.set(0, 0, 0) : e.set(t.width, t.height, t.depth || 0), e;
	}
	set needsUpdate(e) {
		e === !0 && this.version++;
	}
	toJSON(e) {
		let t = e === void 0 || typeof e == "string";
		if (!t && e.images[this.uuid] !== void 0) return e.images[this.uuid];
		let n = {
			uuid: this.uuid,
			url: ""
		}, r = this.data;
		if (r !== null) {
			let e;
			if (Array.isArray(r)) {
				e = [];
				for (let t = 0, n = r.length; t < n; t++) r[t].isDataTexture ? e.push(Ve(r[t].image)) : e.push(Ve(r[t]));
			} else e = Ve(r);
			n.url = e;
		}
		return t || (e.images[this.uuid] = n), n;
	}
};
function Ve(e) {
	return typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap ? Re.getDataURL(e) : e.data ? {
		data: Array.from(e.data),
		width: e.width,
		height: e.height,
		type: e.data.constructor.name
	} : (L("Texture: Unable to serialize Texture."), {});
}
var He = 0, Ue = /*@__PURE__*/ new G(), We = class r extends ce {
	constructor(e = r.DEFAULT_IMAGE, n = r.DEFAULT_MAPPING, s = t, c = t, l = i, u = a, d = m, f = o, p = r.DEFAULT_ANISOTROPY, h = "") {
		super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: He++ }), this.uuid = B(), this.name = "", this.source = new Be(e), this.mipmaps = [], this.mapping = n, this.channel = 0, this.wrapS = s, this.wrapT = c, this.magFilter = l, this.minFilter = u, this.anisotropy = p, this.format = d, this.internalFormat = null, this.type = f, this.offset = new U(0, 0), this.repeat = new U(1, 1), this.center = new U(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new K(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = h, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(e && e.depth && e.depth > 1), this.pmremVersion = 0, this.normalized = !1;
	}
	get width() {
		return this.source.getSize(Ue).x;
	}
	get height() {
		return this.source.getSize(Ue).y;
	}
	get depth() {
		return this.source.getSize(Ue).z;
	}
	get image() {
		return this.source.data;
	}
	set image(e) {
		this.source.data = e;
	}
	updateMatrix() {
		this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
	}
	addUpdateRange(e, t) {
		this.updateRanges.push({
			start: e,
			count: t
		});
	}
	clearUpdateRanges() {
		this.updateRanges.length = 0;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.normalized = e.normalized, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.isArrayTexture = e.isArrayTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
	}
	setValues(e) {
		for (let t in e) {
			let n = e[t];
			if (n === void 0) {
				L(`Texture.setValues(): parameter '${t}' has value of undefined.`);
				continue;
			}
			let r = this[t];
			if (r === void 0) {
				L(`Texture.setValues(): property '${t}' does not exist.`);
				continue;
			}
			r && n && r.isVector2 && n.isVector2 || r && n && r.isVector3 && n.isVector3 || r && n && r.isMatrix3 && n.isMatrix3 ? r.copy(n) : this[t] = n;
		}
	}
	toJSON(e) {
		let t = e === void 0 || typeof e == "string";
		if (!t && e.textures[this.uuid] !== void 0) return e.textures[this.uuid];
		let n = {
			metadata: {
				version: 4.7,
				type: "Texture",
				generator: "Texture.toJSON"
			},
			uuid: this.uuid,
			name: this.name,
			image: this.source.toJSON(e).uuid,
			mapping: this.mapping,
			channel: this.channel,
			repeat: [this.repeat.x, this.repeat.y],
			offset: [this.offset.x, this.offset.y],
			center: [this.center.x, this.center.y],
			rotation: this.rotation,
			wrap: [this.wrapS, this.wrapT],
			format: this.format,
			internalFormat: this.internalFormat,
			type: this.type,
			normalized: this.normalized,
			colorSpace: this.colorSpace,
			minFilter: this.minFilter,
			magFilter: this.magFilter,
			anisotropy: this.anisotropy,
			flipY: this.flipY,
			generateMipmaps: this.generateMipmaps,
			premultiplyAlpha: this.premultiplyAlpha,
			unpackAlignment: this.unpackAlignment
		};
		return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e.textures[this.uuid] = n), n;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
	transformUv(r) {
		if (this.mapping !== 300) return r;
		if (r.applyMatrix3(this.matrix), r.x < 0 || r.x > 1) switch (this.wrapS) {
			case e:
				r.x -= Math.floor(r.x);
				break;
			case t:
				r.x = r.x < 0 ? 0 : 1;
				break;
			case n:
				Math.abs(Math.floor(r.x) % 2) === 1 ? r.x = Math.ceil(r.x) - r.x : r.x -= Math.floor(r.x);
				break;
		}
		if (r.y < 0 || r.y > 1) switch (this.wrapT) {
			case e:
				r.y -= Math.floor(r.y);
				break;
			case t:
				r.y = r.y < 0 ? 0 : 1;
				break;
			case n:
				Math.abs(Math.floor(r.y) % 2) === 1 ? r.y = Math.ceil(r.y) - r.y : r.y -= Math.floor(r.y);
				break;
		}
		return this.flipY && (r.y = 1 - r.y), r;
	}
	set needsUpdate(e) {
		e === !0 && (this.version++, this.source.needsUpdate = !0);
	}
	set needsPMREMUpdate(e) {
		e === !0 && this.pmremVersion++;
	}
};
We.DEFAULT_IMAGE = null, We.DEFAULT_MAPPING = 300, We.DEFAULT_ANISOTROPY = 1;
var Ge = class e {
	static {
		e.prototype.isVector4 = !0;
	}
	constructor(e = 0, t = 0, n = 0, r = 1) {
		this.x = e, this.y = t, this.z = n, this.w = r;
	}
	get width() {
		return this.z;
	}
	set width(e) {
		this.z = e;
	}
	get height() {
		return this.w;
	}
	set height(e) {
		this.w = e;
	}
	set(e, t, n, r) {
		return this.x = e, this.y = t, this.z = n, this.w = r, this;
	}
	setScalar(e) {
		return this.x = e, this.y = e, this.z = e, this.w = e, this;
	}
	setX(e) {
		return this.x = e, this;
	}
	setY(e) {
		return this.y = e, this;
	}
	setZ(e) {
		return this.z = e, this;
	}
	setW(e) {
		return this.w = e, this;
	}
	setComponent(e, t) {
		switch (e) {
			case 0:
				this.x = t;
				break;
			case 1:
				this.y = t;
				break;
			case 2:
				this.z = t;
				break;
			case 3:
				this.w = t;
				break;
			default: throw Error("THREE.Vector4: index is out of range: " + e);
		}
		return this;
	}
	getComponent(e) {
		switch (e) {
			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			case 3: return this.w;
			default: throw Error("THREE.Vector4: index is out of range: " + e);
		}
	}
	clone() {
		return new this.constructor(this.x, this.y, this.z, this.w);
	}
	copy(e) {
		return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w === void 0 ? 1 : e.w, this;
	}
	add(e) {
		return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
	}
	addScalar(e) {
		return this.x += e, this.y += e, this.z += e, this.w += e, this;
	}
	addVectors(e, t) {
		return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
	}
	addScaledVector(e, t) {
		return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
	}
	sub(e) {
		return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
	}
	subScalar(e) {
		return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
	}
	subVectors(e, t) {
		return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
	}
	multiply(e) {
		return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
	}
	multiplyScalar(e) {
		return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
	}
	applyMatrix4(e) {
		let t = this.x, n = this.y, r = this.z, i = this.w, a = e.elements;
		return this.x = a[0] * t + a[4] * n + a[8] * r + a[12] * i, this.y = a[1] * t + a[5] * n + a[9] * r + a[13] * i, this.z = a[2] * t + a[6] * n + a[10] * r + a[14] * i, this.w = a[3] * t + a[7] * n + a[11] * r + a[15] * i, this;
	}
	divide(e) {
		return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
	}
	divideScalar(e) {
		return this.multiplyScalar(1 / e);
	}
	setAxisAngleFromQuaternion(e) {
		this.w = 2 * Math.acos(e.w);
		let t = Math.sqrt(1 - e.w * e.w);
		return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
	}
	setAxisAngleFromRotationMatrix(e) {
		let t, n, r, i, a = .01, o = .1, s = e.elements, c = s[0], l = s[4], u = s[8], d = s[1], f = s[5], p = s[9], m = s[2], h = s[6], g = s[10];
		if (Math.abs(l - d) < a && Math.abs(u - m) < a && Math.abs(p - h) < a) {
			if (Math.abs(l + d) < o && Math.abs(u + m) < o && Math.abs(p + h) < o && Math.abs(c + f + g - 3) < o) return this.set(1, 0, 0, 0), this;
			t = Math.PI;
			let e = (c + 1) / 2, s = (f + 1) / 2, _ = (g + 1) / 2, v = (l + d) / 4, y = (u + m) / 4, b = (p + h) / 4;
			return e > s && e > _ ? e < a ? (n = 0, r = .707106781, i = .707106781) : (n = Math.sqrt(e), r = v / n, i = y / n) : s > _ ? s < a ? (n = .707106781, r = 0, i = .707106781) : (r = Math.sqrt(s), n = v / r, i = b / r) : _ < a ? (n = .707106781, r = .707106781, i = 0) : (i = Math.sqrt(_), n = y / i, r = b / i), this.set(n, r, i, t), this;
		}
		let _ = Math.sqrt((h - p) * (h - p) + (u - m) * (u - m) + (d - l) * (d - l));
		return Math.abs(_) < .001 && (_ = 1), this.x = (h - p) / _, this.y = (u - m) / _, this.z = (d - l) / _, this.w = Math.acos((c + f + g - 1) / 2), this;
	}
	setFromMatrixPosition(e) {
		let t = e.elements;
		return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
	}
	min(e) {
		return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
	}
	max(e) {
		return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
	}
	clamp(e, t) {
		return this.x = V(this.x, e.x, t.x), this.y = V(this.y, e.y, t.y), this.z = V(this.z, e.z, t.z), this.w = V(this.w, e.w, t.w), this;
	}
	clampScalar(e, t) {
		return this.x = V(this.x, e, t), this.y = V(this.y, e, t), this.z = V(this.z, e, t), this.w = V(this.w, e, t), this;
	}
	clampLength(e, t) {
		let n = this.length();
		return this.divideScalar(n || 1).multiplyScalar(V(n, e, t));
	}
	floor() {
		return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
	}
	ceil() {
		return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
	}
	round() {
		return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
	}
	roundToZero() {
		return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
	}
	negate() {
		return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
	}
	dot(e) {
		return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
	}
	manhattanLength() {
		return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
	}
	normalize() {
		return this.divideScalar(this.length() || 1);
	}
	setLength(e) {
		return this.normalize().multiplyScalar(e);
	}
	lerp(e, t) {
		return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
	}
	lerpVectors(e, t, n) {
		return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this.w = e.w + (t.w - e.w) * n, this;
	}
	equals(e) {
		return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
	}
	fromArray(e, t = 0) {
		return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
	}
	fromBufferAttribute(e, t) {
		return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
	}
	random() {
		return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
	}
	*[Symbol.iterator]() {
		yield this.x, yield this.y, yield this.z, yield this.w;
	}
}, Ke = class extends ce {
	constructor(e = 1, t = 1, n = {}) {
		super(), n = Object.assign({
			generateMipmaps: !1,
			internalFormat: null,
			minFilter: i,
			depthBuffer: !0,
			stencilBuffer: !1,
			resolveDepthBuffer: !0,
			resolveStencilBuffer: !0,
			depthTexture: null,
			samples: 0,
			count: 1,
			depth: 1,
			multiview: !1,
			useArrayDepthTexture: !1
		}, n), this.isRenderTarget = !0, this.width = e, this.height = t, this.depth = n.depth, this.scissor = new Ge(0, 0, e, t), this.scissorTest = !1, this.viewport = new Ge(0, 0, e, t), this.textures = [];
		let r = new We({
			width: e,
			height: t,
			depth: n.depth
		}), a = n.count;
		for (let e = 0; e < a; e++) this.textures[e] = r.clone(), this.textures[e].isRenderTargetTexture = !0, this.textures[e].renderTarget = this;
		this._setTextureOptions(n), this.depthBuffer = n.depthBuffer, this.stencilBuffer = n.stencilBuffer, this.resolveDepthBuffer = n.resolveDepthBuffer, this.resolveStencilBuffer = n.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = n.depthTexture, this.samples = n.samples, this.multiview = n.multiview, this.useArrayDepthTexture = n.useArrayDepthTexture;
	}
	_setTextureOptions(e = {}) {
		let t = {
			minFilter: i,
			generateMipmaps: !1,
			flipY: !1,
			internalFormat: null
		};
		e.mapping !== void 0 && (t.mapping = e.mapping), e.wrapS !== void 0 && (t.wrapS = e.wrapS), e.wrapT !== void 0 && (t.wrapT = e.wrapT), e.wrapR !== void 0 && (t.wrapR = e.wrapR), e.magFilter !== void 0 && (t.magFilter = e.magFilter), e.minFilter !== void 0 && (t.minFilter = e.minFilter), e.format !== void 0 && (t.format = e.format), e.type !== void 0 && (t.type = e.type), e.anisotropy !== void 0 && (t.anisotropy = e.anisotropy), e.colorSpace !== void 0 && (t.colorSpace = e.colorSpace), e.flipY !== void 0 && (t.flipY = e.flipY), e.generateMipmaps !== void 0 && (t.generateMipmaps = e.generateMipmaps), e.internalFormat !== void 0 && (t.internalFormat = e.internalFormat);
		for (let e = 0; e < this.textures.length; e++) this.textures[e].setValues(t);
	}
	get texture() {
		return this.textures[0];
	}
	set texture(e) {
		this.textures[0] = e;
	}
	set depthTexture(e) {
		this._depthTexture !== null && (this._depthTexture.renderTarget = null), e !== null && (e.renderTarget = this), this._depthTexture = e;
	}
	get depthTexture() {
		return this._depthTexture;
	}
	setSize(e, t, n = 1) {
		if (this.width !== e || this.height !== t || this.depth !== n) {
			this.width = e, this.height = t, this.depth = n;
			for (let r = 0, i = this.textures.length; r < i; r++) this.textures[r].image.width = e, this.textures[r].image.height = t, this.textures[r].image.depth = n, this.textures[r].isData3DTexture !== !0 && (this.textures[r].isArrayTexture = this.textures[r].image.depth > 1);
			this.dispose();
		}
		this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
		for (let t = 0, n = e.textures.length; t < n; t++) {
			this.textures[t] = e.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
			let n = Object.assign({}, e.textures[t].image);
			this.textures[t].source = new Be(n);
		}
		return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this.multiview = e.multiview, this.useArrayDepthTexture = e.useArrayDepthTexture, this;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
}, qe = class extends Ke {
	constructor(e = 1, t = 1, n = {}) {
		super(e, t, n), this.isWebGLRenderTarget = !0;
	}
}, Je = class extends We {
	constructor(e = null, n = 1, i = 1, a = 1) {
		super(null), this.isDataArrayTexture = !0, this.image = {
			data: e,
			width: n,
			height: i,
			depth: a
		}, this.magFilter = r, this.minFilter = r, this.wrapR = t, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
	}
	addLayerUpdate(e) {
		this.layerUpdates.add(e);
	}
	clearLayerUpdates() {
		this.layerUpdates.clear();
	}
}, Ye = class extends We {
	constructor(e = null, n = 1, i = 1, a = 1) {
		super(null), this.isData3DTexture = !0, this.image = {
			data: e,
			width: n,
			height: i,
			depth: a
		}, this.magFilter = r, this.minFilter = r, this.wrapR = t, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
	}
}, Xe = class e {
	static {
		e.prototype.isMatrix4 = !0;
	}
	constructor(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
		this.elements = [
			1,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			1
		], e !== void 0 && this.set(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h);
	}
	set(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
		let g = this.elements;
		return g[0] = e, g[4] = t, g[8] = n, g[12] = r, g[1] = i, g[5] = a, g[9] = o, g[13] = s, g[2] = c, g[6] = l, g[10] = u, g[14] = d, g[3] = f, g[7] = p, g[11] = m, g[15] = h, this;
	}
	identity() {
		return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
	}
	clone() {
		return new e().fromArray(this.elements);
	}
	copy(e) {
		let t = this.elements, n = e.elements;
		return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
	}
	copyPosition(e) {
		let t = this.elements, n = e.elements;
		return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
	}
	setFromMatrix3(e) {
		let t = e.elements;
		return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
	}
	extractBasis(e, t, n) {
		return this.determinantAffine() === 0 ? (e.set(1, 0, 0), t.set(0, 1, 0), n.set(0, 0, 1), this) : (e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this);
	}
	makeBasis(e, t, n) {
		return this.set(e.x, t.x, n.x, 0, e.y, t.y, n.y, 0, e.z, t.z, n.z, 0, 0, 0, 0, 1), this;
	}
	extractRotation(e) {
		if (e.determinantAffine() === 0) return this.identity();
		let t = this.elements, n = e.elements, r = 1 / Ze.setFromMatrixColumn(e, 0).length(), i = 1 / Ze.setFromMatrixColumn(e, 1).length(), a = 1 / Ze.setFromMatrixColumn(e, 2).length();
		return t[0] = n[0] * r, t[1] = n[1] * r, t[2] = n[2] * r, t[3] = 0, t[4] = n[4] * i, t[5] = n[5] * i, t[6] = n[6] * i, t[7] = 0, t[8] = n[8] * a, t[9] = n[9] * a, t[10] = n[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
	}
	makeRotationFromEuler(e) {
		let t = this.elements, n = e.x, r = e.y, i = e.z, a = Math.cos(n), o = Math.sin(n), s = Math.cos(r), c = Math.sin(r), l = Math.cos(i), u = Math.sin(i);
		if (e.order === "XYZ") {
			let e = a * l, n = a * u, r = o * l, i = o * u;
			t[0] = s * l, t[4] = -s * u, t[8] = c, t[1] = n + r * c, t[5] = e - i * c, t[9] = -o * s, t[2] = i - e * c, t[6] = r + n * c, t[10] = a * s;
		} else if (e.order === "YXZ") {
			let e = s * l, n = s * u, r = c * l, i = c * u;
			t[0] = e + i * o, t[4] = r * o - n, t[8] = a * c, t[1] = a * u, t[5] = a * l, t[9] = -o, t[2] = n * o - r, t[6] = i + e * o, t[10] = a * s;
		} else if (e.order === "ZXY") {
			let e = s * l, n = s * u, r = c * l, i = c * u;
			t[0] = e - i * o, t[4] = -a * u, t[8] = r + n * o, t[1] = n + r * o, t[5] = a * l, t[9] = i - e * o, t[2] = -a * c, t[6] = o, t[10] = a * s;
		} else if (e.order === "ZYX") {
			let e = a * l, n = a * u, r = o * l, i = o * u;
			t[0] = s * l, t[4] = r * c - n, t[8] = e * c + i, t[1] = s * u, t[5] = i * c + e, t[9] = n * c - r, t[2] = -c, t[6] = o * s, t[10] = a * s;
		} else if (e.order === "YZX") {
			let e = a * s, n = a * c, r = o * s, i = o * c;
			t[0] = s * l, t[4] = i - e * u, t[8] = r * u + n, t[1] = u, t[5] = a * l, t[9] = -o * l, t[2] = -c * l, t[6] = n * u + r, t[10] = e - i * u;
		} else if (e.order === "XZY") {
			let e = a * s, n = a * c, r = o * s, i = o * c;
			t[0] = s * l, t[4] = -u, t[8] = c * l, t[1] = e * u + i, t[5] = a * l, t[9] = n * u - r, t[2] = r * u - n, t[6] = o * l, t[10] = i * u + e;
		}
		return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
	}
	makeRotationFromQuaternion(e) {
		return this.compose($e, e, et);
	}
	lookAt(e, t, n) {
		let r = this.elements;
		return rt.subVectors(e, t), rt.lengthSq() === 0 && (rt.z = 1), rt.normalize(), tt.crossVectors(n, rt), tt.lengthSq() === 0 && (Math.abs(n.z) === 1 ? rt.x += 1e-4 : rt.z += 1e-4, rt.normalize(), tt.crossVectors(n, rt)), tt.normalize(), nt.crossVectors(rt, tt), r[0] = tt.x, r[4] = nt.x, r[8] = rt.x, r[1] = tt.y, r[5] = nt.y, r[9] = rt.y, r[2] = tt.z, r[6] = nt.z, r[10] = rt.z, this;
	}
	multiply(e) {
		return this.multiplyMatrices(this, e);
	}
	premultiply(e) {
		return this.multiplyMatrices(e, this);
	}
	multiplyMatrices(e, t) {
		let n = e.elements, r = t.elements, i = this.elements, a = n[0], o = n[4], s = n[8], c = n[12], l = n[1], u = n[5], d = n[9], f = n[13], p = n[2], m = n[6], h = n[10], g = n[14], _ = n[3], v = n[7], y = n[11], b = n[15], x = r[0], S = r[4], C = r[8], w = r[12], T = r[1], E = r[5], D = r[9], O = r[13], k = r[2], A = r[6], j = r[10], M = r[14], N = r[3], ee = r[7], P = r[11], F = r[15];
		return i[0] = a * x + o * T + s * k + c * N, i[4] = a * S + o * E + s * A + c * ee, i[8] = a * C + o * D + s * j + c * P, i[12] = a * w + o * O + s * M + c * F, i[1] = l * x + u * T + d * k + f * N, i[5] = l * S + u * E + d * A + f * ee, i[9] = l * C + u * D + d * j + f * P, i[13] = l * w + u * O + d * M + f * F, i[2] = p * x + m * T + h * k + g * N, i[6] = p * S + m * E + h * A + g * ee, i[10] = p * C + m * D + h * j + g * P, i[14] = p * w + m * O + h * M + g * F, i[3] = _ * x + v * T + y * k + b * N, i[7] = _ * S + v * E + y * A + b * ee, i[11] = _ * C + v * D + y * j + b * P, i[15] = _ * w + v * O + y * M + b * F, this;
	}
	multiplyScalar(e) {
		let t = this.elements;
		return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
	}
	determinant() {
		let e = this.elements, t = e[0], n = e[4], r = e[8], i = e[12], a = e[1], o = e[5], s = e[9], c = e[13], l = e[2], u = e[6], d = e[10], f = e[14], p = e[3], m = e[7], h = e[11], g = e[15], _ = s * f - c * d, v = o * f - c * u, y = o * d - s * u, b = a * f - c * l, x = a * d - s * l, S = a * u - o * l;
		return t * (m * _ - h * v + g * y) - n * (p * _ - h * b + g * x) + r * (p * v - m * b + g * S) - i * (p * y - m * x + h * S);
	}
	determinantAffine() {
		let e = this.elements, t = e[0], n = e[4], r = e[8], i = e[1], a = e[5], o = e[9], s = e[2], c = e[6], l = e[10];
		return t * (a * l - o * c) - n * (i * l - o * s) + r * (i * c - a * s);
	}
	transpose() {
		let e = this.elements, t;
		return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
	}
	setPosition(e, t, n) {
		let r = this.elements;
		return e.isVector3 ? (r[12] = e.x, r[13] = e.y, r[14] = e.z) : (r[12] = e, r[13] = t, r[14] = n), this;
	}
	invert() {
		let e = this.elements, t = e[0], n = e[1], r = e[2], i = e[3], a = e[4], o = e[5], s = e[6], c = e[7], l = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13], h = e[14], g = e[15], _ = t * o - n * a, v = t * s - r * a, y = t * c - i * a, b = n * s - r * o, x = n * c - i * o, S = r * c - i * s, C = l * m - u * p, w = l * h - d * p, T = l * g - f * p, E = u * h - d * m, D = u * g - f * m, O = d * g - f * h, k = _ * O - v * D + y * E + b * T - x * w + S * C;
		if (k === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
		let A = 1 / k;
		return e[0] = (o * O - s * D + c * E) * A, e[1] = (r * D - n * O - i * E) * A, e[2] = (m * S - h * x + g * b) * A, e[3] = (d * x - u * S - f * b) * A, e[4] = (s * T - a * O - c * w) * A, e[5] = (t * O - r * T + i * w) * A, e[6] = (h * y - p * S - g * v) * A, e[7] = (l * S - d * y + f * v) * A, e[8] = (a * D - o * T + c * C) * A, e[9] = (n * T - t * D - i * C) * A, e[10] = (p * x - m * y + g * _) * A, e[11] = (u * y - l * x - f * _) * A, e[12] = (o * w - a * E - s * C) * A, e[13] = (t * E - n * w + r * C) * A, e[14] = (m * v - p * b - h * _) * A, e[15] = (l * b - u * v + d * _) * A, this;
	}
	scale(e) {
		let t = this.elements, n = e.x, r = e.y, i = e.z;
		return t[0] *= n, t[4] *= r, t[8] *= i, t[1] *= n, t[5] *= r, t[9] *= i, t[2] *= n, t[6] *= r, t[10] *= i, t[3] *= n, t[7] *= r, t[11] *= i, this;
	}
	getMaxScaleOnAxis() {
		let e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], r = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
		return Math.sqrt(Math.max(t, n, r));
	}
	makeTranslation(e, t, n) {
		return e.isVector3 ? this.set(1, 0, 0, e.x, 0, 1, 0, e.y, 0, 0, 1, e.z, 0, 0, 0, 1) : this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this;
	}
	makeRotationX(e) {
		let t = Math.cos(e), n = Math.sin(e);
		return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this;
	}
	makeRotationY(e) {
		let t = Math.cos(e), n = Math.sin(e);
		return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this;
	}
	makeRotationZ(e) {
		let t = Math.cos(e), n = Math.sin(e);
		return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
	}
	makeRotationAxis(e, t) {
		let n = Math.cos(t), r = Math.sin(t), i = 1 - n, a = e.x, o = e.y, s = e.z, c = i * a, l = i * o;
		return this.set(c * a + n, c * o - r * s, c * s + r * o, 0, c * o + r * s, l * o + n, l * s - r * a, 0, c * s - r * o, l * s + r * a, i * s * s + n, 0, 0, 0, 0, 1), this;
	}
	makeScale(e, t, n) {
		return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
	}
	makeShear(e, t, n, r, i, a) {
		return this.set(1, n, i, 0, e, 1, a, 0, t, r, 1, 0, 0, 0, 0, 1), this;
	}
	compose(e, t, n) {
		let r = this.elements, i = t._x, a = t._y, o = t._z, s = t._w, c = i + i, l = a + a, u = o + o, d = i * c, f = i * l, p = i * u, m = a * l, h = a * u, g = o * u, _ = s * c, v = s * l, y = s * u, b = n.x, x = n.y, S = n.z;
		return r[0] = (1 - (m + g)) * b, r[1] = (f + y) * b, r[2] = (p - v) * b, r[3] = 0, r[4] = (f - y) * x, r[5] = (1 - (d + g)) * x, r[6] = (h + _) * x, r[7] = 0, r[8] = (p + v) * S, r[9] = (h - _) * S, r[10] = (1 - (d + m)) * S, r[11] = 0, r[12] = e.x, r[13] = e.y, r[14] = e.z, r[15] = 1, this;
	}
	decompose(e, t, n) {
		let r = this.elements;
		e.x = r[12], e.y = r[13], e.z = r[14];
		let i = this.determinantAffine();
		if (i === 0) return n.set(1, 1, 1), t.identity(), this;
		let a = Ze.set(r[0], r[1], r[2]).length(), o = Ze.set(r[4], r[5], r[6]).length(), s = Ze.set(r[8], r[9], r[10]).length();
		i < 0 && (a = -a), Qe.copy(this);
		let c = 1 / a, l = 1 / o, u = 1 / s;
		return Qe.elements[0] *= c, Qe.elements[1] *= c, Qe.elements[2] *= c, Qe.elements[4] *= l, Qe.elements[5] *= l, Qe.elements[6] *= l, Qe.elements[8] *= u, Qe.elements[9] *= u, Qe.elements[10] *= u, t.setFromRotationMatrix(Qe), n.x = a, n.y = o, n.z = s, this;
	}
	makePerspective(e, t, n, r, i, a, o = ee, s = !1) {
		let c = this.elements, l = 2 * i / (t - e), u = 2 * i / (n - r), d = (t + e) / (t - e), f = (n + r) / (n - r), p, m;
		if (s) p = i / (a - i), m = a * i / (a - i);
		else if (o === 2e3) p = -(a + i) / (a - i), m = -2 * a * i / (a - i);
		else if (o === 2001) p = -a / (a - i), m = -a * i / (a - i);
		else throw Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o);
		return c[0] = l, c[4] = 0, c[8] = d, c[12] = 0, c[1] = 0, c[5] = u, c[9] = f, c[13] = 0, c[2] = 0, c[6] = 0, c[10] = p, c[14] = m, c[3] = 0, c[7] = 0, c[11] = -1, c[15] = 0, this;
	}
	makeOrthographic(e, t, n, r, i, a, o = ee, s = !1) {
		let c = this.elements, l = 2 / (t - e), u = 2 / (n - r), d = -(t + e) / (t - e), f = -(n + r) / (n - r), p, m;
		if (s) p = 1 / (a - i), m = a / (a - i);
		else if (o === 2e3) p = -2 / (a - i), m = -(a + i) / (a - i);
		else if (o === 2001) p = -1 / (a - i), m = -i / (a - i);
		else throw Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o);
		return c[0] = l, c[4] = 0, c[8] = 0, c[12] = d, c[1] = 0, c[5] = u, c[9] = 0, c[13] = f, c[2] = 0, c[6] = 0, c[10] = p, c[14] = m, c[3] = 0, c[7] = 0, c[11] = 0, c[15] = 1, this;
	}
	equals(e) {
		let t = this.elements, n = e.elements;
		for (let e = 0; e < 16; e++) if (t[e] !== n[e]) return !1;
		return !0;
	}
	fromArray(e, t = 0) {
		for (let n = 0; n < 16; n++) this.elements[n] = e[n + t];
		return this;
	}
	toArray(e = [], t = 0) {
		let n = this.elements;
		return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e[t + 9] = n[9], e[t + 10] = n[10], e[t + 11] = n[11], e[t + 12] = n[12], e[t + 13] = n[13], e[t + 14] = n[14], e[t + 15] = n[15], e;
	}
}, Ze = /*@__PURE__*/ new G(), Qe = /*@__PURE__*/ new Xe(), $e = /*@__PURE__*/ new G(0, 0, 0), et = /*@__PURE__*/ new G(1, 1, 1), tt = /*@__PURE__*/ new G(), nt = /*@__PURE__*/ new G(), rt = /*@__PURE__*/ new G(), it = /*@__PURE__*/ new Xe(), at = /*@__PURE__*/ new W(), ot = class e {
	constructor(t = 0, n = 0, r = 0, i = e.DEFAULT_ORDER) {
		this.isEuler = !0, this._x = t, this._y = n, this._z = r, this._order = i;
	}
	get x() {
		return this._x;
	}
	set x(e) {
		this._x = e, this._onChangeCallback();
	}
	get y() {
		return this._y;
	}
	set y(e) {
		this._y = e, this._onChangeCallback();
	}
	get z() {
		return this._z;
	}
	set z(e) {
		this._z = e, this._onChangeCallback();
	}
	get order() {
		return this._order;
	}
	set order(e) {
		this._order = e, this._onChangeCallback();
	}
	set(e, t, n, r = this._order) {
		return this._x = e, this._y = t, this._z = n, this._order = r, this._onChangeCallback(), this;
	}
	clone() {
		return new this.constructor(this._x, this._y, this._z, this._order);
	}
	copy(e) {
		return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
	}
	setFromRotationMatrix(e, t = this._order, n = !0) {
		let r = e.elements, i = r[0], a = r[4], o = r[8], s = r[1], c = r[5], l = r[9], u = r[2], d = r[6], f = r[10];
		switch (t) {
			case "XYZ":
				this._y = Math.asin(V(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-l, f), this._z = Math.atan2(-a, i)) : (this._x = Math.atan2(d, c), this._z = 0);
				break;
			case "YXZ":
				this._x = Math.asin(-V(l, -1, 1)), Math.abs(l) < .9999999 ? (this._y = Math.atan2(o, f), this._z = Math.atan2(s, c)) : (this._y = Math.atan2(-u, i), this._z = 0);
				break;
			case "ZXY":
				this._x = Math.asin(V(d, -1, 1)), Math.abs(d) < .9999999 ? (this._y = Math.atan2(-u, f), this._z = Math.atan2(-a, c)) : (this._y = 0, this._z = Math.atan2(s, i));
				break;
			case "ZYX":
				this._y = Math.asin(-V(u, -1, 1)), Math.abs(u) < .9999999 ? (this._x = Math.atan2(d, f), this._z = Math.atan2(s, i)) : (this._x = 0, this._z = Math.atan2(-a, c));
				break;
			case "YZX":
				this._z = Math.asin(V(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-l, c), this._y = Math.atan2(-u, i)) : (this._x = 0, this._y = Math.atan2(o, f));
				break;
			case "XZY":
				this._z = Math.asin(-V(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(d, c), this._y = Math.atan2(o, i)) : (this._x = Math.atan2(-l, f), this._y = 0);
				break;
			default: L("Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
		}
		return this._order = t, n === !0 && this._onChangeCallback(), this;
	}
	setFromQuaternion(e, t, n) {
		return it.makeRotationFromQuaternion(e), this.setFromRotationMatrix(it, t, n);
	}
	setFromVector3(e, t = this._order) {
		return this.set(e.x, e.y, e.z, t);
	}
	reorder(e) {
		return at.setFromEuler(this), this.setFromQuaternion(at, e);
	}
	equals(e) {
		return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
	}
	fromArray(e) {
		return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
	}
	_onChange(e) {
		return this._onChangeCallback = e, this;
	}
	_onChangeCallback() {}
	*[Symbol.iterator]() {
		yield this._x, yield this._y, yield this._z, yield this._order;
	}
};
ot.DEFAULT_ORDER = "XYZ";
var st = class {
	constructor() {
		this.mask = 1;
	}
	set(e) {
		this.mask = (1 << e | 0) >>> 0;
	}
	enable(e) {
		this.mask |= 1 << e | 0;
	}
	enableAll() {
		this.mask = -1;
	}
	toggle(e) {
		this.mask ^= 1 << e | 0;
	}
	disable(e) {
		this.mask &= ~(1 << e | 0);
	}
	disableAll() {
		this.mask = 0;
	}
	test(e) {
		return (this.mask & e.mask) !== 0;
	}
	isEnabled(e) {
		return (this.mask & (1 << e | 0)) != 0;
	}
}, ct = 0, lt = /*@__PURE__*/ new G(), ut = /*@__PURE__*/ new W(), dt = /*@__PURE__*/ new Xe(), ft = /*@__PURE__*/ new G(), pt = /*@__PURE__*/ new G(), mt = /*@__PURE__*/ new G(), ht = /*@__PURE__*/ new W(), gt = /*@__PURE__*/ new G(1, 0, 0), _t = /*@__PURE__*/ new G(0, 1, 0), vt = /*@__PURE__*/ new G(0, 0, 1), yt = { type: "added" }, bt = { type: "removed" }, xt = {
	type: "childadded",
	child: null
}, St = {
	type: "childremoved",
	child: null
}, Ct = class e extends ce {
	constructor() {
		super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: ct++ }), this.uuid = B(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = e.DEFAULT_UP.clone();
		let t = new G(), n = new ot(), r = new W(), i = new G(1, 1, 1);
		function a() {
			r.setFromEuler(n, !1);
		}
		function o() {
			n.setFromQuaternion(r, void 0, !1);
		}
		n._onChange(a), r._onChange(o), Object.defineProperties(this, {
			position: {
				configurable: !0,
				enumerable: !0,
				value: t
			},
			rotation: {
				configurable: !0,
				enumerable: !0,
				value: n
			},
			quaternion: {
				configurable: !0,
				enumerable: !0,
				value: r
			},
			scale: {
				configurable: !0,
				enumerable: !0,
				value: i
			},
			modelViewMatrix: { value: new Xe() },
			normalMatrix: { value: new K() }
		}), this.matrix = new Xe(), this.matrixWorld = new Xe(), this.matrixAutoUpdate = e.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = e.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new st(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.static = !1, this.userData = {}, this.pivot = null;
	}
	onBeforeShadow() {}
	onAfterShadow() {}
	onBeforeRender() {}
	onAfterRender() {}
	applyMatrix4(e) {
		this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
	}
	applyQuaternion(e) {
		return this.quaternion.premultiply(e), this;
	}
	setRotationFromAxisAngle(e, t) {
		this.quaternion.setFromAxisAngle(e, t);
	}
	setRotationFromEuler(e) {
		this.quaternion.setFromEuler(e, !0);
	}
	setRotationFromMatrix(e) {
		this.quaternion.setFromRotationMatrix(e);
	}
	setRotationFromQuaternion(e) {
		this.quaternion.copy(e);
	}
	rotateOnAxis(e, t) {
		return ut.setFromAxisAngle(e, t), this.quaternion.multiply(ut), this;
	}
	rotateOnWorldAxis(e, t) {
		return ut.setFromAxisAngle(e, t), this.quaternion.premultiply(ut), this;
	}
	rotateX(e) {
		return this.rotateOnAxis(gt, e);
	}
	rotateY(e) {
		return this.rotateOnAxis(_t, e);
	}
	rotateZ(e) {
		return this.rotateOnAxis(vt, e);
	}
	translateOnAxis(e, t) {
		return lt.copy(e).applyQuaternion(this.quaternion), this.position.add(lt.multiplyScalar(t)), this;
	}
	translateX(e) {
		return this.translateOnAxis(gt, e);
	}
	translateY(e) {
		return this.translateOnAxis(_t, e);
	}
	translateZ(e) {
		return this.translateOnAxis(vt, e);
	}
	localToWorld(e) {
		return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
	}
	worldToLocal(e) {
		return this.updateWorldMatrix(!0, !1), e.applyMatrix4(dt.copy(this.matrixWorld).invert());
	}
	lookAt(e, t, n) {
		e.isVector3 ? ft.copy(e) : ft.set(e, t, n);
		let r = this.parent;
		this.updateWorldMatrix(!0, !1), pt.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? dt.lookAt(pt, ft, this.up) : dt.lookAt(ft, pt, this.up), this.quaternion.setFromRotationMatrix(dt), r && (dt.extractRotation(r.matrixWorld), ut.setFromRotationMatrix(dt), this.quaternion.premultiply(ut.invert()));
	}
	add(e) {
		if (arguments.length > 1) {
			for (let e = 0; e < arguments.length; e++) this.add(arguments[e]);
			return this;
		}
		return e === this ? (R("Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent(yt), xt.child = e, this.dispatchEvent(xt), xt.child = null) : R("Object3D.add: object not an instance of THREE.Object3D.", e), this);
	}
	remove(e) {
		if (arguments.length > 1) {
			for (let e = 0; e < arguments.length; e++) this.remove(arguments[e]);
			return this;
		}
		let t = this.children.indexOf(e);
		return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent(bt), St.child = e, this.dispatchEvent(St), St.child = null), this;
	}
	removeFromParent() {
		let e = this.parent;
		return e !== null && e.remove(this), this;
	}
	clear() {
		return this.remove(...this.children);
	}
	attach(e) {
		return this.updateWorldMatrix(!0, !1), dt.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), dt.multiply(e.parent.matrixWorld)), e.applyMatrix4(dt), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent(yt), xt.child = e, this.dispatchEvent(xt), xt.child = null, this;
	}
	getObjectById(e) {
		return this.getObjectByProperty("id", e);
	}
	getObjectByName(e) {
		return this.getObjectByProperty("name", e);
	}
	getObjectByProperty(e, t) {
		if (this[e] === t) return this;
		for (let n = 0, r = this.children.length; n < r; n++) {
			let r = this.children[n].getObjectByProperty(e, t);
			if (r !== void 0) return r;
		}
	}
	getObjectsByProperty(e, t, n = []) {
		this[e] === t && n.push(this);
		let r = this.children;
		for (let i = 0, a = r.length; i < a; i++) r[i].getObjectsByProperty(e, t, n);
		return n;
	}
	getWorldPosition(e) {
		return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
	}
	getWorldQuaternion(e) {
		return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(pt, e, mt), e;
	}
	getWorldScale(e) {
		return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(pt, ht, e), e;
	}
	getWorldDirection(e) {
		this.updateWorldMatrix(!0, !1);
		let t = this.matrixWorld.elements;
		return e.set(t[8], t[9], t[10]).normalize();
	}
	raycast() {}
	traverse(e) {
		e(this);
		let t = this.children;
		for (let n = 0, r = t.length; n < r; n++) t[n].traverse(e);
	}
	traverseVisible(e) {
		if (this.visible === !1) return;
		e(this);
		let t = this.children;
		for (let n = 0, r = t.length; n < r; n++) t[n].traverseVisible(e);
	}
	traverseAncestors(e) {
		let t = this.parent;
		t !== null && (e(t), t.traverseAncestors(e));
	}
	updateMatrix() {
		this.matrix.compose(this.position, this.quaternion, this.scale);
		let e = this.pivot;
		if (e !== null) {
			let t = e.x, n = e.y, r = e.z, i = this.matrix.elements;
			i[12] += t - i[0] * t - i[4] * n - i[8] * r, i[13] += n - i[1] * t - i[5] * n - i[9] * r, i[14] += r - i[2] * t - i[6] * n - i[10] * r;
		}
		this.matrixWorldNeedsUpdate = !0;
	}
	updateMatrixWorld(e) {
		this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
		let t = this.children;
		for (let n = 0, r = t.length; n < r; n++) t[n].updateMatrixWorld(e);
	}
	updateWorldMatrix(e, t, n = !1) {
		let r = this.parent;
		if (e === !0 && r !== null && r.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || n) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, n = !0), t === !0) {
			let e = this.children;
			for (let t = 0, r = e.length; t < r; t++) e[t].updateWorldMatrix(!1, !0, n);
		}
	}
	toJSON(e) {
		let t = e === void 0 || typeof e == "string", n = {};
		t && (e = {
			geometries: {},
			materials: {},
			textures: {},
			images: {},
			shapes: {},
			skeletons: {},
			animations: {},
			nodes: {}
		}, n.metadata = {
			version: 4.7,
			type: "Object",
			generator: "Object3D.toJSON"
		});
		let r = {};
		r.uuid = this.uuid, r.type = this.type, this.name !== "" && (r.name = this.name), this.castShadow === !0 && (r.castShadow = !0), this.receiveShadow === !0 && (r.receiveShadow = !0), this.visible === !1 && (r.visible = !1), this.frustumCulled === !1 && (r.frustumCulled = !1), this.renderOrder !== 0 && (r.renderOrder = this.renderOrder), this.static !== !1 && (r.static = this.static), Object.keys(this.userData).length > 0 && (r.userData = this.userData), r.layers = this.layers.mask, r.matrix = this.matrix.toArray(), r.up = this.up.toArray(), this.pivot !== null && (r.pivot = this.pivot.toArray()), this.matrixAutoUpdate === !1 && (r.matrixAutoUpdate = !1), this.morphTargetDictionary !== void 0 && (r.morphTargetDictionary = Object.assign({}, this.morphTargetDictionary)), this.morphTargetInfluences !== void 0 && (r.morphTargetInfluences = this.morphTargetInfluences.slice()), this.isInstancedMesh && (r.type = "InstancedMesh", r.count = this.count, r.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (r.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (r.type = "BatchedMesh", r.perObjectFrustumCulled = this.perObjectFrustumCulled, r.sortObjects = this.sortObjects, r.drawRanges = this._drawRanges, r.reservedRanges = this._reservedRanges, r.geometryInfo = this._geometryInfo.map((e) => ({
			...e,
			boundingBox: e.boundingBox ? e.boundingBox.toJSON() : void 0,
			boundingSphere: e.boundingSphere ? e.boundingSphere.toJSON() : void 0
		})), r.instanceInfo = this._instanceInfo.map((e) => ({ ...e })), r.availableInstanceIds = this._availableInstanceIds.slice(), r.availableGeometryIds = this._availableGeometryIds.slice(), r.nextIndexStart = this._nextIndexStart, r.nextVertexStart = this._nextVertexStart, r.geometryCount = this._geometryCount, r.maxInstanceCount = this._maxInstanceCount, r.maxVertexCount = this._maxVertexCount, r.maxIndexCount = this._maxIndexCount, r.geometryInitialized = this._geometryInitialized, r.matricesTexture = this._matricesTexture.toJSON(e), r.indirectTexture = this._indirectTexture.toJSON(e), this._colorsTexture !== null && (r.colorsTexture = this._colorsTexture.toJSON(e)), this.boundingSphere !== null && (r.boundingSphere = this.boundingSphere.toJSON()), this.boundingBox !== null && (r.boundingBox = this.boundingBox.toJSON()));
		function i(t, n) {
			return t[n.uuid] === void 0 && (t[n.uuid] = n.toJSON(e)), n.uuid;
		}
		if (this.isScene) this.background && (this.background.isColor ? r.background = this.background.toJSON() : this.background.isTexture && (r.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (r.environment = this.environment.toJSON(e).uuid);
		else if (this.isMesh || this.isLine || this.isPoints) {
			r.geometry = i(e.geometries, this.geometry);
			let t = this.geometry.parameters;
			if (t !== void 0 && t.shapes !== void 0) {
				let n = t.shapes;
				if (Array.isArray(n)) for (let t = 0, r = n.length; t < r; t++) {
					let r = n[t];
					i(e.shapes, r);
				}
				else i(e.shapes, n);
			}
		}
		if (this.isSkinnedMesh && (r.bindMode = this.bindMode, r.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (i(e.skeletons, this.skeleton), r.skeleton = this.skeleton.uuid)), this.material !== void 0) if (Array.isArray(this.material)) {
			let t = [];
			for (let n = 0, r = this.material.length; n < r; n++) t.push(i(e.materials, this.material[n]));
			r.material = t;
		} else r.material = i(e.materials, this.material);
		if (this.children.length > 0) {
			r.children = [];
			for (let t = 0; t < this.children.length; t++) r.children.push(this.children[t].toJSON(e).object);
		}
		if (this.animations.length > 0) {
			r.animations = [];
			for (let t = 0; t < this.animations.length; t++) {
				let n = this.animations[t];
				r.animations.push(i(e.animations, n));
			}
		}
		if (t) {
			let t = a(e.geometries), r = a(e.materials), i = a(e.textures), o = a(e.images), s = a(e.shapes), c = a(e.skeletons), l = a(e.animations), u = a(e.nodes);
			t.length > 0 && (n.geometries = t), r.length > 0 && (n.materials = r), i.length > 0 && (n.textures = i), o.length > 0 && (n.images = o), s.length > 0 && (n.shapes = s), c.length > 0 && (n.skeletons = c), l.length > 0 && (n.animations = l), u.length > 0 && (n.nodes = u);
		}
		return n.object = r, n;
		function a(e) {
			let t = [];
			for (let n in e) {
				let r = e[n];
				delete r.metadata, t.push(r);
			}
			return t;
		}
	}
	clone(e) {
		return new this.constructor().copy(this, e);
	}
	copy(e, t = !0) {
		if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.pivot = e.pivot === null ? null : e.pivot.clone(), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.static = e.static, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0) for (let t = 0; t < e.children.length; t++) {
			let n = e.children[t];
			this.add(n.clone());
		}
		return this;
	}
};
Ct.DEFAULT_UP = /*@__PURE__*/ new G(0, 1, 0), Ct.DEFAULT_MATRIX_AUTO_UPDATE = !0, Ct.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
var wt = class extends Ct {
	constructor() {
		super(), this.isGroup = !0, this.type = "Group";
	}
}, Tt = { type: "move" }, Et = class {
	constructor() {
		this._targetRay = null, this._grip = null, this._hand = null;
	}
	getHandSpace() {
		return this._hand === null && (this._hand = new wt(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
	}
	getTargetRaySpace() {
		return this._targetRay === null && (this._targetRay = new wt(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new G(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new G()), this._targetRay;
	}
	getGripSpace() {
		return this._grip === null && (this._grip = new wt(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new G(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new G(), this._grip.eventsEnabled = !1), this._grip;
	}
	dispatchEvent(e) {
		return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
	}
	connect(e) {
		if (e && e.hand) {
			let t = this._hand;
			if (t) for (let n of e.hand.values()) this._getHandJoint(t, n);
		}
		return this.dispatchEvent({
			type: "connected",
			data: e
		}), this;
	}
	disconnect(e) {
		return this.dispatchEvent({
			type: "disconnected",
			data: e
		}), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
	}
	update(e, t, n) {
		let r = null, i = null, a = null, o = this._targetRay, s = this._grip, c = this._hand;
		if (e && t.session.visibilityState !== "visible-blurred") {
			if (c && e.hand) {
				a = !0;
				for (let r of e.hand.values()) {
					let e = t.getJointPose(r, n), i = this._getHandJoint(c, r);
					e !== null && (i.matrix.fromArray(e.transform.matrix), i.matrix.decompose(i.position, i.rotation, i.scale), i.matrixWorldNeedsUpdate = !0, i.jointRadius = e.radius), i.visible = e !== null;
				}
				let r = c.joints["index-finger-tip"], i = c.joints["thumb-tip"], o = r.position.distanceTo(i.position);
				c.inputState.pinching && o > .025 ? (c.inputState.pinching = !1, this.dispatchEvent({
					type: "pinchend",
					handedness: e.handedness,
					target: this
				})) : !c.inputState.pinching && o <= .015 && (c.inputState.pinching = !0, this.dispatchEvent({
					type: "pinchstart",
					handedness: e.handedness,
					target: this
				}));
			} else s !== null && e.gripSpace && (i = t.getPose(e.gripSpace, n), i !== null && (s.matrix.fromArray(i.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(i.linearVelocity)) : s.hasLinearVelocity = !1, i.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(i.angularVelocity)) : s.hasAngularVelocity = !1, s.eventsEnabled && s.dispatchEvent({
				type: "gripUpdated",
				data: e,
				target: this
			})));
			o !== null && (r = t.getPose(e.targetRaySpace, n), r === null && i !== null && (r = i), r !== null && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1, this.dispatchEvent(Tt)));
		}
		return o !== null && (o.visible = r !== null), s !== null && (s.visible = i !== null), c !== null && (c.visible = a !== null), this;
	}
	_getHandJoint(e, t) {
		if (e.joints[t.jointName] === void 0) {
			let n = new wt();
			n.matrixAutoUpdate = !1, n.visible = !1, e.joints[t.jointName] = n, e.add(n);
		}
		return e.joints[t.jointName];
	}
}, Dt = {
	aliceblue: 15792383,
	antiquewhite: 16444375,
	aqua: 65535,
	aquamarine: 8388564,
	azure: 15794175,
	beige: 16119260,
	bisque: 16770244,
	black: 0,
	blanchedalmond: 16772045,
	blue: 255,
	blueviolet: 9055202,
	brown: 10824234,
	burlywood: 14596231,
	cadetblue: 6266528,
	chartreuse: 8388352,
	chocolate: 13789470,
	coral: 16744272,
	cornflowerblue: 6591981,
	cornsilk: 16775388,
	crimson: 14423100,
	cyan: 65535,
	darkblue: 139,
	darkcyan: 35723,
	darkgoldenrod: 12092939,
	darkgray: 11119017,
	darkgreen: 25600,
	darkgrey: 11119017,
	darkkhaki: 12433259,
	darkmagenta: 9109643,
	darkolivegreen: 5597999,
	darkorange: 16747520,
	darkorchid: 10040012,
	darkred: 9109504,
	darksalmon: 15308410,
	darkseagreen: 9419919,
	darkslateblue: 4734347,
	darkslategray: 3100495,
	darkslategrey: 3100495,
	darkturquoise: 52945,
	darkviolet: 9699539,
	deeppink: 16716947,
	deepskyblue: 49151,
	dimgray: 6908265,
	dimgrey: 6908265,
	dodgerblue: 2003199,
	firebrick: 11674146,
	floralwhite: 16775920,
	forestgreen: 2263842,
	fuchsia: 16711935,
	gainsboro: 14474460,
	ghostwhite: 16316671,
	gold: 16766720,
	goldenrod: 14329120,
	gray: 8421504,
	green: 32768,
	greenyellow: 11403055,
	grey: 8421504,
	honeydew: 15794160,
	hotpink: 16738740,
	indianred: 13458524,
	indigo: 4915330,
	ivory: 16777200,
	khaki: 15787660,
	lavender: 15132410,
	lavenderblush: 16773365,
	lawngreen: 8190976,
	lemonchiffon: 16775885,
	lightblue: 11393254,
	lightcoral: 15761536,
	lightcyan: 14745599,
	lightgoldenrodyellow: 16448210,
	lightgray: 13882323,
	lightgreen: 9498256,
	lightgrey: 13882323,
	lightpink: 16758465,
	lightsalmon: 16752762,
	lightseagreen: 2142890,
	lightskyblue: 8900346,
	lightslategray: 7833753,
	lightslategrey: 7833753,
	lightsteelblue: 11584734,
	lightyellow: 16777184,
	lime: 65280,
	limegreen: 3329330,
	linen: 16445670,
	magenta: 16711935,
	maroon: 8388608,
	mediumaquamarine: 6737322,
	mediumblue: 205,
	mediumorchid: 12211667,
	mediumpurple: 9662683,
	mediumseagreen: 3978097,
	mediumslateblue: 8087790,
	mediumspringgreen: 64154,
	mediumturquoise: 4772300,
	mediumvioletred: 13047173,
	midnightblue: 1644912,
	mintcream: 16121850,
	mistyrose: 16770273,
	moccasin: 16770229,
	navajowhite: 16768685,
	navy: 128,
	oldlace: 16643558,
	olive: 8421376,
	olivedrab: 7048739,
	orange: 16753920,
	orangered: 16729344,
	orchid: 14315734,
	palegoldenrod: 15657130,
	palegreen: 10025880,
	paleturquoise: 11529966,
	palevioletred: 14381203,
	papayawhip: 16773077,
	peachpuff: 16767673,
	peru: 13468991,
	pink: 16761035,
	plum: 14524637,
	powderblue: 11591910,
	purple: 8388736,
	rebeccapurple: 6697881,
	red: 16711680,
	rosybrown: 12357519,
	royalblue: 4286945,
	saddlebrown: 9127187,
	salmon: 16416882,
	sandybrown: 16032864,
	seagreen: 3050327,
	seashell: 16774638,
	sienna: 10506797,
	silver: 12632256,
	skyblue: 8900331,
	slateblue: 6970061,
	slategray: 7372944,
	slategrey: 7372944,
	snow: 16775930,
	springgreen: 65407,
	steelblue: 4620980,
	tan: 13808780,
	teal: 32896,
	thistle: 14204888,
	tomato: 16737095,
	turquoise: 4251856,
	violet: 15631086,
	wheat: 16113331,
	white: 16777215,
	whitesmoke: 16119285,
	yellow: 16776960,
	yellowgreen: 10145074
}, Ot = {
	h: 0,
	s: 0,
	l: 0
}, kt = {
	h: 0,
	s: 0,
	l: 0
};
function At(e, t, n) {
	return n < 0 && (n += 1), n > 1 && --n, n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * 6 * (2 / 3 - n) : e;
}
var Z = class {
	constructor(e, t, n) {
		return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, t, n);
	}
	set(e, t, n) {
		if (t === void 0 && n === void 0) {
			let t = e;
			t && t.isColor ? this.copy(t) : typeof t == "number" ? this.setHex(t) : typeof t == "string" && this.setStyle(t);
		} else this.setRGB(e, t, n);
		return this;
	}
	setScalar(e) {
		return this.r = e, this.g = e, this.b = e, this;
	}
	setHex(e, t = O) {
		return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, X.colorSpaceToWorking(this, t), this;
	}
	setRGB(e, t, n, r = X.workingColorSpace) {
		return this.r = e, this.g = t, this.b = n, X.colorSpaceToWorking(this, r), this;
	}
	setHSL(e, t, n, r = X.workingColorSpace) {
		if (e = fe(e, 1), t = V(t, 0, 1), n = V(n, 0, 1), t === 0) this.r = this.g = this.b = n;
		else {
			let r = n <= .5 ? n * (1 + t) : n + t - n * t, i = 2 * n - r;
			this.r = At(i, r, e + 1 / 3), this.g = At(i, r, e), this.b = At(i, r, e - 1 / 3);
		}
		return X.colorSpaceToWorking(this, r), this;
	}
	setStyle(e, t = O) {
		function n(t) {
			t !== void 0 && parseFloat(t) < 1 && L("Color: Alpha component of " + e + " will be ignored.");
		}
		let r;
		if (r = /^(\w+)\(([^\)]*)\)/.exec(e)) {
			let i, a = r[1], o = r[2];
			switch (a) {
				case "rgb":
				case "rgba":
					if (i = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) return n(i[4]), this.setRGB(Math.min(255, parseInt(i[1], 10)) / 255, Math.min(255, parseInt(i[2], 10)) / 255, Math.min(255, parseInt(i[3], 10)) / 255, t);
					if (i = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) return n(i[4]), this.setRGB(Math.min(100, parseInt(i[1], 10)) / 100, Math.min(100, parseInt(i[2], 10)) / 100, Math.min(100, parseInt(i[3], 10)) / 100, t);
					break;
				case "hsl":
				case "hsla":
					if (i = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) return n(i[4]), this.setHSL(parseFloat(i[1]) / 360, parseFloat(i[2]) / 100, parseFloat(i[3]) / 100, t);
					break;
				default: L("Color: Unknown color model " + e);
			}
		} else if (r = /^\#([A-Fa-f\d]+)$/.exec(e)) {
			let n = r[1], i = n.length;
			if (i === 3) return this.setRGB(parseInt(n.charAt(0), 16) / 15, parseInt(n.charAt(1), 16) / 15, parseInt(n.charAt(2), 16) / 15, t);
			if (i === 6) return this.setHex(parseInt(n, 16), t);
			L("Color: Invalid hex color " + e);
		} else if (e && e.length > 0) return this.setColorName(e, t);
		return this;
	}
	setColorName(e, t = O) {
		let n = Dt[e.toLowerCase()];
		return n === void 0 ? L("Color: Unknown color " + e) : this.setHex(n, t), this;
	}
	clone() {
		return new this.constructor(this.r, this.g, this.b);
	}
	copy(e) {
		return this.r = e.r, this.g = e.g, this.b = e.b, this;
	}
	copySRGBToLinear(e) {
		return this.r = Fe(e.r), this.g = Fe(e.g), this.b = Fe(e.b), this;
	}
	copyLinearToSRGB(e) {
		return this.r = Ie(e.r), this.g = Ie(e.g), this.b = Ie(e.b), this;
	}
	convertSRGBToLinear() {
		return this.copySRGBToLinear(this), this;
	}
	convertLinearToSRGB() {
		return this.copyLinearToSRGB(this), this;
	}
	getHex(e = O) {
		return X.workingToColorSpace(jt.copy(this), e), Math.round(V(jt.r * 255, 0, 255)) * 65536 + Math.round(V(jt.g * 255, 0, 255)) * 256 + Math.round(V(jt.b * 255, 0, 255));
	}
	getHexString(e = O) {
		return ("000000" + this.getHex(e).toString(16)).slice(-6);
	}
	getHSL(e, t = X.workingColorSpace) {
		X.workingToColorSpace(jt.copy(this), t);
		let n = jt.r, r = jt.g, i = jt.b, a = Math.max(n, r, i), o = Math.min(n, r, i), s, c, l = (o + a) / 2;
		if (o === a) s = 0, c = 0;
		else {
			let e = a - o;
			switch (c = l <= .5 ? e / (a + o) : e / (2 - a - o), a) {
				case n:
					s = (r - i) / e + (r < i ? 6 : 0);
					break;
				case r:
					s = (i - n) / e + 2;
					break;
				case i:
					s = (n - r) / e + 4;
					break;
			}
			s /= 6;
		}
		return e.h = s, e.s = c, e.l = l, e;
	}
	getRGB(e, t = X.workingColorSpace) {
		return X.workingToColorSpace(jt.copy(this), t), e.r = jt.r, e.g = jt.g, e.b = jt.b, e;
	}
	getStyle(e = O) {
		X.workingToColorSpace(jt.copy(this), e);
		let t = jt.r, n = jt.g, r = jt.b;
		return e === "srgb" ? `rgb(${Math.round(t * 255)},${Math.round(n * 255)},${Math.round(r * 255)})` : `color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${r.toFixed(3)})`;
	}
	offsetHSL(e, t, n) {
		return this.getHSL(Ot), this.setHSL(Ot.h + e, Ot.s + t, Ot.l + n);
	}
	add(e) {
		return this.r += e.r, this.g += e.g, this.b += e.b, this;
	}
	addColors(e, t) {
		return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
	}
	addScalar(e) {
		return this.r += e, this.g += e, this.b += e, this;
	}
	sub(e) {
		return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
	}
	multiply(e) {
		return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
	}
	multiplyScalar(e) {
		return this.r *= e, this.g *= e, this.b *= e, this;
	}
	lerp(e, t) {
		return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
	}
	lerpColors(e, t, n) {
		return this.r = e.r + (t.r - e.r) * n, this.g = e.g + (t.g - e.g) * n, this.b = e.b + (t.b - e.b) * n, this;
	}
	lerpHSL(e, t) {
		this.getHSL(Ot), e.getHSL(kt);
		let n = he(Ot.h, kt.h, t), r = he(Ot.s, kt.s, t), i = he(Ot.l, kt.l, t);
		return this.setHSL(n, r, i), this;
	}
	setFromVector3(e) {
		return this.r = e.x, this.g = e.y, this.b = e.z, this;
	}
	applyMatrix3(e) {
		let t = this.r, n = this.g, r = this.b, i = e.elements;
		return this.r = i[0] * t + i[3] * n + i[6] * r, this.g = i[1] * t + i[4] * n + i[7] * r, this.b = i[2] * t + i[5] * n + i[8] * r, this;
	}
	equals(e) {
		return e.r === this.r && e.g === this.g && e.b === this.b;
	}
	fromArray(e, t = 0) {
		return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
	}
	fromBufferAttribute(e, t) {
		return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
	}
	toJSON() {
		return this.getHex();
	}
	*[Symbol.iterator]() {
		yield this.r, yield this.g, yield this.b;
	}
}, jt = /*@__PURE__*/ new Z();
Z.NAMES = Dt;
var Mt = class extends Ct {
	constructor() {
		super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new ot(), this.environmentIntensity = 1, this.environmentRotation = new ot(), this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
	}
	copy(e, t) {
		return super.copy(e, t), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, this.backgroundRotation.copy(e.backgroundRotation), this.environmentIntensity = e.environmentIntensity, this.environmentRotation.copy(e.environmentRotation), e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return this.fog !== null && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (t.object.backgroundIntensity = this.backgroundIntensity), t.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (t.object.environmentIntensity = this.environmentIntensity), t.object.environmentRotation = this.environmentRotation.toArray(), t;
	}
}, Nt = /*@__PURE__*/ new G(), Pt = /*@__PURE__*/ new G(), Ft = /*@__PURE__*/ new G(), It = /*@__PURE__*/ new G(), Lt = /*@__PURE__*/ new G(), Rt = /*@__PURE__*/ new G(), zt = /*@__PURE__*/ new G(), Bt = /*@__PURE__*/ new G(), Vt = /*@__PURE__*/ new G(), Ht = /*@__PURE__*/ new G(), Ut = /*@__PURE__*/ new Ge(), Wt = /*@__PURE__*/ new Ge(), Gt = /*@__PURE__*/ new Ge(), Kt = class e {
	constructor(e = new G(), t = new G(), n = new G()) {
		this.a = e, this.b = t, this.c = n;
	}
	static getNormal(e, t, n, r) {
		r.subVectors(n, t), Nt.subVectors(e, t), r.cross(Nt);
		let i = r.lengthSq();
		return i > 0 ? r.multiplyScalar(1 / Math.sqrt(i)) : r.set(0, 0, 0);
	}
	static getBarycoord(e, t, n, r, i) {
		Nt.subVectors(r, t), Pt.subVectors(n, t), Ft.subVectors(e, t);
		let a = Nt.dot(Nt), o = Nt.dot(Pt), s = Nt.dot(Ft), c = Pt.dot(Pt), l = Pt.dot(Ft), u = a * c - o * o;
		if (u === 0) return i.set(0, 0, 0), null;
		let d = 1 / u, f = (c * s - o * l) * d, p = (a * l - o * s) * d;
		return i.set(1 - f - p, p, f);
	}
	static containsPoint(e, t, n, r) {
		return this.getBarycoord(e, t, n, r, It) !== null && It.x >= 0 && It.y >= 0 && It.x + It.y <= 1;
	}
	static getInterpolation(e, t, n, r, i, a, o, s) {
		return this.getBarycoord(e, t, n, r, It) === null ? (s.x = 0, s.y = 0, "z" in s && (s.z = 0), "w" in s && (s.w = 0), null) : (s.setScalar(0), s.addScaledVector(i, It.x), s.addScaledVector(a, It.y), s.addScaledVector(o, It.z), s);
	}
	static getInterpolatedAttribute(e, t, n, r, i, a) {
		return Ut.setScalar(0), Wt.setScalar(0), Gt.setScalar(0), Ut.fromBufferAttribute(e, t), Wt.fromBufferAttribute(e, n), Gt.fromBufferAttribute(e, r), a.setScalar(0), a.addScaledVector(Ut, i.x), a.addScaledVector(Wt, i.y), a.addScaledVector(Gt, i.z), a;
	}
	static isFrontFacing(e, t, n, r) {
		return Nt.subVectors(n, t), Pt.subVectors(e, t), Nt.cross(Pt).dot(r) < 0;
	}
	set(e, t, n) {
		return this.a.copy(e), this.b.copy(t), this.c.copy(n), this;
	}
	setFromPointsAndIndices(e, t, n, r) {
		return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[r]), this;
	}
	setFromAttributeAndIndices(e, t, n, r) {
		return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, n), this.c.fromBufferAttribute(e, r), this;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
	}
	getArea() {
		return Nt.subVectors(this.c, this.b), Pt.subVectors(this.a, this.b), Nt.cross(Pt).length() * .5;
	}
	getMidpoint(e) {
		return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
	}
	getNormal(t) {
		return e.getNormal(this.a, this.b, this.c, t);
	}
	getPlane(e) {
		return e.setFromCoplanarPoints(this.a, this.b, this.c);
	}
	getBarycoord(t, n) {
		return e.getBarycoord(t, this.a, this.b, this.c, n);
	}
	getInterpolation(t, n, r, i, a) {
		return e.getInterpolation(t, this.a, this.b, this.c, n, r, i, a);
	}
	containsPoint(t) {
		return e.containsPoint(t, this.a, this.b, this.c);
	}
	isFrontFacing(t) {
		return e.isFrontFacing(this.a, this.b, this.c, t);
	}
	intersectsBox(e) {
		return e.intersectsTriangle(this);
	}
	closestPointToPoint(e, t) {
		let n = this.a, r = this.b, i = this.c, a, o;
		Lt.subVectors(r, n), Rt.subVectors(i, n), Bt.subVectors(e, n);
		let s = Lt.dot(Bt), c = Rt.dot(Bt);
		if (s <= 0 && c <= 0) return t.copy(n);
		Vt.subVectors(e, r);
		let l = Lt.dot(Vt), u = Rt.dot(Vt);
		if (l >= 0 && u <= l) return t.copy(r);
		let d = s * u - l * c;
		if (d <= 0 && s >= 0 && l <= 0) return a = s / (s - l), t.copy(n).addScaledVector(Lt, a);
		Ht.subVectors(e, i);
		let f = Lt.dot(Ht), p = Rt.dot(Ht);
		if (p >= 0 && f <= p) return t.copy(i);
		let m = f * c - s * p;
		if (m <= 0 && c >= 0 && p <= 0) return o = c / (c - p), t.copy(n).addScaledVector(Rt, o);
		let h = l * p - f * u;
		if (h <= 0 && u - l >= 0 && f - p >= 0) return zt.subVectors(i, r), o = (u - l) / (u - l + (f - p)), t.copy(r).addScaledVector(zt, o);
		let g = 1 / (h + m + d);
		return a = m * g, o = d * g, t.copy(n).addScaledVector(Lt, a).addScaledVector(Rt, o);
	}
	equals(e) {
		return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
	}
}, qt = class {
	constructor(e = new G(Infinity, Infinity, Infinity), t = new G(-Infinity, -Infinity, -Infinity)) {
		this.isBox3 = !0, this.min = e, this.max = t;
	}
	set(e, t) {
		return this.min.copy(e), this.max.copy(t), this;
	}
	setFromArray(e) {
		this.makeEmpty();
		for (let t = 0, n = e.length; t < n; t += 3) this.expandByPoint(Yt.fromArray(e, t));
		return this;
	}
	setFromBufferAttribute(e) {
		this.makeEmpty();
		for (let t = 0, n = e.count; t < n; t++) this.expandByPoint(Yt.fromBufferAttribute(e, t));
		return this;
	}
	setFromPoints(e) {
		this.makeEmpty();
		for (let t = 0, n = e.length; t < n; t++) this.expandByPoint(e[t]);
		return this;
	}
	setFromCenterAndSize(e, t) {
		let n = Yt.copy(t).multiplyScalar(.5);
		return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
	}
	setFromObject(e, t = !1) {
		return this.makeEmpty(), this.expandByObject(e, t);
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		return this.min.copy(e.min), this.max.copy(e.max), this;
	}
	makeEmpty() {
		return this.min.x = this.min.y = this.min.z = Infinity, this.max.x = this.max.y = this.max.z = -Infinity, this;
	}
	isEmpty() {
		return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
	}
	getCenter(e) {
		return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(.5);
	}
	getSize(e) {
		return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
	}
	expandByPoint(e) {
		return this.min.min(e), this.max.max(e), this;
	}
	expandByVector(e) {
		return this.min.sub(e), this.max.add(e), this;
	}
	expandByScalar(e) {
		return this.min.addScalar(-e), this.max.addScalar(e), this;
	}
	expandByObject(e, t = !1) {
		e.updateWorldMatrix(!1, !1);
		let n = e.geometry;
		if (n !== void 0) {
			let r = n.getAttribute("position");
			if (t === !0 && r !== void 0 && e.isInstancedMesh !== !0) for (let t = 0, n = r.count; t < n; t++) e.isMesh === !0 ? e.getVertexPosition(t, Yt) : Yt.fromBufferAttribute(r, t), Yt.applyMatrix4(e.matrixWorld), this.expandByPoint(Yt);
			else e.boundingBox === void 0 ? (n.boundingBox === null && n.computeBoundingBox(), Xt.copy(n.boundingBox)) : (e.boundingBox === null && e.computeBoundingBox(), Xt.copy(e.boundingBox)), Xt.applyMatrix4(e.matrixWorld), this.union(Xt);
		}
		let r = e.children;
		for (let e = 0, n = r.length; e < n; e++) this.expandByObject(r[e], t);
		return this;
	}
	containsPoint(e) {
		return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
	}
	containsBox(e) {
		return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
	}
	getParameter(e, t) {
		return t.set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y), (e.z - this.min.z) / (this.max.z - this.min.z));
	}
	intersectsBox(e) {
		return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
	}
	intersectsSphere(e) {
		return this.clampPoint(e.center, Yt), Yt.distanceToSquared(e.center) <= e.radius * e.radius;
	}
	intersectsPlane(e) {
		let t, n;
		return e.normal.x > 0 ? (t = e.normal.x * this.min.x, n = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, n = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, n += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, n += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, n += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, n += e.normal.z * this.min.z), t <= -e.constant && n >= -e.constant;
	}
	intersectsTriangle(e) {
		if (this.isEmpty()) return !1;
		this.getCenter(rn), an.subVectors(this.max, rn), Zt.subVectors(e.a, rn), Qt.subVectors(e.b, rn), $t.subVectors(e.c, rn), en.subVectors(Qt, Zt), tn.subVectors($t, Qt), nn.subVectors(Zt, $t);
		let t = [
			0,
			-en.z,
			en.y,
			0,
			-tn.z,
			tn.y,
			0,
			-nn.z,
			nn.y,
			en.z,
			0,
			-en.x,
			tn.z,
			0,
			-tn.x,
			nn.z,
			0,
			-nn.x,
			-en.y,
			en.x,
			0,
			-tn.y,
			tn.x,
			0,
			-nn.y,
			nn.x,
			0
		];
		return !cn(t, Zt, Qt, $t, an) || (t = [
			1,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			1
		], !cn(t, Zt, Qt, $t, an)) ? !1 : (on.crossVectors(en, tn), t = [
			on.x,
			on.y,
			on.z
		], cn(t, Zt, Qt, $t, an));
	}
	clampPoint(e, t) {
		return t.copy(e).clamp(this.min, this.max);
	}
	distanceToPoint(e) {
		return this.clampPoint(e, Yt).distanceTo(e);
	}
	getBoundingSphere(e) {
		return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize(Yt).length() * .5), e;
	}
	intersect(e) {
		return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
	}
	union(e) {
		return this.min.min(e.min), this.max.max(e.max), this;
	}
	applyMatrix4(e) {
		return this.isEmpty() ? this : (Jt[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), Jt[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), Jt[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), Jt[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), Jt[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), Jt[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), Jt[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), Jt[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(Jt), this);
	}
	translate(e) {
		return this.min.add(e), this.max.add(e), this;
	}
	equals(e) {
		return e.min.equals(this.min) && e.max.equals(this.max);
	}
	toJSON() {
		return {
			min: this.min.toArray(),
			max: this.max.toArray()
		};
	}
	fromJSON(e) {
		return this.min.fromArray(e.min), this.max.fromArray(e.max), this;
	}
}, Jt = [
	/*@__PURE__*/ new G(),
	/*@__PURE__*/ new G(),
	/*@__PURE__*/ new G(),
	/*@__PURE__*/ new G(),
	/*@__PURE__*/ new G(),
	/*@__PURE__*/ new G(),
	/*@__PURE__*/ new G(),
	/*@__PURE__*/ new G()
], Yt = /*@__PURE__*/ new G(), Xt = /*@__PURE__*/ new qt(), Zt = /*@__PURE__*/ new G(), Qt = /*@__PURE__*/ new G(), $t = /*@__PURE__*/ new G(), en = /*@__PURE__*/ new G(), tn = /*@__PURE__*/ new G(), nn = /*@__PURE__*/ new G(), rn = /*@__PURE__*/ new G(), an = /*@__PURE__*/ new G(), on = /*@__PURE__*/ new G(), sn = /*@__PURE__*/ new G();
function cn(e, t, n, r, i) {
	for (let a = 0, o = e.length - 3; a <= o; a += 3) {
		sn.fromArray(e, a);
		let o = i.x * Math.abs(sn.x) + i.y * Math.abs(sn.y) + i.z * Math.abs(sn.z), s = t.dot(sn), c = n.dot(sn), l = r.dot(sn);
		if (Math.max(-Math.max(s, c, l), Math.min(s, c, l)) > o) return !1;
	}
	return !0;
}
var ln = /*@__PURE__*/ new G(), un = /*@__PURE__*/ new U(), dn = 0, fn = class extends ce {
	constructor(e, t, n = !1) {
		if (super(), Array.isArray(e)) throw TypeError("THREE.BufferAttribute: array should be a Typed Array.");
		this.isBufferAttribute = !0, Object.defineProperty(this, "id", { value: dn++ }), this.name = "", this.array = e, this.itemSize = t, this.count = e === void 0 ? 0 : e.length / t, this.normalized = n, this.usage = N, this.updateRanges = [], this.gpuType = l, this.version = 0;
	}
	onUploadCallback() {}
	set needsUpdate(e) {
		e === !0 && this.version++;
	}
	setUsage(e) {
		return this.usage = e, this;
	}
	addUpdateRange(e, t) {
		this.updateRanges.push({
			start: e,
			count: t
		});
	}
	clearUpdateRanges() {
		this.updateRanges.length = 0;
	}
	copy(e) {
		return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
	}
	copyAt(e, t, n) {
		e *= this.itemSize, n *= t.itemSize;
		for (let r = 0, i = this.itemSize; r < i; r++) this.array[e + r] = t.array[n + r];
		return this;
	}
	copyArray(e) {
		return this.array.set(e), this;
	}
	applyMatrix3(e) {
		if (this.itemSize === 2) for (let t = 0, n = this.count; t < n; t++) un.fromBufferAttribute(this, t), un.applyMatrix3(e), this.setXY(t, un.x, un.y);
		else if (this.itemSize === 3) for (let t = 0, n = this.count; t < n; t++) ln.fromBufferAttribute(this, t), ln.applyMatrix3(e), this.setXYZ(t, ln.x, ln.y, ln.z);
		return this;
	}
	applyMatrix4(e) {
		for (let t = 0, n = this.count; t < n; t++) ln.fromBufferAttribute(this, t), ln.applyMatrix4(e), this.setXYZ(t, ln.x, ln.y, ln.z);
		return this;
	}
	applyNormalMatrix(e) {
		for (let t = 0, n = this.count; t < n; t++) ln.fromBufferAttribute(this, t), ln.applyNormalMatrix(e), this.setXYZ(t, ln.x, ln.y, ln.z);
		return this;
	}
	transformDirection(e) {
		for (let t = 0, n = this.count; t < n; t++) ln.fromBufferAttribute(this, t), ln.transformDirection(e), this.setXYZ(t, ln.x, ln.y, ln.z);
		return this;
	}
	set(e, t = 0) {
		return this.array.set(e, t), this;
	}
	getComponent(e, t) {
		let n = this.array[e * this.itemSize + t];
		return this.normalized && (n = Ae(n, this.array)), n;
	}
	setComponent(e, t, n) {
		return this.normalized && (n = H(n, this.array)), this.array[e * this.itemSize + t] = n, this;
	}
	getX(e) {
		let t = this.array[e * this.itemSize];
		return this.normalized && (t = Ae(t, this.array)), t;
	}
	setX(e, t) {
		return this.normalized && (t = H(t, this.array)), this.array[e * this.itemSize] = t, this;
	}
	getY(e) {
		let t = this.array[e * this.itemSize + 1];
		return this.normalized && (t = Ae(t, this.array)), t;
	}
	setY(e, t) {
		return this.normalized && (t = H(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
	}
	getZ(e) {
		let t = this.array[e * this.itemSize + 2];
		return this.normalized && (t = Ae(t, this.array)), t;
	}
	setZ(e, t) {
		return this.normalized && (t = H(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
	}
	getW(e) {
		let t = this.array[e * this.itemSize + 3];
		return this.normalized && (t = Ae(t, this.array)), t;
	}
	setW(e, t) {
		return this.normalized && (t = H(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
	}
	setXY(e, t, n) {
		return e *= this.itemSize, this.normalized && (t = H(t, this.array), n = H(n, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this;
	}
	setXYZ(e, t, n, r) {
		return e *= this.itemSize, this.normalized && (t = H(t, this.array), n = H(n, this.array), r = H(r, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = r, this;
	}
	setXYZW(e, t, n, r, i) {
		return e *= this.itemSize, this.normalized && (t = H(t, this.array), n = H(n, this.array), r = H(r, this.array), i = H(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = r, this.array[e + 3] = i, this;
	}
	onUpload(e) {
		return this.onUploadCallback = e, this;
	}
	clone() {
		return new this.constructor(this.array, this.itemSize).copy(this);
	}
	toJSON() {
		let e = {
			itemSize: this.itemSize,
			type: this.array.constructor.name,
			array: Array.from(this.array),
			normalized: this.normalized
		};
		return this.name !== "" && (e.name = this.name), this.usage !== 35044 && (e.usage = this.usage), e;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
}, pn = class extends fn {
	constructor(e, t, n) {
		super(new Uint16Array(e), t, n);
	}
}, mn = class extends fn {
	constructor(e, t, n) {
		super(new Uint32Array(e), t, n);
	}
}, hn = class extends fn {
	constructor(e, t, n) {
		super(new Float32Array(e), t, n);
	}
}, gn = /*@__PURE__*/ new qt(), _n = /*@__PURE__*/ new G(), vn = /*@__PURE__*/ new G(), yn = class {
	constructor(e = new G(), t = -1) {
		this.isSphere = !0, this.center = e, this.radius = t;
	}
	set(e, t) {
		return this.center.copy(e), this.radius = t, this;
	}
	setFromPoints(e, t) {
		let n = this.center;
		t === void 0 ? gn.setFromPoints(e).getCenter(n) : n.copy(t);
		let r = 0;
		for (let t = 0, i = e.length; t < i; t++) r = Math.max(r, n.distanceToSquared(e[t]));
		return this.radius = Math.sqrt(r), this;
	}
	copy(e) {
		return this.center.copy(e.center), this.radius = e.radius, this;
	}
	isEmpty() {
		return this.radius < 0;
	}
	makeEmpty() {
		return this.center.set(0, 0, 0), this.radius = -1, this;
	}
	containsPoint(e) {
		return e.distanceToSquared(this.center) <= this.radius * this.radius;
	}
	distanceToPoint(e) {
		return e.distanceTo(this.center) - this.radius;
	}
	intersectsSphere(e) {
		let t = this.radius + e.radius;
		return e.center.distanceToSquared(this.center) <= t * t;
	}
	intersectsBox(e) {
		return e.intersectsSphere(this);
	}
	intersectsPlane(e) {
		return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
	}
	clampPoint(e, t) {
		let n = this.center.distanceToSquared(e);
		return t.copy(e), n > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
	}
	getBoundingBox(e) {
		return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
	}
	applyMatrix4(e) {
		return this.center.applyMatrix4(e), this.radius *= e.getMaxScaleOnAxis(), this;
	}
	translate(e) {
		return this.center.add(e), this;
	}
	expandByPoint(e) {
		if (this.isEmpty()) return this.center.copy(e), this.radius = 0, this;
		_n.subVectors(e, this.center);
		let t = _n.lengthSq();
		if (t > this.radius * this.radius) {
			let e = Math.sqrt(t), n = (e - this.radius) * .5;
			this.center.addScaledVector(_n, n / e), this.radius += n;
		}
		return this;
	}
	union(e) {
		return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (vn.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(_n.copy(e.center).add(vn)), this.expandByPoint(_n.copy(e.center).sub(vn))), this);
	}
	equals(e) {
		return e.center.equals(this.center) && e.radius === this.radius;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	toJSON() {
		return {
			radius: this.radius,
			center: this.center.toArray()
		};
	}
	fromJSON(e) {
		return this.radius = e.radius, this.center.fromArray(e.center), this;
	}
}, bn = 0, xn = /*@__PURE__*/ new Xe(), Sn = /*@__PURE__*/ new Ct(), Cn = /*@__PURE__*/ new G(), wn = /*@__PURE__*/ new qt(), Tn = /*@__PURE__*/ new qt(), En = /*@__PURE__*/ new G(), Dn = class e extends ce {
	constructor() {
		super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: bn++ }), this.uuid = B(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.indirectOffset = 0, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
			start: 0,
			count: Infinity
		}, this.userData = {}, this._transformed = !1;
	}
	getIndex() {
		return this.index;
	}
	setIndex(e) {
		return Array.isArray(e) ? this.index = new (P(e) ? mn : pn)(e, 1) : this.index = e, this;
	}
	setIndirect(e, t = 0) {
		return this.indirect = e, this.indirectOffset = t, this;
	}
	getIndirect() {
		return this.indirect;
	}
	getAttribute(e) {
		return this.attributes[e];
	}
	setAttribute(e, t) {
		return this.attributes[e] = t, this;
	}
	deleteAttribute(e) {
		return delete this.attributes[e], this;
	}
	hasAttribute(e) {
		return this.attributes[e] !== void 0;
	}
	addGroup(e, t, n = 0) {
		this.groups.push({
			start: e,
			count: t,
			materialIndex: n
		});
	}
	clearGroups() {
		this.groups = [];
	}
	setDrawRange(e, t) {
		this.drawRange.start = e, this.drawRange.count = t;
	}
	applyMatrix4(e) {
		let t = this.attributes.position;
		t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
		let n = this.attributes.normal;
		if (n !== void 0) {
			let t = new K().getNormalMatrix(e);
			n.applyNormalMatrix(t), n.needsUpdate = !0;
		}
		let r = this.attributes.tangent;
		return r !== void 0 && (r.transformDirection(e), r.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this._transformed = !0, this;
	}
	applyQuaternion(e) {
		return xn.makeRotationFromQuaternion(e), this.applyMatrix4(xn), this;
	}
	rotateX(e) {
		return xn.makeRotationX(e), this.applyMatrix4(xn), this;
	}
	rotateY(e) {
		return xn.makeRotationY(e), this.applyMatrix4(xn), this;
	}
	rotateZ(e) {
		return xn.makeRotationZ(e), this.applyMatrix4(xn), this;
	}
	translate(e, t, n) {
		return xn.makeTranslation(e, t, n), this.applyMatrix4(xn), this;
	}
	scale(e, t, n) {
		return xn.makeScale(e, t, n), this.applyMatrix4(xn), this;
	}
	lookAt(e) {
		return Sn.lookAt(e), Sn.updateMatrix(), this.applyMatrix4(Sn.matrix), this;
	}
	center() {
		return this.computeBoundingBox(), this.boundingBox.getCenter(Cn).negate(), this.translate(Cn.x, Cn.y, Cn.z), this;
	}
	setFromPoints(e) {
		let t = this.getAttribute("position");
		if (t === void 0) {
			let t = [];
			for (let n = 0, r = e.length; n < r; n++) {
				let r = e[n];
				t.push(r.x, r.y, r.z || 0);
			}
			this.setAttribute("position", new hn(t, 3));
		} else {
			let n = Math.min(e.length, t.count);
			for (let r = 0; r < n; r++) {
				let n = e[r];
				t.setXYZ(r, n.x, n.y, n.z || 0);
			}
			e.length > t.count && L("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
		}
		return this;
	}
	computeBoundingBox() {
		this.boundingBox === null && (this.boundingBox = new qt());
		let e = this.attributes.position, t = this.morphAttributes.position;
		if (e && e.isGLBufferAttribute) {
			R("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(new G(-Infinity, -Infinity, -Infinity), new G(Infinity, Infinity, Infinity));
			return;
		}
		if (e !== void 0) {
			if (this.boundingBox.setFromBufferAttribute(e), t) for (let e = 0, n = t.length; e < n; e++) {
				let n = t[e];
				wn.setFromBufferAttribute(n), this.morphTargetsRelative ? (En.addVectors(this.boundingBox.min, wn.min), this.boundingBox.expandByPoint(En), En.addVectors(this.boundingBox.max, wn.max), this.boundingBox.expandByPoint(En)) : (this.boundingBox.expandByPoint(wn.min), this.boundingBox.expandByPoint(wn.max));
			}
		} else this.boundingBox.makeEmpty();
		(isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && R("BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The \"position\" attribute is likely to have NaN values.", this);
	}
	computeBoundingSphere() {
		this.boundingSphere === null && (this.boundingSphere = new yn());
		let e = this.attributes.position, t = this.morphAttributes.position;
		if (e && e.isGLBufferAttribute) {
			R("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new G(), Infinity);
			return;
		}
		if (e) {
			let n = this.boundingSphere.center;
			if (wn.setFromBufferAttribute(e), t) for (let e = 0, n = t.length; e < n; e++) {
				let n = t[e];
				Tn.setFromBufferAttribute(n), this.morphTargetsRelative ? (En.addVectors(wn.min, Tn.min), wn.expandByPoint(En), En.addVectors(wn.max, Tn.max), wn.expandByPoint(En)) : (wn.expandByPoint(Tn.min), wn.expandByPoint(Tn.max));
			}
			wn.getCenter(n);
			let r = 0;
			for (let t = 0, i = e.count; t < i; t++) En.fromBufferAttribute(e, t), r = Math.max(r, n.distanceToSquared(En));
			if (t) for (let i = 0, a = t.length; i < a; i++) {
				let a = t[i], o = this.morphTargetsRelative;
				for (let t = 0, i = a.count; t < i; t++) En.fromBufferAttribute(a, t), o && (Cn.fromBufferAttribute(e, t), En.add(Cn)), r = Math.max(r, n.distanceToSquared(En));
			}
			this.boundingSphere.radius = Math.sqrt(r), isNaN(this.boundingSphere.radius) && R("BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The \"position\" attribute is likely to have NaN values.", this);
		}
	}
	computeTangents() {
		let e = this.index, t = this.attributes;
		if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
			R("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
			return;
		}
		let n = t.position, r = t.normal, i = t.uv, a = this.getAttribute("tangent");
		(a === void 0 || a.count !== n.count) && (a = new fn(new Float32Array(4 * n.count), 4), this.setAttribute("tangent", a));
		let o = [], s = [];
		for (let e = 0; e < n.count; e++) o[e] = new G(), s[e] = new G();
		let c = new G(), l = new G(), u = new G(), d = new U(), f = new U(), p = new U(), m = new G(), h = new G();
		function g(e, t, r) {
			c.fromBufferAttribute(n, e), l.fromBufferAttribute(n, t), u.fromBufferAttribute(n, r), d.fromBufferAttribute(i, e), f.fromBufferAttribute(i, t), p.fromBufferAttribute(i, r), l.sub(c), u.sub(c), f.sub(d), p.sub(d);
			let a = 1 / (f.x * p.y - p.x * f.y);
			isFinite(a) && (m.copy(l).multiplyScalar(p.y).addScaledVector(u, -f.y).multiplyScalar(a), h.copy(u).multiplyScalar(f.x).addScaledVector(l, -p.x).multiplyScalar(a), o[e].add(m), o[t].add(m), o[r].add(m), s[e].add(h), s[t].add(h), s[r].add(h));
		}
		let _ = this.groups;
		_.length === 0 && (_ = [{
			start: 0,
			count: e.count
		}]);
		for (let t = 0, n = _.length; t < n; ++t) {
			let n = _[t], r = n.start, i = n.count;
			for (let t = r, n = r + i; t < n; t += 3) g(e.getX(t + 0), e.getX(t + 1), e.getX(t + 2));
		}
		let v = new G(), y = new G(), b = new G(), x = new G();
		function S(e) {
			b.fromBufferAttribute(r, e), x.copy(b);
			let t = o[e];
			v.copy(t), v.sub(b.multiplyScalar(b.dot(t))).normalize(), y.crossVectors(x, t);
			let n = y.dot(s[e]) < 0 ? -1 : 1;
			a.setXYZW(e, v.x, v.y, v.z, n);
		}
		for (let t = 0, n = _.length; t < n; ++t) {
			let n = _[t], r = n.start, i = n.count;
			for (let t = r, n = r + i; t < n; t += 3) S(e.getX(t + 0)), S(e.getX(t + 1)), S(e.getX(t + 2));
		}
		this._transformed = !0;
	}
	computeVertexNormals() {
		let e = this.index, t = this.getAttribute("position");
		if (t !== void 0) {
			let n = this.getAttribute("normal");
			if (n === void 0 || n.count !== t.count) n = new fn(new Float32Array(t.count * 3), 3), this.setAttribute("normal", n);
			else for (let e = 0, t = n.count; e < t; e++) n.setXYZ(e, 0, 0, 0);
			let r = new G(), i = new G(), a = new G(), o = new G(), s = new G(), c = new G(), l = new G(), u = new G();
			if (e) for (let d = 0, f = e.count; d < f; d += 3) {
				let f = e.getX(d + 0), p = e.getX(d + 1), m = e.getX(d + 2);
				r.fromBufferAttribute(t, f), i.fromBufferAttribute(t, p), a.fromBufferAttribute(t, m), l.subVectors(a, i), u.subVectors(r, i), l.cross(u), o.fromBufferAttribute(n, f), s.fromBufferAttribute(n, p), c.fromBufferAttribute(n, m), o.add(l), s.add(l), c.add(l), n.setXYZ(f, o.x, o.y, o.z), n.setXYZ(p, s.x, s.y, s.z), n.setXYZ(m, c.x, c.y, c.z);
			}
			else for (let e = 0, o = t.count; e < o; e += 3) r.fromBufferAttribute(t, e + 0), i.fromBufferAttribute(t, e + 1), a.fromBufferAttribute(t, e + 2), l.subVectors(a, i), u.subVectors(r, i), l.cross(u), n.setXYZ(e + 0, l.x, l.y, l.z), n.setXYZ(e + 1, l.x, l.y, l.z), n.setXYZ(e + 2, l.x, l.y, l.z);
			this.normalizeNormals(), n.needsUpdate = !0;
		}
	}
	normalizeNormals() {
		let e = this.attributes.normal;
		for (let t = 0, n = e.count; t < n; t++) En.fromBufferAttribute(e, t), En.normalize(), e.setXYZ(t, En.x, En.y, En.z);
	}
	toNonIndexed() {
		function t(e, t) {
			let n = e.array, r = e.itemSize, i = e.normalized, a = new n.constructor(t.length * r), o = 0, s = 0;
			for (let i = 0, c = t.length; i < c; i++) {
				o = e.isInterleavedBufferAttribute ? t[i] * e.data.stride + e.offset : t[i] * r;
				for (let e = 0; e < r; e++) a[s++] = n[o++];
			}
			return new fn(a, r, i);
		}
		if (this.index === null) return L("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
		let n = new e(), r = this.index.array, i = this.attributes;
		for (let e in i) {
			let a = i[e], o = t(a, r);
			n.setAttribute(e, o);
		}
		let a = this.morphAttributes;
		for (let e in a) {
			let i = [], o = a[e];
			for (let e = 0, n = o.length; e < n; e++) {
				let n = o[e], a = t(n, r);
				i.push(a);
			}
			n.morphAttributes[e] = i;
		}
		n.morphTargetsRelative = this.morphTargetsRelative;
		let o = this.groups;
		for (let e = 0, t = o.length; e < t; e++) {
			let t = o[e];
			n.addGroup(t.start, t.count, t.materialIndex);
		}
		return n;
	}
	toJSON() {
		let e = { metadata: {
			version: 4.7,
			type: "BufferGeometry",
			generator: "BufferGeometry.toJSON"
		} };
		if (e.uuid = this.uuid, e.type = this.parameters !== void 0 && this._transformed === !0 ? "BufferGeometry" : this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0 && this._transformed !== !0) {
			let t = this.parameters;
			for (let n in t) t[n] !== void 0 && (e[n] = t[n]);
			return e;
		}
		e.data = { attributes: {} };
		let t = this.index;
		t !== null && (e.data.index = {
			type: t.array.constructor.name,
			array: Array.prototype.slice.call(t.array)
		});
		let n = this.attributes;
		for (let t in n) {
			let r = n[t];
			e.data.attributes[t] = r.toJSON(e.data);
		}
		let r = {}, i = !1;
		for (let t in this.morphAttributes) {
			let n = this.morphAttributes[t], a = [];
			for (let t = 0, r = n.length; t < r; t++) {
				let r = n[t];
				a.push(r.toJSON(e.data));
			}
			a.length > 0 && (r[t] = a, i = !0);
		}
		i && (e.data.morphAttributes = r, e.data.morphTargetsRelative = this.morphTargetsRelative);
		let a = this.groups;
		a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
		let o = this.boundingSphere;
		return o !== null && (e.data.boundingSphere = o.toJSON()), e;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
		let t = {};
		this.name = e.name;
		let n = e.index;
		n !== null && this.setIndex(n.clone());
		let r = e.attributes;
		for (let e in r) {
			let n = r[e];
			this.setAttribute(e, n.clone(t));
		}
		let i = e.morphAttributes;
		for (let e in i) {
			let n = [], r = i[e];
			for (let e = 0, i = r.length; e < i; e++) n.push(r[e].clone(t));
			this.morphAttributes[e] = n;
		}
		this.morphTargetsRelative = e.morphTargetsRelative;
		let a = e.groups;
		for (let e = 0, t = a.length; e < t; e++) {
			let t = a[e];
			this.addGroup(t.start, t.count, t.materialIndex);
		}
		let o = e.boundingBox;
		o !== null && (this.boundingBox = o.clone());
		let s = e.boundingSphere;
		return s !== null && (this.boundingSphere = s.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this._transformed = e._transformed, this;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
}, On = class {
	constructor(e, t) {
		this.isInterleavedBuffer = !0, this.array = e, this.stride = t, this.count = e === void 0 ? 0 : e.length / t, this.usage = N, this.updateRanges = [], this.version = 0, this.uuid = B();
	}
	onUploadCallback() {}
	set needsUpdate(e) {
		e === !0 && this.version++;
	}
	setUsage(e) {
		return this.usage = e, this;
	}
	addUpdateRange(e, t) {
		this.updateRanges.push({
			start: e,
			count: t
		});
	}
	clearUpdateRanges() {
		this.updateRanges.length = 0;
	}
	copy(e) {
		return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.usage = e.usage, this;
	}
	copyAt(e, t, n) {
		e *= this.stride, n *= t.stride;
		for (let r = 0, i = this.stride; r < i; r++) this.array[e + r] = t.array[n + r];
		return this;
	}
	set(e, t = 0) {
		return this.array.set(e, t), this;
	}
	clone(e) {
		e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = B()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
		let t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(t, this.stride);
		return n.setUsage(this.usage), n;
	}
	onUpload(e) {
		return this.onUploadCallback = e, this;
	}
	toJSON(e) {
		return e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = B()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
			uuid: this.uuid,
			buffer: this.array.buffer._uuid,
			type: this.array.constructor.name,
			stride: this.stride
		};
	}
}, kn = /*@__PURE__*/ new G(), An = class e {
	constructor(e, t, n, r = !1) {
		this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e, this.itemSize = t, this.offset = n, this.normalized = r;
	}
	get count() {
		return this.data.count;
	}
	get array() {
		return this.data.array;
	}
	set needsUpdate(e) {
		this.data.needsUpdate = e;
	}
	applyMatrix4(e) {
		for (let t = 0, n = this.data.count; t < n; t++) kn.fromBufferAttribute(this, t), kn.applyMatrix4(e), this.setXYZ(t, kn.x, kn.y, kn.z);
		return this;
	}
	applyNormalMatrix(e) {
		for (let t = 0, n = this.count; t < n; t++) kn.fromBufferAttribute(this, t), kn.applyNormalMatrix(e), this.setXYZ(t, kn.x, kn.y, kn.z);
		return this;
	}
	transformDirection(e) {
		for (let t = 0, n = this.count; t < n; t++) kn.fromBufferAttribute(this, t), kn.transformDirection(e), this.setXYZ(t, kn.x, kn.y, kn.z);
		return this;
	}
	getComponent(e, t) {
		let n = this.array[e * this.data.stride + this.offset + t];
		return this.normalized && (n = Ae(n, this.array)), n;
	}
	setComponent(e, t, n) {
		return this.normalized && (n = H(n, this.array)), this.data.array[e * this.data.stride + this.offset + t] = n, this;
	}
	setX(e, t) {
		return this.normalized && (t = H(t, this.array)), this.data.array[e * this.data.stride + this.offset] = t, this;
	}
	setY(e, t) {
		return this.normalized && (t = H(t, this.array)), this.data.array[e * this.data.stride + this.offset + 1] = t, this;
	}
	setZ(e, t) {
		return this.normalized && (t = H(t, this.array)), this.data.array[e * this.data.stride + this.offset + 2] = t, this;
	}
	setW(e, t) {
		return this.normalized && (t = H(t, this.array)), this.data.array[e * this.data.stride + this.offset + 3] = t, this;
	}
	getX(e) {
		let t = this.data.array[e * this.data.stride + this.offset];
		return this.normalized && (t = Ae(t, this.array)), t;
	}
	getY(e) {
		let t = this.data.array[e * this.data.stride + this.offset + 1];
		return this.normalized && (t = Ae(t, this.array)), t;
	}
	getZ(e) {
		let t = this.data.array[e * this.data.stride + this.offset + 2];
		return this.normalized && (t = Ae(t, this.array)), t;
	}
	getW(e) {
		let t = this.data.array[e * this.data.stride + this.offset + 3];
		return this.normalized && (t = Ae(t, this.array)), t;
	}
	setXY(e, t, n) {
		return e = e * this.data.stride + this.offset, this.normalized && (t = H(t, this.array), n = H(n, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this;
	}
	setXYZ(e, t, n, r) {
		return e = e * this.data.stride + this.offset, this.normalized && (t = H(t, this.array), n = H(n, this.array), r = H(r, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = r, this;
	}
	setXYZW(e, t, n, r, i) {
		return e = e * this.data.stride + this.offset, this.normalized && (t = H(t, this.array), n = H(n, this.array), r = H(r, this.array), i = H(i, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = r, this.data.array[e + 3] = i, this;
	}
	clone(t) {
		if (t === void 0) {
			re("InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
			let e = [];
			for (let t = 0; t < this.count; t++) {
				let n = t * this.data.stride + this.offset;
				for (let t = 0; t < this.itemSize; t++) e.push(this.data.array[n + t]);
			}
			return new fn(new this.array.constructor(e), this.itemSize, this.normalized);
		} else return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new e(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
	}
	toJSON(e) {
		if (e === void 0) {
			re("InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
			let e = [];
			for (let t = 0; t < this.count; t++) {
				let n = t * this.data.stride + this.offset;
				for (let t = 0; t < this.itemSize; t++) e.push(this.data.array[n + t]);
			}
			return {
				itemSize: this.itemSize,
				type: this.array.constructor.name,
				array: e,
				normalized: this.normalized
			};
		} else return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)), {
			isInterleavedBufferAttribute: !0,
			itemSize: this.itemSize,
			data: this.data.uuid,
			offset: this.offset,
			normalized: this.normalized
		};
	}
}, jn = 0, Mn = class extends ce {
	constructor() {
		super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: jn++ }), this.uuid = B(), this.name = "", this.type = "Material", this.blending = 1, this.side = 0, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = 100, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Z(0, 0, 0), this.blendAlpha = 0, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = M, this.stencilZFail = M, this.stencilZPass = M, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
	}
	get alphaTest() {
		return this._alphaTest;
	}
	set alphaTest(e) {
		this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
	}
	onBeforeRender() {}
	onBeforeCompile() {}
	customProgramCacheKey() {
		return this.onBeforeCompile.toString();
	}
	setValues(e) {
		if (e !== void 0) for (let t in e) {
			let n = e[t];
			if (n === void 0) {
				L(`Material: parameter '${t}' has value of undefined.`);
				continue;
			}
			let r = this[t];
			if (r === void 0) {
				L(`Material: '${t}' is not a property of THREE.${this.type}.`);
				continue;
			}
			r && r.isColor ? r.set(n) : r && r.isVector2 && n && n.isVector2 || r && r.isEuler && n && n.isEuler || r && r.isVector3 && n && n.isVector3 ? r.copy(n) : this[t] = n;
		}
	}
	toJSON(e) {
		let t = e === void 0 || typeof e == "string";
		t && (e = {
			textures: {},
			images: {}
		});
		let n = { metadata: {
			version: 4.7,
			type: "Material",
			generator: "Material.toJSON"
		} };
		n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), this.roughness !== void 0 && (n.roughness = this.roughness), this.metalness !== void 0 && (n.metalness = this.metalness), this.sheen !== void 0 && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (n.shininess = this.shininess), this.clearcoat !== void 0 && (n.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (n.sheenColorMap = this.sheenColorMap.toJSON(e).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (n.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid), this.dispersion !== void 0 && (n.dispersion = this.dispersion), this.iridescence !== void 0 && (n.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (n.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (n.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(e).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (n.combine = this.combine)), this.envMapRotation !== void 0 && (n.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (n.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (n.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== Infinity && (n.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (n.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (n.size = this.size), this.shadowSide !== null && (n.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== 1 && (n.blending = this.blending), this.side !== 0 && (n.side = this.side), this.vertexColors === !0 && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), this.transparent === !0 && (n.transparent = !0), this.blendSrc !== 204 && (n.blendSrc = this.blendSrc), this.blendDst !== 205 && (n.blendDst = this.blendDst), this.blendEquation !== 100 && (n.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (n.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (n.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (n.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (n.blendAlpha = this.blendAlpha), this.depthFunc !== 3 && (n.depthFunc = this.depthFunc), this.depthTest === !1 && (n.depthTest = this.depthTest), this.depthWrite === !1 && (n.depthWrite = this.depthWrite), this.colorWrite === !1 && (n.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (n.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== 519 && (n.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (n.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (n.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== 7680 && (n.stencilFail = this.stencilFail), this.stencilZFail !== 7680 && (n.stencilZFail = this.stencilZFail), this.stencilZPass !== 7680 && (n.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (n.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (n.rotation = this.rotation), this.polygonOffset === !0 && (n.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (n.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (n.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (n.linewidth = this.linewidth), this.dashSize !== void 0 && (n.dashSize = this.dashSize), this.gapSize !== void 0 && (n.gapSize = this.gapSize), this.scale !== void 0 && (n.scale = this.scale), this.dithering === !0 && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), this.alphaHash === !0 && (n.alphaHash = !0), this.alphaToCoverage === !0 && (n.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (n.premultipliedAlpha = !0), this.forceSinglePass === !0 && (n.forceSinglePass = !0), this.allowOverride === !1 && (n.allowOverride = !1), this.wireframe === !0 && (n.wireframe = !0), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (n.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (n.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (n.flatShading = !0), this.visible === !1 && (n.visible = !1), this.toneMapped === !1 && (n.toneMapped = !1), this.fog === !1 && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData);
		function r(e) {
			let t = [];
			for (let n in e) {
				let r = e[n];
				delete r.metadata, t.push(r);
			}
			return t;
		}
		if (t) {
			let t = r(e.textures), i = r(e.images);
			t.length > 0 && (n.textures = t), i.length > 0 && (n.images = i);
		}
		return n;
	}
	fromJSON(e, t) {
		if (e.uuid !== void 0 && (this.uuid = e.uuid), e.name !== void 0 && (this.name = e.name), e.color !== void 0 && this.color !== void 0 && this.color.setHex(e.color), e.roughness !== void 0 && (this.roughness = e.roughness), e.metalness !== void 0 && (this.metalness = e.metalness), e.sheen !== void 0 && (this.sheen = e.sheen), e.sheenColor !== void 0 && (this.sheenColor = new Z().setHex(e.sheenColor)), e.sheenRoughness !== void 0 && (this.sheenRoughness = e.sheenRoughness), e.emissive !== void 0 && this.emissive !== void 0 && this.emissive.setHex(e.emissive), e.specular !== void 0 && this.specular !== void 0 && this.specular.setHex(e.specular), e.specularIntensity !== void 0 && (this.specularIntensity = e.specularIntensity), e.specularColor !== void 0 && this.specularColor !== void 0 && this.specularColor.setHex(e.specularColor), e.shininess !== void 0 && (this.shininess = e.shininess), e.clearcoat !== void 0 && (this.clearcoat = e.clearcoat), e.clearcoatRoughness !== void 0 && (this.clearcoatRoughness = e.clearcoatRoughness), e.dispersion !== void 0 && (this.dispersion = e.dispersion), e.iridescence !== void 0 && (this.iridescence = e.iridescence), e.iridescenceIOR !== void 0 && (this.iridescenceIOR = e.iridescenceIOR), e.iridescenceThicknessRange !== void 0 && (this.iridescenceThicknessRange = e.iridescenceThicknessRange), e.transmission !== void 0 && (this.transmission = e.transmission), e.thickness !== void 0 && (this.thickness = e.thickness), e.attenuationDistance !== void 0 && (this.attenuationDistance = e.attenuationDistance), e.attenuationColor !== void 0 && this.attenuationColor !== void 0 && this.attenuationColor.setHex(e.attenuationColor), e.anisotropy !== void 0 && (this.anisotropy = e.anisotropy), e.anisotropyRotation !== void 0 && (this.anisotropyRotation = e.anisotropyRotation), e.fog !== void 0 && (this.fog = e.fog), e.flatShading !== void 0 && (this.flatShading = e.flatShading), e.blending !== void 0 && (this.blending = e.blending), e.combine !== void 0 && (this.combine = e.combine), e.side !== void 0 && (this.side = e.side), e.shadowSide !== void 0 && (this.shadowSide = e.shadowSide), e.opacity !== void 0 && (this.opacity = e.opacity), e.transparent !== void 0 && (this.transparent = e.transparent), e.alphaTest !== void 0 && (this.alphaTest = e.alphaTest), e.alphaHash !== void 0 && (this.alphaHash = e.alphaHash), e.depthFunc !== void 0 && (this.depthFunc = e.depthFunc), e.depthTest !== void 0 && (this.depthTest = e.depthTest), e.depthWrite !== void 0 && (this.depthWrite = e.depthWrite), e.colorWrite !== void 0 && (this.colorWrite = e.colorWrite), e.blendSrc !== void 0 && (this.blendSrc = e.blendSrc), e.blendDst !== void 0 && (this.blendDst = e.blendDst), e.blendEquation !== void 0 && (this.blendEquation = e.blendEquation), e.blendSrcAlpha !== void 0 && (this.blendSrcAlpha = e.blendSrcAlpha), e.blendDstAlpha !== void 0 && (this.blendDstAlpha = e.blendDstAlpha), e.blendEquationAlpha !== void 0 && (this.blendEquationAlpha = e.blendEquationAlpha), e.blendColor !== void 0 && this.blendColor !== void 0 && this.blendColor.setHex(e.blendColor), e.blendAlpha !== void 0 && (this.blendAlpha = e.blendAlpha), e.stencilWriteMask !== void 0 && (this.stencilWriteMask = e.stencilWriteMask), e.stencilFunc !== void 0 && (this.stencilFunc = e.stencilFunc), e.stencilRef !== void 0 && (this.stencilRef = e.stencilRef), e.stencilFuncMask !== void 0 && (this.stencilFuncMask = e.stencilFuncMask), e.stencilFail !== void 0 && (this.stencilFail = e.stencilFail), e.stencilZFail !== void 0 && (this.stencilZFail = e.stencilZFail), e.stencilZPass !== void 0 && (this.stencilZPass = e.stencilZPass), e.stencilWrite !== void 0 && (this.stencilWrite = e.stencilWrite), e.wireframe !== void 0 && (this.wireframe = e.wireframe), e.wireframeLinewidth !== void 0 && (this.wireframeLinewidth = e.wireframeLinewidth), e.wireframeLinecap !== void 0 && (this.wireframeLinecap = e.wireframeLinecap), e.wireframeLinejoin !== void 0 && (this.wireframeLinejoin = e.wireframeLinejoin), e.rotation !== void 0 && (this.rotation = e.rotation), e.linewidth !== void 0 && (this.linewidth = e.linewidth), e.dashSize !== void 0 && (this.dashSize = e.dashSize), e.gapSize !== void 0 && (this.gapSize = e.gapSize), e.scale !== void 0 && (this.scale = e.scale), e.polygonOffset !== void 0 && (this.polygonOffset = e.polygonOffset), e.polygonOffsetFactor !== void 0 && (this.polygonOffsetFactor = e.polygonOffsetFactor), e.polygonOffsetUnits !== void 0 && (this.polygonOffsetUnits = e.polygonOffsetUnits), e.dithering !== void 0 && (this.dithering = e.dithering), e.alphaToCoverage !== void 0 && (this.alphaToCoverage = e.alphaToCoverage), e.premultipliedAlpha !== void 0 && (this.premultipliedAlpha = e.premultipliedAlpha), e.forceSinglePass !== void 0 && (this.forceSinglePass = e.forceSinglePass), e.allowOverride !== void 0 && (this.allowOverride = e.allowOverride), e.visible !== void 0 && (this.visible = e.visible), e.toneMapped !== void 0 && (this.toneMapped = e.toneMapped), e.userData !== void 0 && (this.userData = e.userData), e.vertexColors !== void 0 && (typeof e.vertexColors == "number" ? this.vertexColors = e.vertexColors > 0 : this.vertexColors = e.vertexColors), e.size !== void 0 && (this.size = e.size), e.sizeAttenuation !== void 0 && (this.sizeAttenuation = e.sizeAttenuation), e.map !== void 0 && (this.map = t[e.map] || null), e.matcap !== void 0 && (this.matcap = t[e.matcap] || null), e.alphaMap !== void 0 && (this.alphaMap = t[e.alphaMap] || null), e.bumpMap !== void 0 && (this.bumpMap = t[e.bumpMap] || null), e.bumpScale !== void 0 && (this.bumpScale = e.bumpScale), e.normalMap !== void 0 && (this.normalMap = t[e.normalMap] || null), e.normalMapType !== void 0 && (this.normalMapType = e.normalMapType), e.normalScale !== void 0) {
			let t = e.normalScale;
			Array.isArray(t) === !1 && (t = [t, t]), this.normalScale = new U().fromArray(t);
		}
		return e.displacementMap !== void 0 && (this.displacementMap = t[e.displacementMap] || null), e.displacementScale !== void 0 && (this.displacementScale = e.displacementScale), e.displacementBias !== void 0 && (this.displacementBias = e.displacementBias), e.roughnessMap !== void 0 && (this.roughnessMap = t[e.roughnessMap] || null), e.metalnessMap !== void 0 && (this.metalnessMap = t[e.metalnessMap] || null), e.emissiveMap !== void 0 && (this.emissiveMap = t[e.emissiveMap] || null), e.emissiveIntensity !== void 0 && (this.emissiveIntensity = e.emissiveIntensity), e.specularMap !== void 0 && (this.specularMap = t[e.specularMap] || null), e.specularIntensityMap !== void 0 && (this.specularIntensityMap = t[e.specularIntensityMap] || null), e.specularColorMap !== void 0 && (this.specularColorMap = t[e.specularColorMap] || null), e.envMap !== void 0 && (this.envMap = t[e.envMap] || null), e.envMapRotation !== void 0 && this.envMapRotation.fromArray(e.envMapRotation), e.envMapIntensity !== void 0 && (this.envMapIntensity = e.envMapIntensity), e.reflectivity !== void 0 && (this.reflectivity = e.reflectivity), e.refractionRatio !== void 0 && (this.refractionRatio = e.refractionRatio), e.lightMap !== void 0 && (this.lightMap = t[e.lightMap] || null), e.lightMapIntensity !== void 0 && (this.lightMapIntensity = e.lightMapIntensity), e.aoMap !== void 0 && (this.aoMap = t[e.aoMap] || null), e.aoMapIntensity !== void 0 && (this.aoMapIntensity = e.aoMapIntensity), e.gradientMap !== void 0 && (this.gradientMap = t[e.gradientMap] || null), e.clearcoatMap !== void 0 && (this.clearcoatMap = t[e.clearcoatMap] || null), e.clearcoatRoughnessMap !== void 0 && (this.clearcoatRoughnessMap = t[e.clearcoatRoughnessMap] || null), e.clearcoatNormalMap !== void 0 && (this.clearcoatNormalMap = t[e.clearcoatNormalMap] || null), e.clearcoatNormalScale !== void 0 && (this.clearcoatNormalScale = new U().fromArray(e.clearcoatNormalScale)), e.iridescenceMap !== void 0 && (this.iridescenceMap = t[e.iridescenceMap] || null), e.iridescenceThicknessMap !== void 0 && (this.iridescenceThicknessMap = t[e.iridescenceThicknessMap] || null), e.transmissionMap !== void 0 && (this.transmissionMap = t[e.transmissionMap] || null), e.thicknessMap !== void 0 && (this.thicknessMap = t[e.thicknessMap] || null), e.anisotropyMap !== void 0 && (this.anisotropyMap = t[e.anisotropyMap] || null), e.sheenColorMap !== void 0 && (this.sheenColorMap = t[e.sheenColorMap] || null), e.sheenRoughnessMap !== void 0 && (this.sheenRoughnessMap = t[e.sheenRoughnessMap] || null), this;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
		let t = e.clippingPlanes, n = null;
		if (t !== null) {
			let e = t.length;
			n = Array(e);
			for (let r = 0; r !== e; ++r) n[r] = t[r].clone();
		}
		return this.clippingPlanes = n, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.allowOverride = e.allowOverride, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
	set needsUpdate(e) {
		e === !0 && this.version++;
	}
}, Nn = class extends Mn {
	constructor(e) {
		super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new Z(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.rotation = e.rotation, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
	}
}, Pn, Fn = /*@__PURE__*/ new G(), In = /*@__PURE__*/ new G(), Ln = /*@__PURE__*/ new G(), Rn = /*@__PURE__*/ new U(), zn = /*@__PURE__*/ new U(), Bn = /*@__PURE__*/ new Xe(), Vn = /*@__PURE__*/ new G(), Hn = /*@__PURE__*/ new G(), Un = /*@__PURE__*/ new G(), Wn = /*@__PURE__*/ new U(), Gn = /*@__PURE__*/ new U(), Kn = /*@__PURE__*/ new U(), qn = class extends Ct {
	constructor(e = new Nn()) {
		if (super(), this.isSprite = !0, this.type = "Sprite", Pn === void 0) {
			Pn = new Dn();
			let e = new On(new Float32Array([
				-.5,
				-.5,
				0,
				0,
				0,
				.5,
				-.5,
				0,
				1,
				0,
				.5,
				.5,
				0,
				1,
				1,
				-.5,
				.5,
				0,
				0,
				1
			]), 5);
			Pn.setIndex([
				0,
				1,
				2,
				0,
				2,
				3
			]), Pn.setAttribute("position", new An(e, 3, 0, !1)), Pn.setAttribute("uv", new An(e, 2, 3, !1));
		}
		this.geometry = Pn, this.material = e, this.center = new U(.5, .5), this.count = 1;
	}
	raycast(e, t) {
		e.camera === null && R("Sprite: \"Raycaster.camera\" needs to be set in order to raycast against sprites."), In.setFromMatrixScale(this.matrixWorld), Bn.copy(e.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(e.camera.matrixWorldInverse, this.matrixWorld), Ln.setFromMatrixPosition(this.modelViewMatrix), e.camera.isPerspectiveCamera && this.material.sizeAttenuation === !1 && In.multiplyScalar(-Ln.z);
		let n = this.material.rotation, r, i;
		n !== 0 && (i = Math.cos(n), r = Math.sin(n));
		let a = this.center;
		Jn(Vn.set(-.5, -.5, 0), Ln, a, In, r, i), Jn(Hn.set(.5, -.5, 0), Ln, a, In, r, i), Jn(Un.set(.5, .5, 0), Ln, a, In, r, i), Wn.set(0, 0), Gn.set(1, 0), Kn.set(1, 1);
		let o = e.ray.intersectTriangle(Vn, Hn, Un, !1, Fn);
		if (o === null && (Jn(Hn.set(-.5, .5, 0), Ln, a, In, r, i), Gn.set(0, 1), o = e.ray.intersectTriangle(Vn, Un, Hn, !1, Fn), o === null)) return;
		let s = e.ray.origin.distanceTo(Fn);
		s < e.near || s > e.far || t.push({
			distance: s,
			point: Fn.clone(),
			uv: Kt.getInterpolation(Fn, Vn, Hn, Un, Wn, Gn, Kn, new U()),
			face: null,
			object: this
		});
	}
	copy(e, t) {
		return super.copy(e, t), e.center !== void 0 && this.center.copy(e.center), this.material = e.material, this;
	}
};
function Jn(e, t, n, r, i, a) {
	Rn.subVectors(e, n).addScalar(.5).multiply(r), i === void 0 ? zn.copy(Rn) : (zn.x = a * Rn.x - i * Rn.y, zn.y = i * Rn.x + a * Rn.y), e.copy(t), e.x += zn.x, e.y += zn.y, e.applyMatrix4(Bn);
}
var Yn = /*@__PURE__*/ new G(), Xn = /*@__PURE__*/ new G(), Zn = /*@__PURE__*/ new G(), Qn = /*@__PURE__*/ new G(), $n = /*@__PURE__*/ new G(), er = /*@__PURE__*/ new G(), tr = /*@__PURE__*/ new G(), nr = class {
	constructor(e = new G(), t = new G(0, 0, -1)) {
		this.origin = e, this.direction = t;
	}
	set(e, t) {
		return this.origin.copy(e), this.direction.copy(t), this;
	}
	copy(e) {
		return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
	}
	at(e, t) {
		return t.copy(this.origin).addScaledVector(this.direction, e);
	}
	lookAt(e) {
		return this.direction.copy(e).sub(this.origin).normalize(), this;
	}
	recast(e) {
		return this.origin.copy(this.at(e, Yn)), this;
	}
	closestPointToPoint(e, t) {
		t.subVectors(e, this.origin);
		let n = t.dot(this.direction);
		return n < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, n);
	}
	distanceToPoint(e) {
		return Math.sqrt(this.distanceSqToPoint(e));
	}
	distanceSqToPoint(e) {
		let t = Yn.subVectors(e, this.origin).dot(this.direction);
		return t < 0 ? this.origin.distanceToSquared(e) : (Yn.copy(this.origin).addScaledVector(this.direction, t), Yn.distanceToSquared(e));
	}
	distanceSqToSegment(e, t, n, r) {
		Xn.copy(e).add(t).multiplyScalar(.5), Zn.copy(t).sub(e).normalize(), Qn.copy(this.origin).sub(Xn);
		let i = e.distanceTo(t) * .5, a = -this.direction.dot(Zn), o = Qn.dot(this.direction), s = -Qn.dot(Zn), c = Qn.lengthSq(), l = Math.abs(1 - a * a), u, d, f, p;
		if (l > 0) if (u = a * s - o, d = a * o - s, p = i * l, u >= 0) if (d >= -p) if (d <= p) {
			let e = 1 / l;
			u *= e, d *= e, f = u * (u + a * d + 2 * o) + d * (a * u + d + 2 * s) + c;
		} else d = i, u = Math.max(0, -(a * d + o)), f = -u * u + d * (d + 2 * s) + c;
		else d = -i, u = Math.max(0, -(a * d + o)), f = -u * u + d * (d + 2 * s) + c;
		else d <= -p ? (u = Math.max(0, -(-a * i + o)), d = u > 0 ? -i : Math.min(Math.max(-i, -s), i), f = -u * u + d * (d + 2 * s) + c) : d <= p ? (u = 0, d = Math.min(Math.max(-i, -s), i), f = d * (d + 2 * s) + c) : (u = Math.max(0, -(a * i + o)), d = u > 0 ? i : Math.min(Math.max(-i, -s), i), f = -u * u + d * (d + 2 * s) + c);
		else d = a > 0 ? -i : i, u = Math.max(0, -(a * d + o)), f = -u * u + d * (d + 2 * s) + c;
		return n && n.copy(this.origin).addScaledVector(this.direction, u), r && r.copy(Xn).addScaledVector(Zn, d), f;
	}
	intersectSphere(e, t) {
		Yn.subVectors(e.center, this.origin);
		let n = Yn.dot(this.direction), r = Yn.dot(Yn) - n * n, i = e.radius * e.radius;
		if (r > i) return null;
		let a = Math.sqrt(i - r), o = n - a, s = n + a;
		return s < 0 ? null : o < 0 ? this.at(s, t) : this.at(o, t);
	}
	intersectsSphere(e) {
		return e.radius < 0 ? !1 : this.distanceSqToPoint(e.center) <= e.radius * e.radius;
	}
	distanceToPlane(e) {
		let t = e.normal.dot(this.direction);
		if (t === 0) return e.distanceToPoint(this.origin) === 0 ? 0 : null;
		let n = -(this.origin.dot(e.normal) + e.constant) / t;
		return n >= 0 ? n : null;
	}
	intersectPlane(e, t) {
		let n = this.distanceToPlane(e);
		return n === null ? null : this.at(n, t);
	}
	intersectsPlane(e) {
		let t = e.distanceToPoint(this.origin);
		return t === 0 || e.normal.dot(this.direction) * t < 0;
	}
	intersectBox(e, t) {
		let n, r, i, a, o, s, c = 1 / this.direction.x, l = 1 / this.direction.y, u = 1 / this.direction.z, d = this.origin;
		return c >= 0 ? (n = (e.min.x - d.x) * c, r = (e.max.x - d.x) * c) : (n = (e.max.x - d.x) * c, r = (e.min.x - d.x) * c), l >= 0 ? (i = (e.min.y - d.y) * l, a = (e.max.y - d.y) * l) : (i = (e.max.y - d.y) * l, a = (e.min.y - d.y) * l), n > a || i > r || ((i > n || isNaN(n)) && (n = i), (a < r || isNaN(r)) && (r = a), u >= 0 ? (o = (e.min.z - d.z) * u, s = (e.max.z - d.z) * u) : (o = (e.max.z - d.z) * u, s = (e.min.z - d.z) * u), n > s || o > r) || ((o > n || n !== n) && (n = o), (s < r || r !== r) && (r = s), r < 0) ? null : this.at(n >= 0 ? n : r, t);
	}
	intersectsBox(e) {
		return this.intersectBox(e, Yn) !== null;
	}
	intersectTriangle(e, t, n, r, i) {
		$n.subVectors(t, e), er.subVectors(n, e), tr.crossVectors($n, er);
		let a = this.direction.dot(tr), o;
		if (a > 0) {
			if (r) return null;
			o = 1;
		} else if (a < 0) o = -1, a = -a;
		else return null;
		Qn.subVectors(this.origin, e);
		let s = o * this.direction.dot(er.crossVectors(Qn, er));
		if (s < 0) return null;
		let c = o * this.direction.dot($n.cross(Qn));
		if (c < 0 || s + c > a) return null;
		let l = -o * Qn.dot(tr);
		return l < 0 ? null : this.at(l / a, i);
	}
	applyMatrix4(e) {
		return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
	}
	equals(e) {
		return e.origin.equals(this.origin) && e.direction.equals(this.direction);
	}
	clone() {
		return new this.constructor().copy(this);
	}
}, rr = class extends Mn {
	constructor(e) {
		super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Z(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new ot(), this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
	}
}, ir = /*@__PURE__*/ new Xe(), ar = /*@__PURE__*/ new nr(), or = /*@__PURE__*/ new yn(), sr = /*@__PURE__*/ new G(), cr = /*@__PURE__*/ new G(), lr = /*@__PURE__*/ new G(), ur = /*@__PURE__*/ new G(), dr = /*@__PURE__*/ new G(), fr = /*@__PURE__*/ new G(), pr = /*@__PURE__*/ new G(), mr = /*@__PURE__*/ new G(), hr = class extends Ct {
	constructor(e = new Dn(), t = new rr()) {
		super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
	}
	copy(e, t) {
		return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
	}
	updateMorphTargets() {
		let e = this.geometry.morphAttributes, t = Object.keys(e);
		if (t.length > 0) {
			let n = e[t[0]];
			if (n !== void 0) {
				this.morphTargetInfluences = [], this.morphTargetDictionary = {};
				for (let e = 0, t = n.length; e < t; e++) {
					let t = n[e].name || String(e);
					this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e;
				}
			}
		}
	}
	getVertexPosition(e, t) {
		let n = this.geometry, r = n.attributes.position, i = n.morphAttributes.position, a = n.morphTargetsRelative;
		t.fromBufferAttribute(r, e);
		let o = this.morphTargetInfluences;
		if (i && o) {
			fr.set(0, 0, 0);
			for (let n = 0, r = i.length; n < r; n++) {
				let r = o[n], s = i[n];
				r !== 0 && (dr.fromBufferAttribute(s, e), a ? fr.addScaledVector(dr, r) : fr.addScaledVector(dr.sub(t), r));
			}
			t.add(fr);
		}
		return t;
	}
	raycast(e, t) {
		let n = this.geometry, r = this.material, i = this.matrixWorld;
		r !== void 0 && (n.boundingSphere === null && n.computeBoundingSphere(), or.copy(n.boundingSphere), or.applyMatrix4(i), ar.copy(e.ray).recast(e.near), !(or.containsPoint(ar.origin) === !1 && (ar.intersectSphere(or, sr) === null || ar.origin.distanceToSquared(sr) > (e.far - e.near) ** 2)) && (ir.copy(i).invert(), ar.copy(e.ray).applyMatrix4(ir), !(n.boundingBox !== null && ar.intersectsBox(n.boundingBox) === !1) && this._computeIntersections(e, t, ar)));
	}
	_computeIntersections(e, t, n) {
		let r, i = this.geometry, a = this.material, o = i.index, s = i.attributes.position, c = i.attributes.uv, l = i.attributes.uv1, u = i.attributes.normal, d = i.groups, f = i.drawRange;
		if (o !== null) if (Array.isArray(a)) for (let i = 0, s = d.length; i < s; i++) {
			let s = d[i], p = a[s.materialIndex], m = Math.max(s.start, f.start), h = Math.min(o.count, Math.min(s.start + s.count, f.start + f.count));
			for (let i = m, a = h; i < a; i += 3) {
				let a = o.getX(i), d = o.getX(i + 1), f = o.getX(i + 2);
				r = _r(this, p, e, n, c, l, u, a, d, f), r && (r.faceIndex = Math.floor(i / 3), r.face.materialIndex = s.materialIndex, t.push(r));
			}
		}
		else {
			let i = Math.max(0, f.start), s = Math.min(o.count, f.start + f.count);
			for (let d = i, f = s; d < f; d += 3) {
				let i = o.getX(d), s = o.getX(d + 1), f = o.getX(d + 2);
				r = _r(this, a, e, n, c, l, u, i, s, f), r && (r.faceIndex = Math.floor(d / 3), t.push(r));
			}
		}
		else if (s !== void 0) if (Array.isArray(a)) for (let i = 0, o = d.length; i < o; i++) {
			let o = d[i], p = a[o.materialIndex], m = Math.max(o.start, f.start), h = Math.min(s.count, Math.min(o.start + o.count, f.start + f.count));
			for (let i = m, a = h; i < a; i += 3) {
				let a = i, s = i + 1, d = i + 2;
				r = _r(this, p, e, n, c, l, u, a, s, d), r && (r.faceIndex = Math.floor(i / 3), r.face.materialIndex = o.materialIndex, t.push(r));
			}
		}
		else {
			let i = Math.max(0, f.start), o = Math.min(s.count, f.start + f.count);
			for (let s = i, d = o; s < d; s += 3) {
				let i = s, o = s + 1, d = s + 2;
				r = _r(this, a, e, n, c, l, u, i, o, d), r && (r.faceIndex = Math.floor(s / 3), t.push(r));
			}
		}
	}
};
function gr(e, t, n, r, i, a, o, s) {
	let c;
	if (c = t.side === 1 ? r.intersectTriangle(o, a, i, !0, s) : r.intersectTriangle(i, a, o, t.side === 0, s), c === null) return null;
	mr.copy(s), mr.applyMatrix4(e.matrixWorld);
	let l = n.ray.origin.distanceTo(mr);
	return l < n.near || l > n.far ? null : {
		distance: l,
		point: mr.clone(),
		object: e
	};
}
function _r(e, t, n, r, i, a, o, s, c, l) {
	e.getVertexPosition(s, cr), e.getVertexPosition(c, lr), e.getVertexPosition(l, ur);
	let u = gr(e, t, n, r, cr, lr, ur, pr);
	if (u) {
		let e = new G();
		Kt.getBarycoord(pr, cr, lr, ur, e), i && (u.uv = Kt.getInterpolatedAttribute(i, s, c, l, e, new U())), a && (u.uv1 = Kt.getInterpolatedAttribute(a, s, c, l, e, new U())), o && (u.normal = Kt.getInterpolatedAttribute(o, s, c, l, e, new G()), u.normal.dot(r.direction) > 0 && u.normal.multiplyScalar(-1));
		let t = {
			a: s,
			b: c,
			c: l,
			normal: new G(),
			materialIndex: 0
		};
		Kt.getNormal(cr, lr, ur, t.normal), u.face = t, u.barycoord = e;
	}
	return u;
}
var vr = class extends We {
	constructor(e = null, t = 1, n = 1, i, a, o, s, c, l = r, u = r, d, f) {
		super(null, o, s, c, l, u, i, a, d, f), this.isDataTexture = !0, this.image = {
			data: e,
			width: t,
			height: n
		}, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
	}
}, yr = /*@__PURE__*/ new G(), br = /*@__PURE__*/ new G(), xr = /*@__PURE__*/ new K(), Sr = class {
	constructor(e = new G(1, 0, 0), t = 0) {
		this.isPlane = !0, this.normal = e, this.constant = t;
	}
	set(e, t) {
		return this.normal.copy(e), this.constant = t, this;
	}
	setComponents(e, t, n, r) {
		return this.normal.set(e, t, n), this.constant = r, this;
	}
	setFromNormalAndCoplanarPoint(e, t) {
		return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
	}
	setFromCoplanarPoints(e, t, n) {
		let r = yr.subVectors(n, t).cross(br.subVectors(e, t)).normalize();
		return this.setFromNormalAndCoplanarPoint(r, e), this;
	}
	copy(e) {
		return this.normal.copy(e.normal), this.constant = e.constant, this;
	}
	normalize() {
		let e = 1 / this.normal.length();
		return this.normal.multiplyScalar(e), this.constant *= e, this;
	}
	negate() {
		return this.constant *= -1, this.normal.negate(), this;
	}
	distanceToPoint(e) {
		return this.normal.dot(e) + this.constant;
	}
	distanceToSphere(e) {
		return this.distanceToPoint(e.center) - e.radius;
	}
	projectPoint(e, t) {
		return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
	}
	intersectLine(e, t, n = !0) {
		let r = e.delta(yr), i = this.normal.dot(r);
		if (i === 0) return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
		let a = -(e.start.dot(this.normal) + this.constant) / i;
		return n === !0 && (a < 0 || a > 1) ? null : t.copy(e.start).addScaledVector(r, a);
	}
	intersectsLine(e) {
		let t = this.distanceToPoint(e.start), n = this.distanceToPoint(e.end);
		return t < 0 && n > 0 || n < 0 && t > 0;
	}
	intersectsBox(e) {
		return e.intersectsPlane(this);
	}
	intersectsSphere(e) {
		return e.intersectsPlane(this);
	}
	coplanarPoint(e) {
		return e.copy(this.normal).multiplyScalar(-this.constant);
	}
	applyMatrix4(e, t) {
		let n = t || xr.getNormalMatrix(e), r = this.coplanarPoint(yr).applyMatrix4(e), i = this.normal.applyMatrix3(n).normalize();
		return this.constant = -r.dot(i), this;
	}
	translate(e) {
		return this.constant -= e.dot(this.normal), this;
	}
	equals(e) {
		return e.normal.equals(this.normal) && e.constant === this.constant;
	}
	clone() {
		return new this.constructor().copy(this);
	}
}, Cr = /*@__PURE__*/ new yn(), wr = /*@__PURE__*/ new U(.5, .5), Tr = /*@__PURE__*/ new G(), Er = class {
	constructor(e = new Sr(), t = new Sr(), n = new Sr(), r = new Sr(), i = new Sr(), a = new Sr()) {
		this.planes = [
			e,
			t,
			n,
			r,
			i,
			a
		];
	}
	set(e, t, n, r, i, a) {
		let o = this.planes;
		return o[0].copy(e), o[1].copy(t), o[2].copy(n), o[3].copy(r), o[4].copy(i), o[5].copy(a), this;
	}
	copy(e) {
		let t = this.planes;
		for (let n = 0; n < 6; n++) t[n].copy(e.planes[n]);
		return this;
	}
	setFromProjectionMatrix(e, t = ee, n = !1) {
		let r = this.planes, i = e.elements, a = i[0], o = i[1], s = i[2], c = i[3], l = i[4], u = i[5], d = i[6], f = i[7], p = i[8], m = i[9], h = i[10], g = i[11], _ = i[12], v = i[13], y = i[14], b = i[15];
		if (r[0].setComponents(c - a, f - l, g - p, b - _).normalize(), r[1].setComponents(c + a, f + l, g + p, b + _).normalize(), r[2].setComponents(c + o, f + u, g + m, b + v).normalize(), r[3].setComponents(c - o, f - u, g - m, b - v).normalize(), n) r[4].setComponents(s, d, h, y).normalize(), r[5].setComponents(c - s, f - d, g - h, b - y).normalize();
		else if (r[4].setComponents(c - s, f - d, g - h, b - y).normalize(), t === 2e3) r[5].setComponents(c + s, f + d, g + h, b + y).normalize();
		else if (t === 2001) r[5].setComponents(s, d, h, y).normalize();
		else throw Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
		return this;
	}
	intersectsObject(e) {
		if (e.boundingSphere !== void 0) e.boundingSphere === null && e.computeBoundingSphere(), Cr.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
		else {
			let t = e.geometry;
			t.boundingSphere === null && t.computeBoundingSphere(), Cr.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
		}
		return this.intersectsSphere(Cr);
	}
	intersectsSprite(e) {
		return Cr.center.set(0, 0, 0), Cr.radius = .7071067811865476 + wr.distanceTo(e.center), Cr.applyMatrix4(e.matrixWorld), this.intersectsSphere(Cr);
	}
	intersectsSphere(e) {
		let t = this.planes, n = e.center, r = -e.radius;
		for (let e = 0; e < 6; e++) if (t[e].distanceToPoint(n) < r) return !1;
		return !0;
	}
	intersectsBox(e) {
		let t = this.planes;
		for (let n = 0; n < 6; n++) {
			let r = t[n];
			if (Tr.x = r.normal.x > 0 ? e.max.x : e.min.x, Tr.y = r.normal.y > 0 ? e.max.y : e.min.y, Tr.z = r.normal.z > 0 ? e.max.z : e.min.z, r.distanceToPoint(Tr) < 0) return !1;
		}
		return !0;
	}
	containsPoint(e) {
		let t = this.planes;
		for (let n = 0; n < 6; n++) if (t[n].distanceToPoint(e) < 0) return !1;
		return !0;
	}
	clone() {
		return new this.constructor().copy(this);
	}
}, Dr = class extends We {
	constructor(e = [], t = 301, n, r, i, a, o, s, c, l) {
		super(e, t, n, r, i, a, o, s, c, l), this.isCubeTexture = !0, this.flipY = !1;
	}
	get images() {
		return this.image;
	}
	set images(e) {
		this.image = e;
	}
}, Or = class extends We {
	constructor(e, t, n, r, i, a, o, s, c) {
		super(e, t, n, r, i, a, o, s, c), this.isCanvasTexture = !0, this.needsUpdate = !0;
	}
}, kr = class extends We {
	constructor(e, t, n = c, i, a, o, s = r, l = r, u, d = h, f = 1) {
		if (d !== 1026 && d !== 1027) throw Error("THREE.DepthTexture: format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
		super({
			width: e,
			height: t,
			depth: f
		}, i, a, o, s, l, d, n, u), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
	}
	copy(e) {
		return super.copy(e), this.source = new Be(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return this.compareFunction !== null && (t.compareFunction = this.compareFunction), t;
	}
}, Ar = class extends kr {
	constructor(e, t = c, n = 301, i, a, o = r, s = r, l, u = h) {
		let d = {
			width: e,
			height: e,
			depth: 1
		}, f = [
			d,
			d,
			d,
			d,
			d,
			d
		];
		super(e, e, t, n, i, a, o, s, l, u), this.image = f, this.isCubeDepthTexture = !0, this.isCubeTexture = !0;
	}
	get images() {
		return this.image;
	}
	set images(e) {
		this.image = e;
	}
}, jr = class extends We {
	constructor(e = null) {
		super(), this.sourceTexture = e, this.isExternalTexture = !0;
	}
	copy(e) {
		return super.copy(e), this.sourceTexture = e.sourceTexture, this;
	}
}, Mr = class e extends Dn {
	constructor(e = 1, t = 1, n = 1, r = 1, i = 1, a = 1) {
		super(), this.type = "BoxGeometry", this.parameters = {
			width: e,
			height: t,
			depth: n,
			widthSegments: r,
			heightSegments: i,
			depthSegments: a
		};
		let o = this;
		r = Math.floor(r), i = Math.floor(i), a = Math.floor(a);
		let s = [], c = [], l = [], u = [], d = 0, f = 0;
		p("z", "y", "x", -1, -1, n, t, e, a, i, 0), p("z", "y", "x", 1, -1, n, t, -e, a, i, 1), p("x", "z", "y", 1, 1, e, n, t, r, a, 2), p("x", "z", "y", 1, -1, e, n, -t, r, a, 3), p("x", "y", "z", 1, -1, e, t, n, r, i, 4), p("x", "y", "z", -1, -1, e, t, -n, r, i, 5), this.setIndex(s), this.setAttribute("position", new hn(c, 3)), this.setAttribute("normal", new hn(l, 3)), this.setAttribute("uv", new hn(u, 2));
		function p(e, t, n, r, i, a, p, m, h, g, _) {
			let v = a / h, y = p / g, b = a / 2, x = p / 2, S = m / 2, C = h + 1, w = g + 1, T = 0, E = 0, D = new G();
			for (let a = 0; a < w; a++) {
				let o = a * y - x;
				for (let s = 0; s < C; s++) D[e] = (s * v - b) * r, D[t] = o * i, D[n] = S, c.push(D.x, D.y, D.z), D[e] = 0, D[t] = 0, D[n] = m > 0 ? 1 : -1, l.push(D.x, D.y, D.z), u.push(s / h), u.push(1 - a / g), T += 1;
			}
			for (let e = 0; e < g; e++) for (let t = 0; t < h; t++) {
				let n = d + t + C * e, r = d + t + C * (e + 1), i = d + (t + 1) + C * (e + 1), a = d + (t + 1) + C * e;
				s.push(n, r, a), s.push(r, i, a), E += 6;
			}
			o.addGroup(f, E, _), f += E, d += T;
		}
	}
	copy(e) {
		return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
	}
	static fromJSON(t) {
		return new e(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
	}
}, Nr = class {
	constructor() {
		this.type = "Curve", this.arcLengthDivisions = 200, this.needsUpdate = !1, this.cacheArcLengths = null;
	}
	getPoint() {
		L("Curve: .getPoint() not implemented.");
	}
	getPointAt(e, t) {
		let n = this.getUtoTmapping(e);
		return this.getPoint(n, t);
	}
	getPoints(e = 5) {
		let t = [];
		for (let n = 0; n <= e; n++) t.push(this.getPoint(n / e));
		return t;
	}
	getSpacedPoints(e = 5) {
		let t = [];
		for (let n = 0; n <= e; n++) t.push(this.getPointAt(n / e));
		return t;
	}
	getLength() {
		let e = this.getLengths();
		return e[e.length - 1];
	}
	getLengths(e = this.arcLengthDivisions) {
		if (this.cacheArcLengths && this.cacheArcLengths.length === e + 1 && !this.needsUpdate) return this.cacheArcLengths;
		this.needsUpdate = !1;
		let t = [], n, r = this.getPoint(0), i = 0;
		t.push(0);
		for (let a = 1; a <= e; a++) n = this.getPoint(a / e), i += n.distanceTo(r), t.push(i), r = n;
		return this.cacheArcLengths = t, t;
	}
	updateArcLengths() {
		this.needsUpdate = !0, this.getLengths();
	}
	getUtoTmapping(e, t = null) {
		let n = this.getLengths(), r = 0, i = n.length, a;
		a = t || e * n[i - 1];
		let o = 0, s = i - 1, c;
		for (; o <= s;) if (r = Math.floor(o + (s - o) / 2), c = n[r] - a, c < 0) o = r + 1;
		else if (c > 0) s = r - 1;
		else {
			s = r;
			break;
		}
		if (r = s, n[r] === a) return r / (i - 1);
		let l = n[r], u = n[r + 1] - l, d = (a - l) / u;
		return (r + d) / (i - 1);
	}
	getTangent(e, t) {
		let n = 1e-4, r = e - n, i = e + n;
		r < 0 && (r = 0), i > 1 && (i = 1);
		let a = this.getPoint(r), o = this.getPoint(i), s = t || (a.isVector2 ? new U() : new G());
		return s.copy(o).sub(a).normalize(), s;
	}
	getTangentAt(e, t) {
		let n = this.getUtoTmapping(e);
		return this.getTangent(n, t);
	}
	computeFrenetFrames(e, t = !1) {
		let n = new G(), r = [], i = [], a = [], o = new G(), s = new Xe();
		for (let t = 0; t <= e; t++) {
			let n = t / e;
			r[t] = this.getTangentAt(n, new G());
		}
		i[0] = new G(), a[0] = new G();
		let c = Number.MAX_VALUE, l = Math.abs(r[0].x), u = Math.abs(r[0].y), d = Math.abs(r[0].z);
		l <= c && (c = l, n.set(1, 0, 0)), u <= c && (c = u, n.set(0, 1, 0)), d <= c && n.set(0, 0, 1), o.crossVectors(r[0], n).normalize(), i[0].crossVectors(r[0], o), a[0].crossVectors(r[0], i[0]);
		for (let t = 1; t <= e; t++) {
			if (i[t] = i[t - 1].clone(), a[t] = a[t - 1].clone(), o.crossVectors(r[t - 1], r[t]), o.length() > 2 ** -52) {
				o.normalize();
				let e = Math.acos(V(r[t - 1].dot(r[t]), -1, 1));
				i[t].applyMatrix4(s.makeRotationAxis(o, e));
			}
			a[t].crossVectors(r[t], i[t]);
		}
		if (t === !0) {
			let t = Math.acos(V(i[0].dot(i[e]), -1, 1));
			t /= e, r[0].dot(o.crossVectors(i[0], i[e])) > 0 && (t = -t);
			for (let n = 1; n <= e; n++) i[n].applyMatrix4(s.makeRotationAxis(r[n], t * n)), a[n].crossVectors(r[n], i[n]);
		}
		return {
			tangents: r,
			normals: i,
			binormals: a
		};
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		return this.arcLengthDivisions = e.arcLengthDivisions, this;
	}
	toJSON() {
		let e = { metadata: {
			version: 4.7,
			type: "Curve",
			generator: "Curve.toJSON"
		} };
		return e.arcLengthDivisions = this.arcLengthDivisions, e.type = this.type, e;
	}
	fromJSON(e) {
		return this.arcLengthDivisions = e.arcLengthDivisions, this;
	}
}, Pr = class extends Nr {
	constructor(e = 0, t = 0, n = 1, r = 1, i = 0, a = Math.PI * 2, o = !1, s = 0) {
		super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = e, this.aY = t, this.xRadius = n, this.yRadius = r, this.aStartAngle = i, this.aEndAngle = a, this.aClockwise = o, this.aRotation = s;
	}
	getPoint(e, t = new U()) {
		let n = t, r = Math.PI * 2, i = this.aEndAngle - this.aStartAngle, a = Math.abs(i) < 2 ** -52;
		for (; i < 0;) i += r;
		for (; i > r;) i -= r;
		i < 2 ** -52 && (i = a ? 0 : r), this.aClockwise === !0 && !a && (i === r ? i = -r : i -= r);
		let o = this.aStartAngle + e * i, s = this.aX + this.xRadius * Math.cos(o), c = this.aY + this.yRadius * Math.sin(o);
		if (this.aRotation !== 0) {
			let e = Math.cos(this.aRotation), t = Math.sin(this.aRotation), n = s - this.aX, r = c - this.aY;
			s = n * e - r * t + this.aX, c = n * t + r * e + this.aY;
		}
		return n.set(s, c);
	}
	copy(e) {
		return super.copy(e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
	}
	toJSON() {
		let e = super.toJSON();
		return e.aX = this.aX, e.aY = this.aY, e.xRadius = this.xRadius, e.yRadius = this.yRadius, e.aStartAngle = this.aStartAngle, e.aEndAngle = this.aEndAngle, e.aClockwise = this.aClockwise, e.aRotation = this.aRotation, e;
	}
	fromJSON(e) {
		return super.fromJSON(e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
	}
}, Fr = class extends Pr {
	constructor(e, t, n, r, i, a) {
		super(e, t, n, n, r, i, a), this.isArcCurve = !0, this.type = "ArcCurve";
	}
};
function Ir() {
	let e = 0, t = 0, n = 0, r = 0;
	function i(i, a, o, s) {
		e = i, t = o, n = -3 * i + 3 * a - 2 * o - s, r = 2 * i - 2 * a + o + s;
	}
	return {
		initCatmullRom: function(e, t, n, r, a) {
			i(t, n, a * (n - e), a * (r - t));
		},
		initNonuniformCatmullRom: function(e, t, n, r, a, o, s) {
			let c = (t - e) / a - (n - e) / (a + o) + (n - t) / o, l = (n - t) / o - (r - t) / (o + s) + (r - n) / s;
			c *= o, l *= o, i(t, n, c, l);
		},
		calc: function(i) {
			let a = i * i, o = a * i;
			return e + t * i + n * a + r * o;
		}
	};
}
var Lr = /*@__PURE__*/ new G(), Rr = /*@__PURE__*/ new G(), zr = /*@__PURE__*/ new Ir(), Br = /*@__PURE__*/ new Ir(), Vr = /*@__PURE__*/ new Ir(), Hr = class extends Nr {
	constructor(e = [], t = !1, n = "centripetal", r = .5) {
		super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = e, this.closed = t, this.curveType = n, this.tension = r;
	}
	getPoint(e, t = new G()) {
		let n = t, r = this.points, i = r.length, a = (i - +!this.closed) * e, o = Math.floor(a), s = a - o;
		this.closed ? o += o > 0 ? 0 : (Math.floor(Math.abs(o) / i) + 1) * i : s === 0 && o === i - 1 && (o = i - 2, s = 1);
		let c, l;
		this.closed || o > 0 ? c = r[(o - 1) % i] : (Rr.subVectors(r[0], r[1]).add(r[0]), c = Rr);
		let u = r[o % i], d = r[(o + 1) % i];
		if (this.closed || o + 2 < i ? l = r[(o + 2) % i] : (Lr.subVectors(r[i - 1], r[i - 2]).add(r[i - 1]), l = Lr), this.curveType === "centripetal" || this.curveType === "chordal") {
			let e = this.curveType === "chordal" ? .5 : .25, t = c.distanceToSquared(u) ** +e, n = u.distanceToSquared(d) ** +e, r = d.distanceToSquared(l) ** +e;
			n < 1e-4 && (n = 1), t < 1e-4 && (t = n), r < 1e-4 && (r = n), zr.initNonuniformCatmullRom(c.x, u.x, d.x, l.x, t, n, r), Br.initNonuniformCatmullRom(c.y, u.y, d.y, l.y, t, n, r), Vr.initNonuniformCatmullRom(c.z, u.z, d.z, l.z, t, n, r);
		} else this.curveType === "catmullrom" && (zr.initCatmullRom(c.x, u.x, d.x, l.x, this.tension), Br.initCatmullRom(c.y, u.y, d.y, l.y, this.tension), Vr.initCatmullRom(c.z, u.z, d.z, l.z, this.tension));
		return n.set(zr.calc(s), Br.calc(s), Vr.calc(s)), n;
	}
	copy(e) {
		super.copy(e), this.points = [];
		for (let t = 0, n = e.points.length; t < n; t++) {
			let n = e.points[t];
			this.points.push(n.clone());
		}
		return this.closed = e.closed, this.curveType = e.curveType, this.tension = e.tension, this;
	}
	toJSON() {
		let e = super.toJSON();
		e.points = [];
		for (let t = 0, n = this.points.length; t < n; t++) {
			let n = this.points[t];
			e.points.push(n.toArray());
		}
		return e.closed = this.closed, e.curveType = this.curveType, e.tension = this.tension, e;
	}
	fromJSON(e) {
		super.fromJSON(e), this.points = [];
		for (let t = 0, n = e.points.length; t < n; t++) {
			let n = e.points[t];
			this.points.push(new G().fromArray(n));
		}
		return this.closed = e.closed, this.curveType = e.curveType, this.tension = e.tension, this;
	}
};
function Ur(e, t, n, r, i) {
	let a = (r - t) * .5, o = (i - n) * .5, s = e * e, c = e * s;
	return (2 * n - 2 * r + a + o) * c + (-3 * n + 3 * r - 2 * a - o) * s + a * e + n;
}
function Wr(e, t) {
	let n = 1 - e;
	return n * n * t;
}
function Gr(e, t) {
	return 2 * (1 - e) * e * t;
}
function Kr(e, t) {
	return e * e * t;
}
function qr(e, t, n, r) {
	return Wr(e, t) + Gr(e, n) + Kr(e, r);
}
function Jr(e, t) {
	let n = 1 - e;
	return n * n * n * t;
}
function Yr(e, t) {
	let n = 1 - e;
	return 3 * n * n * e * t;
}
function Xr(e, t) {
	return 3 * (1 - e) * e * e * t;
}
function Zr(e, t) {
	return e * e * e * t;
}
function Qr(e, t, n, r, i) {
	return Jr(e, t) + Yr(e, n) + Xr(e, r) + Zr(e, i);
}
var $r = class extends Nr {
	constructor(e = new U(), t = new U(), n = new U(), r = new U()) {
		super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = e, this.v1 = t, this.v2 = n, this.v3 = r;
	}
	getPoint(e, t = new U()) {
		let n = t, r = this.v0, i = this.v1, a = this.v2, o = this.v3;
		return n.set(Qr(e, r.x, i.x, a.x, o.x), Qr(e, r.y, i.y, a.y, o.y)), n;
	}
	copy(e) {
		return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this.v3.copy(e.v3), this;
	}
	toJSON() {
		let e = super.toJSON();
		return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e.v3 = this.v3.toArray(), e;
	}
	fromJSON(e) {
		return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this.v3.fromArray(e.v3), this;
	}
}, ei = class extends Nr {
	constructor(e = new G(), t = new G(), n = new G(), r = new G()) {
		super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = e, this.v1 = t, this.v2 = n, this.v3 = r;
	}
	getPoint(e, t = new G()) {
		let n = t, r = this.v0, i = this.v1, a = this.v2, o = this.v3;
		return n.set(Qr(e, r.x, i.x, a.x, o.x), Qr(e, r.y, i.y, a.y, o.y), Qr(e, r.z, i.z, a.z, o.z)), n;
	}
	copy(e) {
		return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this.v3.copy(e.v3), this;
	}
	toJSON() {
		let e = super.toJSON();
		return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e.v3 = this.v3.toArray(), e;
	}
	fromJSON(e) {
		return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this.v3.fromArray(e.v3), this;
	}
}, ti = class extends Nr {
	constructor(e = new U(), t = new U()) {
		super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = e, this.v2 = t;
	}
	getPoint(e, t = new U()) {
		let n = t;
		return e === 1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(e).add(this.v1)), n;
	}
	getPointAt(e, t) {
		return this.getPoint(e, t);
	}
	getTangent(e, t = new U()) {
		return t.subVectors(this.v2, this.v1).normalize();
	}
	getTangentAt(e, t) {
		return this.getTangent(e, t);
	}
	copy(e) {
		return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
	}
	toJSON() {
		let e = super.toJSON();
		return e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
	}
	fromJSON(e) {
		return super.fromJSON(e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
	}
}, ni = class extends Nr {
	constructor(e = new G(), t = new G()) {
		super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = e, this.v2 = t;
	}
	getPoint(e, t = new G()) {
		let n = t;
		return e === 1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(e).add(this.v1)), n;
	}
	getPointAt(e, t) {
		return this.getPoint(e, t);
	}
	getTangent(e, t = new G()) {
		return t.subVectors(this.v2, this.v1).normalize();
	}
	getTangentAt(e, t) {
		return this.getTangent(e, t);
	}
	copy(e) {
		return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
	}
	toJSON() {
		let e = super.toJSON();
		return e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
	}
	fromJSON(e) {
		return super.fromJSON(e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
	}
}, ri = class extends Nr {
	constructor(e = new U(), t = new U(), n = new U()) {
		super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = e, this.v1 = t, this.v2 = n;
	}
	getPoint(e, t = new U()) {
		let n = t, r = this.v0, i = this.v1, a = this.v2;
		return n.set(qr(e, r.x, i.x, a.x), qr(e, r.y, i.y, a.y)), n;
	}
	copy(e) {
		return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
	}
	toJSON() {
		let e = super.toJSON();
		return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
	}
	fromJSON(e) {
		return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
	}
}, ii = class extends Nr {
	constructor(e = new G(), t = new G(), n = new G()) {
		super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = e, this.v1 = t, this.v2 = n;
	}
	getPoint(e, t = new G()) {
		let n = t, r = this.v0, i = this.v1, a = this.v2;
		return n.set(qr(e, r.x, i.x, a.x), qr(e, r.y, i.y, a.y), qr(e, r.z, i.z, a.z)), n;
	}
	copy(e) {
		return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
	}
	toJSON() {
		let e = super.toJSON();
		return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
	}
	fromJSON(e) {
		return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
	}
}, ai = class extends Nr {
	constructor(e = []) {
		super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = e;
	}
	getPoint(e, t = new U()) {
		let n = t, r = this.points, i = (r.length - 1) * e, a = Math.floor(i), o = i - a, s = r[a === 0 ? a : a - 1], c = r[a], l = r[a > r.length - 2 ? r.length - 1 : a + 1], u = r[a > r.length - 3 ? r.length - 1 : a + 2];
		return n.set(Ur(o, s.x, c.x, l.x, u.x), Ur(o, s.y, c.y, l.y, u.y)), n;
	}
	copy(e) {
		super.copy(e), this.points = [];
		for (let t = 0, n = e.points.length; t < n; t++) {
			let n = e.points[t];
			this.points.push(n.clone());
		}
		return this;
	}
	toJSON() {
		let e = super.toJSON();
		e.points = [];
		for (let t = 0, n = this.points.length; t < n; t++) {
			let n = this.points[t];
			e.points.push(n.toArray());
		}
		return e;
	}
	fromJSON(e) {
		super.fromJSON(e), this.points = [];
		for (let t = 0, n = e.points.length; t < n; t++) {
			let n = e.points[t];
			this.points.push(new U().fromArray(n));
		}
		return this;
	}
}, oi = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	ArcCurve: Fr,
	CatmullRomCurve3: Hr,
	CubicBezierCurve: $r,
	CubicBezierCurve3: ei,
	EllipseCurve: Pr,
	LineCurve: ti,
	LineCurve3: ni,
	QuadraticBezierCurve: ri,
	QuadraticBezierCurve3: ii,
	SplineCurve: ai
}), si = class extends Nr {
	constructor() {
		super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
	}
	add(e) {
		this.curves.push(e);
	}
	closePath() {
		let e = this.curves[0].getPoint(0), t = this.curves[this.curves.length - 1].getPoint(1);
		if (!e.equals(t)) {
			let n = e.isVector2 === !0 ? "LineCurve" : "LineCurve3";
			this.curves.push(new oi[n](t, e));
		}
		return this;
	}
	getPoint(e, t) {
		let n = e * this.getLength(), r = this.getCurveLengths(), i = 0;
		for (; i < r.length;) {
			if (r[i] >= n) {
				let e = r[i] - n, a = this.curves[i], o = a.getLength(), s = o === 0 ? 0 : 1 - e / o;
				return a.getPointAt(s, t);
			}
			i++;
		}
		return null;
	}
	getLength() {
		let e = this.getCurveLengths();
		return e[e.length - 1];
	}
	updateArcLengths() {
		this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
	}
	getCurveLengths() {
		if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
		let e = [], t = 0;
		for (let n = 0, r = this.curves.length; n < r; n++) t += this.curves[n].getLength(), e.push(t);
		return this.cacheLengths = e, e;
	}
	getSpacedPoints(e = 40) {
		let t = [];
		for (let n = 0; n <= e; n++) t.push(this.getPoint(n / e));
		return this.autoClose && t.push(t[0]), t;
	}
	getPoints(e = 12) {
		let t = [], n;
		for (let r = 0, i = this.curves; r < i.length; r++) {
			let a = i[r], o = a.isEllipseCurve ? e * 2 : a.isLineCurve || a.isLineCurve3 ? 1 : a.isSplineCurve ? e * a.points.length : e, s = a.getPoints(o);
			for (let e = 0; e < s.length; e++) {
				let r = s[e];
				n && n.equals(r) || (t.push(r), n = r);
			}
		}
		return this.autoClose && t.length > 1 && !t[t.length - 1].equals(t[0]) && t.push(t[0]), t;
	}
	copy(e) {
		super.copy(e), this.curves = [];
		for (let t = 0, n = e.curves.length; t < n; t++) {
			let n = e.curves[t];
			this.curves.push(n.clone());
		}
		return this.autoClose = e.autoClose, this;
	}
	toJSON() {
		let e = super.toJSON();
		e.autoClose = this.autoClose, e.curves = [];
		for (let t = 0, n = this.curves.length; t < n; t++) {
			let n = this.curves[t];
			e.curves.push(n.toJSON());
		}
		return e;
	}
	fromJSON(e) {
		super.fromJSON(e), this.autoClose = e.autoClose, this.curves = [];
		for (let t = 0, n = e.curves.length; t < n; t++) {
			let n = e.curves[t];
			this.curves.push(new oi[n.type]().fromJSON(n));
		}
		return this;
	}
}, ci = class extends si {
	constructor(e) {
		super(), this.type = "Path", this.currentPoint = new U(), e && this.setFromPoints(e);
	}
	setFromPoints(e) {
		this.moveTo(e[0].x, e[0].y);
		for (let t = 1, n = e.length; t < n; t++) this.lineTo(e[t].x, e[t].y);
		return this;
	}
	moveTo(e, t) {
		return this.currentPoint.set(e, t), this;
	}
	lineTo(e, t) {
		let n = new ti(this.currentPoint.clone(), new U(e, t));
		return this.curves.push(n), this.currentPoint.set(e, t), this;
	}
	quadraticCurveTo(e, t, n, r) {
		let i = new ri(this.currentPoint.clone(), new U(e, t), new U(n, r));
		return this.curves.push(i), this.currentPoint.set(n, r), this;
	}
	bezierCurveTo(e, t, n, r, i, a) {
		let o = new $r(this.currentPoint.clone(), new U(e, t), new U(n, r), new U(i, a));
		return this.curves.push(o), this.currentPoint.set(i, a), this;
	}
	splineThru(e) {
		let t = new ai([this.currentPoint.clone()].concat(e));
		return this.curves.push(t), this.currentPoint.copy(e[e.length - 1]), this;
	}
	arc(e, t, n, r, i, a) {
		let o = this.currentPoint.x, s = this.currentPoint.y;
		return this.absarc(e + o, t + s, n, r, i, a), this;
	}
	absarc(e, t, n, r, i, a) {
		return this.absellipse(e, t, n, n, r, i, a), this;
	}
	ellipse(e, t, n, r, i, a, o, s) {
		let c = this.currentPoint.x, l = this.currentPoint.y;
		return this.absellipse(e + c, t + l, n, r, i, a, o, s), this;
	}
	absellipse(e, t, n, r, i, a, o, s) {
		let c = new Pr(e, t, n, r, i, a, o, s);
		if (this.curves.length > 0) {
			let e = c.getPoint(0);
			e.equals(this.currentPoint) || this.lineTo(e.x, e.y);
		}
		this.curves.push(c);
		let l = c.getPoint(1);
		return this.currentPoint.copy(l), this;
	}
	copy(e) {
		return super.copy(e), this.currentPoint.copy(e.currentPoint), this;
	}
	toJSON() {
		let e = super.toJSON();
		return e.currentPoint = this.currentPoint.toArray(), e;
	}
	fromJSON(e) {
		return super.fromJSON(e), this.currentPoint.fromArray(e.currentPoint), this;
	}
}, li = class extends ci {
	constructor(e) {
		super(e), this.uuid = B(), this.type = "Shape", this.holes = [];
	}
	getPointsHoles(e) {
		let t = [];
		for (let n = 0, r = this.holes.length; n < r; n++) t[n] = this.holes[n].getPoints(e);
		return t;
	}
	extractPoints(e) {
		return {
			shape: this.getPoints(e),
			holes: this.getPointsHoles(e)
		};
	}
	copy(e) {
		super.copy(e), this.holes = [];
		for (let t = 0, n = e.holes.length; t < n; t++) {
			let n = e.holes[t];
			this.holes.push(n.clone());
		}
		return this;
	}
	toJSON() {
		let e = super.toJSON();
		e.uuid = this.uuid, e.holes = [];
		for (let t = 0, n = this.holes.length; t < n; t++) {
			let n = this.holes[t];
			e.holes.push(n.toJSON());
		}
		return e;
	}
	fromJSON(e) {
		super.fromJSON(e), this.uuid = e.uuid, this.holes = [];
		for (let t = 0, n = e.holes.length; t < n; t++) {
			let n = e.holes[t];
			this.holes.push(new ci().fromJSON(n));
		}
		return this;
	}
};
function ui(e, t, n = 2) {
	let r = t && t.length, i = r ? t[0] * n : e.length, a = di(e, 0, i, n, !0), o = [];
	if (!a || a.next === a.prev) return o;
	let s, c, l;
	if (r && (a = vi(e, t, a, n)), e.length > 80 * n) {
		s = e[0], c = e[1];
		let t = s, r = c;
		for (let a = n; a < i; a += n) {
			let n = e[a], i = e[a + 1];
			n < s && (s = n), i < c && (c = i), n > t && (t = n), i > r && (r = i);
		}
		l = Math.max(t - s, r - c), l = l === 0 ? 0 : 32767 / l;
	}
	return pi(a, o, n, s, c, l, 0), o;
}
function di(e, t, n, r, i) {
	let a;
	if (i === Hi(e, t, n, r) > 0) for (let i = t; i < n; i += r) a = zi(i / r | 0, e[i], e[i + 1], a);
	else for (let i = n - r; i >= t; i -= r) a = zi(i / r | 0, e[i], e[i + 1], a);
	return a && ji(a, a.next) && (Bi(a), a = a.next), a;
}
function fi(e, t) {
	if (!e) return e;
	t ||= e;
	let n = e, r;
	do
		if (r = !1, !n.steiner && (ji(n, n.next) || Ai(n.prev, n, n.next) === 0)) {
			if (Bi(n), n = t = n.prev, n === n.next) break;
			r = !0;
		} else n = n.next;
	while (r || n !== t);
	return t;
}
function pi(e, t, n, r, i, a, o) {
	if (!e) return;
	!o && a && Ci(e, r, i, a);
	let s = e;
	for (; e.prev !== e.next;) {
		let c = e.prev, l = e.next;
		if (a ? hi(e, r, i, a) : mi(e)) {
			t.push(c.i, e.i, l.i), Bi(e), e = l.next, s = l.next;
			continue;
		}
		if (e = l, e === s) {
			o ? o === 1 ? (e = gi(fi(e), t), pi(e, t, n, r, i, a, 2)) : o === 2 && _i(e, t, n, r, i, a) : pi(fi(e), t, n, r, i, a, 1);
			break;
		}
	}
}
function mi(e) {
	let t = e.prev, n = e, r = e.next;
	if (Ai(t, n, r) >= 0) return !1;
	let i = t.x, a = n.x, o = r.x, s = t.y, c = n.y, l = r.y, u = Math.min(i, a, o), d = Math.min(s, c, l), f = Math.max(i, a, o), p = Math.max(s, c, l), m = r.next;
	for (; m !== t;) {
		if (m.x >= u && m.x <= f && m.y >= d && m.y <= p && Oi(i, s, a, c, o, l, m.x, m.y) && Ai(m.prev, m, m.next) >= 0) return !1;
		m = m.next;
	}
	return !0;
}
function hi(e, t, n, r) {
	let i = e.prev, a = e, o = e.next;
	if (Ai(i, a, o) >= 0) return !1;
	let s = i.x, c = a.x, l = o.x, u = i.y, d = a.y, f = o.y, p = Math.min(s, c, l), m = Math.min(u, d, f), h = Math.max(s, c, l), g = Math.max(u, d, f), _ = Ti(p, m, t, n, r), v = Ti(h, g, t, n, r), y = e.prevZ, b = e.nextZ;
	for (; y && y.z >= _ && b && b.z <= v;) {
		if (y.x >= p && y.x <= h && y.y >= m && y.y <= g && y !== i && y !== o && Oi(s, u, c, d, l, f, y.x, y.y) && Ai(y.prev, y, y.next) >= 0 || (y = y.prevZ, b.x >= p && b.x <= h && b.y >= m && b.y <= g && b !== i && b !== o && Oi(s, u, c, d, l, f, b.x, b.y) && Ai(b.prev, b, b.next) >= 0)) return !1;
		b = b.nextZ;
	}
	for (; y && y.z >= _;) {
		if (y.x >= p && y.x <= h && y.y >= m && y.y <= g && y !== i && y !== o && Oi(s, u, c, d, l, f, y.x, y.y) && Ai(y.prev, y, y.next) >= 0) return !1;
		y = y.prevZ;
	}
	for (; b && b.z <= v;) {
		if (b.x >= p && b.x <= h && b.y >= m && b.y <= g && b !== i && b !== o && Oi(s, u, c, d, l, f, b.x, b.y) && Ai(b.prev, b, b.next) >= 0) return !1;
		b = b.nextZ;
	}
	return !0;
}
function gi(e, t) {
	let n = e;
	do {
		let r = n.prev, i = n.next.next;
		!ji(r, i) && Mi(r, n, n.next, i) && Ii(r, i) && Ii(i, r) && (t.push(r.i, n.i, i.i), Bi(n), Bi(n.next), n = e = i), n = n.next;
	} while (n !== e);
	return fi(n);
}
function _i(e, t, n, r, i, a) {
	let o = e;
	do {
		let e = o.next.next;
		for (; e !== o.prev;) {
			if (o.i !== e.i && ki(o, e)) {
				let s = Ri(o, e);
				o = fi(o, o.next), s = fi(s, s.next), pi(o, t, n, r, i, a, 0), pi(s, t, n, r, i, a, 0);
				return;
			}
			e = e.next;
		}
		o = o.next;
	} while (o !== e);
}
function vi(e, t, n, r) {
	let i = [];
	for (let n = 0, a = t.length; n < a; n++) {
		let o = di(e, t[n] * r, n < a - 1 ? t[n + 1] * r : e.length, r, !1);
		o === o.next && (o.steiner = !0), i.push(Ei(o));
	}
	i.sort(yi);
	for (let e = 0; e < i.length; e++) n = bi(i[e], n);
	return n;
}
function yi(e, t) {
	let n = e.x - t.x;
	return n === 0 && (n = e.y - t.y, n === 0 && (n = (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x))), n;
}
function bi(e, t) {
	let n = xi(e, t);
	if (!n) return t;
	let r = Ri(n, e);
	return fi(r, r.next), fi(n, n.next);
}
function xi(e, t) {
	let n = t, r = e.x, i = e.y, a = -Infinity, o;
	if (ji(e, n)) return n;
	do {
		if (ji(e, n.next)) return n.next;
		if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
			let e = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
			if (e <= r && e > a && (a = e, o = n.x < n.next.x ? n : n.next, e === r)) return o;
		}
		n = n.next;
	} while (n !== t);
	if (!o) return null;
	let s = o, c = o.x, l = o.y, u = Infinity;
	n = o;
	do {
		if (r >= n.x && n.x >= c && r !== n.x && Di(i < l ? r : a, i, c, l, i < l ? a : r, i, n.x, n.y)) {
			let t = Math.abs(i - n.y) / (r - n.x);
			Ii(n, e) && (t < u || t === u && (n.x > o.x || n.x === o.x && Si(o, n))) && (o = n, u = t);
		}
		n = n.next;
	} while (n !== s);
	return o;
}
function Si(e, t) {
	return Ai(e.prev, e, t.prev) < 0 && Ai(t.next, e, e.next) < 0;
}
function Ci(e, t, n, r) {
	let i = e;
	do
		i.z === 0 && (i.z = Ti(i.x, i.y, t, n, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
	while (i !== e);
	i.prevZ.nextZ = null, i.prevZ = null, wi(i);
}
function wi(e) {
	let t, n = 1;
	do {
		let r = e, i;
		e = null;
		let a = null;
		for (t = 0; r;) {
			t++;
			let o = r, s = 0;
			for (let e = 0; e < n && (s++, o = o.nextZ, o); e++);
			let c = n;
			for (; s > 0 || c > 0 && o;) s !== 0 && (c === 0 || !o || r.z <= o.z) ? (i = r, r = r.nextZ, s--) : (i = o, o = o.nextZ, c--), a ? a.nextZ = i : e = i, i.prevZ = a, a = i;
			r = o;
		}
		a.nextZ = null, n *= 2;
	} while (t > 1);
	return e;
}
function Ti(e, t, n, r, i) {
	return e = (e - n) * i | 0, t = (t - r) * i | 0, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, e | t << 1;
}
function Ei(e) {
	let t = e, n = e;
	do
		(t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
	while (t !== e);
	return n;
}
function Di(e, t, n, r, i, a, o, s) {
	return (i - o) * (t - s) >= (e - o) * (a - s) && (e - o) * (r - s) >= (n - o) * (t - s) && (n - o) * (a - s) >= (i - o) * (r - s);
}
function Oi(e, t, n, r, i, a, o, s) {
	return !(e === o && t === s) && Di(e, t, n, r, i, a, o, s);
}
function ki(e, t) {
	return e.next.i !== t.i && e.prev.i !== t.i && !Fi(e, t) && (Ii(e, t) && Ii(t, e) && Li(e, t) && (Ai(e.prev, e, t.prev) || Ai(e, t.prev, t)) || ji(e, t) && Ai(e.prev, e, e.next) > 0 && Ai(t.prev, t, t.next) > 0);
}
function Ai(e, t, n) {
	return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
}
function ji(e, t) {
	return e.x === t.x && e.y === t.y;
}
function Mi(e, t, n, r) {
	let i = Pi(Ai(e, t, n)), a = Pi(Ai(e, t, r)), o = Pi(Ai(n, r, e)), s = Pi(Ai(n, r, t));
	return !!(i !== a && o !== s || i === 0 && Ni(e, n, t) || a === 0 && Ni(e, r, t) || o === 0 && Ni(n, e, r) || s === 0 && Ni(n, t, r));
}
function Ni(e, t, n) {
	return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
}
function Pi(e) {
	return e > 0 ? 1 : e < 0 ? -1 : 0;
}
function Fi(e, t) {
	let n = e;
	do {
		if (n.i !== e.i && n.next.i !== e.i && n.i !== t.i && n.next.i !== t.i && Mi(n, n.next, e, t)) return !0;
		n = n.next;
	} while (n !== e);
	return !1;
}
function Ii(e, t) {
	return Ai(e.prev, e, e.next) < 0 ? Ai(e, t, e.next) >= 0 && Ai(e, e.prev, t) >= 0 : Ai(e, t, e.prev) < 0 || Ai(e, e.next, t) < 0;
}
function Li(e, t) {
	let n = e, r = !1, i = (e.x + t.x) / 2, a = (e.y + t.y) / 2;
	do
		n.y > a != n.next.y > a && n.next.y !== n.y && i < (n.next.x - n.x) * (a - n.y) / (n.next.y - n.y) + n.x && (r = !r), n = n.next;
	while (n !== e);
	return r;
}
function Ri(e, t) {
	let n = Vi(e.i, e.x, e.y), r = Vi(t.i, t.x, t.y), i = e.next, a = t.prev;
	return e.next = t, t.prev = e, n.next = i, i.prev = n, r.next = n, n.prev = r, a.next = r, r.prev = a, r;
}
function zi(e, t, n, r) {
	let i = Vi(e, t, n);
	return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function Bi(e) {
	e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ);
}
function Vi(e, t, n) {
	return {
		i: e,
		x: t,
		y: n,
		prev: null,
		next: null,
		z: 0,
		prevZ: null,
		nextZ: null,
		steiner: !1
	};
}
function Hi(e, t, n, r) {
	let i = 0;
	for (let a = t, o = n - r; a < n; a += r) i += (e[o] - e[a]) * (e[a + 1] + e[o + 1]), o = a;
	return i;
}
var Ui = class {
	static triangulate(e, t, n = 2) {
		return ui(e, t, n);
	}
}, Wi = class e {
	static area(e) {
		let t = e.length, n = 0;
		for (let r = t - 1, i = 0; i < t; r = i++) n += e[r].x * e[i].y - e[i].x * e[r].y;
		return n * .5;
	}
	static isClockWise(t) {
		return e.area(t) < 0;
	}
	static triangulateShape(e, t) {
		let n = [], r = [], i = [];
		Gi(e), Ki(n, e);
		let a = e.length;
		t.forEach(Gi);
		for (let e = 0; e < t.length; e++) r.push(a), a += t[e].length, Ki(n, t[e]);
		let o = Ui.triangulate(n, r);
		for (let e = 0; e < o.length; e += 3) i.push(o.slice(e, e + 3));
		return i;
	}
};
function Gi(e) {
	let t = e.length;
	t > 2 && e[t - 1].equals(e[0]) && e.pop();
}
function Ki(e, t) {
	for (let n = 0; n < t.length; n++) e.push(t[n].x), e.push(t[n].y);
}
var qi = class e extends Dn {
	constructor(e = new li([
		new U(.5, .5),
		new U(-.5, .5),
		new U(-.5, -.5),
		new U(.5, -.5)
	]), t = {}) {
		super(), this.type = "ExtrudeGeometry", this.parameters = {
			shapes: e,
			options: t
		}, e = Array.isArray(e) ? e : [e];
		let n = this, r = [], i = [];
		for (let t = 0, n = e.length; t < n; t++) {
			let n = e[t];
			a(n);
		}
		this.setAttribute("position", new hn(r, 3)), this.setAttribute("uv", new hn(i, 2)), this.computeVertexNormals();
		function a(e) {
			let a = [], o = t.curveSegments === void 0 ? 12 : t.curveSegments, s = t.steps === void 0 ? 1 : t.steps, c = t.depth === void 0 ? 1 : t.depth, l = t.bevelEnabled === void 0 || t.bevelEnabled, u = t.bevelThickness === void 0 ? .2 : t.bevelThickness, d = t.bevelSize === void 0 ? u - .1 : t.bevelSize, f = t.bevelOffset === void 0 ? 0 : t.bevelOffset, p = t.bevelSegments === void 0 ? 3 : t.bevelSegments, m = t.extrudePath, h = t.UVGenerator === void 0 ? Ji : t.UVGenerator, g, _ = !1, v, y, b, x;
			if (m) {
				g = m.getSpacedPoints(s), _ = !0, l = !1;
				let e = m.isCatmullRomCurve3 ? m.closed : !1;
				v = m.computeFrenetFrames(s, e), y = new G(), b = new G(), x = new G();
			}
			l || (p = 0, u = 0, d = 0, f = 0);
			let S = e.extractPoints(o), C = S.shape, w = S.holes;
			if (!Wi.isClockWise(C)) {
				C = C.reverse();
				for (let e = 0, t = w.length; e < t; e++) {
					let t = w[e];
					Wi.isClockWise(t) && (w[e] = t.reverse());
				}
			}
			function T(e) {
				let t = e[0];
				for (let n = 1; n <= e.length; n++) {
					let r = n % e.length, i = e[r], a = i.x - t.x, o = i.y - t.y, s = a * a + o * o, c = Math.max(Math.abs(i.x), Math.abs(i.y), Math.abs(t.x), Math.abs(t.y));
					if (s <= 10000000000000001e-36 * c * c) {
						e.splice(r, 1), n--;
						continue;
					}
					t = i;
				}
			}
			T(C), w.forEach(T);
			let E = w.length, D = C;
			for (let e = 0; e < E; e++) {
				let t = w[e];
				C = C.concat(t);
			}
			function O(e, t, n) {
				return t || R("ExtrudeGeometry: vec does not exist"), e.clone().addScaledVector(t, n);
			}
			let k = C.length;
			function A(e, t, n) {
				let r, i, a, o = e.x - t.x, s = e.y - t.y, c = n.x - e.x, l = n.y - e.y, u = o * o + s * s, d = o * l - s * c;
				if (Math.abs(d) > 2 ** -52) {
					let d = Math.sqrt(u), f = Math.sqrt(c * c + l * l), p = t.x - s / d, m = t.y + o / d, h = n.x - l / f, g = n.y + c / f, _ = ((h - p) * l - (g - m) * c) / (o * l - s * c);
					r = p + o * _ - e.x, i = m + s * _ - e.y;
					let v = r * r + i * i;
					if (v <= 2) return new U(r, i);
					a = Math.sqrt(v / 2);
				} else {
					let e = !1;
					o > 2 ** -52 ? c > 2 ** -52 && (e = !0) : o < -(2 ** -52) ? c < -(2 ** -52) && (e = !0) : Math.sign(s) === Math.sign(l) && (e = !0), e ? (r = -s, i = o, a = Math.sqrt(u)) : (r = o, i = s, a = Math.sqrt(u / 2));
				}
				return new U(r / a, i / a);
			}
			let j = [];
			for (let e = 0, t = D.length, n = t - 1, r = e + 1; e < t; e++, n++, r++) n === t && (n = 0), r === t && (r = 0), j[e] = A(D[e], D[n], D[r]);
			let M = [], N, ee = j.concat();
			for (let e = 0, t = E; e < t; e++) {
				let t = w[e];
				N = [];
				for (let e = 0, n = t.length, r = n - 1, i = e + 1; e < n; e++, r++, i++) r === n && (r = 0), i === n && (i = 0), N[e] = A(t[e], t[r], t[i]);
				M.push(N), ee = ee.concat(N);
			}
			let P;
			if (p === 0) P = Wi.triangulateShape(D, w);
			else {
				let e = [], t = [];
				for (let n = 0; n < p; n++) {
					let r = n / p, i = u * Math.cos(r * Math.PI / 2), a = d * Math.sin(r * Math.PI / 2) + f;
					for (let t = 0, n = D.length; t < n; t++) {
						let n = O(D[t], j[t], a);
						ie(n.x, n.y, -i), r === 0 && e.push(n);
					}
					for (let e = 0, n = E; e < n; e++) {
						let n = w[e];
						N = M[e];
						let o = [];
						for (let e = 0, t = n.length; e < t; e++) {
							let t = O(n[e], N[e], a);
							ie(t.x, t.y, -i), r === 0 && o.push(t);
						}
						r === 0 && t.push(o);
					}
				}
				P = Wi.triangulateShape(e, t);
			}
			let F = P.length, te = d + f;
			for (let e = 0; e < k; e++) {
				let t = l ? O(C[e], ee[e], te) : C[e];
				_ ? (b.copy(v.normals[0]).multiplyScalar(t.x), y.copy(v.binormals[0]).multiplyScalar(t.y), x.copy(g[0]).add(b).add(y), ie(x.x, x.y, x.z)) : ie(t.x, t.y, 0);
			}
			for (let e = 1; e <= s; e++) for (let t = 0; t < k; t++) {
				let n = l ? O(C[t], ee[t], te) : C[t];
				_ ? (b.copy(v.normals[e]).multiplyScalar(n.x), y.copy(v.binormals[e]).multiplyScalar(n.y), x.copy(g[e]).add(b).add(y), ie(x.x, x.y, x.z)) : ie(n.x, n.y, c / s * e);
			}
			for (let e = p - 1; e >= 0; e--) {
				let t = e / p, n = u * Math.cos(t * Math.PI / 2), r = d * Math.sin(t * Math.PI / 2) + f;
				for (let e = 0, t = D.length; e < t; e++) {
					let t = O(D[e], j[e], r);
					ie(t.x, t.y, c + n);
				}
				for (let e = 0, t = w.length; e < t; e++) {
					let t = w[e];
					N = M[e];
					for (let e = 0, i = t.length; e < i; e++) {
						let i = O(t[e], N[e], r);
						_ ? ie(i.x, i.y + g[s - 1].y, g[s - 1].x + n) : ie(i.x, i.y, c + n);
					}
				}
			}
			ne(), I();
			function ne() {
				let e = r.length / 3;
				if (l) {
					let e = 0, t = k * e;
					for (let e = 0; e < F; e++) {
						let n = P[e];
						L(n[2] + t, n[1] + t, n[0] + t);
					}
					e = s + p * 2, t = k * e;
					for (let e = 0; e < F; e++) {
						let n = P[e];
						L(n[0] + t, n[1] + t, n[2] + t);
					}
				} else {
					for (let e = 0; e < F; e++) {
						let t = P[e];
						L(t[2], t[1], t[0]);
					}
					for (let e = 0; e < F; e++) {
						let t = P[e];
						L(t[0] + k * s, t[1] + k * s, t[2] + k * s);
					}
				}
				n.addGroup(e, r.length / 3 - e, 0);
			}
			function I() {
				let e = r.length / 3, t = 0;
				re(D, t), t += D.length;
				for (let e = 0, n = w.length; e < n; e++) {
					let n = w[e];
					re(n, t), t += n.length;
				}
				n.addGroup(e, r.length / 3 - e, 1);
			}
			function re(e, t) {
				let n = e.length;
				for (; --n >= 0;) {
					let r = n, i = n - 1;
					i < 0 && (i = e.length - 1);
					for (let e = 0, n = s + p * 2; e < n; e++) {
						let n = k * e, a = k * (e + 1);
						ae(t + r + n, t + i + n, t + i + a, t + r + a);
					}
				}
			}
			function ie(e, t, n) {
				a.push(e), a.push(t), a.push(n);
			}
			function L(e, t, i) {
				oe(e), oe(t), oe(i);
				let a = r.length / 3, o = h.generateTopUV(n, r, a - 3, a - 2, a - 1);
				se(o[0]), se(o[1]), se(o[2]);
			}
			function ae(e, t, i, a) {
				oe(e), oe(t), oe(a), oe(t), oe(i), oe(a);
				let o = r.length / 3, s = h.generateSideWallUV(n, r, o - 6, o - 3, o - 2, o - 1);
				se(s[0]), se(s[1]), se(s[3]), se(s[1]), se(s[2]), se(s[3]);
			}
			function oe(e) {
				r.push(a[e * 3 + 0]), r.push(a[e * 3 + 1]), r.push(a[e * 3 + 2]);
			}
			function se(e) {
				i.push(e.x), i.push(e.y);
			}
		}
	}
	copy(e) {
		return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
	}
	toJSON() {
		let e = super.toJSON(), t = this.parameters.shapes, n = this.parameters.options;
		return Yi(t, n, e);
	}
	static fromJSON(t, n) {
		let r = [];
		for (let e = 0, i = t.shapes.length; e < i; e++) {
			let i = n[t.shapes[e]];
			r.push(i);
		}
		let i = t.options.extrudePath;
		return i !== void 0 && (t.options.extrudePath = new oi[i.type]().fromJSON(i)), new e(r, t.options);
	}
}, Ji = {
	generateTopUV: function(e, t, n, r, i) {
		let a = t[n * 3], o = t[n * 3 + 1], s = t[r * 3], c = t[r * 3 + 1], l = t[i * 3], u = t[i * 3 + 1];
		return [
			new U(a, o),
			new U(s, c),
			new U(l, u)
		];
	},
	generateSideWallUV: function(e, t, n, r, i, a) {
		let o = t[n * 3], s = t[n * 3 + 1], c = t[n * 3 + 2], l = t[r * 3], u = t[r * 3 + 1], d = t[r * 3 + 2], f = t[i * 3], p = t[i * 3 + 1], m = t[i * 3 + 2], h = t[a * 3], g = t[a * 3 + 1], _ = t[a * 3 + 2];
		return Math.abs(s - u) < Math.abs(o - l) ? [
			new U(o, 1 - c),
			new U(l, 1 - d),
			new U(f, 1 - m),
			new U(h, 1 - _)
		] : [
			new U(s, 1 - c),
			new U(u, 1 - d),
			new U(p, 1 - m),
			new U(g, 1 - _)
		];
	}
};
function Yi(e, t, n) {
	if (n.shapes = [], Array.isArray(e)) for (let t = 0, r = e.length; t < r; t++) {
		let r = e[t];
		n.shapes.push(r.uuid);
	}
	else n.shapes.push(e.uuid);
	return n.options = Object.assign({}, t), t.extrudePath !== void 0 && (n.options.extrudePath = t.extrudePath.toJSON()), n;
}
var Xi = class e extends Dn {
	constructor(e = 1, t = 1, n = 1, r = 1) {
		super(), this.type = "PlaneGeometry", this.parameters = {
			width: e,
			height: t,
			widthSegments: n,
			heightSegments: r
		};
		let i = e / 2, a = t / 2, o = Math.floor(n), s = Math.floor(r), c = o + 1, l = s + 1, u = e / o, d = t / s, f = [], p = [], m = [], h = [];
		for (let e = 0; e < l; e++) {
			let t = e * d - a;
			for (let n = 0; n < c; n++) {
				let r = n * u - i;
				p.push(r, -t, 0), m.push(0, 0, 1), h.push(n / o), h.push(1 - e / s);
			}
		}
		for (let e = 0; e < s; e++) for (let t = 0; t < o; t++) {
			let n = t + c * e, r = t + c * (e + 1), i = t + 1 + c * (e + 1), a = t + 1 + c * e;
			f.push(n, r, a), f.push(r, i, a);
		}
		this.setIndex(f), this.setAttribute("position", new hn(p, 3)), this.setAttribute("normal", new hn(m, 3)), this.setAttribute("uv", new hn(h, 2));
	}
	copy(e) {
		return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
	}
	static fromJSON(t) {
		return new e(t.width, t.height, t.widthSegments, t.heightSegments);
	}
}, Zi = class e extends Dn {
	constructor(e = new li([
		new U(0, .5),
		new U(-.5, -.5),
		new U(.5, -.5)
	]), t = 12) {
		super(), this.type = "ShapeGeometry", this.parameters = {
			shapes: e,
			curveSegments: t
		};
		let n = [], r = [], i = [], a = [], o = 0, s = 0;
		if (Array.isArray(e) === !1) c(e);
		else for (let t = 0; t < e.length; t++) c(e[t]), this.addGroup(o, s, t), o += s, s = 0;
		this.setIndex(n), this.setAttribute("position", new hn(r, 3)), this.setAttribute("normal", new hn(i, 3)), this.setAttribute("uv", new hn(a, 2));
		function c(e) {
			let o = r.length / 3, c = e.extractPoints(t), l = c.shape, u = c.holes;
			Wi.isClockWise(l) === !1 && (l = l.reverse());
			for (let e = 0, t = u.length; e < t; e++) {
				let t = u[e];
				Wi.isClockWise(t) === !0 && (u[e] = t.reverse());
			}
			let d = Wi.triangulateShape(l, u);
			for (let e = 0, t = u.length; e < t; e++) {
				let t = u[e];
				l = l.concat(t);
			}
			for (let e = 0, t = l.length; e < t; e++) {
				let t = l[e];
				r.push(t.x, t.y, 0), i.push(0, 0, 1), a.push(t.x, t.y);
			}
			for (let e = 0, t = d.length; e < t; e++) {
				let t = d[e], r = t[0] + o, i = t[1] + o, a = t[2] + o;
				n.push(r, i, a), s += 3;
			}
		}
	}
	copy(e) {
		return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
	}
	toJSON() {
		let e = super.toJSON(), t = this.parameters.shapes;
		return Qi(t, e);
	}
	static fromJSON(t, n) {
		let r = [];
		for (let e = 0, i = t.shapes.length; e < i; e++) {
			let i = n[t.shapes[e]];
			r.push(i);
		}
		return new e(r, t.curveSegments);
	}
};
function Qi(e, t) {
	if (t.shapes = [], Array.isArray(e)) for (let n = 0, r = e.length; n < r; n++) {
		let r = e[n];
		t.shapes.push(r.uuid);
	}
	else t.shapes.push(e.uuid);
	return t;
}
function $i(e) {
	let t = {};
	for (let n in e) {
		t[n] = {};
		for (let r in e[n]) {
			let i = e[n][r];
			if (ta(i)) i.isRenderTargetTexture ? (L("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), t[n][r] = null) : t[n][r] = i.clone();
			else if (Array.isArray(i)) if (ta(i[0])) {
				let e = [];
				for (let t = 0, n = i.length; t < n; t++) e[t] = i[t].clone();
				t[n][r] = e;
			} else t[n][r] = i.slice();
			else t[n][r] = i;
		}
	}
	return t;
}
function ea(e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = $i(e[n]);
		for (let e in r) t[e] = r[e];
	}
	return t;
}
function ta(e) {
	return e && (e.isColor || e.isMatrix3 || e.isMatrix4 || e.isVector2 || e.isVector3 || e.isVector4 || e.isTexture || e.isQuaternion);
}
function na(e) {
	let t = [];
	for (let n = 0; n < e.length; n++) t.push(e[n].clone());
	return t;
}
function ra(e) {
	let t = e.getRenderTarget();
	return t === null ? e.outputColorSpace : t.isXRRenderTarget === !0 ? t.texture.colorSpace : X.workingColorSpace;
}
var ia = {
	clone: $i,
	merge: ea
}, aa = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", oa = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", sa = class extends Mn {
	constructor(e) {
		super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = aa, this.fragmentShader = oa, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
			clipCullDistance: !1,
			multiDraw: !1
		}, this.defaultAttributeValues = {
			color: [
				1,
				1,
				1
			],
			uv: [0, 0],
			uv1: [0, 0]
		}, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = $i(e.uniforms), this.uniformsGroups = na(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this.defaultAttributeValues = Object.assign({}, e.defaultAttributeValues), this.index0AttributeName = e.index0AttributeName, this.uniformsNeedUpdate = e.uniformsNeedUpdate, this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		t.glslVersion = this.glslVersion, t.uniforms = {};
		for (let n in this.uniforms) {
			let r = this.uniforms[n].value;
			r && r.isTexture ? t.uniforms[n] = {
				type: "t",
				value: r.toJSON(e).uuid
			} : r && r.isColor ? t.uniforms[n] = {
				type: "c",
				value: r.getHex()
			} : r && r.isVector2 ? t.uniforms[n] = {
				type: "v2",
				value: r.toArray()
			} : r && r.isVector3 ? t.uniforms[n] = {
				type: "v3",
				value: r.toArray()
			} : r && r.isVector4 ? t.uniforms[n] = {
				type: "v4",
				value: r.toArray()
			} : r && r.isMatrix3 ? t.uniforms[n] = {
				type: "m3",
				value: r.toArray()
			} : r && r.isMatrix4 ? t.uniforms[n] = {
				type: "m4",
				value: r.toArray()
			} : t.uniforms[n] = { value: r };
		}
		Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
		let n = {};
		for (let e in this.extensions) this.extensions[e] === !0 && (n[e] = !0);
		return Object.keys(n).length > 0 && (t.extensions = n), t;
	}
	fromJSON(e, t) {
		if (super.fromJSON(e, t), e.uniforms !== void 0) for (let n in e.uniforms) {
			let r = e.uniforms[n];
			switch (this.uniforms[n] = {}, r.type) {
				case "t":
					this.uniforms[n].value = t[r.value] || null;
					break;
				case "c":
					this.uniforms[n].value = new Z().setHex(r.value);
					break;
				case "v2":
					this.uniforms[n].value = new U().fromArray(r.value);
					break;
				case "v3":
					this.uniforms[n].value = new G().fromArray(r.value);
					break;
				case "v4":
					this.uniforms[n].value = new Ge().fromArray(r.value);
					break;
				case "m3":
					this.uniforms[n].value = new K().fromArray(r.value);
					break;
				case "m4":
					this.uniforms[n].value = new Xe().fromArray(r.value);
					break;
				default: this.uniforms[n].value = r.value;
			}
		}
		if (e.defines !== void 0 && (this.defines = e.defines), e.vertexShader !== void 0 && (this.vertexShader = e.vertexShader), e.fragmentShader !== void 0 && (this.fragmentShader = e.fragmentShader), e.glslVersion !== void 0 && (this.glslVersion = e.glslVersion), e.extensions !== void 0) for (let t in e.extensions) this.extensions[t] = e.extensions[t];
		return e.lights !== void 0 && (this.lights = e.lights), e.clipping !== void 0 && (this.clipping = e.clipping), this;
	}
}, ca = class extends sa {
	constructor(e) {
		super(e), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
	}
}, la = class extends Mn {
	constructor(e) {
		super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = 3200, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
	}
}, ua = class extends Mn {
	constructor(e) {
		super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
	}
};
function da(e, t) {
	return !e || e.constructor === t ? e : typeof t.BYTES_PER_ELEMENT == "number" ? new t(e) : Array.prototype.slice.call(e);
}
var fa = class {
	constructor(e, t, n, r) {
		this.parameterPositions = e, this._cachedIndex = 0, this.resultBuffer = r === void 0 ? new t.constructor(n) : r, this.sampleValues = t, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
	}
	evaluate(e) {
		let t = this.parameterPositions, n = this._cachedIndex, r = t[n], i = t[n - 1];
		validate_interval: {
			seek: {
				let a;
				linear_scan: {
					forward_scan: if (!(e < r)) {
						for (let a = n + 2;;) {
							if (r === void 0) {
								if (e < i) break forward_scan;
								return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
							}
							if (n === a) break;
							if (i = r, r = t[++n], e < r) break seek;
						}
						a = t.length;
						break linear_scan;
					}
					if (!(e >= i)) {
						let o = t[1];
						e < o && (n = 2, i = o);
						for (let a = n - 2;;) {
							if (i === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
							if (n === a) break;
							if (r = i, i = t[--n - 1], e >= i) break seek;
						}
						a = n, n = 0;
						break linear_scan;
					}
					break validate_interval;
				}
				for (; n < a;) {
					let r = n + a >>> 1;
					e < t[r] ? a = r : n = r + 1;
				}
				if (r = t[n], i = t[n - 1], i === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
				if (r === void 0) return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
			}
			this._cachedIndex = n, this.intervalChanged_(n, i, r);
		}
		return this.interpolate_(n, i, e, r);
	}
	getSettings_() {
		return this.settings || this.DefaultSettings_;
	}
	copySampleValue_(e) {
		let t = this.resultBuffer, n = this.sampleValues, r = this.valueSize, i = e * r;
		for (let e = 0; e !== r; ++e) t[e] = n[i + e];
		return t;
	}
	interpolate_() {
		throw Error("THREE.Interpolant: Call to abstract method.");
	}
	intervalChanged_() {}
}, pa = class extends fa {
	constructor(e, t, n, r) {
		super(e, t, n, r), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
			endingStart: T,
			endingEnd: T
		};
	}
	intervalChanged_(e, t, n) {
		let r = this.parameterPositions, i = e - 2, a = e + 1, o = r[i], s = r[a];
		if (o === void 0) switch (this.getSettings_().endingStart) {
			case E:
				i = e, o = 2 * t - n;
				break;
			case D:
				i = r.length - 2, o = t + r[i] - r[i + 1];
				break;
			default: i = e, o = n;
		}
		if (s === void 0) switch (this.getSettings_().endingEnd) {
			case E:
				a = e, s = 2 * n - t;
				break;
			case D:
				a = 1, s = n + r[1] - r[0];
				break;
			default: a = e - 1, s = t;
		}
		let c = (n - t) * .5, l = this.valueSize;
		this._weightPrev = c / (t - o), this._weightNext = c / (s - n), this._offsetPrev = i * l, this._offsetNext = a * l;
	}
	interpolate_(e, t, n, r) {
		let i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = e * o, c = s - o, l = this._offsetPrev, u = this._offsetNext, d = this._weightPrev, f = this._weightNext, p = (n - t) / (r - t), m = p * p, h = m * p, g = -d * h + 2 * d * m - d * p, _ = (1 + d) * h + (-1.5 - 2 * d) * m + (-.5 + d) * p + 1, v = (-1 - f) * h + (1.5 + f) * m + .5 * p, y = f * h - f * m;
		for (let e = 0; e !== o; ++e) i[e] = g * a[l + e] + _ * a[c + e] + v * a[s + e] + y * a[u + e];
		return i;
	}
}, ma = class extends fa {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
	interpolate_(e, t, n, r) {
		let i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = e * o, c = s - o, l = (n - t) / (r - t), u = 1 - l;
		for (let e = 0; e !== o; ++e) i[e] = a[c + e] * u + a[s + e] * l;
		return i;
	}
}, ha = class extends fa {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
	interpolate_(e) {
		return this.copySampleValue_(e - 1);
	}
}, ga = class extends fa {
	interpolate_(e, t, n, r) {
		let i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = e * o, c = s - o, l = this.inTangents, u = this.outTangents;
		if (!l || !u) {
			let e = (n - t) / (r - t), l = 1 - e;
			for (let t = 0; t !== o; ++t) i[t] = a[c + t] * l + a[s + t] * e;
			return i;
		}
		let d = o * 2, f = e - 1;
		for (let p = 0; p !== o; ++p) {
			let o = a[c + p], m = a[s + p], h = f * d + p * 2, g = u[h], _ = u[h + 1], v = e * d + p * 2, y = l[v], b = l[v + 1], x = (n - t) / (r - t), S, C, w, T, E;
			for (let e = 0; e < 8; e++) {
				S = x * x, C = S * x, w = 1 - x, T = w * w, E = T * w;
				let e = E * t + 3 * T * x * g + 3 * w * S * y + C * r - n;
				if (Math.abs(e) < 1e-10) break;
				let i = 3 * T * (g - t) + 6 * w * x * (y - g) + 3 * S * (r - y);
				if (Math.abs(i) < 1e-10) break;
				x -= e / i, x = Math.max(0, Math.min(1, x));
			}
			i[p] = E * o + 3 * T * x * _ + 3 * w * S * b + C * m;
		}
		return i;
	}
}, _a = class {
	constructor(e, t, n, r) {
		if (e === void 0) throw Error("THREE.KeyframeTrack: track name is undefined");
		if (t === void 0 || t.length === 0) throw Error("THREE.KeyframeTrack: no keyframes in track named " + e);
		this.name = e, this.times = da(t, this.TimeBufferType), this.values = da(n, this.ValueBufferType), this.setInterpolation(r || this.DefaultInterpolation);
	}
	static toJSON(e) {
		let t = e.constructor, n;
		if (t.toJSON !== this.toJSON) n = t.toJSON(e);
		else {
			n = {
				name: e.name,
				times: da(e.times, Array),
				values: da(e.values, Array)
			};
			let t = e.getInterpolation();
			t !== e.DefaultInterpolation && (n.interpolation = t);
		}
		return n.type = e.ValueTypeName, n;
	}
	InterpolantFactoryMethodDiscrete(e) {
		return new ha(this.times, this.values, this.getValueSize(), e);
	}
	InterpolantFactoryMethodLinear(e) {
		return new ma(this.times, this.values, this.getValueSize(), e);
	}
	InterpolantFactoryMethodSmooth(e) {
		return new pa(this.times, this.values, this.getValueSize(), e);
	}
	InterpolantFactoryMethodBezier(e) {
		let t = new ga(this.times, this.values, this.getValueSize(), e);
		return this.settings && (t.inTangents = this.settings.inTangents, t.outTangents = this.settings.outTangents), t;
	}
	setInterpolation(e) {
		let t;
		switch (e) {
			case x:
				t = this.InterpolantFactoryMethodDiscrete;
				break;
			case S:
				t = this.InterpolantFactoryMethodLinear;
				break;
			case C:
				t = this.InterpolantFactoryMethodSmooth;
				break;
			case w:
				t = this.InterpolantFactoryMethodBezier;
				break;
		}
		if (t === void 0) {
			let t = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
			if (this.createInterpolant === void 0) if (e !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
			else throw Error(t);
			return L("KeyframeTrack:", t), this;
		}
		return this.createInterpolant = t, this;
	}
	getInterpolation() {
		switch (this.createInterpolant) {
			case this.InterpolantFactoryMethodDiscrete: return x;
			case this.InterpolantFactoryMethodLinear: return S;
			case this.InterpolantFactoryMethodSmooth: return C;
			case this.InterpolantFactoryMethodBezier: return w;
		}
	}
	getValueSize() {
		return this.values.length / this.times.length;
	}
	shift(e) {
		if (e !== 0) {
			let t = this.times;
			for (let n = 0, r = t.length; n !== r; ++n) t[n] += e;
		}
		return this;
	}
	scale(e) {
		if (e !== 1) {
			let t = this.times;
			for (let n = 0, r = t.length; n !== r; ++n) t[n] *= e;
		}
		return this;
	}
	trim(e, t) {
		let n = this.times, r = n.length, i = 0, a = r - 1;
		for (; i !== r && n[i] < e;) ++i;
		for (; a !== -1 && n[a] > t;) --a;
		if (++a, i !== 0 || a !== r) {
			i >= a && (a = Math.max(a, 1), i = a - 1);
			let e = this.getValueSize();
			this.times = n.slice(i, a), this.values = this.values.slice(i * e, a * e);
		}
		return this;
	}
	validate() {
		let e = !0, t = this.getValueSize();
		t - Math.floor(t) !== 0 && (R("KeyframeTrack: Invalid value size in track.", this), e = !1);
		let n = this.times, r = this.values, i = n.length;
		i === 0 && (R("KeyframeTrack: Track is empty.", this), e = !1);
		let a = null;
		for (let t = 0; t !== i; t++) {
			let r = n[t];
			if (typeof r == "number" && isNaN(r)) {
				R("KeyframeTrack: Time is not a valid number.", this, t, r), e = !1;
				break;
			}
			if (a !== null && a > r) {
				R("KeyframeTrack: Out of order keys.", this, t, r, a), e = !1;
				break;
			}
			a = r;
		}
		if (r !== void 0 && F(r)) for (let t = 0, n = r.length; t !== n; ++t) {
			let n = r[t];
			if (isNaN(n)) {
				R("KeyframeTrack: Value is not a valid number.", this, t, n), e = !1;
				break;
			}
		}
		return e;
	}
	optimize() {
		let e = this.times.slice(), t = this.values.slice(), n = this.getValueSize(), r = this.getInterpolation() === C, i = e.length - 1, a = 1;
		for (let o = 1; o < i; ++o) {
			let i = !1, s = e[o];
			if (s !== e[o + 1] && (o !== 1 || s !== e[0])) if (r) i = !0;
			else {
				let e = o * n, r = e - n, a = e + n;
				for (let o = 0; o !== n; ++o) {
					let n = t[e + o];
					if (n !== t[r + o] || n !== t[a + o]) {
						i = !0;
						break;
					}
				}
			}
			if (i) {
				if (o !== a) {
					e[a] = e[o];
					let r = o * n, i = a * n;
					for (let e = 0; e !== n; ++e) t[i + e] = t[r + e];
				}
				++a;
			}
		}
		if (i > 0) {
			e[a] = e[i];
			for (let e = i * n, r = a * n, o = 0; o !== n; ++o) t[r + o] = t[e + o];
			++a;
		}
		return a === e.length ? (this.times = e, this.values = t) : (this.times = e.slice(0, a), this.values = t.slice(0, a * n)), this;
	}
	clone() {
		let e = this.times.slice(), t = this.values.slice(), n = this.constructor, r = new n(this.name, e, t);
		return r.createInterpolant = this.createInterpolant, r;
	}
};
_a.prototype.ValueTypeName = "", _a.prototype.TimeBufferType = Float32Array, _a.prototype.ValueBufferType = Float32Array, _a.prototype.DefaultInterpolation = S;
var va = class extends _a {
	constructor(e, t, n) {
		super(e, t, n);
	}
};
va.prototype.ValueTypeName = "bool", va.prototype.ValueBufferType = Array, va.prototype.DefaultInterpolation = x, va.prototype.InterpolantFactoryMethodLinear = void 0, va.prototype.InterpolantFactoryMethodSmooth = void 0;
var ya = class extends _a {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
};
ya.prototype.ValueTypeName = "color";
var ba = class extends _a {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
};
ba.prototype.ValueTypeName = "number";
var xa = class extends fa {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
	interpolate_(e, t, n, r) {
		let i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = (n - t) / (r - t), c = e * o;
		for (let e = c + o; c !== e; c += 4) W.slerpFlat(i, 0, a, c - o, a, c, s);
		return i;
	}
}, Sa = class extends _a {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
	InterpolantFactoryMethodLinear(e) {
		return new xa(this.times, this.values, this.getValueSize(), e);
	}
};
Sa.prototype.ValueTypeName = "quaternion", Sa.prototype.InterpolantFactoryMethodSmooth = void 0;
var Ca = class extends _a {
	constructor(e, t, n) {
		super(e, t, n);
	}
};
Ca.prototype.ValueTypeName = "string", Ca.prototype.ValueBufferType = Array, Ca.prototype.DefaultInterpolation = x, Ca.prototype.InterpolantFactoryMethodLinear = void 0, Ca.prototype.InterpolantFactoryMethodSmooth = void 0;
var wa = class extends _a {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
};
wa.prototype.ValueTypeName = "vector";
var Ta = {
	enabled: !1,
	files: {},
	add: function(e, t) {
		this.enabled !== !1 && (Ea(e) || (this.files[e] = t));
	},
	get: function(e) {
		if (this.enabled !== !1 && !Ea(e)) return this.files[e];
	},
	remove: function(e) {
		delete this.files[e];
	},
	clear: function() {
		this.files = {};
	}
};
function Ea(e) {
	try {
		let t = e.slice(e.indexOf(":") + 1);
		return new URL(t).protocol === "blob:";
	} catch {
		return !1;
	}
}
var Da = /*@__PURE__*/ new class {
	constructor(e, t, n) {
		let r = this, i = !1, a = 0, o = 0, s, c = [];
		this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = n, this._abortController = null, this.itemStart = function(e) {
			o++, i === !1 && r.onStart !== void 0 && r.onStart(e, a, o), i = !0;
		}, this.itemEnd = function(e) {
			a++, r.onProgress !== void 0 && r.onProgress(e, a, o), a === o && (i = !1, r.onLoad !== void 0 && r.onLoad());
		}, this.itemError = function(e) {
			r.onError !== void 0 && r.onError(e);
		}, this.resolveURL = function(e) {
			return e = e.normalize("NFC"), s ? s(e) : e;
		}, this.setURLModifier = function(e) {
			return s = e, this;
		}, this.addHandler = function(e, t) {
			return c.push(e, t), this;
		}, this.removeHandler = function(e) {
			let t = c.indexOf(e);
			return t !== -1 && c.splice(t, 2), this;
		}, this.getHandler = function(e) {
			for (let t = 0, n = c.length; t < n; t += 2) {
				let n = c[t], r = c[t + 1];
				if (n.global && (n.lastIndex = 0), n.test(e)) return r;
			}
			return null;
		}, this.abort = function() {
			return this.abortController.abort(), this._abortController = null, this;
		};
	}
	get abortController() {
		return this._abortController ||= new AbortController(), this._abortController;
	}
}(), Oa = class {
	constructor(e) {
		this.manager = e === void 0 ? Da : e, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {}, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
	}
	load() {}
	loadAsync(e, t) {
		let n = this;
		return new Promise(function(r, i) {
			n.load(e, r, t, i);
		});
	}
	parse() {}
	setCrossOrigin(e) {
		return this.crossOrigin = e, this;
	}
	setWithCredentials(e) {
		return this.withCredentials = e, this;
	}
	setPath(e) {
		return this.path = e, this;
	}
	setResourcePath(e) {
		return this.resourcePath = e, this;
	}
	setRequestHeader(e) {
		return this.requestHeader = e, this;
	}
	abort() {
		return this;
	}
};
Oa.DEFAULT_MATERIAL_NAME = "__DEFAULT";
var ka = /* @__PURE__ */ new WeakMap(), Aa = class extends Oa {
	constructor(e) {
		super(e);
	}
	load(e, t, n, r) {
		this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
		let i = this, a = Ta.get(`image:${e}`);
		if (a !== void 0) {
			if (a.complete === !0) i.manager.itemStart(e), setTimeout(function() {
				t && t(a), i.manager.itemEnd(e);
			}, 0);
			else {
				let e = ka.get(a);
				e === void 0 && (e = [], ka.set(a, e)), e.push({
					onLoad: t,
					onError: r
				});
			}
			return a;
		}
		let o = te("img");
		function s() {
			l(), t && t(this);
			let n = ka.get(this) || [];
			for (let e = 0; e < n.length; e++) {
				let t = n[e];
				t.onLoad && t.onLoad(this);
			}
			ka.delete(this), i.manager.itemEnd(e);
		}
		function c(t) {
			l(), r && r(t), Ta.remove(`image:${e}`);
			let n = ka.get(this) || [];
			for (let e = 0; e < n.length; e++) {
				let r = n[e];
				r.onError && r.onError(t);
			}
			ka.delete(this), i.manager.itemError(e), i.manager.itemEnd(e);
		}
		function l() {
			o.removeEventListener("load", s, !1), o.removeEventListener("error", c, !1);
		}
		return o.addEventListener("load", s, !1), o.addEventListener("error", c, !1), e.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (o.crossOrigin = this.crossOrigin), Ta.add(`image:${e}`, o), i.manager.itemStart(e), o.src = e, o;
	}
}, ja = class extends Oa {
	constructor(e) {
		super(e);
	}
	load(e, t, n, r) {
		let i = new We(), a = new Aa(this.manager);
		return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e, function(e) {
			i.image = e, i.needsUpdate = !0, t !== void 0 && t(i);
		}, n, r), i;
	}
}, Ma = class extends Ct {
	constructor(e, t = 1) {
		super(), this.isLight = !0, this.type = "Light", this.color = new Z(e), this.intensity = t;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
	copy(e, t) {
		return super.copy(e, t), this.color.copy(e.color), this.intensity = e.intensity, this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, t;
	}
}, Na = class extends Ma {
	constructor(e, t, n) {
		super(e, n), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(Ct.DEFAULT_UP), this.updateMatrix(), this.groundColor = new Z(t);
	}
	copy(e, t) {
		return super.copy(e, t), this.groundColor.copy(e.groundColor), this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.groundColor = this.groundColor.getHex(), t;
	}
}, Pa = /*@__PURE__*/ new Xe(), Fa = /*@__PURE__*/ new G(), Ia = /*@__PURE__*/ new G(), La = class {
	constructor(e) {
		this.camera = e, this.intensity = 1, this.bias = 0, this.biasNode = null, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new U(512, 512), this.mapType = o, this.map = null, this.mapPass = null, this.matrix = new Xe(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new Er(), this._frameExtents = new U(1, 1), this._viewportCount = 1, this._viewports = [new Ge(0, 0, 1, 1)];
	}
	getViewportCount() {
		return this._viewportCount;
	}
	getFrustum() {
		return this._frustum;
	}
	updateMatrices(e) {
		let t = this.camera, n = this.matrix;
		Fa.setFromMatrixPosition(e.matrixWorld), t.position.copy(Fa), Ia.setFromMatrixPosition(e.target.matrixWorld), t.lookAt(Ia), t.updateMatrixWorld(), Pa.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), this._frustum.setFromProjectionMatrix(Pa, t.coordinateSystem, t.reversedDepth), t.coordinateSystem === 2001 || t.reversedDepth ? n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, 1, 0, 0, 0, 0, 1) : n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(Pa);
	}
	getViewport(e) {
		return this._viewports[e];
	}
	getFrameExtents() {
		return this._frameExtents;
	}
	dispose() {
		this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
	}
	copy(e) {
		return this.camera = e.camera.clone(), this.intensity = e.intensity, this.bias = e.bias, this.radius = e.radius, this.autoUpdate = e.autoUpdate, this.needsUpdate = e.needsUpdate, this.normalBias = e.normalBias, this.blurSamples = e.blurSamples, this.mapSize.copy(e.mapSize), this.biasNode = e.biasNode, this;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	toJSON() {
		let e = {};
		return this.intensity !== 1 && (e.intensity = this.intensity), this.bias !== 0 && (e.bias = this.bias), this.normalBias !== 0 && (e.normalBias = this.normalBias), this.radius !== 1 && (e.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
	}
}, Ra = /*@__PURE__*/ new G(), za = /*@__PURE__*/ new W(), Ba = /*@__PURE__*/ new G(), Va = class extends Ct {
	constructor() {
		super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Xe(), this.projectionMatrix = new Xe(), this.projectionMatrixInverse = new Xe(), this.coordinateSystem = ee, this._reversedDepth = !1;
	}
	get reversedDepth() {
		return this._reversedDepth;
	}
	copy(e, t) {
		return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
	}
	getWorldDirection(e) {
		return super.getWorldDirection(e).negate();
	}
	updateMatrixWorld(e) {
		super.updateMatrixWorld(e), this.matrixWorld.decompose(Ra, za, Ba), Ba.x === 1 && Ba.y === 1 && Ba.z === 1 ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose(Ra, za, Ba.set(1, 1, 1)).invert();
	}
	updateWorldMatrix(e, t, n = !1) {
		super.updateWorldMatrix(e, t, n), this.matrixWorld.decompose(Ra, za, Ba), Ba.x === 1 && Ba.y === 1 && Ba.z === 1 ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose(Ra, za, Ba.set(1, 1, 1)).invert();
	}
	clone() {
		return new this.constructor().copy(this);
	}
}, Ha = /*@__PURE__*/ new G(), Ua = /*@__PURE__*/ new U(), Wa = /*@__PURE__*/ new U(), Ga = class extends Va {
	constructor(e = 50, t = 1, n = .1, r = 2e3) {
		super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = n, this.far = r, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
	}
	copy(e, t) {
		return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
	}
	setFocalLength(e) {
		let t = .5 * this.getFilmHeight() / e;
		this.fov = z * 2 * Math.atan(t), this.updateProjectionMatrix();
	}
	getFocalLength() {
		let e = Math.tan(de * .5 * this.fov);
		return .5 * this.getFilmHeight() / e;
	}
	getEffectiveFOV() {
		return z * 2 * Math.atan(Math.tan(de * .5 * this.fov) / this.zoom);
	}
	getFilmWidth() {
		return this.filmGauge * Math.min(this.aspect, 1);
	}
	getFilmHeight() {
		return this.filmGauge / Math.max(this.aspect, 1);
	}
	getViewBounds(e, t, n) {
		Ha.set(-1, -1, .5).applyMatrix4(this.projectionMatrixInverse), t.set(Ha.x, Ha.y).multiplyScalar(-e / Ha.z), Ha.set(1, 1, .5).applyMatrix4(this.projectionMatrixInverse), n.set(Ha.x, Ha.y).multiplyScalar(-e / Ha.z);
	}
	getViewSize(e, t) {
		return this.getViewBounds(e, Ua, Wa), t.subVectors(Wa, Ua);
	}
	setViewOffset(e, t, n, r, i, a) {
		this.aspect = e / t, this.view === null && (this.view = {
			enabled: !0,
			fullWidth: 1,
			fullHeight: 1,
			offsetX: 0,
			offsetY: 0,
			width: 1,
			height: 1
		}), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = r, this.view.width = i, this.view.height = a, this.updateProjectionMatrix();
	}
	clearViewOffset() {
		this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
	}
	updateProjectionMatrix() {
		let e = this.near, t = e * Math.tan(de * .5 * this.fov) / this.zoom, n = 2 * t, r = this.aspect * n, i = -.5 * r, a = this.view;
		if (this.view !== null && this.view.enabled) {
			let e = a.fullWidth, o = a.fullHeight;
			i += a.offsetX * r / e, t -= a.offsetY * n / o, r *= a.width / e, n *= a.height / o;
		}
		let o = this.filmOffset;
		o !== 0 && (i += e * o / this.getFilmWidth()), this.projectionMatrix.makePerspective(i, i + r, t, t - n, e, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
	}
}, Ka = class extends Va {
	constructor(e = -1, t = 1, n = 1, r = -1, i = .1, a = 2e3) {
		super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = n, this.bottom = r, this.near = i, this.far = a, this.updateProjectionMatrix();
	}
	copy(e, t) {
		return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
	}
	setViewOffset(e, t, n, r, i, a) {
		this.view === null && (this.view = {
			enabled: !0,
			fullWidth: 1,
			fullHeight: 1,
			offsetX: 0,
			offsetY: 0,
			width: 1,
			height: 1
		}), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = r, this.view.width = i, this.view.height = a, this.updateProjectionMatrix();
	}
	clearViewOffset() {
		this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
	}
	updateProjectionMatrix() {
		let e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, r = (this.top + this.bottom) / 2, i = n - e, a = n + e, o = r + t, s = r - t;
		if (this.view !== null && this.view.enabled) {
			let e = (this.right - this.left) / this.view.fullWidth / this.zoom, t = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
			i += e * this.view.offsetX, a = i + e * this.view.width, o -= t * this.view.offsetY, s = o - t * this.view.height;
		}
		this.projectionMatrix.makeOrthographic(i, a, o, s, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
	}
}, qa = class extends La {
	constructor() {
		super(new Ka(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
	}
}, Ja = class extends Ma {
	constructor(e, t) {
		super(e, t), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(Ct.DEFAULT_UP), this.updateMatrix(), this.target = new Ct(), this.shadow = new qa();
	}
	dispose() {
		super.dispose(), this.shadow.dispose();
	}
	copy(e) {
		return super.copy(e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.shadow = this.shadow.toJSON(), t.object.target = this.target.uuid, t;
	}
}, Ya = -90, Xa = 1, Za = class extends Ct {
	constructor(e, t, n) {
		super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null, this.activeMipmapLevel = 0;
		let r = new Ga(Ya, Xa, e, t);
		r.layers = this.layers, this.add(r);
		let i = new Ga(Ya, Xa, e, t);
		i.layers = this.layers, this.add(i);
		let a = new Ga(Ya, Xa, e, t);
		a.layers = this.layers, this.add(a);
		let o = new Ga(Ya, Xa, e, t);
		o.layers = this.layers, this.add(o);
		let s = new Ga(Ya, Xa, e, t);
		s.layers = this.layers, this.add(s);
		let c = new Ga(Ya, Xa, e, t);
		c.layers = this.layers, this.add(c);
	}
	updateCoordinateSystem() {
		let e = this.coordinateSystem, t = this.children.concat(), [n, r, i, a, o, s] = t;
		for (let e of t) this.remove(e);
		if (e === 2e3) n.up.set(0, 1, 0), n.lookAt(1, 0, 0), r.up.set(0, 1, 0), r.lookAt(-1, 0, 0), i.up.set(0, 0, -1), i.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), o.up.set(0, 1, 0), o.lookAt(0, 0, 1), s.up.set(0, 1, 0), s.lookAt(0, 0, -1);
		else if (e === 2001) n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), r.up.set(0, -1, 0), r.lookAt(1, 0, 0), i.up.set(0, 0, 1), i.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), o.up.set(0, -1, 0), o.lookAt(0, 0, 1), s.up.set(0, -1, 0), s.lookAt(0, 0, -1);
		else throw Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
		for (let e of t) this.add(e), e.updateMatrixWorld();
	}
	update(e, t) {
		this.parent === null && this.updateMatrixWorld();
		let { renderTarget: n, activeMipmapLevel: r } = this;
		this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
		let [i, a, o, s, c, l] = this.children, u = e.getRenderTarget(), d = e.getActiveCubeFace(), f = e.getActiveMipmapLevel(), p = e.xr.enabled;
		e.xr.enabled = !1;
		let m = n.texture.generateMipmaps;
		n.texture.generateMipmaps = !1;
		let h = !1;
		h = e.isWebGLRenderer === !0 ? e.state.buffers.depth.getReversed() : e.reversedDepthBuffer, e.setRenderTarget(n, 0, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, i), e.setRenderTarget(n, 1, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, a), e.setRenderTarget(n, 2, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, o), e.setRenderTarget(n, 3, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, s), e.setRenderTarget(n, 4, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, c), n.texture.generateMipmaps = m, e.setRenderTarget(n, 5, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, l), e.setRenderTarget(u, d, f), e.xr.enabled = p, n.texture.needsPMREMUpdate = !0;
	}
}, Qa = class extends Ga {
	constructor(e = []) {
		super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = e;
	}
}, $a = class {
	constructor() {
		this._previousTime = 0, this._currentTime = 0, this._startTime = performance.now(), this._delta = 0, this._elapsed = 0, this._timescale = 1, this._document = null, this._pageVisibilityHandler = null;
	}
	connect(e) {
		this._document = e, e.hidden !== void 0 && (this._pageVisibilityHandler = eo.bind(this), e.addEventListener("visibilitychange", this._pageVisibilityHandler, !1));
	}
	disconnect() {
		this._pageVisibilityHandler !== null && (this._document.removeEventListener("visibilitychange", this._pageVisibilityHandler), this._pageVisibilityHandler = null), this._document = null;
	}
	getDelta() {
		return this._delta / 1e3;
	}
	getElapsed() {
		return this._elapsed / 1e3;
	}
	getTimescale() {
		return this._timescale;
	}
	setTimescale(e) {
		return this._timescale = e, this;
	}
	reset() {
		return this._currentTime = performance.now() - this._startTime, this;
	}
	dispose() {
		this.disconnect();
	}
	update(e) {
		return this._pageVisibilityHandler !== null && this._document.hidden === !0 ? this._delta = 0 : (this._previousTime = this._currentTime, this._currentTime = (e === void 0 ? performance.now() : e) - this._startTime, this._delta = (this._currentTime - this._previousTime) * this._timescale, this._elapsed += this._delta), this;
	}
};
function eo() {
	this._document.hidden === !1 && this.reset();
}
var to = "\\[\\]\\.:\\/", no = /* @__PURE__ */ RegExp("[\\[\\]\\.:\\/]", "g"), ro = "[^\\[\\]\\.:\\/]", io = "[^" + to.replace("\\.", "") + "]", ao = /*@__PURE__*/ "((?:WC+[\\/:])*)".replace("WC", ro), oo = /*@__PURE__*/ "(WCOD+)?".replace("WCOD", io), so = /*@__PURE__*/ "(?:\\.(WC+)(?:\\[(.+)\\])?)?".replace("WC", ro), co = /*@__PURE__*/ "\\.(WC+)(?:\\[(.+)\\])?".replace("WC", ro), lo = RegExp("^" + ao + oo + so + co + "$"), uo = [
	"material",
	"materials",
	"bones",
	"map"
], fo = class {
	constructor(e, t, n) {
		let r = n || po.parseTrackName(t);
		this._targetGroup = e, this._bindings = e.subscribe_(t, r);
	}
	getValue(e, t) {
		this.bind();
		let n = this._targetGroup.nCachedObjects_, r = this._bindings[n];
		r !== void 0 && r.getValue(e, t);
	}
	setValue(e, t) {
		let n = this._bindings;
		for (let r = this._targetGroup.nCachedObjects_, i = n.length; r !== i; ++r) n[r].setValue(e, t);
	}
	bind() {
		let e = this._bindings;
		for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t) e[t].bind();
	}
	unbind() {
		let e = this._bindings;
		for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t) e[t].unbind();
	}
}, po = class e {
	constructor(t, n, r) {
		this.path = n, this.parsedPath = r || e.parseTrackName(n), this.node = e.findNode(t, this.parsedPath.nodeName), this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
	}
	static create(t, n, r) {
		return t && t.isAnimationObjectGroup ? new e.Composite(t, n, r) : new e(t, n, r);
	}
	static sanitizeNodeName(e) {
		return e.replace(/\s/g, "_").replace(no, "");
	}
	static parseTrackName(e) {
		let t = lo.exec(e);
		if (t === null) throw Error("THREE.PropertyBinding: Cannot parse trackName: " + e);
		let n = {
			nodeName: t[2],
			objectName: t[3],
			objectIndex: t[4],
			propertyName: t[5],
			propertyIndex: t[6]
		}, r = n.nodeName && n.nodeName.lastIndexOf(".");
		if (r !== void 0 && r !== -1) {
			let e = n.nodeName.substring(r + 1);
			uo.indexOf(e) !== -1 && (n.nodeName = n.nodeName.substring(0, r), n.objectName = e);
		}
		if (n.propertyName === null || n.propertyName.length === 0) throw Error("THREE.PropertyBinding: can not parse propertyName from trackName: " + e);
		return n;
	}
	static findNode(e, t) {
		if (t === void 0 || t === "" || t === "." || t === -1 || t === e.name || t === e.uuid) return e;
		if (e.skeleton) {
			let n = e.skeleton.getBoneByName(t);
			if (n !== void 0) return n;
		}
		if (e.children) {
			let n = function(e) {
				for (let r = 0; r < e.length; r++) {
					let i = e[r];
					if (i.name === t || i.uuid === t) return i;
					let a = n(i.children);
					if (a) return a;
				}
				return null;
			}, r = n(e.children);
			if (r) return r;
		}
		return null;
	}
	_getValue_unavailable() {}
	_setValue_unavailable() {}
	_getValue_direct(e, t) {
		e[t] = this.targetObject[this.propertyName];
	}
	_getValue_array(e, t) {
		let n = this.resolvedProperty;
		for (let r = 0, i = n.length; r !== i; ++r) e[t++] = n[r];
	}
	_getValue_arrayElement(e, t) {
		e[t] = this.resolvedProperty[this.propertyIndex];
	}
	_getValue_toArray(e, t) {
		this.resolvedProperty.toArray(e, t);
	}
	_setValue_direct(e, t) {
		this.targetObject[this.propertyName] = e[t];
	}
	_setValue_direct_setNeedsUpdate(e, t) {
		this.targetObject[this.propertyName] = e[t], this.targetObject.needsUpdate = !0;
	}
	_setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
		this.targetObject[this.propertyName] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
	}
	_setValue_array(e, t) {
		let n = this.resolvedProperty;
		for (let r = 0, i = n.length; r !== i; ++r) n[r] = e[t++];
	}
	_setValue_array_setNeedsUpdate(e, t) {
		let n = this.resolvedProperty;
		for (let r = 0, i = n.length; r !== i; ++r) n[r] = e[t++];
		this.targetObject.needsUpdate = !0;
	}
	_setValue_array_setMatrixWorldNeedsUpdate(e, t) {
		let n = this.resolvedProperty;
		for (let r = 0, i = n.length; r !== i; ++r) n[r] = e[t++];
		this.targetObject.matrixWorldNeedsUpdate = !0;
	}
	_setValue_arrayElement(e, t) {
		this.resolvedProperty[this.propertyIndex] = e[t];
	}
	_setValue_arrayElement_setNeedsUpdate(e, t) {
		this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.needsUpdate = !0;
	}
	_setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
		this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
	}
	_setValue_fromArray(e, t) {
		this.resolvedProperty.fromArray(e, t);
	}
	_setValue_fromArray_setNeedsUpdate(e, t) {
		this.resolvedProperty.fromArray(e, t), this.targetObject.needsUpdate = !0;
	}
	_setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
		this.resolvedProperty.fromArray(e, t), this.targetObject.matrixWorldNeedsUpdate = !0;
	}
	_getValue_unbound(e, t) {
		this.bind(), this.getValue(e, t);
	}
	_setValue_unbound(e, t) {
		this.bind(), this.setValue(e, t);
	}
	bind() {
		let t = this.node, n = this.parsedPath, r = n.objectName, i = n.propertyName, a = n.propertyIndex;
		if (t || (t = e.findNode(this.rootNode, n.nodeName), this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) {
			L("PropertyBinding: No target node found for track: " + this.path + ".");
			return;
		}
		if (r) {
			let e = n.objectIndex;
			switch (r) {
				case "materials":
					if (!t.material) {
						R("PropertyBinding: Can not bind to material as node does not have a material.", this);
						return;
					}
					if (!t.material.materials) {
						R("PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
						return;
					}
					t = t.material.materials;
					break;
				case "bones":
					if (!t.skeleton) {
						R("PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
						return;
					}
					t = t.skeleton.bones;
					for (let n = 0; n < t.length; n++) if (t[n].name === e) {
						e = n;
						break;
					}
					break;
				case "map":
					if ("map" in t) {
						t = t.map;
						break;
					}
					if (!t.material) {
						R("PropertyBinding: Can not bind to material as node does not have a material.", this);
						return;
					}
					if (!t.material.map) {
						R("PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
						return;
					}
					t = t.material.map;
					break;
				default:
					if (t[r] === void 0) {
						R("PropertyBinding: Can not bind to objectName of node undefined.", this);
						return;
					}
					t = t[r];
			}
			if (e !== void 0) {
				if (t[e] === void 0) {
					R("PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
					return;
				}
				t = t[e];
			}
		}
		let o = t[i];
		if (o === void 0) {
			let e = n.nodeName;
			R("PropertyBinding: Trying to update property for track: " + e + "." + i + " but it wasn't found.", t);
			return;
		}
		let s = this.Versioning.None;
		this.targetObject = t, t.isMaterial === !0 ? s = this.Versioning.NeedsUpdate : t.isObject3D === !0 && (s = this.Versioning.MatrixWorldNeedsUpdate);
		let c = this.BindingType.Direct;
		if (a !== void 0) {
			if (i === "morphTargetInfluences") {
				if (!t.geometry) {
					R("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
					return;
				}
				if (!t.geometry.morphAttributes) {
					R("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
					return;
				}
				t.morphTargetDictionary[a] !== void 0 && (a = t.morphTargetDictionary[a]);
			}
			c = this.BindingType.ArrayElement, this.resolvedProperty = o, this.propertyIndex = a;
		} else o.fromArray !== void 0 && o.toArray !== void 0 ? (c = this.BindingType.HasFromToArray, this.resolvedProperty = o) : Array.isArray(o) ? (c = this.BindingType.EntireArray, this.resolvedProperty = o) : this.propertyName = i;
		this.getValue = this.GetterByBindingType[c], this.setValue = this.SetterByBindingTypeAndVersioning[c][s];
	}
	unbind() {
		this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
	}
};
po.Composite = fo, po.prototype.BindingType = {
	Direct: 0,
	EntireArray: 1,
	ArrayElement: 2,
	HasFromToArray: 3
}, po.prototype.Versioning = {
	None: 0,
	NeedsUpdate: 1,
	MatrixWorldNeedsUpdate: 2
}, po.prototype.GetterByBindingType = [
	po.prototype._getValue_direct,
	po.prototype._getValue_array,
	po.prototype._getValue_arrayElement,
	po.prototype._getValue_toArray
], po.prototype.SetterByBindingTypeAndVersioning = [
	[
		po.prototype._setValue_direct,
		po.prototype._setValue_direct_setNeedsUpdate,
		po.prototype._setValue_direct_setMatrixWorldNeedsUpdate
	],
	[
		po.prototype._setValue_array,
		po.prototype._setValue_array_setNeedsUpdate,
		po.prototype._setValue_array_setMatrixWorldNeedsUpdate
	],
	[
		po.prototype._setValue_arrayElement,
		po.prototype._setValue_arrayElement_setNeedsUpdate,
		po.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
	],
	[
		po.prototype._setValue_fromArray,
		po.prototype._setValue_fromArray_setNeedsUpdate,
		po.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
	]
];
var mo = /*@__PURE__*/ new Xe(), ho = class {
	constructor(e, t, n = 0, r = Infinity) {
		this.ray = new nr(e, t), this.near = n, this.far = r, this.camera = null, this.layers = new st(), this.params = {
			Mesh: {},
			Line: { threshold: 1 },
			LOD: {},
			Points: { threshold: 1 },
			Sprite: {}
		};
	}
	set(e, t) {
		this.ray.set(e, t);
	}
	setFromCamera(e, t) {
		t.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(e.x, e.y, .5).unproject(t).sub(this.ray.origin).normalize(), this.camera = t) : t.isOrthographicCamera ? (this.ray.origin.set(e.x, e.y, t.projectionMatrix.elements[14]).unproject(t), this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld), this.camera = t) : R("Raycaster: Unsupported camera type: " + t.type);
	}
	setFromXRController(e) {
		return mo.identity().extractRotation(e.matrixWorld), this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4(mo), this;
	}
	intersectObject(e, t = !0, n = []) {
		return _o(e, this, n, t), n.sort(go), n;
	}
	intersectObjects(e, t = !0, n = []) {
		for (let r = 0, i = e.length; r < i; r++) _o(e[r], this, n, t);
		return n.sort(go), n;
	}
};
function go(e, t) {
	return e.distance - t.distance;
}
function _o(e, t, n, r) {
	let i = !0;
	if (e.layers.test(t.layers) && e.raycast(t, n) === !1 && (i = !1), i === !0 && r === !0) {
		let r = e.children;
		for (let e = 0, i = r.length; e < i; e++) _o(r[e], t, n, !0);
	}
}
(class e {
	static {
		e.prototype.isMatrix2 = !0;
	}
	constructor(e, t, n, r) {
		this.elements = [
			1,
			0,
			0,
			1
		], e !== void 0 && this.set(e, t, n, r);
	}
	identity() {
		return this.set(1, 0, 0, 1), this;
	}
	fromArray(e, t = 0) {
		for (let n = 0; n < 4; n++) this.elements[n] = e[n + t];
		return this;
	}
	set(e, t, n, r) {
		let i = this.elements;
		return i[0] = e, i[2] = t, i[1] = n, i[3] = r, this;
	}
});
function vo(e, t, n, r) {
	let i = yo(r);
	switch (n) {
		case 1021: return e * t;
		case 1028: return e * t / i.components * i.byteLength;
		case _: return e * t / i.components * i.byteLength;
		case v: return e * t * 2 / i.components * i.byteLength;
		case y: return e * t * 2 / i.components * i.byteLength;
		case 1022: return e * t * 3 / i.components * i.byteLength;
		case m: return e * t * 4 / i.components * i.byteLength;
		case b: return e * t * 4 / i.components * i.byteLength;
		case 33776:
		case 33777: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
		case 33778:
		case 33779: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
		case 35841:
		case 35843: return Math.max(e, 16) * Math.max(t, 8) / 4;
		case 35840:
		case 35842: return Math.max(e, 8) * Math.max(t, 8) / 2;
		case 36196:
		case 37492:
		case 37488:
		case 37489: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
		case 37496:
		case 37490:
		case 37491: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
		case 37808: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
		case 37809: return Math.floor((e + 4) / 5) * Math.floor((t + 3) / 4) * 16;
		case 37810: return Math.floor((e + 4) / 5) * Math.floor((t + 4) / 5) * 16;
		case 37811: return Math.floor((e + 5) / 6) * Math.floor((t + 4) / 5) * 16;
		case 37812: return Math.floor((e + 5) / 6) * Math.floor((t + 5) / 6) * 16;
		case 37813: return Math.floor((e + 7) / 8) * Math.floor((t + 4) / 5) * 16;
		case 37814: return Math.floor((e + 7) / 8) * Math.floor((t + 5) / 6) * 16;
		case 37815: return Math.floor((e + 7) / 8) * Math.floor((t + 7) / 8) * 16;
		case 37816: return Math.floor((e + 9) / 10) * Math.floor((t + 4) / 5) * 16;
		case 37817: return Math.floor((e + 9) / 10) * Math.floor((t + 5) / 6) * 16;
		case 37818: return Math.floor((e + 9) / 10) * Math.floor((t + 7) / 8) * 16;
		case 37819: return Math.floor((e + 9) / 10) * Math.floor((t + 9) / 10) * 16;
		case 37820: return Math.floor((e + 11) / 12) * Math.floor((t + 9) / 10) * 16;
		case 37821: return Math.floor((e + 11) / 12) * Math.floor((t + 11) / 12) * 16;
		case 36492:
		case 36494:
		case 36495: return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
		case 36283:
		case 36284: return Math.ceil(e / 4) * Math.ceil(t / 4) * 8;
		case 36285:
		case 36286: return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
	}
	throw Error(`Unable to determine texture byte length for ${n} format.`);
}
function yo(e) {
	switch (e) {
		case o:
		case 1010: return {
			byteLength: 1,
			components: 1
		};
		case s:
		case 1011:
		case u: return {
			byteLength: 2,
			components: 1
		};
		case d:
		case f: return {
			byteLength: 2,
			components: 4
		};
		case c:
		case 1013:
		case l: return {
			byteLength: 4,
			components: 1
		};
		case 35902:
		case 35899: return {
			byteLength: 4,
			components: 3
		};
	}
	throw Error(`THREE.TextureUtils: Unknown texture type ${e}.`);
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: { revision: "185" } })), typeof window < "u" && (window.__THREE__ ? L("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = "185");
//#endregion
//#region node_modules/three/build/three.module.js
function bo() {
	let e = null, t = !1, n = null, r = null;
	function i(t, a) {
		n(t, a), r = e.requestAnimationFrame(i);
	}
	return {
		start: function() {
			t !== !0 && n !== null && e !== null && (r = e.requestAnimationFrame(i), t = !0);
		},
		stop: function() {
			e !== null && e.cancelAnimationFrame(r), t = !1;
		},
		setAnimationLoop: function(e) {
			n = e;
		},
		setContext: function(t) {
			e = t;
		}
	};
}
function xo(e) {
	let t = /* @__PURE__ */ new WeakMap();
	function n(t, n) {
		let r = t.array, i = t.usage, a = r.byteLength, o = e.createBuffer();
		e.bindBuffer(n, o), e.bufferData(n, r, i), t.onUploadCallback();
		let s;
		if (r instanceof Float32Array) s = e.FLOAT;
		else if (typeof Float16Array < "u" && r instanceof Float16Array) s = e.HALF_FLOAT;
		else if (r instanceof Uint16Array) s = t.isFloat16BufferAttribute ? e.HALF_FLOAT : e.UNSIGNED_SHORT;
		else if (r instanceof Int16Array) s = e.SHORT;
		else if (r instanceof Uint32Array) s = e.UNSIGNED_INT;
		else if (r instanceof Int32Array) s = e.INT;
		else if (r instanceof Int8Array) s = e.BYTE;
		else if (r instanceof Uint8Array) s = e.UNSIGNED_BYTE;
		else if (r instanceof Uint8ClampedArray) s = e.UNSIGNED_BYTE;
		else throw Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
		return {
			buffer: o,
			type: s,
			bytesPerElement: r.BYTES_PER_ELEMENT,
			version: t.version,
			size: a
		};
	}
	function r(t, n, r) {
		let i = n.array, a = n.updateRanges;
		if (e.bindBuffer(r, t), a.length === 0) e.bufferSubData(r, 0, i);
		else {
			a.sort((e, t) => e.start - t.start);
			let t = 0;
			for (let e = 1; e < a.length; e++) {
				let n = a[t], r = a[e];
				r.start <= n.start + n.count + 1 ? n.count = Math.max(n.count, r.start + r.count - n.start) : (++t, a[t] = r);
			}
			a.length = t + 1;
			for (let t = 0, n = a.length; t < n; t++) {
				let n = a[t];
				e.bufferSubData(r, n.start * i.BYTES_PER_ELEMENT, i, n.start, n.count);
			}
			n.clearUpdateRanges();
		}
		n.onUploadCallback();
	}
	function i(e) {
		return e.isInterleavedBufferAttribute && (e = e.data), t.get(e);
	}
	function a(n) {
		n.isInterleavedBufferAttribute && (n = n.data);
		let r = t.get(n);
		r && (e.deleteBuffer(r.buffer), t.delete(n));
	}
	function o(e, i) {
		if (e.isInterleavedBufferAttribute && (e = e.data), e.isGLBufferAttribute) {
			let n = t.get(e);
			(!n || n.version < e.version) && t.set(e, {
				buffer: e.buffer,
				type: e.type,
				bytesPerElement: e.elementSize,
				version: e.version
			});
			return;
		}
		let a = t.get(e);
		if (a === void 0) t.set(e, n(e, i));
		else if (a.version < e.version) {
			if (a.size !== e.array.byteLength) throw Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
			r(a.buffer, e, i), a.version = e.version;
		}
	}
	return {
		get: i,
		remove: a,
		update: o
	};
}
var Q = {
	alphahash_fragment: "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
	alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif",
	alphamap_fragment: "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
	alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
	alphatest_fragment: "#ifdef USE_ALPHATEST\n	#ifdef ALPHA_TO_COVERAGE\n	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n	if ( diffuseColor.a == 0.0 ) discard;\n	#else\n	if ( diffuseColor.a < alphaTest ) discard;\n	#endif\n#endif",
	alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif",
	aomap_fragment: "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif",
	aomap_pars_fragment: "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif",
	batching_pars_vertex: "#ifdef USE_BATCHING\n	#if ! defined( GL_ANGLE_multi_draw )\n	#define gl_DrawID _gl_DrawID\n	uniform int _gl_DrawID;\n	#endif\n	uniform highp sampler2D batchingTexture;\n	uniform highp usampler2D batchingIdTexture;\n	mat4 getBatchingMatrix( const in float i ) {\n		int size = textureSize( batchingTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n	float getIndirectIndex( const in int i ) {\n		int size = textureSize( batchingIdTexture, 0 ).x;\n		int x = i % size;\n		int y = i / size;\n		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n	}\n#endif\n#ifdef USE_BATCHING_COLOR\n	uniform sampler2D batchingColorTexture;\n	vec4 getBatchingColor( const in float i ) {\n		int size = textureSize( batchingColorTexture, 0 ).x;\n		int j = int( i );\n		int x = j % size;\n		int y = j / size;\n		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 );\n	}\n#endif",
	batching_vertex: "#ifdef USE_BATCHING\n	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif",
	begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif",
	beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif",
	bsdfs: "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated",
	iridescence_fragment: "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif",
	bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif",
	clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#ifdef ALPHA_TO_COVERAGE\n		float distanceToPlane, distanceGradient;\n		float clipOpacity = 1.0;\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n			distanceGradient = fwidth( distanceToPlane ) / 2.0;\n			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			if ( clipOpacity == 0.0 ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			float unionClipOpacity = 1.0;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n				distanceGradient = fwidth( distanceToPlane ) / 2.0;\n				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			}\n			#pragma unroll_loop_end\n			clipOpacity *= 1.0 - unionClipOpacity;\n		#endif\n		diffuseColor.a *= clipOpacity;\n		if ( diffuseColor.a == 0.0 ) discard;\n	#else\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			bool clipped = true;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n			}\n			#pragma unroll_loop_end\n			if ( clipped ) discard;\n		#endif\n	#endif\n#endif",
	clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
	clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif",
	clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif",
	color_fragment: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#endif",
	color_pars_fragment: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#endif",
	color_pars_vertex: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	varying vec4 vColor;\n#endif",
	color_vertex: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	vColor = vec4( 1.0 );\n#endif\n#ifdef USE_COLOR_ALPHA\n	vColor *= color;\n#elif defined( USE_COLOR )\n	vColor.rgb *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.rgb *= instanceColor.rgb;\n#endif\n#ifdef USE_BATCHING_COLOR\n	vColor *= getBatchingColor( getIndirectIndex( gl_DrawID ) );\n#endif",
	common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\n#define inverseTransformDirection transformDirectionByInverseViewMatrix\nvec3 transformNormalByInverseViewMatrix( in vec3 normal, in mat4 viewMatrix ) {\n	return normalize( ( vec4( normal, 0.0 ) * viewMatrix ).xyz );\n}\nvec3 transformDirectionByInverseViewMatrix( in vec3 dir, in mat4 viewMatrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * viewMatrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
	cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif",
	defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n	vec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n	mat3 bm = mat3( batchingMatrix );\n	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n	transformedNormal = bm * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = bm * transformedTangent;\n	#endif\n#endif\n#ifdef USE_INSTANCING\n	mat3 im = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n	transformedNormal = im * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = im * transformedTangent;\n	#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n#endif",
	displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif",
	displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
	emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n		emissiveColor = sRGBTransferEOTF( emissiveColor );\n	#endif\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
	emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif",
	colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
	colorspace_pars_fragment: "vec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
	envmap_fragment: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, envMapRotation * reflectVec );\n		#ifdef ENVMAP_BLENDING_MULTIPLY\n			outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n		#elif defined( ENVMAP_BLENDING_MIX )\n			outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n		#elif defined( ENVMAP_BLENDING_ADD )\n			outgoingLight += envColor.xyz * specularStrength * reflectivity;\n		#endif\n	#endif\n#endif",
	envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform mat3 envMapRotation;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n#endif",
	envmap_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif",
	envmap_pars_vertex: "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif",
	envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n			reflectVec = transformDirectionByInverseViewMatrix( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif",
	envmap_vertex: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif",
	fog_vertex: "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif",
	fog_pars_vertex: "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif",
	fog_fragment: "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
	fog_pars_fragment: "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif",
	gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}",
	lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif",
	lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
	lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert",
	lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if ( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif\n#include <lightprobes_pars_fragment>",
	lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
	lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon",
	lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
	lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong",
	lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.metalness = metalnessFactor;\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;\n	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = vec3( 0.04 );\n	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n	material.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	if( material.anisotropy == 0.0 ) {\n		anisotropyV = vec2( 1.0, 0.0 );\n	} else {\n		anisotropyV /= material.anisotropy;\n		material.anisotropy = saturate( material.anisotropy );\n	}\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif",
	lights_physical_pars_fragment: "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n	vec3 diffuseColor;\n	vec3 diffuseContribution;\n	vec3 specularColor;\n	vec3 specularColorBlended;\n	float roughness;\n	float metalness;\n	float specularF90;\n	float dispersion;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n		vec3 iridescenceFresnelDielectric;\n		vec3 iridescenceFresnelMetallic;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		return 0.5 / max( gv + gl, EPSILON );\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColorBlended;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float rInv = 1.0 / ( roughness + 0.1 );\n	float a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;\n	float b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;\n	float DG = exp( a * dotNV + b );\n	return saturate( DG );\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	float dotNV = saturate( dot( normal, viewDir ) );\n	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	vec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;\n	vec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;\n	vec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;\n	vec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;\n	float Ess_V = dfgV.x + dfgV.y;\n	float Ess_L = dfgL.x + dfgL.y;\n	float Ems_V = 1.0 - Ess_V;\n	float Ems_L = 1.0 - Ess_L;\n	vec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;\n	vec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );\n	float compensationFactor = Ems_V * Ems_L;\n	vec3 multiScatter = Fms * compensationFactor;\n	return singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColorBlended * t2.x + ( material.specularF90 - material.specularColorBlended ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n		#ifdef USE_CLEARCOAT\n			vec3 Ncc = geometryClearcoatNormal;\n			vec2 uvClearcoat = LTC_Uv( Ncc, viewDir, material.clearcoatRoughness );\n			vec4 t1Clearcoat = texture2D( ltc_1, uvClearcoat );\n			vec4 t2Clearcoat = texture2D( ltc_2, uvClearcoat );\n			mat3 mInvClearcoat = mat3(\n				vec3( t1Clearcoat.x, 0, t1Clearcoat.y ),\n				vec3(             0, 1,             0 ),\n				vec3( t1Clearcoat.z, 0, t1Clearcoat.w )\n			);\n			vec3 fresnelClearcoat = material.clearcoatF0 * t2Clearcoat.x + ( material.clearcoatF90 - material.clearcoatF0 ) * t2Clearcoat.y;\n			clearcoatSpecularDirect += lightColor * fresnelClearcoat * LTC_Evaluate( Ncc, viewDir, position, mInvClearcoat, rectCoords );\n		#endif\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n \n 		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n \n 		float sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n 		float sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );\n \n 		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );\n \n 		irradiance *= sheenEnergyComp;\n \n 	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );\n	#ifdef USE_SHEEN\n		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n		diffuse *= sheenEnergyComp;\n	#endif\n	reflectedLight.indirectDiffuse += diffuse;\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;\n 	#endif\n	vec3 singleScatteringDielectric = vec3( 0.0 );\n	vec3 multiScatteringDielectric = vec3( 0.0 );\n	vec3 singleScatteringMetallic = vec3( 0.0 );\n	vec3 multiScatteringMetallic = vec3( 0.0 );\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n		computeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n	#endif\n	vec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );\n	vec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );\n	vec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;\n	vec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	vec3 indirectSpecular = radiance * singleScattering;\n	indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	vec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;\n	#ifdef USE_SHEEN\n		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n		indirectSpecular *= sheenEnergyComp;\n		indirectDiffuse *= sheenEnergyComp;\n	#endif\n	reflectedLight.indirectSpecular += indirectSpecular;\n	reflectedLight.indirectDiffuse += indirectDiffuse;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
	lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );\n		material.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n	#ifdef USE_LIGHT_PROBES_GRID\n		vec3 probeWorldPos = ( ( vec4( geometryPosition, 1.0 ) - viewMatrix[ 3 ] ) * viewMatrix ).xyz;\n		vec3 probeWorldNormal = transformNormalByInverseViewMatrix( geometryNormal, viewMatrix );\n		irradiance += getLightProbeGridIrradiance( probeWorldPos, probeWorldNormal );\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
	lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( ENVMAP_TYPE_CUBE_UV )\n		#if defined( STANDARD ) || defined( LAMBERT ) || defined( PHONG )\n			iblIrradiance += getIBLIrradiance( geometryNormal );\n		#endif\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif",
	lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n	#if defined( LAMBERT ) || defined( PHONG )\n		irradiance += iblIrradiance;\n	#endif\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
	lightprobes_pars_fragment: "#ifdef USE_LIGHT_PROBES_GRID\nuniform highp sampler3D probesSH;\nuniform vec3 probesMin;\nuniform vec3 probesMax;\nuniform vec3 probesResolution;\nvec3 getLightProbeGridIrradiance( vec3 worldPos, vec3 worldNormal ) {\n	vec3 res = probesResolution;\n	vec3 gridRange = probesMax - probesMin;\n	vec3 resMinusOne = res - 1.0;\n	vec3 probeSpacing = gridRange / resMinusOne;\n	vec3 samplePos = worldPos + worldNormal * probeSpacing * 0.5;\n	vec3 uvw = clamp( ( samplePos - probesMin ) / gridRange, 0.0, 1.0 );\n	uvw = uvw * resMinusOne / res + 0.5 / res;\n	float nz          = res.z;\n	float paddedSlices = nz + 2.0;\n	float atlasDepth  = 7.0 * paddedSlices;\n	float uvZBase     = uvw.z * nz + 1.0;\n	vec4 s0 = texture( probesSH, vec3( uvw.xy, ( uvZBase                       ) / atlasDepth ) );\n	vec4 s1 = texture( probesSH, vec3( uvw.xy, ( uvZBase +       paddedSlices   ) / atlasDepth ) );\n	vec4 s2 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 2.0 * paddedSlices   ) / atlasDepth ) );\n	vec4 s3 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 3.0 * paddedSlices   ) / atlasDepth ) );\n	vec4 s4 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 4.0 * paddedSlices   ) / atlasDepth ) );\n	vec4 s5 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 5.0 * paddedSlices   ) / atlasDepth ) );\n	vec4 s6 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 6.0 * paddedSlices   ) / atlasDepth ) );\n	vec3 c0 = s0.xyz;\n	vec3 c1 = vec3( s0.w, s1.xy );\n	vec3 c2 = vec3( s1.zw, s2.x );\n	vec3 c3 = s2.yzw;\n	vec3 c4 = s3.xyz;\n	vec3 c5 = vec3( s3.w, s4.xy );\n	vec3 c6 = vec3( s4.zw, s5.x );\n	vec3 c7 = s5.yzw;\n	vec3 c8 = s6.xyz;\n	float x = worldNormal.x, y = worldNormal.y, z = worldNormal.z;\n	vec3 result = c0 * 0.886227;\n	result += c1 * 2.0 * 0.511664 * y;\n	result += c2 * 2.0 * 0.511664 * z;\n	result += c3 * 2.0 * 0.511664 * x;\n	result += c4 * 2.0 * 0.429043 * x * y;\n	result += c5 * 2.0 * 0.429043 * y * z;\n	result += c6 * ( 0.743125 * z * z - 0.247708 );\n	result += c7 * 2.0 * 0.429043 * x * z;\n	result += c8 * 0.429043 * ( x * x - y * y );\n	return max( result, vec3( 0.0 ) );\n}\n#endif",
	logdepthbuf_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
	logdepthbuf_pars_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
	logdepthbuf_pars_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
	logdepthbuf_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n	vFragDepth = 1.0 + gl_Position.w;\n	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif",
	map_fragment: "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif",
	map_pars_fragment: "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif",
	map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
	map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
	metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif",
	metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif",
	morphinstance_vertex: "#ifdef USE_INSTANCING_MORPH\n	float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n	}\n#endif",
	morphcolor_vertex: "#if defined( USE_MORPHCOLORS )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif",
	morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif",
	morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n	#ifndef USE_INSTANCING_MORPH\n		uniform float morphTargetBaseInfluence;\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	#endif\n	uniform sampler2DArray morphTargetsTexture;\n	uniform ivec2 morphTargetsTextureSize;\n	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n		int y = texelIndex / morphTargetsTextureSize.x;\n		int x = texelIndex - y * morphTargetsTextureSize.x;\n		ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n		return texelFetch( morphTargetsTexture, morphUV, 0 );\n	}\n#endif",
	morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif",
	normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#ifdef DOUBLE_SIDED\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#ifdef DOUBLE_SIDED\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
	normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#if defined( USE_PACKED_NORMALMAP )\n		mapN = vec3( mapN.xy, sqrt( saturate( 1.0 - dot( mapN.xy, mapN.xy ) ) ) );\n	#endif\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
	normal_pars_fragment: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
	normal_pars_vertex: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
	normal_vertex: "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n		#ifdef FLIP_SIDED\n			vBitangent = - vBitangent;\n		#endif\n	#endif\n#endif",
	normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif",
	clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
	clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
	clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif",
	iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif",
	opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
	packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n	if( v <= 0.0 )\n		return vec4( 0., 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec4( 1., 1., 1., 1. );\n	float vuf;\n	float af = modf( v * PackFactors.a, vuf );\n	float bf = modf( vuf * ShiftRight8, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n	if( v <= 0.0 )\n		return vec3( 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec3( 1., 1., 1. );\n	float vuf;\n	float bf = modf( v * PackFactors.b, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n	if( v <= 0.0 )\n		return vec2( 0., 0. );\n	if( v >= 1.0 )\n		return vec2( 1., 1. );\n	float vuf;\n	float gf = modf( v * 256., vuf );\n	return vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n	return dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	#ifdef USE_REVERSED_DEPTH_BUFFER\n	\n		return depth * ( far - near ) - far;\n	#else\n		return depth * ( near - far ) - near;\n	#endif\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	\n	#ifdef USE_REVERSED_DEPTH_BUFFER\n		return ( near * far ) / ( ( near - far ) * depth - near );\n	#else\n		return ( near * far ) / ( ( far - near ) * depth - far );\n	#endif\n}",
	premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif",
	project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n	mvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
	dithering_fragment: "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
	dithering_pars_fragment: "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif",
	roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif",
	roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif",
	shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#if defined( SHADOWMAP_TYPE_PCF )\n			uniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		#else\n			uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		#endif\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		#if defined( SHADOWMAP_TYPE_PCF )\n			uniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		#else\n			uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		#endif\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#if defined( SHADOWMAP_TYPE_PCF )\n			uniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		#elif defined( SHADOWMAP_TYPE_BASIC )\n			uniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		#endif\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	#if defined( SHADOWMAP_TYPE_PCF )\n		float interleavedGradientNoise( vec2 position ) {\n			return fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );\n		}\n		vec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {\n			const float goldenAngle = 2.399963229728653;\n			float r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );\n			float theta = float( sampleIndex ) * goldenAngle + phi;\n			return vec2( cos( theta ), sin( theta ) ) * r;\n		}\n	#endif\n	#if defined( SHADOWMAP_TYPE_PCF )\n		float getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n			float shadow = 1.0;\n			shadowCoord.xyz /= shadowCoord.w;\n			shadowCoord.z += shadowBias;\n			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n			if ( frustumTest ) {\n				vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n				float radius = shadowRadius * texelSize.x;\n				float phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n				shadow = (\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )\n				) * 0.2;\n			}\n			return mix( 1.0, shadow, shadowIntensity );\n		}\n	#elif defined( SHADOWMAP_TYPE_VSM )\n		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n			float shadow = 1.0;\n			shadowCoord.xyz /= shadowCoord.w;\n			#ifdef USE_REVERSED_DEPTH_BUFFER\n				shadowCoord.z -= shadowBias;\n			#else\n				shadowCoord.z += shadowBias;\n			#endif\n			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n			if ( frustumTest ) {\n				vec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;\n				float mean = distribution.x;\n				float variance = distribution.y * distribution.y;\n				#ifdef USE_REVERSED_DEPTH_BUFFER\n					float hard_shadow = step( mean, shadowCoord.z );\n				#else\n					float hard_shadow = step( shadowCoord.z, mean );\n				#endif\n				\n				if ( hard_shadow == 1.0 ) {\n					shadow = 1.0;\n				} else {\n					variance = max( variance, 0.0000001 );\n					float d = shadowCoord.z - mean;\n					float p_max = variance / ( variance + d * d );\n					p_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );\n					shadow = max( hard_shadow, p_max );\n				}\n			}\n			return mix( 1.0, shadow, shadowIntensity );\n		}\n	#else\n		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n			float shadow = 1.0;\n			shadowCoord.xyz /= shadowCoord.w;\n			#ifdef USE_REVERSED_DEPTH_BUFFER\n				shadowCoord.z -= shadowBias;\n			#else\n				shadowCoord.z += shadowBias;\n			#endif\n			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n			if ( frustumTest ) {\n				float depth = texture2D( shadowMap, shadowCoord.xy ).r;\n				#ifdef USE_REVERSED_DEPTH_BUFFER\n					shadow = step( depth, shadowCoord.z );\n				#else\n					shadow = step( shadowCoord.z, depth );\n				#endif\n			}\n			return mix( 1.0, shadow, shadowIntensity );\n		}\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	#if defined( SHADOWMAP_TYPE_PCF )\n	float getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		vec3 bd3D = normalize( lightToPosition );\n		vec3 absVec = abs( lightToPosition );\n		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n			#ifdef USE_REVERSED_DEPTH_BUFFER\n				float dp = ( shadowCameraNear * ( shadowCameraFar - viewSpaceZ ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n				dp -= shadowBias;\n			#else\n				float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n				dp += shadowBias;\n			#endif\n			float texelSize = shadowRadius / shadowMapSize.x;\n			vec3 absDir = abs( bd3D );\n			vec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );\n			tangent = normalize( cross( bd3D, tangent ) );\n			vec3 bitangent = cross( bd3D, tangent );\n			float phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n			vec2 sample0 = vogelDiskSample( 0, 5, phi );\n			vec2 sample1 = vogelDiskSample( 1, 5, phi );\n			vec2 sample2 = vogelDiskSample( 2, 5, phi );\n			vec2 sample3 = vogelDiskSample( 3, 5, phi );\n			vec2 sample4 = vogelDiskSample( 4, 5, phi );\n			shadow = (\n				texture( shadowMap, vec4( bd3D + ( tangent * sample0.x + bitangent * sample0.y ) * texelSize, dp ) ) +\n				texture( shadowMap, vec4( bd3D + ( tangent * sample1.x + bitangent * sample1.y ) * texelSize, dp ) ) +\n				texture( shadowMap, vec4( bd3D + ( tangent * sample2.x + bitangent * sample2.y ) * texelSize, dp ) ) +\n				texture( shadowMap, vec4( bd3D + ( tangent * sample3.x + bitangent * sample3.y ) * texelSize, dp ) ) +\n				texture( shadowMap, vec4( bd3D + ( tangent * sample4.x + bitangent * sample4.y ) * texelSize, dp ) )\n			) * 0.2;\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	#elif defined( SHADOWMAP_TYPE_BASIC )\n	float getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		vec3 absVec = abs( lightToPosition );\n		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n			float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n			dp += shadowBias;\n			vec3 bd3D = normalize( lightToPosition );\n			float depth = textureCube( shadowMap, bd3D ).r;\n			#ifdef USE_REVERSED_DEPTH_BUFFER\n				depth = 1.0 - depth;\n			#endif\n			shadow = step( dp, depth );\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	#endif\n	#endif\n#endif",
	shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif",
	shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	#ifdef HAS_NORMAL\n		vec3 shadowWorldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );\n	#else\n		vec3 shadowWorldNormal = vec3( 0.0 );\n	#endif\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif",
	shadowmask_pars_fragment: "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}",
	skinbase_vertex: "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
	skinning_pars_vertex: "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	mat4 getBoneMatrix( const in float i ) {\n		int size = textureSize( boneTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n#endif",
	skinning_vertex: "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
	skinnormal_vertex: "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif",
	specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif",
	specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif",
	tonemapping_fragment: "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
	tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n	vec3( 1.6605, - 0.1246, - 0.0182 ),\n	vec3( - 0.5876, 1.1329, - 0.1006 ),\n	vec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n	vec3( 0.6274, 0.0691, 0.0164 ),\n	vec3( 0.3293, 0.9195, 0.0880 ),\n	vec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n	vec3 x2 = x * x;\n	vec3 x4 = x2 * x2;\n	return + 15.5 * x4 * x2\n		- 40.14 * x4 * x\n		+ 31.96 * x4\n		- 6.868 * x2 * x\n		+ 0.4298 * x2\n		+ 0.1191 * x\n		- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n	const mat3 AgXInsetMatrix = mat3(\n		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n	);\n	const mat3 AgXOutsetMatrix = mat3(\n		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n	);\n	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;\n	color *= toneMappingExposure;\n	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n	color = AgXInsetMatrix * color;\n	color = max( color, 1e-10 );	color = log2( color );\n	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n	color = clamp( color, 0.0, 1.0 );\n	color = agxDefaultContrastApprox( color );\n	color = AgXOutsetMatrix * color;\n	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n	color = clamp( color, 0.0, 1.0 );\n	return color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n	const float StartCompression = 0.8 - 0.04;\n	const float Desaturation = 0.15;\n	color *= toneMappingExposure;\n	float x = min( color.r, min( color.g, color.b ) );\n	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n	color -= offset;\n	float peak = max( color.r, max( color.g, color.b ) );\n	if ( peak < StartCompression ) return color;\n	float d = 1. - StartCompression;\n	float newPeak = 1. - d * d / ( peak + d - StartCompression );\n	color *= newPeak / peak;\n	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n	return mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
	transmission_fragment: "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = transformNormalByInverseViewMatrix( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
	transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec4 transmittedLight;\n		vec3 transmittance;\n		#ifdef USE_DISPERSION\n			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n			for ( int i = 0; i < 3; i ++ ) {\n				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n				vec3 refractedRayExit = position + transmissionRay;\n				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n				vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n				refractionCoords += 1.0;\n				refractionCoords /= 2.0;\n				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n				transmittedLight[ i ] = transmissionSample[ i ];\n				transmittedLight.a += transmissionSample.a;\n				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n			}\n			transmittedLight.a /= 3.0;\n		#else\n			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n			vec3 refractedRayExit = position + transmissionRay;\n			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n			vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n			refractionCoords += 1.0;\n			refractionCoords /= 2.0;\n			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		#endif\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif",
	uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
	uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
	uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
	worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_BATCHING\n		worldPosition = batchingMatrix * worldPosition;\n	#endif\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif",
	background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
	background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
	backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
	backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, backgroundRotation * vWorldDirection );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
	cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
	cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
	depth_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}",
	depth_frag: "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	#ifdef USE_REVERSED_DEPTH_BUFFER\n		float fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n	#else\n		float fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n	#endif\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#elif DEPTH_PACKING == 3202\n		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n	#elif DEPTH_PACKING == 3203\n		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n	#endif\n}",
	distance_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}",
	distance_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );\n}",
	equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}",
	equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
	linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
	linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
	meshbasic_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}",
	meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
	meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}",
	meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}",
	meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}",
	meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
	meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}",
	meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n	uniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n \n		outgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;\n \n 	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
	meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}",
	points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
	shadow_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
	shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
	sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix[ 3 ];\n	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
	sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}"
}, $ = {
	common: {
		diffuse: { value: /*@__PURE__*/ new Z(16777215) },
		opacity: { value: 1 },
		map: { value: null },
		mapTransform: { value: /*@__PURE__*/ new K() },
		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new K() },
		alphaTest: { value: 0 }
	},
	specularmap: {
		specularMap: { value: null },
		specularMapTransform: { value: /*@__PURE__*/ new K() }
	},
	envmap: {
		envMap: { value: null },
		envMapRotation: { value: /*@__PURE__*/ new K() },
		reflectivity: { value: 1 },
		ior: { value: 1.5 },
		refractionRatio: { value: .98 },
		dfgLUT: { value: null }
	},
	aomap: {
		aoMap: { value: null },
		aoMapIntensity: { value: 1 },
		aoMapTransform: { value: /*@__PURE__*/ new K() }
	},
	lightmap: {
		lightMap: { value: null },
		lightMapIntensity: { value: 1 },
		lightMapTransform: { value: /*@__PURE__*/ new K() }
	},
	bumpmap: {
		bumpMap: { value: null },
		bumpMapTransform: { value: /*@__PURE__*/ new K() },
		bumpScale: { value: 1 }
	},
	normalmap: {
		normalMap: { value: null },
		normalMapTransform: { value: /*@__PURE__*/ new K() },
		normalScale: { value: /*@__PURE__*/ new U(1, 1) }
	},
	displacementmap: {
		displacementMap: { value: null },
		displacementMapTransform: { value: /*@__PURE__*/ new K() },
		displacementScale: { value: 1 },
		displacementBias: { value: 0 }
	},
	emissivemap: {
		emissiveMap: { value: null },
		emissiveMapTransform: { value: /*@__PURE__*/ new K() }
	},
	metalnessmap: {
		metalnessMap: { value: null },
		metalnessMapTransform: { value: /*@__PURE__*/ new K() }
	},
	roughnessmap: {
		roughnessMap: { value: null },
		roughnessMapTransform: { value: /*@__PURE__*/ new K() }
	},
	gradientmap: { gradientMap: { value: null } },
	fog: {
		fogDensity: { value: 25e-5 },
		fogNear: { value: 1 },
		fogFar: { value: 2e3 },
		fogColor: { value: /*@__PURE__*/ new Z(16777215) }
	},
	lights: {
		ambientLightColor: { value: [] },
		lightProbe: { value: [] },
		directionalLights: {
			value: [],
			properties: {
				direction: {},
				color: {}
			}
		},
		directionalLightShadows: {
			value: [],
			properties: {
				shadowIntensity: 1,
				shadowBias: {},
				shadowNormalBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			}
		},
		directionalShadowMatrix: { value: [] },
		spotLights: {
			value: [],
			properties: {
				color: {},
				position: {},
				direction: {},
				distance: {},
				coneCos: {},
				penumbraCos: {},
				decay: {}
			}
		},
		spotLightShadows: {
			value: [],
			properties: {
				shadowIntensity: 1,
				shadowBias: {},
				shadowNormalBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			}
		},
		spotLightMap: { value: [] },
		spotLightMatrix: { value: [] },
		pointLights: {
			value: [],
			properties: {
				color: {},
				position: {},
				decay: {},
				distance: {}
			}
		},
		pointLightShadows: {
			value: [],
			properties: {
				shadowIntensity: 1,
				shadowBias: {},
				shadowNormalBias: {},
				shadowRadius: {},
				shadowMapSize: {},
				shadowCameraNear: {},
				shadowCameraFar: {}
			}
		},
		pointShadowMatrix: { value: [] },
		hemisphereLights: {
			value: [],
			properties: {
				direction: {},
				skyColor: {},
				groundColor: {}
			}
		},
		rectAreaLights: {
			value: [],
			properties: {
				color: {},
				position: {},
				width: {},
				height: {}
			}
		},
		ltc_1: { value: null },
		ltc_2: { value: null },
		probesSH: { value: null },
		probesMin: { value: /*@__PURE__*/ new G() },
		probesMax: { value: /*@__PURE__*/ new G() },
		probesResolution: { value: /*@__PURE__*/ new G() }
	},
	points: {
		diffuse: { value: /*@__PURE__*/ new Z(16777215) },
		opacity: { value: 1 },
		size: { value: 1 },
		scale: { value: 1 },
		map: { value: null },
		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new K() },
		alphaTest: { value: 0 },
		uvTransform: { value: /*@__PURE__*/ new K() }
	},
	sprite: {
		diffuse: { value: /*@__PURE__*/ new Z(16777215) },
		opacity: { value: 1 },
		center: { value: /*@__PURE__*/ new U(.5, .5) },
		rotation: { value: 0 },
		map: { value: null },
		mapTransform: { value: /*@__PURE__*/ new K() },
		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new K() },
		alphaTest: { value: 0 }
	}
}, So = {
	basic: {
		uniforms: /*@__PURE__*/ ea([
			$.common,
			$.specularmap,
			$.envmap,
			$.aomap,
			$.lightmap,
			$.fog
		]),
		vertexShader: Q.meshbasic_vert,
		fragmentShader: Q.meshbasic_frag
	},
	lambert: {
		uniforms: /*@__PURE__*/ ea([
			$.common,
			$.specularmap,
			$.envmap,
			$.aomap,
			$.lightmap,
			$.emissivemap,
			$.bumpmap,
			$.normalmap,
			$.displacementmap,
			$.fog,
			$.lights,
			{
				emissive: { value: /*@__PURE__*/ new Z(0) },
				envMapIntensity: { value: 1 }
			}
		]),
		vertexShader: Q.meshlambert_vert,
		fragmentShader: Q.meshlambert_frag
	},
	phong: {
		uniforms: /*@__PURE__*/ ea([
			$.common,
			$.specularmap,
			$.envmap,
			$.aomap,
			$.lightmap,
			$.emissivemap,
			$.bumpmap,
			$.normalmap,
			$.displacementmap,
			$.fog,
			$.lights,
			{
				emissive: { value: /*@__PURE__*/ new Z(0) },
				specular: { value: /*@__PURE__*/ new Z(1118481) },
				shininess: { value: 30 },
				envMapIntensity: { value: 1 }
			}
		]),
		vertexShader: Q.meshphong_vert,
		fragmentShader: Q.meshphong_frag
	},
	standard: {
		uniforms: /*@__PURE__*/ ea([
			$.common,
			$.envmap,
			$.aomap,
			$.lightmap,
			$.emissivemap,
			$.bumpmap,
			$.normalmap,
			$.displacementmap,
			$.roughnessmap,
			$.metalnessmap,
			$.fog,
			$.lights,
			{
				emissive: { value: /*@__PURE__*/ new Z(0) },
				roughness: { value: 1 },
				metalness: { value: 0 },
				envMapIntensity: { value: 1 }
			}
		]),
		vertexShader: Q.meshphysical_vert,
		fragmentShader: Q.meshphysical_frag
	},
	toon: {
		uniforms: /*@__PURE__*/ ea([
			$.common,
			$.aomap,
			$.lightmap,
			$.emissivemap,
			$.bumpmap,
			$.normalmap,
			$.displacementmap,
			$.gradientmap,
			$.fog,
			$.lights,
			{ emissive: { value: /*@__PURE__*/ new Z(0) } }
		]),
		vertexShader: Q.meshtoon_vert,
		fragmentShader: Q.meshtoon_frag
	},
	matcap: {
		uniforms: /*@__PURE__*/ ea([
			$.common,
			$.bumpmap,
			$.normalmap,
			$.displacementmap,
			$.fog,
			{ matcap: { value: null } }
		]),
		vertexShader: Q.meshmatcap_vert,
		fragmentShader: Q.meshmatcap_frag
	},
	points: {
		uniforms: /*@__PURE__*/ ea([$.points, $.fog]),
		vertexShader: Q.points_vert,
		fragmentShader: Q.points_frag
	},
	dashed: {
		uniforms: /*@__PURE__*/ ea([
			$.common,
			$.fog,
			{
				scale: { value: 1 },
				dashSize: { value: 1 },
				totalSize: { value: 2 }
			}
		]),
		vertexShader: Q.linedashed_vert,
		fragmentShader: Q.linedashed_frag
	},
	depth: {
		uniforms: /*@__PURE__*/ ea([$.common, $.displacementmap]),
		vertexShader: Q.depth_vert,
		fragmentShader: Q.depth_frag
	},
	normal: {
		uniforms: /*@__PURE__*/ ea([
			$.common,
			$.bumpmap,
			$.normalmap,
			$.displacementmap,
			{ opacity: { value: 1 } }
		]),
		vertexShader: Q.meshnormal_vert,
		fragmentShader: Q.meshnormal_frag
	},
	sprite: {
		uniforms: /*@__PURE__*/ ea([$.sprite, $.fog]),
		vertexShader: Q.sprite_vert,
		fragmentShader: Q.sprite_frag
	},
	background: {
		uniforms: {
			uvTransform: { value: /*@__PURE__*/ new K() },
			t2D: { value: null },
			backgroundIntensity: { value: 1 }
		},
		vertexShader: Q.background_vert,
		fragmentShader: Q.background_frag
	},
	backgroundCube: {
		uniforms: {
			envMap: { value: null },
			backgroundBlurriness: { value: 0 },
			backgroundIntensity: { value: 1 },
			backgroundRotation: { value: /*@__PURE__*/ new K() }
		},
		vertexShader: Q.backgroundCube_vert,
		fragmentShader: Q.backgroundCube_frag
	},
	cube: {
		uniforms: {
			tCube: { value: null },
			tFlip: { value: -1 },
			opacity: { value: 1 }
		},
		vertexShader: Q.cube_vert,
		fragmentShader: Q.cube_frag
	},
	equirect: {
		uniforms: { tEquirect: { value: null } },
		vertexShader: Q.equirect_vert,
		fragmentShader: Q.equirect_frag
	},
	distance: {
		uniforms: /*@__PURE__*/ ea([
			$.common,
			$.displacementmap,
			{
				referencePosition: { value: /*@__PURE__*/ new G() },
				nearDistance: { value: 1 },
				farDistance: { value: 1e3 }
			}
		]),
		vertexShader: Q.distance_vert,
		fragmentShader: Q.distance_frag
	},
	shadow: {
		uniforms: /*@__PURE__*/ ea([
			$.lights,
			$.fog,
			{
				color: { value: /*@__PURE__*/ new Z(0) },
				opacity: { value: 1 }
			}
		]),
		vertexShader: Q.shadow_vert,
		fragmentShader: Q.shadow_frag
	}
};
So.physical = {
	uniforms: /*@__PURE__*/ ea([So.standard.uniforms, {
		clearcoat: { value: 0 },
		clearcoatMap: { value: null },
		clearcoatMapTransform: { value: /*@__PURE__*/ new K() },
		clearcoatNormalMap: { value: null },
		clearcoatNormalMapTransform: { value: /*@__PURE__*/ new K() },
		clearcoatNormalScale: { value: /*@__PURE__*/ new U(1, 1) },
		clearcoatRoughness: { value: 0 },
		clearcoatRoughnessMap: { value: null },
		clearcoatRoughnessMapTransform: { value: /*@__PURE__*/ new K() },
		dispersion: { value: 0 },
		iridescence: { value: 0 },
		iridescenceMap: { value: null },
		iridescenceMapTransform: { value: /*@__PURE__*/ new K() },
		iridescenceIOR: { value: 1.3 },
		iridescenceThicknessMinimum: { value: 100 },
		iridescenceThicknessMaximum: { value: 400 },
		iridescenceThicknessMap: { value: null },
		iridescenceThicknessMapTransform: { value: /*@__PURE__*/ new K() },
		sheen: { value: 0 },
		sheenColor: { value: /*@__PURE__*/ new Z(0) },
		sheenColorMap: { value: null },
		sheenColorMapTransform: { value: /*@__PURE__*/ new K() },
		sheenRoughness: { value: 1 },
		sheenRoughnessMap: { value: null },
		sheenRoughnessMapTransform: { value: /*@__PURE__*/ new K() },
		transmission: { value: 0 },
		transmissionMap: { value: null },
		transmissionMapTransform: { value: /*@__PURE__*/ new K() },
		transmissionSamplerSize: { value: /*@__PURE__*/ new U() },
		transmissionSamplerMap: { value: null },
		thickness: { value: 0 },
		thicknessMap: { value: null },
		thicknessMapTransform: { value: /*@__PURE__*/ new K() },
		attenuationDistance: { value: 0 },
		attenuationColor: { value: /*@__PURE__*/ new Z(0) },
		specularColor: { value: /*@__PURE__*/ new Z(1, 1, 1) },
		specularColorMap: { value: null },
		specularColorMapTransform: { value: /*@__PURE__*/ new K() },
		specularIntensity: { value: 1 },
		specularIntensityMap: { value: null },
		specularIntensityMapTransform: { value: /*@__PURE__*/ new K() },
		anisotropyVector: { value: /*@__PURE__*/ new U() },
		anisotropyMap: { value: null },
		anisotropyMapTransform: { value: /*@__PURE__*/ new K() }
	}]),
	vertexShader: Q.meshphysical_vert,
	fragmentShader: Q.meshphysical_frag
};
var Co = {
	r: 0,
	b: 0,
	g: 0
}, wo = /*@__PURE__*/ new Xe(), To = /*@__PURE__*/ new K();
To.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
function Eo(e, t, n, r, i, a) {
	let o = new Z(0), s = i === !0 ? 0 : 1, c, l, u = null, d = 0, f = null;
	function p(e) {
		let n = e.isScene === !0 ? e.background : null;
		if (n && n.isTexture) {
			let r = e.backgroundBlurriness > 0;
			n = t.get(n, r);
		}
		return n;
	}
	function m(t) {
		let r = !1, i = p(t);
		i === null ? g(o, s) : i && i.isColor && (g(i, 1), r = !0);
		let c = e.xr.getEnvironmentBlendMode();
		c === "additive" ? n.buffers.color.setClear(0, 0, 0, 1, a) : c === "alpha-blend" && n.buffers.color.setClear(0, 0, 0, 0, a), (e.autoClear || r) && (n.buffers.depth.setTest(!0), n.buffers.depth.setMask(!0), n.buffers.color.setMask(!0), e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil));
	}
	function h(t, n) {
		let i = p(n);
		i && (i.isCubeTexture || i.mapping === 306) ? (l === void 0 && (l = new hr(new Mr(1, 1, 1), new sa({
			name: "BackgroundCubeMaterial",
			uniforms: $i(So.backgroundCube.uniforms),
			vertexShader: So.backgroundCube.vertexShader,
			fragmentShader: So.backgroundCube.fragmentShader,
			side: 1,
			depthTest: !1,
			depthWrite: !1,
			fog: !1,
			allowOverride: !1
		})), l.geometry.deleteAttribute("normal"), l.geometry.deleteAttribute("uv"), l.onBeforeRender = function(e, t, n) {
			this.matrixWorld.copyPosition(n.matrixWorld);
		}, Object.defineProperty(l.material, "envMap", { get: function() {
			return this.uniforms.envMap.value;
		} }), r.update(l)), l.material.uniforms.envMap.value = i, l.material.uniforms.backgroundBlurriness.value = n.backgroundBlurriness, l.material.uniforms.backgroundIntensity.value = n.backgroundIntensity, l.material.uniforms.backgroundRotation.value.setFromMatrix4(wo.makeRotationFromEuler(n.backgroundRotation)).transpose(), i.isCubeTexture && i.isRenderTargetTexture === !1 && l.material.uniforms.backgroundRotation.value.premultiply(To), l.material.toneMapped = X.getTransfer(i.colorSpace) !== j, (u !== i || d !== i.version || f !== e.toneMapping) && (l.material.needsUpdate = !0, u = i, d = i.version, f = e.toneMapping), l.layers.enableAll(), t.unshift(l, l.geometry, l.material, 0, 0, null)) : i && i.isTexture && (c === void 0 && (c = new hr(new Xi(2, 2), new sa({
			name: "BackgroundMaterial",
			uniforms: $i(So.background.uniforms),
			vertexShader: So.background.vertexShader,
			fragmentShader: So.background.fragmentShader,
			side: 0,
			depthTest: !1,
			depthWrite: !1,
			fog: !1,
			allowOverride: !1
		})), c.geometry.deleteAttribute("normal"), Object.defineProperty(c.material, "map", { get: function() {
			return this.uniforms.t2D.value;
		} }), r.update(c)), c.material.uniforms.t2D.value = i, c.material.uniforms.backgroundIntensity.value = n.backgroundIntensity, c.material.toneMapped = X.getTransfer(i.colorSpace) !== j, i.matrixAutoUpdate === !0 && i.updateMatrix(), c.material.uniforms.uvTransform.value.copy(i.matrix), (u !== i || d !== i.version || f !== e.toneMapping) && (c.material.needsUpdate = !0, u = i, d = i.version, f = e.toneMapping), c.layers.enableAll(), t.unshift(c, c.geometry, c.material, 0, 0, null));
	}
	function g(t, r) {
		t.getRGB(Co, ra(e)), n.buffers.color.setClear(Co.r, Co.g, Co.b, r, a);
	}
	function _() {
		l !== void 0 && (l.geometry.dispose(), l.material.dispose(), l = void 0), c !== void 0 && (c.geometry.dispose(), c.material.dispose(), c = void 0);
	}
	return {
		getClearColor: function() {
			return o;
		},
		setClearColor: function(e, t = 1) {
			o.set(e), s = t, g(o, s);
		},
		getClearAlpha: function() {
			return s;
		},
		setClearAlpha: function(e) {
			s = e, g(o, s);
		},
		render: m,
		addToRenderList: h,
		dispose: _
	};
}
function Do(e, t) {
	let n = e.getParameter(e.MAX_VERTEX_ATTRIBS), r = {}, i = f(null), a = i, o = !1;
	function s(n, r, i, s, c) {
		let u = !1, f = d(n, s, i, r);
		a !== f && (a = f, l(a.object)), u = p(n, s, i, c), u && m(n, s, i, c), c !== null && t.update(c, e.ELEMENT_ARRAY_BUFFER), (u || o) && (o = !1, b(n, r, i, s), c !== null && e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t.get(c).buffer));
	}
	function c() {
		return e.createVertexArray();
	}
	function l(t) {
		return e.bindVertexArray(t);
	}
	function u(t) {
		return e.deleteVertexArray(t);
	}
	function d(e, t, n, i) {
		let a = i.wireframe === !0, o = r[t.id];
		o === void 0 && (o = {}, r[t.id] = o);
		let s = e.isInstancedMesh === !0 ? e.id : 0, l = o[s];
		l === void 0 && (l = {}, o[s] = l);
		let u = l[n.id];
		u === void 0 && (u = {}, l[n.id] = u);
		let d = u[a];
		return d === void 0 && (d = f(c()), u[a] = d), d;
	}
	function f(e) {
		let t = [], r = [], i = [];
		for (let e = 0; e < n; e++) t[e] = 0, r[e] = 0, i[e] = 0;
		return {
			geometry: null,
			program: null,
			wireframe: !1,
			newAttributes: t,
			enabledAttributes: r,
			attributeDivisors: i,
			object: e,
			attributes: {},
			index: null
		};
	}
	function p(e, t, n, r) {
		let i = a.attributes, o = t.attributes, s = 0, c = n.getAttributes();
		for (let t in c) if (c[t].location >= 0) {
			let n = i[t], r = o[t];
			if (r === void 0 && (t === "instanceMatrix" && e.instanceMatrix && (r = e.instanceMatrix), t === "instanceColor" && e.instanceColor && (r = e.instanceColor)), n === void 0 || n.attribute !== r || r && n.data !== r.data) return !0;
			s++;
		}
		return a.attributesNum !== s || a.index !== r;
	}
	function m(e, t, n, r) {
		let i = {}, o = t.attributes, s = 0, c = n.getAttributes();
		for (let t in c) if (c[t].location >= 0) {
			let n = o[t];
			n === void 0 && (t === "instanceMatrix" && e.instanceMatrix && (n = e.instanceMatrix), t === "instanceColor" && e.instanceColor && (n = e.instanceColor));
			let r = {};
			r.attribute = n, n && n.data && (r.data = n.data), i[t] = r, s++;
		}
		a.attributes = i, a.attributesNum = s, a.index = r;
	}
	function h() {
		let e = a.newAttributes;
		for (let t = 0, n = e.length; t < n; t++) e[t] = 0;
	}
	function g(e) {
		_(e, 0);
	}
	function _(t, n) {
		let r = a.newAttributes, i = a.enabledAttributes, o = a.attributeDivisors;
		r[t] = 1, i[t] === 0 && (e.enableVertexAttribArray(t), i[t] = 1), o[t] !== n && (e.vertexAttribDivisor(t, n), o[t] = n);
	}
	function v() {
		let t = a.newAttributes, n = a.enabledAttributes;
		for (let r = 0, i = n.length; r < i; r++) n[r] !== t[r] && (e.disableVertexAttribArray(r), n[r] = 0);
	}
	function y(t, n, r, i, a, o, s) {
		s === !0 ? e.vertexAttribIPointer(t, n, r, a, o) : e.vertexAttribPointer(t, n, r, i, a, o);
	}
	function b(n, r, i, a) {
		h();
		let o = a.attributes, s = i.getAttributes(), c = r.defaultAttributeValues;
		for (let r in s) {
			let i = s[r];
			if (i.location >= 0) {
				let s = o[r];
				if (s === void 0 && (r === "instanceMatrix" && n.instanceMatrix && (s = n.instanceMatrix), r === "instanceColor" && n.instanceColor && (s = n.instanceColor)), s !== void 0) {
					let r = s.normalized, o = s.itemSize, c = t.get(s);
					if (c === void 0) continue;
					let l = c.buffer, u = c.type, d = c.bytesPerElement, f = u === e.INT || u === e.UNSIGNED_INT || s.gpuType === 1013;
					if (s.isInterleavedBufferAttribute) {
						let t = s.data, c = t.stride, p = s.offset;
						if (t.isInstancedInterleavedBuffer) {
							for (let e = 0; e < i.locationSize; e++) _(i.location + e, t.meshPerAttribute);
							n.isInstancedMesh !== !0 && a._maxInstanceCount === void 0 && (a._maxInstanceCount = t.meshPerAttribute * t.count);
						} else for (let e = 0; e < i.locationSize; e++) g(i.location + e);
						e.bindBuffer(e.ARRAY_BUFFER, l);
						for (let e = 0; e < i.locationSize; e++) y(i.location + e, o / i.locationSize, u, r, c * d, (p + o / i.locationSize * e) * d, f);
					} else {
						if (s.isInstancedBufferAttribute) {
							for (let e = 0; e < i.locationSize; e++) _(i.location + e, s.meshPerAttribute);
							n.isInstancedMesh !== !0 && a._maxInstanceCount === void 0 && (a._maxInstanceCount = s.meshPerAttribute * s.count);
						} else for (let e = 0; e < i.locationSize; e++) g(i.location + e);
						e.bindBuffer(e.ARRAY_BUFFER, l);
						for (let e = 0; e < i.locationSize; e++) y(i.location + e, o / i.locationSize, u, r, o * d, o / i.locationSize * e * d, f);
					}
				} else if (c !== void 0) {
					let t = c[r];
					if (t !== void 0) switch (t.length) {
						case 2:
							e.vertexAttrib2fv(i.location, t);
							break;
						case 3:
							e.vertexAttrib3fv(i.location, t);
							break;
						case 4:
							e.vertexAttrib4fv(i.location, t);
							break;
						default: e.vertexAttrib1fv(i.location, t);
					}
				}
			}
		}
		v();
	}
	function x() {
		T();
		for (let e in r) {
			let t = r[e];
			for (let e in t) {
				let n = t[e];
				for (let e in n) {
					let t = n[e];
					for (let e in t) u(t[e].object), delete t[e];
					delete n[e];
				}
			}
			delete r[e];
		}
	}
	function S(e) {
		if (r[e.id] === void 0) return;
		let t = r[e.id];
		for (let e in t) {
			let n = t[e];
			for (let e in n) {
				let t = n[e];
				for (let e in t) u(t[e].object), delete t[e];
				delete n[e];
			}
		}
		delete r[e.id];
	}
	function C(e) {
		for (let t in r) {
			let n = r[t];
			for (let t in n) {
				let r = n[t];
				if (r[e.id] === void 0) continue;
				let i = r[e.id];
				for (let e in i) u(i[e].object), delete i[e];
				delete r[e.id];
			}
		}
	}
	function w(e) {
		for (let t in r) {
			let n = r[t], i = e.isInstancedMesh === !0 ? e.id : 0, a = n[i];
			if (a !== void 0) {
				for (let e in a) {
					let t = a[e];
					for (let e in t) u(t[e].object), delete t[e];
					delete a[e];
				}
				delete n[i], Object.keys(n).length === 0 && delete r[t];
			}
		}
	}
	function T() {
		E(), o = !0, a !== i && (a = i, l(a.object));
	}
	function E() {
		i.geometry = null, i.program = null, i.wireframe = !1;
	}
	return {
		setup: s,
		reset: T,
		resetDefaultState: E,
		dispose: x,
		releaseStatesOfGeometry: S,
		releaseStatesOfObject: w,
		releaseStatesOfProgram: C,
		initAttributes: h,
		enableAttribute: g,
		disableUnusedAttributes: v
	};
}
function Oo(e, t, n) {
	let r;
	function i(e) {
		r = e;
	}
	function a(t, i) {
		e.drawArrays(r, t, i), n.update(i, r, 1);
	}
	function o(t, i, a) {
		a !== 0 && (e.drawArraysInstanced(r, t, i, a), n.update(i, r, a));
	}
	function s(e, i, a) {
		if (a === 0) return;
		t.get("WEBGL_multi_draw").multiDrawArraysWEBGL(r, e, 0, i, 0, a);
		let o = 0;
		for (let e = 0; e < a; e++) o += i[e];
		n.update(o, r, 1);
	}
	this.setMode = i, this.render = a, this.renderInstances = o, this.renderMultiDraw = s;
}
function ko(e, t, n, r) {
	let i;
	function a() {
		if (i !== void 0) return i;
		if (t.has("EXT_texture_filter_anisotropic") === !0) {
			let n = t.get("EXT_texture_filter_anisotropic");
			i = e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
		} else i = 0;
		return i;
	}
	function o(t) {
		return !(t !== 1023 && r.convert(t) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_FORMAT));
	}
	function s(n) {
		let i = n === 1016 && (t.has("EXT_color_buffer_half_float") || t.has("EXT_color_buffer_float"));
		return !(n !== 1009 && r.convert(n) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_TYPE) && n !== 1015 && !i);
	}
	function c(t) {
		if (t === "highp") {
			if (e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision > 0) return "highp";
			t = "mediump";
		}
		return t === "mediump" && e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
	}
	let l = n.precision === void 0 ? "highp" : n.precision, u = c(l);
	u !== l && (L("WebGLRenderer:", l, "not supported, using", u, "instead."), l = u);
	let d = n.logarithmicDepthBuffer === !0, f = n.reversedDepthBuffer === !0 && t.has("EXT_clip_control");
	n.reversedDepthBuffer === !0 && f === !1 && L("WebGLRenderer: Unable to use reversed depth buffer due to missing EXT_clip_control extension. Fallback to default depth buffer.");
	let p = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS), m = e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS), h = e.getParameter(e.MAX_TEXTURE_SIZE), g = e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE), _ = e.getParameter(e.MAX_VERTEX_ATTRIBS), v = e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS), y = e.getParameter(e.MAX_VARYING_VECTORS), b = e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS), x = e.getParameter(e.MAX_SAMPLES), S = e.getParameter(e.SAMPLES);
	return {
		isWebGL2: !0,
		getMaxAnisotropy: a,
		getMaxPrecision: c,
		textureFormatReadable: o,
		textureTypeReadable: s,
		precision: l,
		logarithmicDepthBuffer: d,
		reversedDepthBuffer: f,
		maxTextures: p,
		maxVertexTextures: m,
		maxTextureSize: h,
		maxCubemapSize: g,
		maxAttributes: _,
		maxVertexUniforms: v,
		maxVaryings: y,
		maxFragmentUniforms: b,
		maxSamples: x,
		samples: S
	};
}
function Ao(e) {
	let t = this, n = null, r = 0, i = !1, a = !1, o = new Sr(), s = new K(), c = {
		value: null,
		needsUpdate: !1
	};
	this.uniform = c, this.numPlanes = 0, this.numIntersection = 0, this.init = function(e, t) {
		let n = e.length !== 0 || t || r !== 0 || i;
		return i = t, r = e.length, n;
	}, this.beginShadows = function() {
		a = !0, u(null);
	}, this.endShadows = function() {
		a = !1;
	}, this.setGlobalState = function(e, t) {
		n = u(e, t, 0);
	}, this.setState = function(t, o, s) {
		let d = t.clippingPlanes, f = t.clipIntersection, p = t.clipShadows, m = e.get(t);
		if (!i || d === null || d.length === 0 || a && !p) a ? u(null) : l();
		else {
			let e = a ? 0 : r, t = e * 4, i = m.clippingState || null;
			c.value = i, i = u(d, o, t, s);
			for (let e = 0; e !== t; ++e) i[e] = n[e];
			m.clippingState = i, this.numIntersection = f ? this.numPlanes : 0, this.numPlanes += e;
		}
	};
	function l() {
		c.value !== n && (c.value = n, c.needsUpdate = r > 0), t.numPlanes = r, t.numIntersection = 0;
	}
	function u(e, n, r, i) {
		let a = e === null ? 0 : e.length, l = null;
		if (a !== 0) {
			if (l = c.value, i !== !0 || l === null) {
				let t = r + a * 4, i = n.matrixWorldInverse;
				s.getNormalMatrix(i), (l === null || l.length < t) && (l = new Float32Array(t));
				for (let t = 0, n = r; t !== a; ++t, n += 4) o.copy(e[t]).applyMatrix4(i, s), o.normal.toArray(l, n), l[n + 3] = o.constant;
			}
			c.value = l, c.needsUpdate = !0;
		}
		return t.numPlanes = a, t.numIntersection = 0, l;
	}
}
var jo = 4, Mo = [
	.125,
	.215,
	.35,
	.446,
	.526,
	.582
], No = 20, Po = 256, Fo = /*@__PURE__*/ new Ka(), Io = /*@__PURE__*/ new Z(), Lo = null, Ro = 0, zo = 0, Bo = !1, Vo = /*@__PURE__*/ new G(), Ho = class {
	constructor(e) {
		this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._backgroundBox = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._blurMaterial = null, this._ggxMaterial = null;
	}
	fromScene(e, t = 0, n = .1, r = 100, i = {}) {
		let { size: a = 256, position: o = Vo } = i;
		Lo = this._renderer.getRenderTarget(), Ro = this._renderer.getActiveCubeFace(), zo = this._renderer.getActiveMipmapLevel(), Bo = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(a);
		let s = this._allocateTargets();
		return s.depthBuffer = !0, this._sceneToCubeUV(e, n, r, s, o), t > 0 && this._blur(s, 0, 0, t), this._applyPMREM(s), this._cleanup(s), s;
	}
	fromEquirectangular(e, t = null) {
		return this._fromTexture(e, t);
	}
	fromCubemap(e, t = null) {
		return this._fromTexture(e, t);
	}
	compileCubemapShader() {
		this._cubemapMaterial === null && (this._cubemapMaterial = Yo(), this._compileMaterial(this._cubemapMaterial));
	}
	compileEquirectangularShader() {
		this._equirectMaterial === null && (this._equirectMaterial = Jo(), this._compileMaterial(this._equirectMaterial));
	}
	dispose() {
		this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose(), this._backgroundBox !== null && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
	}
	_setSize(e) {
		this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = 2 ** this._lodMax;
	}
	_dispose() {
		this._blurMaterial !== null && this._blurMaterial.dispose(), this._ggxMaterial !== null && this._ggxMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
		for (let e = 0; e < this._lodMeshes.length; e++) this._lodMeshes[e].geometry.dispose();
	}
	_cleanup(e) {
		this._renderer.setRenderTarget(Lo, Ro, zo), this._renderer.xr.enabled = Bo, e.scissorTest = !1, Go(e, 0, 0, e.width, e.height);
	}
	_fromTexture(e, t) {
		e.mapping === 301 || e.mapping === 302 ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), Lo = this._renderer.getRenderTarget(), Ro = this._renderer.getActiveCubeFace(), zo = this._renderer.getActiveMipmapLevel(), Bo = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
		let n = t || this._allocateTargets();
		return this._textureToCubeUV(e, n), this._applyPMREM(n), this._cleanup(n), n;
	}
	_allocateTargets() {
		let e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, n = {
			magFilter: i,
			minFilter: i,
			generateMipmaps: !1,
			type: u,
			format: m,
			colorSpace: k,
			depthBuffer: !1
		}, r = Wo(e, t, n);
		if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
			this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = Wo(e, t, n);
			let { _lodMax: r } = this;
			({lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas} = Uo(r)), this._blurMaterial = qo(r, e, t), this._ggxMaterial = Ko(r, e, t);
		}
		return r;
	}
	_compileMaterial(e) {
		let t = new hr(new Dn(), e);
		this._renderer.compile(t, Fo);
	}
	_sceneToCubeUV(e, t, n, r, i) {
		let a = new Ga(90, 1, t, n), o = [
			1,
			-1,
			1,
			1,
			1,
			1
		], s = [
			1,
			1,
			1,
			-1,
			-1,
			-1
		], c = this._renderer, l = c.autoClear, u = c.toneMapping;
		c.getClearColor(Io), c.toneMapping = 0, c.autoClear = !1, c.state.buffers.depth.getReversed() && (c.setRenderTarget(r), c.clearDepth(), c.setRenderTarget(null)), this._backgroundBox === null && (this._backgroundBox = new hr(new Mr(), new rr({
			name: "PMREM.Background",
			side: 1,
			depthWrite: !1,
			depthTest: !1
		})));
		let d = this._backgroundBox, f = d.material, p = !1, m = e.background;
		m ? m.isColor && (f.color.copy(m), e.background = null, p = !0) : (f.color.copy(Io), p = !0);
		for (let t = 0; t < 6; t++) {
			let n = t % 3;
			n === 0 ? (a.up.set(0, o[t], 0), a.position.set(i.x, i.y, i.z), a.lookAt(i.x + s[t], i.y, i.z)) : n === 1 ? (a.up.set(0, 0, o[t]), a.position.set(i.x, i.y, i.z), a.lookAt(i.x, i.y + s[t], i.z)) : (a.up.set(0, o[t], 0), a.position.set(i.x, i.y, i.z), a.lookAt(i.x, i.y, i.z + s[t]));
			let l = this._cubeSize;
			Go(r, n * l, t > 2 ? l : 0, l, l), c.setRenderTarget(r), p && c.render(d, a), c.render(e, a);
		}
		c.toneMapping = u, c.autoClear = l, e.background = m;
	}
	_textureToCubeUV(e, t) {
		let n = this._renderer, r = e.mapping === 301 || e.mapping === 302;
		r ? (this._cubemapMaterial === null && (this._cubemapMaterial = Yo()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = Jo());
		let i = r ? this._cubemapMaterial : this._equirectMaterial, a = this._lodMeshes[0];
		a.material = i;
		let o = i.uniforms;
		o.envMap.value = e;
		let s = this._cubeSize;
		Go(t, 0, 0, 3 * s, 2 * s), n.setRenderTarget(t), n.render(a, Fo);
	}
	_applyPMREM(e) {
		let t = this._renderer, n = t.autoClear;
		t.autoClear = !1;
		let r = this._lodMeshes.length;
		for (let t = 1; t < r; t++) this._applyGGXFilter(e, t - 1, t);
		t.autoClear = n;
	}
	_applyGGXFilter(e, t, n) {
		let r = this._renderer, i = this._pingPongRenderTarget, a = this._ggxMaterial, o = this._lodMeshes[n];
		o.material = a;
		let s = a.uniforms, c = n / (this._lodMeshes.length - 1), l = t / (this._lodMeshes.length - 1), u = Math.sqrt(c * c - l * l) * (0 + c * 1.25), { _lodMax: d } = this, f = this._sizeLods[n], p = 3 * f * (n > d - jo ? n - d + jo : 0), m = 4 * (this._cubeSize - f);
		s.envMap.value = e.texture, s.roughness.value = u, s.mipInt.value = d - t, Go(i, p, m, 3 * f, 2 * f), r.setRenderTarget(i), r.render(o, Fo), s.envMap.value = i.texture, s.roughness.value = 0, s.mipInt.value = d - n, Go(e, p, m, 3 * f, 2 * f), r.setRenderTarget(e), r.render(o, Fo);
	}
	_blur(e, t, n, r, i) {
		let a = this._pingPongRenderTarget;
		this._halfBlur(e, a, t, n, r, "latitudinal", i), this._halfBlur(a, e, n, n, r, "longitudinal", i);
	}
	_halfBlur(e, t, n, r, i, a, o) {
		let s = this._renderer, c = this._blurMaterial;
		a !== "latitudinal" && a !== "longitudinal" && R("blur direction must be either latitudinal or longitudinal!");
		let l = this._lodMeshes[r];
		l.material = c;
		let u = c.uniforms, d = this._sizeLods[n] - 1, f = isFinite(i) ? Math.PI / (2 * d) : 2 * Math.PI / (2 * No - 1), p = i / f, m = isFinite(i) ? 1 + Math.floor(3 * p) : No;
		m > No && L(`sigmaRadians, ${i}, is too large and will clip, as it requested ${m} samples when the maximum is set to ${No}`);
		let h = [], g = 0;
		for (let e = 0; e < No; ++e) {
			let t = e / p, n = Math.exp(-t * t / 2);
			h.push(n), e === 0 ? g += n : e < m && (g += 2 * n);
		}
		for (let e = 0; e < h.length; e++) h[e] = h[e] / g;
		u.envMap.value = e.texture, u.samples.value = m, u.weights.value = h, u.latitudinal.value = a === "latitudinal", o && (u.poleAxis.value = o);
		let { _lodMax: _ } = this;
		u.dTheta.value = f, u.mipInt.value = _ - n;
		let v = this._sizeLods[r];
		Go(t, 3 * v * (r > _ - jo ? r - _ + jo : 0), 4 * (this._cubeSize - v), 3 * v, 2 * v), s.setRenderTarget(t), s.render(l, Fo);
	}
};
function Uo(e) {
	let t = [], n = [], r = [], i = e, a = e - jo + 1 + Mo.length;
	for (let o = 0; o < a; o++) {
		let a = 2 ** i;
		t.push(a);
		let s = 1 / a;
		o > e - jo ? s = Mo[o - e + jo - 1] : o === 0 && (s = 0), n.push(s);
		let c = 1 / (a - 2), l = -c, u = 1 + c, d = [
			l,
			l,
			u,
			l,
			u,
			u,
			l,
			l,
			u,
			u,
			l,
			u
		], f = /* @__PURE__ */ new Float32Array(108), p = /* @__PURE__ */ new Float32Array(72), m = /* @__PURE__ */ new Float32Array(36);
		for (let e = 0; e < 6; e++) {
			let t = e % 3 * 2 / 3 - 1, n = e > 2 ? 0 : -1, r = [
				t,
				n,
				0,
				t + 2 / 3,
				n,
				0,
				t + 2 / 3,
				n + 1,
				0,
				t,
				n,
				0,
				t + 2 / 3,
				n + 1,
				0,
				t,
				n + 1,
				0
			];
			f.set(r, 18 * e), p.set(d, 12 * e);
			let i = [
				e,
				e,
				e,
				e,
				e,
				e
			];
			m.set(i, 6 * e);
		}
		let h = new Dn();
		h.setAttribute("position", new fn(f, 3)), h.setAttribute("uv", new fn(p, 2)), h.setAttribute("faceIndex", new fn(m, 1)), r.push(new hr(h, null)), i > jo && i--;
	}
	return {
		lodMeshes: r,
		sizeLods: t,
		sigmas: n
	};
}
function Wo(e, t, n) {
	let r = new qe(e, t, n);
	return r.texture.mapping = 306, r.texture.name = "PMREM.cubeUv", r.scissorTest = !0, r;
}
function Go(e, t, n, r, i) {
	e.viewport.set(t, n, r, i), e.scissor.set(t, n, r, i);
}
function Ko(e, t, n) {
	return new sa({
		name: "PMREMGGXConvolution",
		defines: {
			GGX_SAMPLES: Po,
			CUBEUV_TEXEL_WIDTH: 1 / t,
			CUBEUV_TEXEL_HEIGHT: 1 / n,
			CUBEUV_MAX_MIP: `${e}.0`
		},
		uniforms: {
			envMap: { value: null },
			roughness: { value: 0 },
			mipInt: { value: 0 }
		},
		vertexShader: Xo(),
		fragmentShader: "\n\n			precision highp float;\n			precision highp int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform float roughness;\n			uniform float mipInt;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			#define PI 3.14159265359\n\n			// Van der Corput radical inverse\n			float radicalInverse_VdC(uint bits) {\n				bits = (bits << 16u) | (bits >> 16u);\n				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);\n				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);\n				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);\n				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);\n				return float(bits) * 2.3283064365386963e-10; // / 0x100000000\n			}\n\n			// Hammersley sequence\n			vec2 hammersley(uint i, uint N) {\n				return vec2(float(i) / float(N), radicalInverse_VdC(i));\n			}\n\n			// GGX VNDF importance sampling (Eric Heitz 2018)\n			// \"Sampling the GGX Distribution of Visible Normals\"\n			// https://jcgt.org/published/0007/04/01/\n			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {\n				float alpha = roughness * roughness;\n\n				// Section 4.1: Orthonormal basis\n				vec3 T1 = vec3(1.0, 0.0, 0.0);\n				vec3 T2 = cross(V, T1);\n\n				// Section 4.2: Parameterization of projected area\n				float r = sqrt(Xi.x);\n				float phi = 2.0 * PI * Xi.y;\n				float t1 = r * cos(phi);\n				float t2 = r * sin(phi);\n				float s = 0.5 * (1.0 + V.z);\n				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;\n\n				// Section 4.3: Reprojection onto hemisphere\n				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * V;\n\n				// Section 3.4: Transform back to ellipsoid configuration\n				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));\n			}\n\n			void main() {\n				vec3 N = normalize(vOutputDirection);\n				vec3 V = N; // Assume view direction equals normal for pre-filtering\n\n				vec3 prefilteredColor = vec3(0.0);\n				float totalWeight = 0.0;\n\n				// For very low roughness, just sample the environment directly\n				if (roughness < 0.001) {\n					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);\n					return;\n				}\n\n				// Tangent space basis for VNDF sampling\n				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);\n				vec3 tangent = normalize(cross(up, N));\n				vec3 bitangent = cross(N, tangent);\n\n				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {\n					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));\n\n					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)\n					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);\n\n					// Transform H back to world space\n					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);\n					vec3 L = normalize(2.0 * dot(V, H) * H - V);\n\n					float NdotL = max(dot(N, L), 0.0);\n\n					if(NdotL > 0.0) {\n						// Sample environment at fixed mip level\n						// VNDF importance sampling handles the distribution filtering\n						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);\n\n						// Weight by NdotL for the split-sum approximation\n						// VNDF PDF naturally accounts for the visible microfacet distribution\n						prefilteredColor += sampleColor * NdotL;\n						totalWeight += NdotL;\n					}\n				}\n\n				if (totalWeight > 0.0) {\n					prefilteredColor = prefilteredColor / totalWeight;\n				}\n\n				gl_FragColor = vec4(prefilteredColor, 1.0);\n			}\n		",
		blending: 0,
		depthTest: !1,
		depthWrite: !1
	});
}
function qo(e, t, n) {
	let r = new Float32Array(No), i = new G(0, 1, 0);
	return new sa({
		name: "SphericalGaussianBlur",
		defines: {
			n: No,
			CUBEUV_TEXEL_WIDTH: 1 / t,
			CUBEUV_TEXEL_HEIGHT: 1 / n,
			CUBEUV_MAX_MIP: `${e}.0`
		},
		uniforms: {
			envMap: { value: null },
			samples: { value: 1 },
			weights: { value: r },
			latitudinal: { value: !1 },
			dTheta: { value: 0 },
			mipInt: { value: 0 },
			poleAxis: { value: i }
		},
		vertexShader: Xo(),
		fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n			}\n		",
		blending: 0,
		depthTest: !1,
		depthWrite: !1
	});
}
function Jo() {
	return new sa({
		name: "EquirectangularToCubeUV",
		uniforms: { envMap: { value: null } },
		vertexShader: Xo(),
		fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n\n			#include <common>\n\n			void main() {\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n			}\n		",
		blending: 0,
		depthTest: !1,
		depthWrite: !1
	});
}
function Yo() {
	return new sa({
		name: "CubemapToCubeUV",
		uniforms: {
			envMap: { value: null },
			flipEnvMap: { value: -1 }
		},
		vertexShader: Xo(),
		fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			uniform float flipEnvMap;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			void main() {\n\n				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n			}\n		",
		blending: 0,
		depthTest: !1,
		depthWrite: !1
	});
}
function Xo() {
	return "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	";
}
var Zo = class extends qe {
	constructor(e = 1, t = {}) {
		super(e, e, t), this.isWebGLCubeRenderTarget = !0;
		let n = {
			width: e,
			height: e,
			depth: 1
		}, r = [
			n,
			n,
			n,
			n,
			n,
			n
		];
		this.texture = new Dr(r), this._setTextureOptions(t), this.texture.isRenderTargetTexture = !0;
	}
	fromEquirectangularTexture(e, t) {
		this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
		let n = {
			uniforms: { tEquirect: { value: null } },
			vertexShader: "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			",
			fragmentShader: "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			"
		}, r = new Mr(5, 5, 5), a = new sa({
			name: "CubemapFromEquirect",
			uniforms: $i(n.uniforms),
			vertexShader: n.vertexShader,
			fragmentShader: n.fragmentShader,
			side: 1,
			blending: 0
		});
		a.uniforms.tEquirect.value = t;
		let o = new hr(r, a), s = t.minFilter;
		return t.minFilter === 1008 && (t.minFilter = i), new Za(1, 10, this).update(e, o), t.minFilter = s, o.geometry.dispose(), o.material.dispose(), this;
	}
	clear(e, t = !0, n = !0, r = !0) {
		let i = e.getRenderTarget();
		for (let i = 0; i < 6; i++) e.setRenderTarget(this, i), e.clear(t, n, r);
		e.setRenderTarget(i);
	}
};
function Qo(e) {
	let t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), r = null;
	function i(e, t = !1) {
		return e == null ? null : t ? o(e) : a(e);
	}
	function a(n) {
		if (n && n.isTexture) {
			let r = n.mapping;
			if (r === 303 || r === 304) if (t.has(n)) {
				let e = t.get(n).texture;
				return s(e, n.mapping);
			} else {
				let r = n.image;
				if (r && r.height > 0) {
					let i = new Zo(r.height);
					return i.fromEquirectangularTexture(e, n), t.set(n, i), n.addEventListener("dispose", l), s(i.texture, n.mapping);
				} else return null;
			}
		}
		return n;
	}
	function o(t) {
		if (t && t.isTexture) {
			let i = t.mapping, a = i === 303 || i === 304, o = i === 301 || i === 302;
			if (a || o) {
				let i = n.get(t), s = i === void 0 ? 0 : i.texture.pmremVersion;
				if (t.isRenderTargetTexture && t.pmremVersion !== s) return r === null && (r = new Ho(e)), i = a ? r.fromEquirectangular(t, i) : r.fromCubemap(t, i), i.texture.pmremVersion = t.pmremVersion, n.set(t, i), i.texture;
				if (i !== void 0) return i.texture;
				{
					let s = t.image;
					return a && s && s.height > 0 || o && s && c(s) ? (r === null && (r = new Ho(e)), i = a ? r.fromEquirectangular(t) : r.fromCubemap(t), i.texture.pmremVersion = t.pmremVersion, n.set(t, i), t.addEventListener("dispose", u), i.texture) : null;
				}
			}
		}
		return t;
	}
	function s(e, t) {
		return t === 303 ? e.mapping = 301 : t === 304 && (e.mapping = 302), e;
	}
	function c(e) {
		let t = 0;
		for (let n = 0; n < 6; n++) e[n] !== void 0 && t++;
		return t === 6;
	}
	function l(e) {
		let n = e.target;
		n.removeEventListener("dispose", l);
		let r = t.get(n);
		r !== void 0 && (t.delete(n), r.dispose());
	}
	function u(e) {
		let t = e.target;
		t.removeEventListener("dispose", u);
		let r = n.get(t);
		r !== void 0 && (n.delete(t), r.dispose());
	}
	function d() {
		t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), r !== null && (r.dispose(), r = null);
	}
	return {
		get: i,
		dispose: d
	};
}
function $o(e) {
	let t = {};
	function n(n) {
		if (t[n] !== void 0) return t[n];
		let r = e.getExtension(n);
		return t[n] = r, r;
	}
	return {
		has: function(e) {
			return n(e) !== null;
		},
		init: function() {
			n("EXT_color_buffer_float"), n("WEBGL_clip_cull_distance"), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture"), n("WEBGL_render_shared_exponent");
		},
		get: function(e) {
			let t = n(e);
			return t === null && ae("WebGLRenderer: " + e + " extension not supported."), t;
		}
	};
}
function es(e, t, n, r) {
	let i = {}, a = /* @__PURE__ */ new WeakMap();
	function o(e) {
		let s = e.target;
		s.index !== null && t.remove(s.index);
		for (let e in s.attributes) t.remove(s.attributes[e]);
		s.removeEventListener("dispose", o), delete i[s.id];
		let c = a.get(s);
		c && (t.remove(c), a.delete(s)), r.releaseStatesOfGeometry(s), s.isInstancedBufferGeometry === !0 && delete s._maxInstanceCount, n.memory.geometries--;
	}
	function s(e, t) {
		return i[t.id] === !0 ? t : (t.addEventListener("dispose", o), i[t.id] = !0, n.memory.geometries++, t);
	}
	function c(n) {
		let r = n.attributes;
		for (let n in r) t.update(r[n], e.ARRAY_BUFFER);
	}
	function l(e) {
		let n = [], r = e.index, i = e.attributes.position, o = 0;
		if (i === void 0) return;
		if (r !== null) {
			let e = r.array;
			o = r.version;
			for (let t = 0, r = e.length; t < r; t += 3) {
				let r = e[t + 0], i = e[t + 1], a = e[t + 2];
				n.push(r, i, i, a, a, r);
			}
		} else {
			let e = i.array;
			o = i.version;
			for (let t = 0, r = e.length / 3 - 1; t < r; t += 3) {
				let e = t + 0, r = t + 1, i = t + 2;
				n.push(e, r, r, i, i, e);
			}
		}
		let s = new (i.count >= 65535 ? mn : pn)(n, 1);
		s.version = o;
		let c = a.get(e);
		c && t.remove(c), a.set(e, s);
	}
	function u(e) {
		let t = a.get(e);
		if (t) {
			let n = e.index;
			n !== null && t.version < n.version && l(e);
		} else l(e);
		return a.get(e);
	}
	return {
		get: s,
		update: c,
		getWireframeAttribute: u
	};
}
function ts(e, t, n) {
	let r;
	function i(e) {
		r = e;
	}
	let a, o;
	function s(e) {
		a = e.type, o = e.bytesPerElement;
	}
	function c(t, i) {
		e.drawElements(r, i, a, t * o), n.update(i, r, 1);
	}
	function l(t, i, s) {
		s !== 0 && (e.drawElementsInstanced(r, i, a, t * o, s), n.update(i, r, s));
	}
	function u(e, i, o) {
		if (o === 0) return;
		t.get("WEBGL_multi_draw").multiDrawElementsWEBGL(r, i, 0, a, e, 0, o);
		let s = 0;
		for (let e = 0; e < o; e++) s += i[e];
		n.update(s, r, 1);
	}
	this.setMode = i, this.setIndex = s, this.render = c, this.renderInstances = l, this.renderMultiDraw = u;
}
function ns(e) {
	let t = {
		geometries: 0,
		textures: 0
	}, n = {
		frame: 0,
		calls: 0,
		triangles: 0,
		points: 0,
		lines: 0
	};
	function r(t, r, i) {
		switch (n.calls++, r) {
			case e.TRIANGLES:
				n.triangles += t / 3 * i;
				break;
			case e.LINES:
				n.lines += t / 2 * i;
				break;
			case e.LINE_STRIP:
				n.lines += i * (t - 1);
				break;
			case e.LINE_LOOP:
				n.lines += i * t;
				break;
			case e.POINTS:
				n.points += i * t;
				break;
			default:
				R("WebGLInfo: Unknown draw mode:", r);
				break;
		}
	}
	function i() {
		n.calls = 0, n.triangles = 0, n.points = 0, n.lines = 0;
	}
	return {
		memory: t,
		render: n,
		programs: null,
		autoReset: !0,
		reset: i,
		update: r
	};
}
function rs(e, t, n) {
	let r = /* @__PURE__ */ new WeakMap(), i = new Ge();
	function a(a, o, s) {
		let c = a.morphTargetInfluences, u = o.morphAttributes.position || o.morphAttributes.normal || o.morphAttributes.color, d = u === void 0 ? 0 : u.length, f = r.get(o);
		if (f === void 0 || f.count !== d) {
			f !== void 0 && f.texture.dispose();
			let e = o.morphAttributes.position !== void 0, n = o.morphAttributes.normal !== void 0, a = o.morphAttributes.color !== void 0, s = o.morphAttributes.position || [], c = o.morphAttributes.normal || [], u = o.morphAttributes.color || [], p = 0;
			e === !0 && (p = 1), n === !0 && (p = 2), a === !0 && (p = 3);
			let m = o.attributes.position.count * p, h = 1;
			m > t.maxTextureSize && (h = Math.ceil(m / t.maxTextureSize), m = t.maxTextureSize);
			let g = new Float32Array(m * h * 4 * d), _ = new Je(g, m, h, d);
			_.type = l, _.needsUpdate = !0;
			let v = p * 4;
			for (let t = 0; t < d; t++) {
				let r = s[t], o = c[t], l = u[t], d = m * h * 4 * t;
				for (let t = 0; t < r.count; t++) {
					let s = t * v;
					e === !0 && (i.fromBufferAttribute(r, t), g[d + s + 0] = i.x, g[d + s + 1] = i.y, g[d + s + 2] = i.z, g[d + s + 3] = 0), n === !0 && (i.fromBufferAttribute(o, t), g[d + s + 4] = i.x, g[d + s + 5] = i.y, g[d + s + 6] = i.z, g[d + s + 7] = 0), a === !0 && (i.fromBufferAttribute(l, t), g[d + s + 8] = i.x, g[d + s + 9] = i.y, g[d + s + 10] = i.z, g[d + s + 11] = l.itemSize === 4 ? i.w : 1);
				}
			}
			f = {
				count: d,
				texture: _,
				size: new U(m, h)
			}, r.set(o, f);
			function y() {
				_.dispose(), r.delete(o), o.removeEventListener("dispose", y);
			}
			o.addEventListener("dispose", y);
		}
		if (a.isInstancedMesh === !0 && a.morphTexture !== null) s.getUniforms().setValue(e, "morphTexture", a.morphTexture, n);
		else {
			let t = 0;
			for (let e = 0; e < c.length; e++) t += c[e];
			let n = o.morphTargetsRelative ? 1 : 1 - t;
			s.getUniforms().setValue(e, "morphTargetBaseInfluence", n), s.getUniforms().setValue(e, "morphTargetInfluences", c);
		}
		s.getUniforms().setValue(e, "morphTargetsTexture", f.texture, n), s.getUniforms().setValue(e, "morphTargetsTextureSize", f.size);
	}
	return { update: a };
}
function is(e, t, n, r, i) {
	let a = /* @__PURE__ */ new WeakMap();
	function o(r) {
		let o = i.render.frame, s = r.geometry, l = t.get(r, s);
		if (a.get(l) !== o && (t.update(l), a.set(l, o)), r.isInstancedMesh && (r.hasEventListener("dispose", c) === !1 && r.addEventListener("dispose", c), a.get(r) !== o && (n.update(r.instanceMatrix, e.ARRAY_BUFFER), r.instanceColor !== null && n.update(r.instanceColor, e.ARRAY_BUFFER), a.set(r, o))), r.isSkinnedMesh) {
			let e = r.skeleton;
			a.get(e) !== o && (e.update(), a.set(e, o));
		}
		return l;
	}
	function s() {
		a = /* @__PURE__ */ new WeakMap();
	}
	function c(e) {
		let t = e.target;
		t.removeEventListener("dispose", c), r.releaseStatesOfObject(t), n.remove(t.instanceMatrix), t.instanceColor !== null && n.remove(t.instanceColor);
	}
	return {
		update: o,
		dispose: s
	};
}
var as = {
	1: "LINEAR_TONE_MAPPING",
	2: "REINHARD_TONE_MAPPING",
	3: "CINEON_TONE_MAPPING",
	4: "ACES_FILMIC_TONE_MAPPING",
	6: "AGX_TONE_MAPPING",
	7: "NEUTRAL_TONE_MAPPING",
	5: "CUSTOM_TONE_MAPPING"
};
function os(e, t, n, r, i, a) {
	let o = new qe(t, n, {
		type: e,
		depthBuffer: i,
		stencilBuffer: a,
		samples: r ? 4 : 0,
		depthTexture: i ? new kr(t, n) : void 0
	}), s = new qe(t, n, {
		type: u,
		depthBuffer: !1,
		stencilBuffer: !1
	}), c = new Dn();
	c.setAttribute("position", new hn([
		-1,
		3,
		0,
		-1,
		-1,
		0,
		3,
		-1,
		0
	], 3)), c.setAttribute("uv", new hn([
		0,
		2,
		0,
		0,
		2,
		0
	], 2));
	let l = new ca({
		uniforms: { tDiffuse: { value: null } },
		vertexShader: "\n			precision highp float;\n\n			uniform mat4 modelViewMatrix;\n			uniform mat4 projectionMatrix;\n\n			attribute vec3 position;\n			attribute vec2 uv;\n\n			varying vec2 vUv;\n\n			void main() {\n				vUv = uv;\n				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n			}",
		fragmentShader: "\n			precision highp float;\n\n			uniform sampler2D tDiffuse;\n\n			varying vec2 vUv;\n\n			#include <tonemapping_pars_fragment>\n			#include <colorspace_pars_fragment>\n\n			void main() {\n				gl_FragColor = texture2D( tDiffuse, vUv );\n\n				#ifdef LINEAR_TONE_MAPPING\n					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );\n				#elif defined( REINHARD_TONE_MAPPING )\n					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );\n				#elif defined( CINEON_TONE_MAPPING )\n					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );\n				#elif defined( ACES_FILMIC_TONE_MAPPING )\n					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );\n				#elif defined( AGX_TONE_MAPPING )\n					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );\n				#elif defined( NEUTRAL_TONE_MAPPING )\n					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );\n				#elif defined( CUSTOM_TONE_MAPPING )\n					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );\n				#endif\n\n				#ifdef SRGB_TRANSFER\n					gl_FragColor = sRGBTransferOETF( gl_FragColor );\n				#endif\n			}",
		depthTest: !1,
		depthWrite: !1
	}), d = new hr(c, l), f = new Ka(-1, 1, 1, -1, 0, 1), p = null, m = null, h = !1, g, _ = null, v = [], y = !1;
	this.setSize = function(e, t) {
		o.setSize(e, t), s.setSize(e, t);
		for (let n = 0; n < v.length; n++) {
			let r = v[n];
			r.setSize && r.setSize(e, t);
		}
	}, this.setEffects = function(e) {
		v = e, y = v.length > 0 && v[0].isRenderPass === !0;
		let t = o.width, n = o.height;
		for (let e = 0; e < v.length; e++) {
			let r = v[e];
			r.setSize && r.setSize(t, n);
		}
	}, this.begin = function(e, t) {
		if (h || e.toneMapping === 0 && v.length === 0) return !1;
		if (_ = t, t !== null) {
			let e = t.width, n = t.height;
			(o.width !== e || o.height !== n) && this.setSize(e, n);
		}
		return y === !1 && e.setRenderTarget(o), g = e.toneMapping, e.toneMapping = 0, !0;
	}, this.hasRenderPass = function() {
		return y;
	}, this.end = function(e, t) {
		e.toneMapping = g, h = !0;
		let n = o, r = s;
		for (let i = 0; i < v.length; i++) {
			let a = v[i];
			if (a.enabled !== !1 && (a.render(e, r, n, t), a.needsSwap !== !1)) {
				let e = n;
				n = r, r = e;
			}
		}
		if (p !== e.outputColorSpace || m !== e.toneMapping) {
			p = e.outputColorSpace, m = e.toneMapping, l.defines = {}, X.getTransfer(p) === "srgb" && (l.defines.SRGB_TRANSFER = "");
			let t = as[m];
			t && (l.defines[t] = ""), l.needsUpdate = !0;
		}
		l.uniforms.tDiffuse.value = n.texture, e.setRenderTarget(_), e.render(d, f), _ = null, h = !1;
	}, this.isCompositing = function() {
		return h;
	}, this.dispose = function() {
		o.depthTexture && o.depthTexture.dispose(), o.dispose(), s.dispose(), c.dispose(), l.dispose();
	};
}
var ss = /*@__PURE__*/ new We(), cs = /*@__PURE__*/ new kr(1, 1), ls = /*@__PURE__*/ new Je(), us = /*@__PURE__*/ new Ye(), ds = /*@__PURE__*/ new Dr(), fs = [], ps = [], ms = /* @__PURE__ */ new Float32Array(16), hs = /* @__PURE__ */ new Float32Array(9), gs = /* @__PURE__ */ new Float32Array(4);
function _s(e, t, n) {
	let r = e[0];
	if (r <= 0 || r > 0) return e;
	let i = t * n, a = fs[i];
	if (a === void 0 && (a = new Float32Array(i), fs[i] = a), t !== 0) {
		r.toArray(a, 0);
		for (let r = 1, i = 0; r !== t; ++r) i += n, e[r].toArray(a, i);
	}
	return a;
}
function vs(e, t) {
	if (e.length !== t.length) return !1;
	for (let n = 0, r = e.length; n < r; n++) if (e[n] !== t[n]) return !1;
	return !0;
}
function ys(e, t) {
	for (let n = 0, r = t.length; n < r; n++) e[n] = t[n];
}
function bs(e, t) {
	let n = ps[t];
	n === void 0 && (n = new Int32Array(t), ps[t] = n);
	for (let r = 0; r !== t; ++r) n[r] = e.allocateTextureUnit();
	return n;
}
function xs(e, t) {
	let n = this.cache;
	n[0] !== t && (e.uniform1f(this.addr, t), n[0] = t);
}
function Ss(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y) && (e.uniform2f(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
	else {
		if (vs(n, t)) return;
		e.uniform2fv(this.addr, t), ys(n, t);
	}
}
function Cs(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z) && (e.uniform3f(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
	else if (t.r !== void 0) (n[0] !== t.r || n[1] !== t.g || n[2] !== t.b) && (e.uniform3f(this.addr, t.r, t.g, t.b), n[0] = t.r, n[1] = t.g, n[2] = t.b);
	else {
		if (vs(n, t)) return;
		e.uniform3fv(this.addr, t), ys(n, t);
	}
}
function ws(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z || n[3] !== t.w) && (e.uniform4f(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
	else {
		if (vs(n, t)) return;
		e.uniform4fv(this.addr, t), ys(n, t);
	}
}
function Ts(e, t) {
	let n = this.cache, r = t.elements;
	if (r === void 0) {
		if (vs(n, t)) return;
		e.uniformMatrix2fv(this.addr, !1, t), ys(n, t);
	} else {
		if (vs(n, r)) return;
		gs.set(r), e.uniformMatrix2fv(this.addr, !1, gs), ys(n, r);
	}
}
function Es(e, t) {
	let n = this.cache, r = t.elements;
	if (r === void 0) {
		if (vs(n, t)) return;
		e.uniformMatrix3fv(this.addr, !1, t), ys(n, t);
	} else {
		if (vs(n, r)) return;
		hs.set(r), e.uniformMatrix3fv(this.addr, !1, hs), ys(n, r);
	}
}
function Ds(e, t) {
	let n = this.cache, r = t.elements;
	if (r === void 0) {
		if (vs(n, t)) return;
		e.uniformMatrix4fv(this.addr, !1, t), ys(n, t);
	} else {
		if (vs(n, r)) return;
		ms.set(r), e.uniformMatrix4fv(this.addr, !1, ms), ys(n, r);
	}
}
function Os(e, t) {
	let n = this.cache;
	n[0] !== t && (e.uniform1i(this.addr, t), n[0] = t);
}
function ks(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y) && (e.uniform2i(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
	else {
		if (vs(n, t)) return;
		e.uniform2iv(this.addr, t), ys(n, t);
	}
}
function As(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z) && (e.uniform3i(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
	else {
		if (vs(n, t)) return;
		e.uniform3iv(this.addr, t), ys(n, t);
	}
}
function js(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z || n[3] !== t.w) && (e.uniform4i(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
	else {
		if (vs(n, t)) return;
		e.uniform4iv(this.addr, t), ys(n, t);
	}
}
function Ms(e, t) {
	let n = this.cache;
	n[0] !== t && (e.uniform1ui(this.addr, t), n[0] = t);
}
function Ns(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y) && (e.uniform2ui(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
	else {
		if (vs(n, t)) return;
		e.uniform2uiv(this.addr, t), ys(n, t);
	}
}
function Ps(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z) && (e.uniform3ui(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
	else {
		if (vs(n, t)) return;
		e.uniform3uiv(this.addr, t), ys(n, t);
	}
}
function Fs(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z || n[3] !== t.w) && (e.uniform4ui(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
	else {
		if (vs(n, t)) return;
		e.uniform4uiv(this.addr, t), ys(n, t);
	}
}
function Is(e, t, n) {
	let r = this.cache, i = n.allocateTextureUnit();
	r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i);
	let a;
	this.type === e.SAMPLER_2D_SHADOW ? (cs.compareFunction = n.isReversedDepthBuffer() ? 518 : 515, a = cs) : a = ss, n.setTexture2D(t || a, i);
}
function Ls(e, t, n) {
	let r = this.cache, i = n.allocateTextureUnit();
	r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i), n.setTexture3D(t || us, i);
}
function Rs(e, t, n) {
	let r = this.cache, i = n.allocateTextureUnit();
	r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i), n.setTextureCube(t || ds, i);
}
function zs(e, t, n) {
	let r = this.cache, i = n.allocateTextureUnit();
	r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i), n.setTexture2DArray(t || ls, i);
}
function Bs(e) {
	switch (e) {
		case 5126: return xs;
		case 35664: return Ss;
		case 35665: return Cs;
		case 35666: return ws;
		case 35674: return Ts;
		case 35675: return Es;
		case 35676: return Ds;
		case 5124:
		case 35670: return Os;
		case 35667:
		case 35671: return ks;
		case 35668:
		case 35672: return As;
		case 35669:
		case 35673: return js;
		case 5125: return Ms;
		case 36294: return Ns;
		case 36295: return Ps;
		case 36296: return Fs;
		case 35678:
		case 36198:
		case 36298:
		case 36306:
		case 35682: return Is;
		case 35679:
		case 36299:
		case 36307: return Ls;
		case 35680:
		case 36300:
		case 36308:
		case 36293: return Rs;
		case 36289:
		case 36303:
		case 36311:
		case 36292: return zs;
	}
}
function Vs(e, t) {
	e.uniform1fv(this.addr, t);
}
function Hs(e, t) {
	let n = _s(t, this.size, 2);
	e.uniform2fv(this.addr, n);
}
function Us(e, t) {
	let n = _s(t, this.size, 3);
	e.uniform3fv(this.addr, n);
}
function Ws(e, t) {
	let n = _s(t, this.size, 4);
	e.uniform4fv(this.addr, n);
}
function Gs(e, t) {
	let n = _s(t, this.size, 4);
	e.uniformMatrix2fv(this.addr, !1, n);
}
function Ks(e, t) {
	let n = _s(t, this.size, 9);
	e.uniformMatrix3fv(this.addr, !1, n);
}
function qs(e, t) {
	let n = _s(t, this.size, 16);
	e.uniformMatrix4fv(this.addr, !1, n);
}
function Js(e, t) {
	e.uniform1iv(this.addr, t);
}
function Ys(e, t) {
	e.uniform2iv(this.addr, t);
}
function Xs(e, t) {
	e.uniform3iv(this.addr, t);
}
function Zs(e, t) {
	e.uniform4iv(this.addr, t);
}
function Qs(e, t) {
	e.uniform1uiv(this.addr, t);
}
function $s(e, t) {
	e.uniform2uiv(this.addr, t);
}
function ec(e, t) {
	e.uniform3uiv(this.addr, t);
}
function tc(e, t) {
	e.uniform4uiv(this.addr, t);
}
function nc(e, t, n) {
	let r = this.cache, i = t.length, a = bs(n, i);
	vs(r, a) || (e.uniform1iv(this.addr, a), ys(r, a));
	let o;
	o = this.type === e.SAMPLER_2D_SHADOW ? cs : ss;
	for (let e = 0; e !== i; ++e) n.setTexture2D(t[e] || o, a[e]);
}
function rc(e, t, n) {
	let r = this.cache, i = t.length, a = bs(n, i);
	vs(r, a) || (e.uniform1iv(this.addr, a), ys(r, a));
	for (let e = 0; e !== i; ++e) n.setTexture3D(t[e] || us, a[e]);
}
function ic(e, t, n) {
	let r = this.cache, i = t.length, a = bs(n, i);
	vs(r, a) || (e.uniform1iv(this.addr, a), ys(r, a));
	for (let e = 0; e !== i; ++e) n.setTextureCube(t[e] || ds, a[e]);
}
function ac(e, t, n) {
	let r = this.cache, i = t.length, a = bs(n, i);
	vs(r, a) || (e.uniform1iv(this.addr, a), ys(r, a));
	for (let e = 0; e !== i; ++e) n.setTexture2DArray(t[e] || ls, a[e]);
}
function oc(e) {
	switch (e) {
		case 5126: return Vs;
		case 35664: return Hs;
		case 35665: return Us;
		case 35666: return Ws;
		case 35674: return Gs;
		case 35675: return Ks;
		case 35676: return qs;
		case 5124:
		case 35670: return Js;
		case 35667:
		case 35671: return Ys;
		case 35668:
		case 35672: return Xs;
		case 35669:
		case 35673: return Zs;
		case 5125: return Qs;
		case 36294: return $s;
		case 36295: return ec;
		case 36296: return tc;
		case 35678:
		case 36198:
		case 36298:
		case 36306:
		case 35682: return nc;
		case 35679:
		case 36299:
		case 36307: return rc;
		case 35680:
		case 36300:
		case 36308:
		case 36293: return ic;
		case 36289:
		case 36303:
		case 36311:
		case 36292: return ac;
	}
}
var sc = class {
	constructor(e, t, n) {
		this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.setValue = Bs(t.type);
	}
}, cc = class {
	constructor(e, t, n) {
		this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.size = t.size, this.setValue = oc(t.type);
	}
}, lc = class {
	constructor(e) {
		this.id = e, this.seq = [], this.map = {};
	}
	setValue(e, t, n) {
		let r = this.seq;
		for (let i = 0, a = r.length; i !== a; ++i) {
			let a = r[i];
			a.setValue(e, t[a.id], n);
		}
	}
}, uc = /(\w+)(\])?(\[|\.)?/g;
function dc(e, t) {
	e.seq.push(t), e.map[t.id] = t;
}
function fc(e, t, n) {
	let r = e.name, i = r.length;
	for (uc.lastIndex = 0;;) {
		let a = uc.exec(r), o = uc.lastIndex, s = a[1], c = a[2] === "]", l = a[3];
		if (c && (s |= 0), l === void 0 || l === "[" && o + 2 === i) {
			dc(n, l === void 0 ? new sc(s, e, t) : new cc(s, e, t));
			break;
		} else {
			let e = n.map[s];
			e === void 0 && (e = new lc(s), dc(n, e)), n = e;
		}
	}
}
var pc = class {
	constructor(e, t) {
		this.seq = [], this.map = {};
		let n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
		for (let r = 0; r < n; ++r) {
			let n = e.getActiveUniform(t, r);
			fc(n, e.getUniformLocation(t, n.name), this);
		}
		let r = [], i = [];
		for (let t of this.seq) t.type === e.SAMPLER_2D_SHADOW || t.type === e.SAMPLER_CUBE_SHADOW || t.type === e.SAMPLER_2D_ARRAY_SHADOW ? r.push(t) : i.push(t);
		r.length > 0 && (this.seq = r.concat(i));
	}
	setValue(e, t, n, r) {
		let i = this.map[t];
		i !== void 0 && i.setValue(e, n, r);
	}
	setOptional(e, t, n) {
		let r = t[n];
		r !== void 0 && this.setValue(e, n, r);
	}
	static upload(e, t, n, r) {
		for (let i = 0, a = t.length; i !== a; ++i) {
			let a = t[i], o = n[a.id];
			o.needsUpdate !== !1 && a.setValue(e, o.value, r);
		}
	}
	static seqWithValue(e, t) {
		let n = [];
		for (let r = 0, i = e.length; r !== i; ++r) {
			let i = e[r];
			i.id in t && n.push(i);
		}
		return n;
	}
};
function mc(e, t, n) {
	let r = e.createShader(t);
	return e.shaderSource(r, n), e.compileShader(r), r;
}
var hc = 37297, gc = 0;
function _c(e, t) {
	let n = e.split("\n"), r = [], i = Math.max(t - 6, 0), a = Math.min(t + 6, n.length);
	for (let e = i; e < a; e++) {
		let i = e + 1;
		r.push(`${i === t ? ">" : " "} ${i}: ${n[e]}`);
	}
	return r.join("\n");
}
var vc = /*@__PURE__*/ new K();
function yc(e) {
	X._getMatrix(vc, X.workingColorSpace, e);
	let t = `mat3( ${vc.elements.map((e) => e.toFixed(4))} )`;
	switch (X.getTransfer(e)) {
		case A: return [t, "LinearTransferOETF"];
		case j: return [t, "sRGBTransferOETF"];
		default: return L("WebGLProgram: Unsupported color space: ", e), [t, "LinearTransferOETF"];
	}
}
function bc(e, t, n) {
	let r = e.getShaderParameter(t, e.COMPILE_STATUS), i = (e.getShaderInfoLog(t) || "").trim();
	if (r && i === "") return "";
	let a = /ERROR: 0:(\d+)/.exec(i);
	if (a) {
		let r = parseInt(a[1]);
		return n.toUpperCase() + "\n\n" + i + "\n\n" + _c(e.getShaderSource(t), r);
	} else return i;
}
function xc(e, t) {
	let n = yc(t);
	return [
		`vec4 ${e}( vec4 value ) {`,
		`	return ${n[1]}( vec4( value.rgb * ${n[0]}, value.a ) );`,
		"}"
	].join("\n");
}
var Sc = {
	1: "Linear",
	2: "Reinhard",
	3: "Cineon",
	4: "ACESFilmic",
	6: "AgX",
	7: "Neutral",
	5: "Custom"
};
function Cc(e, t) {
	let n = Sc[t];
	return n === void 0 ? (L("WebGLProgram: Unsupported toneMapping:", t), "vec3 " + e + "( vec3 color ) { return LinearToneMapping( color ); }") : "vec3 " + e + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
}
var wc = /*@__PURE__*/ new G();
function Tc() {
	return X.getLuminanceCoefficients(wc), [
		"float luminance( const in vec3 rgb ) {",
		`	const vec3 weights = vec3( ${wc.x.toFixed(4)}, ${wc.y.toFixed(4)}, ${wc.z.toFixed(4)} );`,
		"	return dot( weights, rgb );",
		"}"
	].join("\n");
}
function Ec(e) {
	return [e.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "", e.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""].filter(kc).join("\n");
}
function Dc(e) {
	let t = [];
	for (let n in e) {
		let r = e[n];
		r !== !1 && t.push("#define " + n + " " + r);
	}
	return t.join("\n");
}
function Oc(e, t) {
	let n = {}, r = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES);
	for (let i = 0; i < r; i++) {
		let r = e.getActiveAttrib(t, i), a = r.name, o = 1;
		r.type === e.FLOAT_MAT2 && (o = 2), r.type === e.FLOAT_MAT3 && (o = 3), r.type === e.FLOAT_MAT4 && (o = 4), n[a] = {
			type: r.type,
			location: e.getAttribLocation(t, a),
			locationSize: o
		};
	}
	return n;
}
function kc(e) {
	return e !== "";
}
function Ac(e, t) {
	let n = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
	return e.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function jc(e, t) {
	return e.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
var Mc = /^[ \t]*#include +<([\w\d./]+)>/gm;
function Nc(e) {
	return e.replace(Mc, Fc);
}
var Pc = /* @__PURE__ */ new Map();
function Fc(e, t) {
	let n = Q[t];
	if (n === void 0) {
		let e = Pc.get(t);
		if (e !== void 0) n = Q[e], L("WebGLRenderer: Shader chunk \"%s\" has been deprecated. Use \"%s\" instead.", t, e);
		else throw Error("THREE.WebGLProgram: Can not resolve #include <" + t + ">");
	}
	return Nc(n);
}
var Ic = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function Lc(e) {
	return e.replace(Ic, Rc);
}
function Rc(e, t, n, r) {
	let i = "";
	for (let e = parseInt(t); e < parseInt(n); e++) i += r.replace(/\[\s*i\s*\]/g, "[ " + e + " ]").replace(/UNROLLED_LOOP_INDEX/g, e);
	return i;
}
function zc(e) {
	let t = `precision ${e.precision} float;
	precision ${e.precision} int;
	precision ${e.precision} sampler2D;
	precision ${e.precision} samplerCube;
	precision ${e.precision} sampler3D;
	precision ${e.precision} sampler2DArray;
	precision ${e.precision} sampler2DShadow;
	precision ${e.precision} samplerCubeShadow;
	precision ${e.precision} sampler2DArrayShadow;
	precision ${e.precision} isampler2D;
	precision ${e.precision} isampler3D;
	precision ${e.precision} isamplerCube;
	precision ${e.precision} isampler2DArray;
	precision ${e.precision} usampler2D;
	precision ${e.precision} usampler3D;
	precision ${e.precision} usamplerCube;
	precision ${e.precision} usampler2DArray;
	`;
	return e.precision === "highp" ? t += "\n#define HIGH_PRECISION" : e.precision === "mediump" ? t += "\n#define MEDIUM_PRECISION" : e.precision === "lowp" && (t += "\n#define LOW_PRECISION"), t;
}
var Bc = {
	1: "SHADOWMAP_TYPE_PCF",
	3: "SHADOWMAP_TYPE_VSM"
};
function Vc(e) {
	return Bc[e.shadowMapType] || "SHADOWMAP_TYPE_BASIC";
}
var Hc = {
	301: "ENVMAP_TYPE_CUBE",
	302: "ENVMAP_TYPE_CUBE",
	306: "ENVMAP_TYPE_CUBE_UV"
};
function Uc(e) {
	return e.envMap === !1 ? "ENVMAP_TYPE_CUBE" : Hc[e.envMapMode] || "ENVMAP_TYPE_CUBE";
}
var Wc = { 302: "ENVMAP_MODE_REFRACTION" };
function Gc(e) {
	return e.envMap === !1 ? "ENVMAP_MODE_REFLECTION" : Wc[e.envMapMode] || "ENVMAP_MODE_REFLECTION";
}
var Kc = {
	0: "ENVMAP_BLENDING_MULTIPLY",
	1: "ENVMAP_BLENDING_MIX",
	2: "ENVMAP_BLENDING_ADD"
};
function qc(e) {
	return e.envMap === !1 ? "ENVMAP_BLENDING_NONE" : Kc[e.combine] || "ENVMAP_BLENDING_NONE";
}
function Jc(e) {
	let t = e.envMapCubeUVHeight;
	if (t === null) return null;
	let n = Math.log2(t) - 2, r = 1 / t;
	return {
		texelWidth: 1 / (3 * Math.max(2 ** n, 112)),
		texelHeight: r,
		maxMip: n
	};
}
function Yc(e, t, n, r) {
	let i = e.getContext(), a = n.defines, o = n.vertexShader, s = n.fragmentShader, c = Vc(n), l = Uc(n), u = Gc(n), d = qc(n), f = Jc(n), p = Ec(n), m = Dc(a), h = i.createProgram(), g, _, v = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
	n.isRawShaderMaterial ? (g = [
		"#define SHADER_TYPE " + n.shaderType,
		"#define SHADER_NAME " + n.shaderName,
		m
	].filter(kc).join("\n"), g.length > 0 && (g += "\n"), _ = [
		"#define SHADER_TYPE " + n.shaderType,
		"#define SHADER_NAME " + n.shaderName,
		m
	].filter(kc).join("\n"), _.length > 0 && (_ += "\n")) : (g = [
		zc(n),
		"#define SHADER_TYPE " + n.shaderType,
		"#define SHADER_NAME " + n.shaderName,
		m,
		n.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
		n.batching ? "#define USE_BATCHING" : "",
		n.batchingColor ? "#define USE_BATCHING_COLOR" : "",
		n.instancing ? "#define USE_INSTANCING" : "",
		n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
		n.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
		n.useFog && n.fog ? "#define USE_FOG" : "",
		n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
		n.map ? "#define USE_MAP" : "",
		n.envMap ? "#define USE_ENVMAP" : "",
		n.envMap ? "#define " + u : "",
		n.lightMap ? "#define USE_LIGHTMAP" : "",
		n.aoMap ? "#define USE_AOMAP" : "",
		n.bumpMap ? "#define USE_BUMPMAP" : "",
		n.normalMap ? "#define USE_NORMALMAP" : "",
		n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
		n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
		n.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
		n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
		n.anisotropy ? "#define USE_ANISOTROPY" : "",
		n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
		n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
		n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
		n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
		n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
		n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
		n.specularMap ? "#define USE_SPECULARMAP" : "",
		n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
		n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
		n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
		n.metalnessMap ? "#define USE_METALNESSMAP" : "",
		n.alphaMap ? "#define USE_ALPHAMAP" : "",
		n.alphaHash ? "#define USE_ALPHAHASH" : "",
		n.transmission ? "#define USE_TRANSMISSION" : "",
		n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
		n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
		n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
		n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
		n.mapUv ? "#define MAP_UV " + n.mapUv : "",
		n.alphaMapUv ? "#define ALPHAMAP_UV " + n.alphaMapUv : "",
		n.lightMapUv ? "#define LIGHTMAP_UV " + n.lightMapUv : "",
		n.aoMapUv ? "#define AOMAP_UV " + n.aoMapUv : "",
		n.emissiveMapUv ? "#define EMISSIVEMAP_UV " + n.emissiveMapUv : "",
		n.bumpMapUv ? "#define BUMPMAP_UV " + n.bumpMapUv : "",
		n.normalMapUv ? "#define NORMALMAP_UV " + n.normalMapUv : "",
		n.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + n.displacementMapUv : "",
		n.metalnessMapUv ? "#define METALNESSMAP_UV " + n.metalnessMapUv : "",
		n.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + n.roughnessMapUv : "",
		n.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + n.anisotropyMapUv : "",
		n.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + n.clearcoatMapUv : "",
		n.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + n.clearcoatNormalMapUv : "",
		n.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + n.clearcoatRoughnessMapUv : "",
		n.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + n.iridescenceMapUv : "",
		n.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + n.iridescenceThicknessMapUv : "",
		n.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + n.sheenColorMapUv : "",
		n.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + n.sheenRoughnessMapUv : "",
		n.specularMapUv ? "#define SPECULARMAP_UV " + n.specularMapUv : "",
		n.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + n.specularColorMapUv : "",
		n.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + n.specularIntensityMapUv : "",
		n.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + n.transmissionMapUv : "",
		n.thicknessMapUv ? "#define THICKNESSMAP_UV " + n.thicknessMapUv : "",
		n.vertexTangents && n.flatShading === !1 ? "#define USE_TANGENT" : "",
		n.vertexNormals ? "#define HAS_NORMAL" : "",
		n.vertexColors ? "#define USE_COLOR" : "",
		n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
		n.vertexUv1s ? "#define USE_UV1" : "",
		n.vertexUv2s ? "#define USE_UV2" : "",
		n.vertexUv3s ? "#define USE_UV3" : "",
		n.pointsUvs ? "#define USE_POINTS_UV" : "",
		n.flatShading ? "#define FLAT_SHADED" : "",
		n.skinning ? "#define USE_SKINNING" : "",
		n.morphTargets ? "#define USE_MORPHTARGETS" : "",
		n.morphNormals && n.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
		n.morphColors ? "#define USE_MORPHCOLORS" : "",
		n.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "",
		n.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "",
		n.doubleSided ? "#define DOUBLE_SIDED" : "",
		n.flipSided ? "#define FLIP_SIDED" : "",
		n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
		n.shadowMapEnabled ? "#define " + c : "",
		n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
		n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
		n.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
		n.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
		"uniform mat4 modelMatrix;",
		"uniform mat4 modelViewMatrix;",
		"uniform mat4 projectionMatrix;",
		"uniform mat4 viewMatrix;",
		"uniform mat3 normalMatrix;",
		"uniform vec3 cameraPosition;",
		"uniform bool isOrthographic;",
		"#ifdef USE_INSTANCING",
		"	attribute mat4 instanceMatrix;",
		"#endif",
		"#ifdef USE_INSTANCING_COLOR",
		"	attribute vec3 instanceColor;",
		"#endif",
		"#ifdef USE_INSTANCING_MORPH",
		"	uniform sampler2D morphTexture;",
		"#endif",
		"attribute vec3 position;",
		"attribute vec3 normal;",
		"attribute vec2 uv;",
		"#ifdef USE_UV1",
		"	attribute vec2 uv1;",
		"#endif",
		"#ifdef USE_UV2",
		"	attribute vec2 uv2;",
		"#endif",
		"#ifdef USE_UV3",
		"	attribute vec2 uv3;",
		"#endif",
		"#ifdef USE_TANGENT",
		"	attribute vec4 tangent;",
		"#endif",
		"#if defined( USE_COLOR_ALPHA )",
		"	attribute vec4 color;",
		"#elif defined( USE_COLOR )",
		"	attribute vec3 color;",
		"#endif",
		"#ifdef USE_SKINNING",
		"	attribute vec4 skinIndex;",
		"	attribute vec4 skinWeight;",
		"#endif",
		"\n"
	].filter(kc).join("\n"), _ = [
		zc(n),
		"#define SHADER_TYPE " + n.shaderType,
		"#define SHADER_NAME " + n.shaderName,
		m,
		n.useFog && n.fog ? "#define USE_FOG" : "",
		n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
		n.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
		n.map ? "#define USE_MAP" : "",
		n.matcap ? "#define USE_MATCAP" : "",
		n.envMap ? "#define USE_ENVMAP" : "",
		n.envMap ? "#define " + l : "",
		n.envMap ? "#define " + u : "",
		n.envMap ? "#define " + d : "",
		f ? "#define CUBEUV_TEXEL_WIDTH " + f.texelWidth : "",
		f ? "#define CUBEUV_TEXEL_HEIGHT " + f.texelHeight : "",
		f ? "#define CUBEUV_MAX_MIP " + f.maxMip + ".0" : "",
		n.lightMap ? "#define USE_LIGHTMAP" : "",
		n.aoMap ? "#define USE_AOMAP" : "",
		n.bumpMap ? "#define USE_BUMPMAP" : "",
		n.normalMap ? "#define USE_NORMALMAP" : "",
		n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
		n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
		n.packedNormalMap ? "#define USE_PACKED_NORMALMAP" : "",
		n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
		n.anisotropy ? "#define USE_ANISOTROPY" : "",
		n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
		n.clearcoat ? "#define USE_CLEARCOAT" : "",
		n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
		n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
		n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
		n.dispersion ? "#define USE_DISPERSION" : "",
		n.iridescence ? "#define USE_IRIDESCENCE" : "",
		n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
		n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
		n.specularMap ? "#define USE_SPECULARMAP" : "",
		n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
		n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
		n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
		n.metalnessMap ? "#define USE_METALNESSMAP" : "",
		n.alphaMap ? "#define USE_ALPHAMAP" : "",
		n.alphaTest ? "#define USE_ALPHATEST" : "",
		n.alphaHash ? "#define USE_ALPHAHASH" : "",
		n.sheen ? "#define USE_SHEEN" : "",
		n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
		n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
		n.transmission ? "#define USE_TRANSMISSION" : "",
		n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
		n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
		n.vertexTangents && n.flatShading === !1 ? "#define USE_TANGENT" : "",
		n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "",
		n.vertexAlphas || n.batchingColor ? "#define USE_COLOR_ALPHA" : "",
		n.vertexUv1s ? "#define USE_UV1" : "",
		n.vertexUv2s ? "#define USE_UV2" : "",
		n.vertexUv3s ? "#define USE_UV3" : "",
		n.pointsUvs ? "#define USE_POINTS_UV" : "",
		n.gradientMap ? "#define USE_GRADIENTMAP" : "",
		n.flatShading ? "#define FLAT_SHADED" : "",
		n.doubleSided ? "#define DOUBLE_SIDED" : "",
		n.flipSided ? "#define FLIP_SIDED" : "",
		n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
		n.shadowMapEnabled ? "#define " + c : "",
		n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
		n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
		n.numLightProbeGrids > 0 ? "#define USE_LIGHT_PROBES_GRID" : "",
		n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
		n.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
		n.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
		n.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
		"uniform mat4 viewMatrix;",
		"uniform vec3 cameraPosition;",
		"uniform bool isOrthographic;",
		n.toneMapping === 0 ? "" : "#define TONE_MAPPING",
		n.toneMapping === 0 ? "" : Q.tonemapping_pars_fragment,
		n.toneMapping === 0 ? "" : Cc("toneMapping", n.toneMapping),
		n.dithering ? "#define DITHERING" : "",
		n.opaque ? "#define OPAQUE" : "",
		Q.colorspace_pars_fragment,
		xc("linearToOutputTexel", n.outputColorSpace),
		Tc(),
		n.useDepthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
		"\n"
	].filter(kc).join("\n")), o = Nc(o), o = Ac(o, n), o = jc(o, n), s = Nc(s), s = Ac(s, n), s = jc(s, n), o = Lc(o), s = Lc(s), n.isRawShaderMaterial !== !0 && (v = "#version 300 es\n", g = [
		p,
		"#define attribute in",
		"#define varying out",
		"#define texture2D texture"
	].join("\n") + "\n" + g, _ = [
		"#define varying in",
		n.glslVersion === "300 es" ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
		n.glslVersion === "300 es" ? "" : "#define gl_FragColor pc_fragColor",
		"#define gl_FragDepthEXT gl_FragDepth",
		"#define texture2D texture",
		"#define textureCube texture",
		"#define texture2DProj textureProj",
		"#define texture2DLodEXT textureLod",
		"#define texture2DProjLodEXT textureProjLod",
		"#define textureCubeLodEXT textureLod",
		"#define texture2DGradEXT textureGrad",
		"#define texture2DProjGradEXT textureProjGrad",
		"#define textureCubeGradEXT textureGrad"
	].join("\n") + "\n" + _);
	let y = v + g + o, b = v + _ + s, x = mc(i, i.VERTEX_SHADER, y), S = mc(i, i.FRAGMENT_SHADER, b);
	i.attachShader(h, x), i.attachShader(h, S), n.index0AttributeName === void 0 ? n.hasPositionAttribute === !0 && i.bindAttribLocation(h, 0, "position") : i.bindAttribLocation(h, 0, n.index0AttributeName), i.linkProgram(h);
	function C(t) {
		if (e.debug.checkShaderErrors) {
			let n = i.getProgramInfoLog(h) || "", r = i.getShaderInfoLog(x) || "", a = i.getShaderInfoLog(S) || "", o = n.trim(), s = r.trim(), c = a.trim(), l = !0, u = !0;
			if (i.getProgramParameter(h, i.LINK_STATUS) === !1) if (l = !1, typeof e.debug.onShaderError == "function") e.debug.onShaderError(i, h, x, S);
			else {
				let e = bc(i, x, "vertex"), n = bc(i, S, "fragment");
				R("WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(h, i.VALIDATE_STATUS) + "\n\nMaterial Name: " + t.name + "\nMaterial Type: " + t.type + "\n\nProgram Info Log: " + o + "\n" + e + "\n" + n);
			}
			else o === "" ? (s === "" || c === "") && (u = !1) : L("WebGLProgram: Program Info Log:", o);
			u && (t.diagnostics = {
				runnable: l,
				programLog: o,
				vertexShader: {
					log: s,
					prefix: g
				},
				fragmentShader: {
					log: c,
					prefix: _
				}
			});
		}
		i.deleteShader(x), i.deleteShader(S), w = new pc(i, h), T = Oc(i, h);
	}
	let w;
	this.getUniforms = function() {
		return w === void 0 && C(this), w;
	};
	let T;
	this.getAttributes = function() {
		return T === void 0 && C(this), T;
	};
	let E = n.rendererExtensionParallelShaderCompile === !1;
	return this.isReady = function() {
		return E === !1 && (E = i.getProgramParameter(h, hc)), E;
	}, this.destroy = function() {
		r.releaseStatesOfProgram(this), i.deleteProgram(h), this.program = void 0;
	}, this.type = n.shaderType, this.name = n.shaderName, this.id = gc++, this.cacheKey = t, this.usedTimes = 1, this.program = h, this.vertexShader = x, this.fragmentShader = S, this;
}
var Xc = 0, Zc = class {
	constructor() {
		this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
	}
	update(e, t, n) {
		let r = this._getShaderCacheForMaterial(e);
		return r.has(t) === !1 && (r.add(t), t.usedTimes++), r.has(n) === !1 && (r.add(n), n.usedTimes++), this;
	}
	remove(e) {
		let t = this.materialCache.get(e);
		for (let e of t) e.usedTimes--, e.usedTimes === 0 && this.shaderCache.delete(e.code);
		return this.materialCache.delete(e), this;
	}
	getVertexShaderStage(e) {
		return this._getShaderStage(e.vertexShader);
	}
	getFragmentShaderStage(e) {
		return this._getShaderStage(e.fragmentShader);
	}
	dispose() {
		this.shaderCache.clear(), this.materialCache.clear();
	}
	_getShaderCacheForMaterial(e) {
		let t = this.materialCache, n = t.get(e);
		return n === void 0 && (n = /* @__PURE__ */ new Set(), t.set(e, n)), n;
	}
	_getShaderStage(e) {
		let t = this.shaderCache, n = t.get(e);
		return n === void 0 && (n = new Qc(e), t.set(e, n)), n;
	}
}, Qc = class {
	constructor(e) {
		this.id = Xc++, this.code = e, this.usedTimes = 0;
	}
};
function $c(e) {
	return e === 1030 || e === 37490 || e === 36285;
}
function el(e, t, n, r, i, a) {
	let o = new st(), s = new Zc(), c = /* @__PURE__ */ new Set(), l = [], u = /* @__PURE__ */ new Map(), d = r.logarithmicDepthBuffer, f = r.precision, p = {
		MeshDepthMaterial: "depth",
		MeshDistanceMaterial: "distance",
		MeshNormalMaterial: "normal",
		MeshBasicMaterial: "basic",
		MeshLambertMaterial: "lambert",
		MeshPhongMaterial: "phong",
		MeshToonMaterial: "toon",
		MeshStandardMaterial: "physical",
		MeshPhysicalMaterial: "physical",
		MeshMatcapMaterial: "matcap",
		LineBasicMaterial: "basic",
		LineDashedMaterial: "dashed",
		PointsMaterial: "points",
		ShadowMaterial: "shadow",
		SpriteMaterial: "sprite"
	};
	function m(e) {
		return c.add(e), e === 0 ? "uv" : `uv${e}`;
	}
	function h(i, o, l, u, h, g) {
		let _ = u.fog, v = h.geometry, y = i.isMeshStandardMaterial || i.isMeshLambertMaterial || i.isMeshPhongMaterial ? u.environment : null, b = i.isMeshStandardMaterial || i.isMeshLambertMaterial && !i.envMap || i.isMeshPhongMaterial && !i.envMap, x = t.get(i.envMap || y, b), S = x && x.mapping === 306 ? x.image.height : null, C = p[i.type];
		i.precision !== null && (f = r.getMaxPrecision(i.precision), f !== i.precision && L("WebGLProgram.getParameters:", i.precision, "not supported, using", f, "instead."));
		let w = v.morphAttributes.position || v.morphAttributes.normal || v.morphAttributes.color, T = w === void 0 ? 0 : w.length, E = 0;
		v.morphAttributes.position !== void 0 && (E = 1), v.morphAttributes.normal !== void 0 && (E = 2), v.morphAttributes.color !== void 0 && (E = 3);
		let D, O, k, A;
		if (C) {
			let e = So[C];
			D = e.vertexShader, O = e.fragmentShader;
		} else {
			D = i.vertexShader, O = i.fragmentShader;
			let e = s.getVertexShaderStage(i), t = s.getFragmentShaderStage(i);
			s.update(i, e, t), k = e.id, A = t.id;
		}
		let j = e.getRenderTarget(), M = e.state.buffers.depth.getReversed(), N = h.isInstancedMesh === !0, ee = h.isBatchedMesh === !0, P = !!i.map, F = !!i.matcap, te = !!x, ne = !!i.aoMap, I = !!i.lightMap, re = !!i.bumpMap && i.wireframe === !1, ie = !!i.normalMap, R = !!i.displacementMap, ae = !!i.emissiveMap, oe = !!i.metalnessMap, se = !!i.roughnessMap, ce = i.anisotropy > 0, le = i.clearcoat > 0, ue = i.dispersion > 0, de = i.iridescence > 0, z = i.sheen > 0, B = i.transmission > 0, V = ce && !!i.anisotropyMap, fe = le && !!i.clearcoatMap, pe = le && !!i.clearcoatNormalMap, me = le && !!i.clearcoatRoughnessMap, he = de && !!i.iridescenceMap, ge = de && !!i.iridescenceThicknessMap, _e = z && !!i.sheenColorMap, ve = z && !!i.sheenRoughnessMap, ye = !!i.specularMap, be = !!i.specularColorMap, xe = !!i.specularIntensityMap, Se = B && !!i.transmissionMap, Ce = B && !!i.thicknessMap, we = !!i.gradientMap, Te = !!i.alphaMap, Ee = i.alphaTest > 0, De = !!i.alphaHash, Oe = !!i.extensions, ke = 0;
		i.toneMapped && (j === null || j.isXRRenderTarget === !0) && (ke = e.toneMapping);
		let Ae = {
			shaderID: C,
			shaderType: i.type,
			shaderName: i.name,
			vertexShader: D,
			fragmentShader: O,
			defines: i.defines,
			customVertexShaderID: k,
			customFragmentShaderID: A,
			isRawShaderMaterial: i.isRawShaderMaterial === !0,
			glslVersion: i.glslVersion,
			precision: f,
			batching: ee,
			batchingColor: ee && h._colorsTexture !== null,
			instancing: N,
			instancingColor: N && h.instanceColor !== null,
			instancingMorph: N && h.morphTexture !== null,
			outputColorSpace: j === null ? e.outputColorSpace : j.isXRRenderTarget === !0 ? j.texture.colorSpace : X.workingColorSpace,
			alphaToCoverage: !!i.alphaToCoverage,
			map: P,
			matcap: F,
			envMap: te,
			envMapMode: te && x.mapping,
			envMapCubeUVHeight: S,
			aoMap: ne,
			lightMap: I,
			bumpMap: re,
			normalMap: ie,
			displacementMap: R,
			emissiveMap: ae,
			normalMapObjectSpace: ie && i.normalMapType === 1,
			normalMapTangentSpace: ie && i.normalMapType === 0,
			packedNormalMap: ie && i.normalMapType === 0 && $c(i.normalMap.format),
			metalnessMap: oe,
			roughnessMap: se,
			anisotropy: ce,
			anisotropyMap: V,
			clearcoat: le,
			clearcoatMap: fe,
			clearcoatNormalMap: pe,
			clearcoatRoughnessMap: me,
			dispersion: ue,
			iridescence: de,
			iridescenceMap: he,
			iridescenceThicknessMap: ge,
			sheen: z,
			sheenColorMap: _e,
			sheenRoughnessMap: ve,
			specularMap: ye,
			specularColorMap: be,
			specularIntensityMap: xe,
			transmission: B,
			transmissionMap: Se,
			thicknessMap: Ce,
			gradientMap: we,
			opaque: i.transparent === !1 && i.blending === 1 && i.alphaToCoverage === !1,
			alphaMap: Te,
			alphaTest: Ee,
			alphaHash: De,
			combine: i.combine,
			mapUv: P && m(i.map.channel),
			aoMapUv: ne && m(i.aoMap.channel),
			lightMapUv: I && m(i.lightMap.channel),
			bumpMapUv: re && m(i.bumpMap.channel),
			normalMapUv: ie && m(i.normalMap.channel),
			displacementMapUv: R && m(i.displacementMap.channel),
			emissiveMapUv: ae && m(i.emissiveMap.channel),
			metalnessMapUv: oe && m(i.metalnessMap.channel),
			roughnessMapUv: se && m(i.roughnessMap.channel),
			anisotropyMapUv: V && m(i.anisotropyMap.channel),
			clearcoatMapUv: fe && m(i.clearcoatMap.channel),
			clearcoatNormalMapUv: pe && m(i.clearcoatNormalMap.channel),
			clearcoatRoughnessMapUv: me && m(i.clearcoatRoughnessMap.channel),
			iridescenceMapUv: he && m(i.iridescenceMap.channel),
			iridescenceThicknessMapUv: ge && m(i.iridescenceThicknessMap.channel),
			sheenColorMapUv: _e && m(i.sheenColorMap.channel),
			sheenRoughnessMapUv: ve && m(i.sheenRoughnessMap.channel),
			specularMapUv: ye && m(i.specularMap.channel),
			specularColorMapUv: be && m(i.specularColorMap.channel),
			specularIntensityMapUv: xe && m(i.specularIntensityMap.channel),
			transmissionMapUv: Se && m(i.transmissionMap.channel),
			thicknessMapUv: Ce && m(i.thicknessMap.channel),
			alphaMapUv: Te && m(i.alphaMap.channel),
			vertexTangents: !!v.attributes.tangent && (ie || ce),
			vertexNormals: !!v.attributes.normal,
			vertexColors: i.vertexColors,
			vertexAlphas: i.vertexColors === !0 && !!v.attributes.color && v.attributes.color.itemSize === 4,
			pointsUvs: h.isPoints === !0 && !!v.attributes.uv && (P || Te),
			fog: !!_,
			useFog: i.fog === !0,
			fogExp2: !!_ && _.isFogExp2,
			flatShading: i.wireframe === !1 && (i.flatShading === !0 || v.attributes.normal === void 0 && ie === !1 && (i.isMeshLambertMaterial || i.isMeshPhongMaterial || i.isMeshStandardMaterial || i.isMeshPhysicalMaterial)),
			sizeAttenuation: i.sizeAttenuation === !0,
			logarithmicDepthBuffer: d,
			reversedDepthBuffer: M,
			skinning: h.isSkinnedMesh === !0,
			hasPositionAttribute: v.attributes.position !== void 0,
			morphTargets: v.morphAttributes.position !== void 0,
			morphNormals: v.morphAttributes.normal !== void 0,
			morphColors: v.morphAttributes.color !== void 0,
			morphTargetsCount: T,
			morphTextureStride: E,
			numDirLights: o.directional.length,
			numPointLights: o.point.length,
			numSpotLights: o.spot.length,
			numSpotLightMaps: o.spotLightMap.length,
			numRectAreaLights: o.rectArea.length,
			numHemiLights: o.hemi.length,
			numDirLightShadows: o.directionalShadowMap.length,
			numPointLightShadows: o.pointShadowMap.length,
			numSpotLightShadows: o.spotShadowMap.length,
			numSpotLightShadowsWithMaps: o.numSpotLightShadowsWithMaps,
			numLightProbes: o.numLightProbes,
			numLightProbeGrids: g.length,
			numClippingPlanes: a.numPlanes,
			numClipIntersection: a.numIntersection,
			dithering: i.dithering,
			shadowMapEnabled: e.shadowMap.enabled && l.length > 0,
			shadowMapType: e.shadowMap.type,
			toneMapping: ke,
			decodeVideoTexture: P && i.map.isVideoTexture === !0 && X.getTransfer(i.map.colorSpace) === "srgb",
			decodeVideoTextureEmissive: ae && i.emissiveMap.isVideoTexture === !0 && X.getTransfer(i.emissiveMap.colorSpace) === "srgb",
			premultipliedAlpha: i.premultipliedAlpha,
			doubleSided: i.side === 2,
			flipSided: i.side === 1,
			useDepthPacking: i.depthPacking >= 0,
			depthPacking: i.depthPacking || 0,
			index0AttributeName: i.index0AttributeName,
			extensionClipCullDistance: Oe && i.extensions.clipCullDistance === !0 && n.has("WEBGL_clip_cull_distance"),
			extensionMultiDraw: (Oe && i.extensions.multiDraw === !0 || ee) && n.has("WEBGL_multi_draw"),
			rendererExtensionParallelShaderCompile: n.has("KHR_parallel_shader_compile"),
			customProgramCacheKey: i.customProgramCacheKey()
		};
		return Ae.vertexUv1s = c.has(1), Ae.vertexUv2s = c.has(2), Ae.vertexUv3s = c.has(3), c.clear(), Ae;
	}
	function g(t) {
		let n = [];
		if (t.shaderID ? n.push(t.shaderID) : (n.push(t.customVertexShaderID), n.push(t.customFragmentShaderID)), t.defines !== void 0) for (let e in t.defines) n.push(e), n.push(t.defines[e]);
		return t.isRawShaderMaterial === !1 && (_(n, t), v(n, t), n.push(e.outputColorSpace)), n.push(t.customProgramCacheKey), n.join();
	}
	function _(e, t) {
		e.push(t.precision), e.push(t.outputColorSpace), e.push(t.envMapMode), e.push(t.envMapCubeUVHeight), e.push(t.mapUv), e.push(t.alphaMapUv), e.push(t.lightMapUv), e.push(t.aoMapUv), e.push(t.bumpMapUv), e.push(t.normalMapUv), e.push(t.displacementMapUv), e.push(t.emissiveMapUv), e.push(t.metalnessMapUv), e.push(t.roughnessMapUv), e.push(t.anisotropyMapUv), e.push(t.clearcoatMapUv), e.push(t.clearcoatNormalMapUv), e.push(t.clearcoatRoughnessMapUv), e.push(t.iridescenceMapUv), e.push(t.iridescenceThicknessMapUv), e.push(t.sheenColorMapUv), e.push(t.sheenRoughnessMapUv), e.push(t.specularMapUv), e.push(t.specularColorMapUv), e.push(t.specularIntensityMapUv), e.push(t.transmissionMapUv), e.push(t.thicknessMapUv), e.push(t.combine), e.push(t.fogExp2), e.push(t.sizeAttenuation), e.push(t.morphTargetsCount), e.push(t.morphAttributeCount), e.push(t.numDirLights), e.push(t.numPointLights), e.push(t.numSpotLights), e.push(t.numSpotLightMaps), e.push(t.numHemiLights), e.push(t.numRectAreaLights), e.push(t.numDirLightShadows), e.push(t.numPointLightShadows), e.push(t.numSpotLightShadows), e.push(t.numSpotLightShadowsWithMaps), e.push(t.numLightProbes), e.push(t.shadowMapType), e.push(t.toneMapping), e.push(t.numClippingPlanes), e.push(t.numClipIntersection), e.push(t.depthPacking);
	}
	function v(e, t) {
		o.disableAll(), t.instancing && o.enable(0), t.instancingColor && o.enable(1), t.instancingMorph && o.enable(2), t.matcap && o.enable(3), t.envMap && o.enable(4), t.normalMapObjectSpace && o.enable(5), t.normalMapTangentSpace && o.enable(6), t.clearcoat && o.enable(7), t.iridescence && o.enable(8), t.alphaTest && o.enable(9), t.vertexColors && o.enable(10), t.vertexAlphas && o.enable(11), t.vertexUv1s && o.enable(12), t.vertexUv2s && o.enable(13), t.vertexUv3s && o.enable(14), t.vertexTangents && o.enable(15), t.anisotropy && o.enable(16), t.alphaHash && o.enable(17), t.batching && o.enable(18), t.dispersion && o.enable(19), t.batchingColor && o.enable(20), t.gradientMap && o.enable(21), t.packedNormalMap && o.enable(22), t.vertexNormals && o.enable(23), e.push(o.mask), o.disableAll(), t.fog && o.enable(0), t.useFog && o.enable(1), t.flatShading && o.enable(2), t.logarithmicDepthBuffer && o.enable(3), t.reversedDepthBuffer && o.enable(4), t.skinning && o.enable(5), t.morphTargets && o.enable(6), t.morphNormals && o.enable(7), t.morphColors && o.enable(8), t.premultipliedAlpha && o.enable(9), t.shadowMapEnabled && o.enable(10), t.doubleSided && o.enable(11), t.flipSided && o.enable(12), t.useDepthPacking && o.enable(13), t.dithering && o.enable(14), t.transmission && o.enable(15), t.sheen && o.enable(16), t.opaque && o.enable(17), t.pointsUvs && o.enable(18), t.decodeVideoTexture && o.enable(19), t.decodeVideoTextureEmissive && o.enable(20), t.alphaToCoverage && o.enable(21), t.numLightProbeGrids > 0 && o.enable(22), t.hasPositionAttribute && o.enable(23), e.push(o.mask);
	}
	function y(e) {
		let t = p[e.type], n;
		if (t) {
			let e = So[t];
			n = ia.clone(e.uniforms);
		} else n = e.uniforms;
		return n;
	}
	function b(t, n) {
		let r = u.get(n);
		return r === void 0 ? (r = new Yc(e, n, t, i), l.push(r), u.set(n, r)) : ++r.usedTimes, r;
	}
	function x(e) {
		if (--e.usedTimes === 0) {
			let t = l.indexOf(e);
			l[t] = l[l.length - 1], l.pop(), u.delete(e.cacheKey), e.destroy();
		}
	}
	function S(e) {
		s.remove(e);
	}
	function C() {
		s.dispose();
	}
	return {
		getParameters: h,
		getProgramCacheKey: g,
		getUniforms: y,
		acquireProgram: b,
		releaseProgram: x,
		releaseShaderCache: S,
		programs: l,
		dispose: C
	};
}
function tl() {
	let e = /* @__PURE__ */ new WeakMap();
	function t(t) {
		return e.has(t);
	}
	function n(t) {
		let n = e.get(t);
		return n === void 0 && (n = {}, e.set(t, n)), n;
	}
	function r(t) {
		e.delete(t);
	}
	function i(t, n, r) {
		e.get(t)[n] = r;
	}
	function a() {
		e = /* @__PURE__ */ new WeakMap();
	}
	return {
		has: t,
		get: n,
		remove: r,
		update: i,
		dispose: a
	};
}
function nl(e, t) {
	return e.groupOrder === t.groupOrder ? e.renderOrder === t.renderOrder ? e.material.id === t.material.id ? e.materialVariant === t.materialVariant ? e.z === t.z ? e.id - t.id : e.z - t.z : e.materialVariant - t.materialVariant : e.material.id - t.material.id : e.renderOrder - t.renderOrder : e.groupOrder - t.groupOrder;
}
function rl(e, t) {
	return e.groupOrder === t.groupOrder ? e.renderOrder === t.renderOrder ? e.z === t.z ? e.id - t.id : t.z - e.z : e.renderOrder - t.renderOrder : e.groupOrder - t.groupOrder;
}
function il() {
	let e = [], t = 0, n = [], r = [], i = [];
	function a() {
		t = 0, n.length = 0, r.length = 0, i.length = 0;
	}
	function o(e) {
		let t = 0;
		return e.isInstancedMesh && (t += 2), e.isSkinnedMesh && (t += 1), t;
	}
	function s(n, r, i, a, s, c) {
		let l = e[t];
		return l === void 0 ? (l = {
			id: n.id,
			object: n,
			geometry: r,
			material: i,
			materialVariant: o(n),
			groupOrder: a,
			renderOrder: n.renderOrder,
			z: s,
			group: c
		}, e[t] = l) : (l.id = n.id, l.object = n, l.geometry = r, l.material = i, l.materialVariant = o(n), l.groupOrder = a, l.renderOrder = n.renderOrder, l.z = s, l.group = c), t++, l;
	}
	function c(e, t, a, o, c, l) {
		let u = s(e, t, a, o, c, l);
		a.transmission > 0 ? r.push(u) : a.transparent === !0 ? i.push(u) : n.push(u);
	}
	function l(e, t, a, o, c, l) {
		let u = s(e, t, a, o, c, l);
		a.transmission > 0 ? r.unshift(u) : a.transparent === !0 ? i.unshift(u) : n.unshift(u);
	}
	function u(e, t, a) {
		n.length > 1 && n.sort(e || nl), r.length > 1 && r.sort(t || rl), i.length > 1 && i.sort(t || rl), a && (n.reverse(), r.reverse(), i.reverse());
	}
	function d() {
		for (let n = t, r = e.length; n < r; n++) {
			let t = e[n];
			if (t.id === null) break;
			t.id = null, t.object = null, t.geometry = null, t.material = null, t.group = null;
		}
	}
	return {
		opaque: n,
		transmissive: r,
		transparent: i,
		init: a,
		push: c,
		unshift: l,
		finish: d,
		sort: u
	};
}
function al() {
	let e = /* @__PURE__ */ new WeakMap();
	function t(t, n) {
		let r = e.get(t), i;
		return r === void 0 ? (i = new il(), e.set(t, [i])) : n >= r.length ? (i = new il(), r.push(i)) : i = r[n], i;
	}
	function n() {
		e = /* @__PURE__ */ new WeakMap();
	}
	return {
		get: t,
		dispose: n
	};
}
function ol() {
	let e = {};
	return { get: function(t) {
		if (e[t.id] !== void 0) return e[t.id];
		let n;
		switch (t.type) {
			case "DirectionalLight":
				n = {
					direction: new G(),
					color: new Z()
				};
				break;
			case "SpotLight":
				n = {
					position: new G(),
					direction: new G(),
					color: new Z(),
					distance: 0,
					coneCos: 0,
					penumbraCos: 0,
					decay: 0
				};
				break;
			case "PointLight":
				n = {
					position: new G(),
					color: new Z(),
					distance: 0,
					decay: 0
				};
				break;
			case "HemisphereLight":
				n = {
					direction: new G(),
					skyColor: new Z(),
					groundColor: new Z()
				};
				break;
			case "RectAreaLight":
				n = {
					color: new Z(),
					position: new G(),
					halfWidth: new G(),
					halfHeight: new G()
				};
				break;
		}
		return e[t.id] = n, n;
	} };
}
function sl() {
	let e = {};
	return { get: function(t) {
		if (e[t.id] !== void 0) return e[t.id];
		let n;
		switch (t.type) {
			case "DirectionalLight":
				n = {
					shadowIntensity: 1,
					shadowBias: 0,
					shadowNormalBias: 0,
					shadowRadius: 1,
					shadowMapSize: new U()
				};
				break;
			case "SpotLight":
				n = {
					shadowIntensity: 1,
					shadowBias: 0,
					shadowNormalBias: 0,
					shadowRadius: 1,
					shadowMapSize: new U()
				};
				break;
			case "PointLight":
				n = {
					shadowIntensity: 1,
					shadowBias: 0,
					shadowNormalBias: 0,
					shadowRadius: 1,
					shadowMapSize: new U(),
					shadowCameraNear: 1,
					shadowCameraFar: 1e3
				};
				break;
		}
		return e[t.id] = n, n;
	} };
}
var cl = 0;
function ll(e, t) {
	return (t.castShadow ? 2 : 0) - (e.castShadow ? 2 : 0) + +!!t.map - !!e.map;
}
function ul(e) {
	let t = new ol(), n = sl(), r = {
		version: 0,
		hash: {
			directionalLength: -1,
			pointLength: -1,
			spotLength: -1,
			rectAreaLength: -1,
			hemiLength: -1,
			numDirectionalShadows: -1,
			numPointShadows: -1,
			numSpotShadows: -1,
			numSpotMaps: -1,
			numLightProbes: -1
		},
		ambient: [
			0,
			0,
			0
		],
		probe: [],
		directional: [],
		directionalShadow: [],
		directionalShadowMap: [],
		directionalShadowMatrix: [],
		spot: [],
		spotLightMap: [],
		spotShadow: [],
		spotShadowMap: [],
		spotLightMatrix: [],
		rectArea: [],
		rectAreaLTC1: null,
		rectAreaLTC2: null,
		point: [],
		pointShadow: [],
		pointShadowMap: [],
		pointShadowMatrix: [],
		hemi: [],
		numSpotLightShadowsWithMaps: 0,
		numLightProbes: 0
	};
	for (let e = 0; e < 9; e++) r.probe.push(new G());
	let i = new G(), a = new Xe(), o = new Xe();
	function s(i) {
		let a = 0, o = 0, s = 0;
		for (let e = 0; e < 9; e++) r.probe[e].set(0, 0, 0);
		let c = 0, l = 0, u = 0, d = 0, f = 0, p = 0, m = 0, h = 0, g = 0, _ = 0, v = 0;
		i.sort(ll);
		for (let e = 0, y = i.length; e < y; e++) {
			let y = i[e], b = y.color, x = y.intensity, S = y.distance, C = null;
			if (y.shadow && y.shadow.map && (C = y.shadow.map.texture.format === 1030 ? y.shadow.map.texture : y.shadow.map.depthTexture || y.shadow.map.texture), y.isAmbientLight) a += b.r * x, o += b.g * x, s += b.b * x;
			else if (y.isLightProbe) {
				for (let e = 0; e < 9; e++) r.probe[e].addScaledVector(y.sh.coefficients[e], x);
				v++;
			} else if (y.isDirectionalLight) {
				let e = t.get(y);
				if (e.color.copy(y.color).multiplyScalar(y.intensity), y.castShadow) {
					let e = y.shadow, t = n.get(y);
					t.shadowIntensity = e.intensity, t.shadowBias = e.bias, t.shadowNormalBias = e.normalBias, t.shadowRadius = e.radius, t.shadowMapSize = e.mapSize, r.directionalShadow[c] = t, r.directionalShadowMap[c] = C, r.directionalShadowMatrix[c] = y.shadow.matrix, p++;
				}
				r.directional[c] = e, c++;
			} else if (y.isSpotLight) {
				let e = t.get(y);
				e.position.setFromMatrixPosition(y.matrixWorld), e.color.copy(b).multiplyScalar(x), e.distance = S, e.coneCos = Math.cos(y.angle), e.penumbraCos = Math.cos(y.angle * (1 - y.penumbra)), e.decay = y.decay, r.spot[u] = e;
				let i = y.shadow;
				if (y.map && (r.spotLightMap[g] = y.map, g++, i.updateMatrices(y), y.castShadow && _++), r.spotLightMatrix[u] = i.matrix, y.castShadow) {
					let e = n.get(y);
					e.shadowIntensity = i.intensity, e.shadowBias = i.bias, e.shadowNormalBias = i.normalBias, e.shadowRadius = i.radius, e.shadowMapSize = i.mapSize, r.spotShadow[u] = e, r.spotShadowMap[u] = C, h++;
				}
				u++;
			} else if (y.isRectAreaLight) {
				let e = t.get(y);
				e.color.copy(b).multiplyScalar(x), e.halfWidth.set(y.width * .5, 0, 0), e.halfHeight.set(0, y.height * .5, 0), r.rectArea[d] = e, d++;
			} else if (y.isPointLight) {
				let e = t.get(y);
				if (e.color.copy(y.color).multiplyScalar(y.intensity), e.distance = y.distance, e.decay = y.decay, y.castShadow) {
					let e = y.shadow, t = n.get(y);
					t.shadowIntensity = e.intensity, t.shadowBias = e.bias, t.shadowNormalBias = e.normalBias, t.shadowRadius = e.radius, t.shadowMapSize = e.mapSize, t.shadowCameraNear = e.camera.near, t.shadowCameraFar = e.camera.far, r.pointShadow[l] = t, r.pointShadowMap[l] = C, r.pointShadowMatrix[l] = y.shadow.matrix, m++;
				}
				r.point[l] = e, l++;
			} else if (y.isHemisphereLight) {
				let e = t.get(y);
				e.skyColor.copy(y.color).multiplyScalar(x), e.groundColor.copy(y.groundColor).multiplyScalar(x), r.hemi[f] = e, f++;
			}
		}
		d > 0 && (e.has("OES_texture_float_linear") === !0 ? (r.rectAreaLTC1 = $.LTC_FLOAT_1, r.rectAreaLTC2 = $.LTC_FLOAT_2) : (r.rectAreaLTC1 = $.LTC_HALF_1, r.rectAreaLTC2 = $.LTC_HALF_2)), r.ambient[0] = a, r.ambient[1] = o, r.ambient[2] = s;
		let y = r.hash;
		(y.directionalLength !== c || y.pointLength !== l || y.spotLength !== u || y.rectAreaLength !== d || y.hemiLength !== f || y.numDirectionalShadows !== p || y.numPointShadows !== m || y.numSpotShadows !== h || y.numSpotMaps !== g || y.numLightProbes !== v) && (r.directional.length = c, r.spot.length = u, r.rectArea.length = d, r.point.length = l, r.hemi.length = f, r.directionalShadow.length = p, r.directionalShadowMap.length = p, r.pointShadow.length = m, r.pointShadowMap.length = m, r.spotShadow.length = h, r.spotShadowMap.length = h, r.directionalShadowMatrix.length = p, r.pointShadowMatrix.length = m, r.spotLightMatrix.length = h + g - _, r.spotLightMap.length = g, r.numSpotLightShadowsWithMaps = _, r.numLightProbes = v, y.directionalLength = c, y.pointLength = l, y.spotLength = u, y.rectAreaLength = d, y.hemiLength = f, y.numDirectionalShadows = p, y.numPointShadows = m, y.numSpotShadows = h, y.numSpotMaps = g, y.numLightProbes = v, r.version = cl++);
	}
	function c(e, t) {
		let n = 0, s = 0, c = 0, l = 0, u = 0, d = t.matrixWorldInverse;
		for (let t = 0, f = e.length; t < f; t++) {
			let f = e[t];
			if (f.isDirectionalLight) {
				let e = r.directional[n];
				e.direction.setFromMatrixPosition(f.matrixWorld), i.setFromMatrixPosition(f.target.matrixWorld), e.direction.sub(i), e.direction.transformDirection(d), n++;
			} else if (f.isSpotLight) {
				let e = r.spot[c];
				e.position.setFromMatrixPosition(f.matrixWorld), e.position.applyMatrix4(d), e.direction.setFromMatrixPosition(f.matrixWorld), i.setFromMatrixPosition(f.target.matrixWorld), e.direction.sub(i), e.direction.transformDirection(d), c++;
			} else if (f.isRectAreaLight) {
				let e = r.rectArea[l];
				e.position.setFromMatrixPosition(f.matrixWorld), e.position.applyMatrix4(d), o.identity(), a.copy(f.matrixWorld), a.premultiply(d), o.extractRotation(a), e.halfWidth.set(f.width * .5, 0, 0), e.halfHeight.set(0, f.height * .5, 0), e.halfWidth.applyMatrix4(o), e.halfHeight.applyMatrix4(o), l++;
			} else if (f.isPointLight) {
				let e = r.point[s];
				e.position.setFromMatrixPosition(f.matrixWorld), e.position.applyMatrix4(d), s++;
			} else if (f.isHemisphereLight) {
				let e = r.hemi[u];
				e.direction.setFromMatrixPosition(f.matrixWorld), e.direction.transformDirection(d), u++;
			}
		}
	}
	return {
		setup: s,
		setupView: c,
		state: r
	};
}
function dl(e) {
	let t = new ul(e), n = [], r = [], i = [];
	function a(e) {
		d.camera = e, n.length = 0, r.length = 0, i.length = 0;
	}
	function o(e) {
		n.push(e);
	}
	function s(e) {
		r.push(e);
	}
	function c(e) {
		i.push(e);
	}
	function l() {
		t.setup(n);
	}
	function u(e) {
		t.setupView(n, e);
	}
	let d = {
		lightsArray: n,
		shadowsArray: r,
		lightProbeGridArray: i,
		camera: null,
		lights: t,
		transmissionRenderTarget: {},
		textureUnits: 0
	};
	return {
		init: a,
		state: d,
		setupLights: l,
		setupLightsView: u,
		pushLight: o,
		pushShadow: s,
		pushLightProbeGrid: c
	};
}
function fl(e) {
	let t = /* @__PURE__ */ new WeakMap();
	function n(n, r = 0) {
		let i = t.get(n), a;
		return i === void 0 ? (a = new dl(e), t.set(n, [a])) : r >= i.length ? (a = new dl(e), i.push(a)) : a = i[r], a;
	}
	function r() {
		t = /* @__PURE__ */ new WeakMap();
	}
	return {
		get: n,
		dispose: r
	};
}
var pl = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}", ml = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );\n	gl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );\n}", hl = [
	/*@__PURE__*/ new G(1, 0, 0),
	/*@__PURE__*/ new G(-1, 0, 0),
	/*@__PURE__*/ new G(0, 1, 0),
	/*@__PURE__*/ new G(0, -1, 0),
	/*@__PURE__*/ new G(0, 0, 1),
	/*@__PURE__*/ new G(0, 0, -1)
], gl = [
	/*@__PURE__*/ new G(0, -1, 0),
	/*@__PURE__*/ new G(0, -1, 0),
	/*@__PURE__*/ new G(0, 0, 1),
	/*@__PURE__*/ new G(0, 0, -1),
	/*@__PURE__*/ new G(0, -1, 0),
	/*@__PURE__*/ new G(0, -1, 0)
], _l = /*@__PURE__*/ new Xe(), vl = /*@__PURE__*/ new G(), yl = /*@__PURE__*/ new G();
function bl(e, t, n) {
	let a = new Er(), o = new U(), s = new U(), d = new Ge(), f = new la(), p = new ua(), m = {}, g = n.maxTextureSize, _ = {
		0: 1,
		1: 0,
		2: 2
	}, y = new sa({
		defines: { VSM_SAMPLES: 8 },
		uniforms: {
			shadow_pass: { value: null },
			resolution: { value: new U() },
			radius: { value: 4 }
		},
		vertexShader: pl,
		fragmentShader: ml
	}), b = y.clone();
	b.defines.HORIZONTAL_PASS = 1;
	let x = new Dn();
	x.setAttribute("position", new fn(new Float32Array([
		-1,
		-1,
		.5,
		3,
		-1,
		.5,
		-1,
		3,
		.5
	]), 3));
	let S = new hr(x, y), C = this;
	this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1;
	let w = this.type;
	this.render = function(t, n, f) {
		if (C.enabled === !1 || C.autoUpdate === !1 && C.needsUpdate === !1 || t.length === 0) return;
		this.type === 2 && (L("WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead."), this.type = 1);
		let p = e.getRenderTarget(), m = e.getActiveCubeFace(), _ = e.getActiveMipmapLevel(), y = e.state;
		y.setBlending(0), y.buffers.depth.getReversed() === !0 ? y.buffers.color.setClear(0, 0, 0, 0) : y.buffers.color.setClear(1, 1, 1, 1), y.buffers.depth.setTest(!0), y.setScissorTest(!1);
		let b = w !== this.type;
		b && n.traverse(function(e) {
			e.material && (Array.isArray(e.material) ? e.material.forEach((e) => e.needsUpdate = !0) : e.material.needsUpdate = !0);
		});
		for (let p = 0, m = t.length; p < m; p++) {
			let m = t[p], _ = m.shadow;
			if (_ === void 0) {
				L("WebGLShadowMap:", m, "has no shadow.");
				continue;
			}
			if (_.autoUpdate === !1 && _.needsUpdate === !1) continue;
			o.copy(_.mapSize);
			let x = _.getFrameExtents();
			o.multiply(x), s.copy(_.mapSize), (o.x > g || o.y > g) && (o.x > g && (s.x = Math.floor(g / x.x), o.x = s.x * x.x, _.mapSize.x = s.x), o.y > g && (s.y = Math.floor(g / x.y), o.y = s.y * x.y, _.mapSize.y = s.y));
			let S = e.state.buffers.depth.getReversed();
			if (_.camera._reversedDepth = S, _.map === null || b === !0) {
				if (_.map !== null && (_.map.depthTexture !== null && (_.map.depthTexture.dispose(), _.map.depthTexture = null), _.map.dispose()), this.type === 3) {
					if (m.isPointLight) {
						L("WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.");
						continue;
					}
					_.map = new qe(o.x, o.y, {
						format: v,
						type: u,
						minFilter: i,
						magFilter: i,
						generateMipmaps: !1
					}), _.map.texture.name = m.name + ".shadowMap", _.map.depthTexture = new kr(o.x, o.y, l), _.map.depthTexture.name = m.name + ".shadowMapDepth", _.map.depthTexture.format = h, _.map.depthTexture.compareFunction = null, _.map.depthTexture.minFilter = r, _.map.depthTexture.magFilter = r;
				} else m.isPointLight ? (_.map = new Zo(o.x), _.map.depthTexture = new Ar(o.x, c)) : (_.map = new qe(o.x, o.y), _.map.depthTexture = new kr(o.x, o.y, c)), _.map.depthTexture.name = m.name + ".shadowMap", _.map.depthTexture.format = h, this.type === 1 ? (_.map.depthTexture.compareFunction = S ? 518 : 515, _.map.depthTexture.minFilter = i, _.map.depthTexture.magFilter = i) : (_.map.depthTexture.compareFunction = null, _.map.depthTexture.minFilter = r, _.map.depthTexture.magFilter = r);
				_.camera.updateProjectionMatrix();
			}
			let C = _.map.isWebGLCubeRenderTarget ? 6 : 1;
			for (let t = 0; t < C; t++) {
				if (_.map.isWebGLCubeRenderTarget) e.setRenderTarget(_.map, t), e.clear();
				else {
					t === 0 && (e.setRenderTarget(_.map), e.clear());
					let n = _.getViewport(t);
					d.set(s.x * n.x, s.y * n.y, s.x * n.z, s.y * n.w), y.viewport(d);
				}
				if (m.isPointLight) {
					let e = _.camera, n = _.matrix, r = m.distance || e.far;
					r !== e.far && (e.far = r, e.updateProjectionMatrix()), vl.setFromMatrixPosition(m.matrixWorld), e.position.copy(vl), yl.copy(e.position), yl.add(hl[t]), e.up.copy(gl[t]), e.lookAt(yl), e.updateMatrixWorld(), n.makeTranslation(-vl.x, -vl.y, -vl.z), _l.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), _._frustum.setFromProjectionMatrix(_l, e.coordinateSystem, e.reversedDepth);
				} else _.updateMatrices(m);
				a = _.getFrustum(), D(n, f, _.camera, m, this.type);
			}
			_.isPointLightShadow !== !0 && this.type === 3 && T(_, f), _.needsUpdate = !1;
		}
		w = this.type, C.needsUpdate = !1, e.setRenderTarget(p, m, _);
	};
	function T(n, r) {
		let i = t.update(S);
		y.defines.VSM_SAMPLES !== n.blurSamples && (y.defines.VSM_SAMPLES = n.blurSamples, b.defines.VSM_SAMPLES = n.blurSamples, y.needsUpdate = !0, b.needsUpdate = !0), n.mapPass === null && (n.mapPass = new qe(o.x, o.y, {
			format: v,
			type: u
		})), y.uniforms.shadow_pass.value = n.map.depthTexture, y.uniforms.resolution.value = n.mapSize, y.uniforms.radius.value = n.radius, e.setRenderTarget(n.mapPass), e.clear(), e.renderBufferDirect(r, null, i, y, S, null), b.uniforms.shadow_pass.value = n.mapPass.texture, b.uniforms.resolution.value = n.mapSize, b.uniforms.radius.value = n.radius, e.setRenderTarget(n.map), e.clear(), e.renderBufferDirect(r, null, i, b, S, null);
	}
	function E(t, n, r, i) {
		let a = null, o = r.isPointLight === !0 ? t.customDistanceMaterial : t.customDepthMaterial;
		if (o !== void 0) a = o;
		else if (a = r.isPointLight === !0 ? p : f, e.localClippingEnabled && n.clipShadows === !0 && Array.isArray(n.clippingPlanes) && n.clippingPlanes.length !== 0 || n.displacementMap && n.displacementScale !== 0 || n.alphaMap && n.alphaTest > 0 || n.map && n.alphaTest > 0 || n.alphaToCoverage === !0) {
			let e = a.uuid, t = n.uuid, r = m[e];
			r === void 0 && (r = {}, m[e] = r);
			let i = r[t];
			i === void 0 && (i = a.clone(), r[t] = i, n.addEventListener("dispose", O)), a = i;
		}
		if (a.visible = n.visible, a.wireframe = n.wireframe, i === 3 ? a.side = n.shadowSide === null ? n.side : n.shadowSide : a.side = n.shadowSide === null ? _[n.side] : n.shadowSide, a.alphaMap = n.alphaMap, a.alphaTest = n.alphaToCoverage === !0 ? .5 : n.alphaTest, a.map = n.map, a.clipShadows = n.clipShadows, a.clippingPlanes = n.clippingPlanes, a.clipIntersection = n.clipIntersection, a.displacementMap = n.displacementMap, a.displacementScale = n.displacementScale, a.displacementBias = n.displacementBias, a.wireframeLinewidth = n.wireframeLinewidth, a.linewidth = n.linewidth, r.isPointLight === !0 && a.isMeshDistanceMaterial === !0) {
			let t = e.properties.get(a);
			t.light = r;
		}
		return a;
	}
	function D(n, r, i, o, s) {
		if (n.visible === !1) return;
		if (n.layers.test(r.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && s === 3) && (!n.frustumCulled || a.intersectsObject(n))) {
			n.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, n.matrixWorld);
			let a = t.update(n), c = n.material;
			if (Array.isArray(c)) {
				let t = a.groups;
				for (let l = 0, u = t.length; l < u; l++) {
					let u = t[l], d = c[u.materialIndex];
					if (d && d.visible) {
						let t = E(n, d, o, s);
						n.onBeforeShadow(e, n, r, i, a, t, u), e.renderBufferDirect(i, null, a, t, n, u), n.onAfterShadow(e, n, r, i, a, t, u);
					}
				}
			} else if (c.visible) {
				let t = E(n, c, o, s);
				n.onBeforeShadow(e, n, r, i, a, t, null), e.renderBufferDirect(i, null, a, t, n, null), n.onAfterShadow(e, n, r, i, a, t, null);
			}
		}
		let c = n.children;
		for (let e = 0, t = c.length; e < t; e++) D(c[e], r, i, o, s);
	}
	function O(e) {
		e.target.removeEventListener("dispose", O);
		for (let t in m) {
			let n = m[t], r = e.target.uuid;
			r in n && (n[r].dispose(), delete n[r]);
		}
	}
}
function xl(e, t) {
	function n() {
		let t = !1, n = new Ge(), r = null, i = new Ge(0, 0, 0, 0);
		return {
			setMask: function(n) {
				r !== n && !t && (e.colorMask(n, n, n, n), r = n);
			},
			setLocked: function(e) {
				t = e;
			},
			setClear: function(t, r, a, o, s) {
				s === !0 && (t *= o, r *= o, a *= o), n.set(t, r, a, o), i.equals(n) === !1 && (e.clearColor(t, r, a, o), i.copy(n));
			},
			reset: function() {
				t = !1, r = null, i.set(-1, 0, 0, 0);
			}
		};
	}
	function r() {
		let n = !1, r = !1, i = null, a = null, o = null;
		return {
			setReversed: function(e) {
				if (r !== e) {
					let n = t.get("EXT_clip_control");
					e ? n.clipControlEXT(n.LOWER_LEFT_EXT, n.ZERO_TO_ONE_EXT) : n.clipControlEXT(n.LOWER_LEFT_EXT, n.NEGATIVE_ONE_TO_ONE_EXT), r = e;
					let i = o;
					o = null, this.setClear(i);
				}
			},
			getReversed: function() {
				return r;
			},
			setTest: function(t) {
				t ? oe(e.DEPTH_TEST) : ce(e.DEPTH_TEST);
			},
			setMask: function(t) {
				i !== t && !n && (e.depthMask(t), i = t);
			},
			setFunc: function(t) {
				if (r && (t = se[t]), a !== t) {
					switch (t) {
						case 0:
							e.depthFunc(e.NEVER);
							break;
						case 1:
							e.depthFunc(e.ALWAYS);
							break;
						case 2:
							e.depthFunc(e.LESS);
							break;
						case 3:
							e.depthFunc(e.LEQUAL);
							break;
						case 4:
							e.depthFunc(e.EQUAL);
							break;
						case 5:
							e.depthFunc(e.GEQUAL);
							break;
						case 6:
							e.depthFunc(e.GREATER);
							break;
						case 7:
							e.depthFunc(e.NOTEQUAL);
							break;
						default: e.depthFunc(e.LEQUAL);
					}
					a = t;
				}
			},
			setLocked: function(e) {
				n = e;
			},
			setClear: function(t) {
				o !== t && (o = t, r && (t = 1 - t), e.clearDepth(t));
			},
			reset: function() {
				n = !1, i = null, a = null, o = null, r = !1;
			}
		};
	}
	function i() {
		let t = !1, n = null, r = null, i = null, a = null, o = null, s = null, c = null, l = null;
		return {
			setTest: function(n) {
				t || (n ? oe(e.STENCIL_TEST) : ce(e.STENCIL_TEST));
			},
			setMask: function(r) {
				n !== r && !t && (e.stencilMask(r), n = r);
			},
			setFunc: function(t, n, o) {
				(r !== t || i !== n || a !== o) && (e.stencilFunc(t, n, o), r = t, i = n, a = o);
			},
			setOp: function(t, n, r) {
				(o !== t || s !== n || c !== r) && (e.stencilOp(t, n, r), o = t, s = n, c = r);
			},
			setLocked: function(e) {
				t = e;
			},
			setClear: function(t) {
				l !== t && (e.clearStencil(t), l = t);
			},
			reset: function() {
				t = !1, n = null, r = null, i = null, a = null, o = null, s = null, c = null, l = null;
			}
		};
	}
	let a = new n(), o = new r(), s = new i(), c = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap(), u = {}, d = {}, f = {}, p = /* @__PURE__ */ new WeakMap(), m = [], h = null, g = !1, _ = null, v = null, y = null, b = null, x = null, S = null, C = null, w = new Z(0, 0, 0), T = 0, E = !1, D = null, O = null, k = null, A = null, j = null, M = e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS), N = !1, ee = 0, P = e.getParameter(e.VERSION);
	P.indexOf("WebGL") === -1 ? P.indexOf("OpenGL ES") !== -1 && (ee = parseFloat(/^OpenGL ES (\d)/.exec(P)[1]), N = ee >= 2) : (ee = parseFloat(/^WebGL (\d)/.exec(P)[1]), N = ee >= 1);
	let F = null, te = {}, ne = e.getParameter(e.SCISSOR_BOX), I = e.getParameter(e.VIEWPORT), re = new Ge().fromArray(ne), ie = new Ge().fromArray(I);
	function L(t, n, r, i) {
		let a = /* @__PURE__ */ new Uint8Array(4), o = e.createTexture();
		e.bindTexture(t, o), e.texParameteri(t, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(t, e.TEXTURE_MAG_FILTER, e.NEAREST);
		for (let o = 0; o < r; o++) t === e.TEXTURE_3D || t === e.TEXTURE_2D_ARRAY ? e.texImage3D(n, 0, e.RGBA, 1, 1, i, 0, e.RGBA, e.UNSIGNED_BYTE, a) : e.texImage2D(n + o, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, a);
		return o;
	}
	let ae = {};
	ae[e.TEXTURE_2D] = L(e.TEXTURE_2D, e.TEXTURE_2D, 1), ae[e.TEXTURE_CUBE_MAP] = L(e.TEXTURE_CUBE_MAP, e.TEXTURE_CUBE_MAP_POSITIVE_X, 6), ae[e.TEXTURE_2D_ARRAY] = L(e.TEXTURE_2D_ARRAY, e.TEXTURE_2D_ARRAY, 1, 1), ae[e.TEXTURE_3D] = L(e.TEXTURE_3D, e.TEXTURE_3D, 1, 1), a.setClear(0, 0, 0, 1), o.setClear(1), s.setClear(0), oe(e.DEPTH_TEST), o.setFunc(3), pe(!1), me(1), oe(e.CULL_FACE), V(0);
	function oe(t) {
		u[t] !== !0 && (e.enable(t), u[t] = !0);
	}
	function ce(t) {
		u[t] !== !1 && (e.disable(t), u[t] = !1);
	}
	function le(t, n) {
		return f[t] === n ? !1 : (e.bindFramebuffer(t, n), f[t] = n, t === e.DRAW_FRAMEBUFFER && (f[e.FRAMEBUFFER] = n), t === e.FRAMEBUFFER && (f[e.DRAW_FRAMEBUFFER] = n), !0);
	}
	function ue(t, n) {
		let r = m, i = !1;
		if (t) {
			r = p.get(n), r === void 0 && (r = [], p.set(n, r));
			let a = t.textures;
			if (r.length !== a.length || r[0] !== e.COLOR_ATTACHMENT0) {
				for (let t = 0, n = a.length; t < n; t++) r[t] = e.COLOR_ATTACHMENT0 + t;
				r.length = a.length, i = !0;
			}
		} else r[0] !== e.BACK && (r[0] = e.BACK, i = !0);
		i && e.drawBuffers(r);
	}
	function de(t) {
		return h === t ? !1 : (e.useProgram(t), h = t, !0);
	}
	let z = {
		100: e.FUNC_ADD,
		101: e.FUNC_SUBTRACT,
		102: e.FUNC_REVERSE_SUBTRACT
	};
	z[103] = e.MIN, z[104] = e.MAX;
	let B = {
		200: e.ZERO,
		201: e.ONE,
		202: e.SRC_COLOR,
		204: e.SRC_ALPHA,
		210: e.SRC_ALPHA_SATURATE,
		208: e.DST_COLOR,
		206: e.DST_ALPHA,
		203: e.ONE_MINUS_SRC_COLOR,
		205: e.ONE_MINUS_SRC_ALPHA,
		209: e.ONE_MINUS_DST_COLOR,
		207: e.ONE_MINUS_DST_ALPHA,
		211: e.CONSTANT_COLOR,
		212: e.ONE_MINUS_CONSTANT_COLOR,
		213: e.CONSTANT_ALPHA,
		214: e.ONE_MINUS_CONSTANT_ALPHA
	};
	function V(t, n, r, i, a, o, s, c, l, u) {
		if (t === 0) {
			g === !0 && (ce(e.BLEND), g = !1);
			return;
		}
		if (g === !1 && (oe(e.BLEND), g = !0), t !== 5) {
			if (t !== _ || u !== E) {
				if ((v !== 100 || x !== 100) && (e.blendEquation(e.FUNC_ADD), v = 100, x = 100), u) switch (t) {
					case 1:
						e.blendFuncSeparate(e.ONE, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
						break;
					case 2:
						e.blendFunc(e.ONE, e.ONE);
						break;
					case 3:
						e.blendFuncSeparate(e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ZERO, e.ONE);
						break;
					case 4:
						e.blendFuncSeparate(e.DST_COLOR, e.ONE_MINUS_SRC_ALPHA, e.ZERO, e.ONE);
						break;
					default:
						R("WebGLState: Invalid blending: ", t);
						break;
				}
				else switch (t) {
					case 1:
						e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
						break;
					case 2:
						e.blendFuncSeparate(e.SRC_ALPHA, e.ONE, e.ONE, e.ONE);
						break;
					case 3:
						R("WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
						break;
					case 4:
						R("WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
						break;
					default:
						R("WebGLState: Invalid blending: ", t);
						break;
				}
				y = null, b = null, S = null, C = null, w.set(0, 0, 0), T = 0, _ = t, E = u;
			}
			return;
		}
		a ||= n, o ||= r, s ||= i, (n !== v || a !== x) && (e.blendEquationSeparate(z[n], z[a]), v = n, x = a), (r !== y || i !== b || o !== S || s !== C) && (e.blendFuncSeparate(B[r], B[i], B[o], B[s]), y = r, b = i, S = o, C = s), (c.equals(w) === !1 || l !== T) && (e.blendColor(c.r, c.g, c.b, l), w.copy(c), T = l), _ = t, E = !1;
	}
	function fe(t, n) {
		t.side === 2 ? ce(e.CULL_FACE) : oe(e.CULL_FACE);
		let r = t.side === 1;
		n && (r = !r), pe(r), t.blending === 1 && t.transparent === !1 ? V(0) : V(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.blendColor, t.blendAlpha, t.premultipliedAlpha), o.setFunc(t.depthFunc), o.setTest(t.depthTest), o.setMask(t.depthWrite), a.setMask(t.colorWrite);
		let i = t.stencilWrite;
		s.setTest(i), i && (s.setMask(t.stencilWriteMask), s.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), s.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), ge(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), t.alphaToCoverage === !0 ? oe(e.SAMPLE_ALPHA_TO_COVERAGE) : ce(e.SAMPLE_ALPHA_TO_COVERAGE);
	}
	function pe(t) {
		D !== t && (t ? e.frontFace(e.CW) : e.frontFace(e.CCW), D = t);
	}
	function me(t) {
		t === 0 ? ce(e.CULL_FACE) : (oe(e.CULL_FACE), t !== O && (t === 1 ? e.cullFace(e.BACK) : t === 2 ? e.cullFace(e.FRONT) : e.cullFace(e.FRONT_AND_BACK))), O = t;
	}
	function he(t) {
		t !== k && (N && e.lineWidth(t), k = t);
	}
	function ge(t, n, r) {
		t ? (oe(e.POLYGON_OFFSET_FILL), (A !== n || j !== r) && (A = n, j = r, o.getReversed() && (n = -n), e.polygonOffset(n, r))) : ce(e.POLYGON_OFFSET_FILL);
	}
	function _e(t) {
		t ? oe(e.SCISSOR_TEST) : ce(e.SCISSOR_TEST);
	}
	function ve(t) {
		t === void 0 && (t = e.TEXTURE0 + M - 1), F !== t && (e.activeTexture(t), F = t);
	}
	function ye(t, n, r) {
		r === void 0 && (r = F === null ? e.TEXTURE0 + M - 1 : F);
		let i = te[r];
		i === void 0 && (i = {
			type: void 0,
			texture: void 0
		}, te[r] = i), (i.type !== t || i.texture !== n) && (F !== r && (e.activeTexture(r), F = r), e.bindTexture(t, n || ae[t]), i.type = t, i.texture = n);
	}
	function be() {
		let t = te[F];
		t !== void 0 && t.type !== void 0 && (e.bindTexture(t.type, null), t.type = void 0, t.texture = void 0);
	}
	function xe() {
		try {
			e.compressedTexImage2D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function Se() {
		try {
			e.compressedTexImage3D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function Ce() {
		try {
			e.texSubImage2D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function we() {
		try {
			e.texSubImage3D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function Te() {
		try {
			e.compressedTexSubImage2D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function Ee() {
		try {
			e.compressedTexSubImage3D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function De() {
		try {
			e.texStorage2D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function Oe() {
		try {
			e.texStorage3D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function ke() {
		try {
			e.texImage2D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function Ae() {
		try {
			e.texImage3D(...arguments);
		} catch (e) {
			R("WebGLState:", e);
		}
	}
	function H(t) {
		return d[t] === void 0 ? e.getParameter(t) : d[t];
	}
	function je(t, n) {
		d[t] !== n && (e.pixelStorei(t, n), d[t] = n);
	}
	function U(t) {
		re.equals(t) === !1 && (e.scissor(t.x, t.y, t.z, t.w), re.copy(t));
	}
	function W(t) {
		ie.equals(t) === !1 && (e.viewport(t.x, t.y, t.z, t.w), ie.copy(t));
	}
	function G(t, n) {
		let r = l.get(n);
		r === void 0 && (r = /* @__PURE__ */ new WeakMap(), l.set(n, r));
		let i = r.get(t);
		i === void 0 && (i = e.getUniformBlockIndex(n, t.name), r.set(t, i));
	}
	function Me(t, n) {
		let r = l.get(n).get(t);
		c.get(n) !== r && (e.uniformBlockBinding(n, r, t.__bindingPointIndex), c.set(n, r));
	}
	function Ne() {
		e.disable(e.BLEND), e.disable(e.CULL_FACE), e.disable(e.DEPTH_TEST), e.disable(e.POLYGON_OFFSET_FILL), e.disable(e.SCISSOR_TEST), e.disable(e.STENCIL_TEST), e.disable(e.SAMPLE_ALPHA_TO_COVERAGE), e.blendEquation(e.FUNC_ADD), e.blendFunc(e.ONE, e.ZERO), e.blendFuncSeparate(e.ONE, e.ZERO, e.ONE, e.ZERO), e.blendColor(0, 0, 0, 0), e.colorMask(!0, !0, !0, !0), e.clearColor(0, 0, 0, 0), e.depthMask(!0), e.depthFunc(e.LESS), o.setReversed(!1), e.clearDepth(1), e.stencilMask(4294967295), e.stencilFunc(e.ALWAYS, 0, 4294967295), e.stencilOp(e.KEEP, e.KEEP, e.KEEP), e.clearStencil(0), e.cullFace(e.BACK), e.frontFace(e.CCW), e.polygonOffset(0, 0), e.activeTexture(e.TEXTURE0), e.bindFramebuffer(e.FRAMEBUFFER, null), e.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), e.bindFramebuffer(e.READ_FRAMEBUFFER, null), e.useProgram(null), e.lineWidth(1), e.scissor(0, 0, e.canvas.width, e.canvas.height), e.viewport(0, 0, e.canvas.width, e.canvas.height), e.pixelStorei(e.PACK_ALIGNMENT, 4), e.pixelStorei(e.UNPACK_ALIGNMENT, 4), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, !1), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, e.BROWSER_DEFAULT_WEBGL), e.pixelStorei(e.PACK_ROW_LENGTH, 0), e.pixelStorei(e.PACK_SKIP_PIXELS, 0), e.pixelStorei(e.PACK_SKIP_ROWS, 0), e.pixelStorei(e.UNPACK_ROW_LENGTH, 0), e.pixelStorei(e.UNPACK_IMAGE_HEIGHT, 0), e.pixelStorei(e.UNPACK_SKIP_PIXELS, 0), e.pixelStorei(e.UNPACK_SKIP_ROWS, 0), e.pixelStorei(e.UNPACK_SKIP_IMAGES, 0), u = {}, d = {}, F = null, te = {}, f = {}, p = /* @__PURE__ */ new WeakMap(), m = [], h = null, g = !1, _ = null, v = null, y = null, b = null, x = null, S = null, C = null, w = new Z(0, 0, 0), T = 0, E = !1, D = null, O = null, k = null, A = null, j = null, re.set(0, 0, e.canvas.width, e.canvas.height), ie.set(0, 0, e.canvas.width, e.canvas.height), a.reset(), o.reset(), s.reset();
	}
	return {
		buffers: {
			color: a,
			depth: o,
			stencil: s
		},
		enable: oe,
		disable: ce,
		bindFramebuffer: le,
		drawBuffers: ue,
		useProgram: de,
		setBlending: V,
		setMaterial: fe,
		setFlipSided: pe,
		setCullFace: me,
		setLineWidth: he,
		setPolygonOffset: ge,
		setScissorTest: _e,
		activeTexture: ve,
		bindTexture: ye,
		unbindTexture: be,
		compressedTexImage2D: xe,
		compressedTexImage3D: Se,
		texImage2D: ke,
		texImage3D: Ae,
		pixelStorei: je,
		getParameter: H,
		updateUBOMapping: G,
		uniformBlockBinding: Me,
		texStorage2D: De,
		texStorage3D: Oe,
		texSubImage2D: Ce,
		texSubImage3D: we,
		compressedTexSubImage2D: Te,
		compressedTexSubImage3D: Ee,
		scissor: U,
		viewport: W,
		reset: Ne
	};
}
function Sl(o, s, c, l, u, d, f) {
	let p = s.has("WEBGL_multisampled_render_to_texture") ? s.get("WEBGL_multisampled_render_to_texture") : null, m = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), h = new U(), _ = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new Set(), y, b = /* @__PURE__ */ new WeakMap(), x = !1;
	try {
		x = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
	} catch {}
	function S(e, t) {
		return x ? new OffscreenCanvas(e, t) : te("canvas");
	}
	function C(e, t, n) {
		let r = 1, i = Ae(e);
		if ((i.width > n || i.height > n) && (r = n / Math.max(i.width, i.height)), r < 1) if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap || typeof VideoFrame < "u" && e instanceof VideoFrame) {
			let n = Math.floor(r * i.width), a = Math.floor(r * i.height);
			y === void 0 && (y = S(n, a));
			let o = t ? S(n, a) : y;
			return o.width = n, o.height = a, o.getContext("2d").drawImage(e, 0, 0, n, a), L("WebGLRenderer: Texture has been resized from (" + i.width + "x" + i.height + ") to (" + n + "x" + a + ")."), o;
		} else return "data" in e && L("WebGLRenderer: Image in DataTexture is too big (" + i.width + "x" + i.height + ")."), e;
		return e;
	}
	function w(e) {
		return e.generateMipmaps;
	}
	function T(e) {
		o.generateMipmap(e);
	}
	function E(e) {
		return e.isWebGLCubeRenderTarget ? o.TEXTURE_CUBE_MAP : e.isWebGL3DRenderTarget ? o.TEXTURE_3D : e.isWebGLArrayRenderTarget || e.isCompressedArrayTexture ? o.TEXTURE_2D_ARRAY : o.TEXTURE_2D;
	}
	function D(e, t, n, r, i, a = !1) {
		if (e !== null) {
			if (o[e] !== void 0) return o[e];
			L("WebGLRenderer: Attempt to use non-existing WebGL internal format '" + e + "'");
		}
		let c;
		r && (c = s.get("EXT_texture_norm16"), c || L("WebGLRenderer: Unable to use normalized textures without EXT_texture_norm16 extension"));
		let l = t;
		if (t === o.RED && (n === o.FLOAT && (l = o.R32F), n === o.HALF_FLOAT && (l = o.R16F), n === o.UNSIGNED_BYTE && (l = o.R8), n === o.UNSIGNED_SHORT && c && (l = c.R16_EXT), n === o.SHORT && c && (l = c.R16_SNORM_EXT)), t === o.RED_INTEGER && (n === o.UNSIGNED_BYTE && (l = o.R8UI), n === o.UNSIGNED_SHORT && (l = o.R16UI), n === o.UNSIGNED_INT && (l = o.R32UI), n === o.BYTE && (l = o.R8I), n === o.SHORT && (l = o.R16I), n === o.INT && (l = o.R32I)), t === o.RG && (n === o.FLOAT && (l = o.RG32F), n === o.HALF_FLOAT && (l = o.RG16F), n === o.UNSIGNED_BYTE && (l = o.RG8), n === o.UNSIGNED_SHORT && c && (l = c.RG16_EXT), n === o.SHORT && c && (l = c.RG16_SNORM_EXT)), t === o.RG_INTEGER && (n === o.UNSIGNED_BYTE && (l = o.RG8UI), n === o.UNSIGNED_SHORT && (l = o.RG16UI), n === o.UNSIGNED_INT && (l = o.RG32UI), n === o.BYTE && (l = o.RG8I), n === o.SHORT && (l = o.RG16I), n === o.INT && (l = o.RG32I)), t === o.RGB_INTEGER && (n === o.UNSIGNED_BYTE && (l = o.RGB8UI), n === o.UNSIGNED_SHORT && (l = o.RGB16UI), n === o.UNSIGNED_INT && (l = o.RGB32UI), n === o.BYTE && (l = o.RGB8I), n === o.SHORT && (l = o.RGB16I), n === o.INT && (l = o.RGB32I)), t === o.RGBA_INTEGER && (n === o.UNSIGNED_BYTE && (l = o.RGBA8UI), n === o.UNSIGNED_SHORT && (l = o.RGBA16UI), n === o.UNSIGNED_INT && (l = o.RGBA32UI), n === o.BYTE && (l = o.RGBA8I), n === o.SHORT && (l = o.RGBA16I), n === o.INT && (l = o.RGBA32I)), t === o.RGB && (n === o.UNSIGNED_SHORT && c && (l = c.RGB16_EXT), n === o.SHORT && c && (l = c.RGB16_SNORM_EXT), n === o.UNSIGNED_INT_5_9_9_9_REV && (l = o.RGB9_E5), n === o.UNSIGNED_INT_10F_11F_11F_REV && (l = o.R11F_G11F_B10F)), t === o.RGBA) {
			let e = a ? A : X.getTransfer(i);
			n === o.FLOAT && (l = o.RGBA32F), n === o.HALF_FLOAT && (l = o.RGBA16F), n === o.UNSIGNED_BYTE && (l = e === "srgb" ? o.SRGB8_ALPHA8 : o.RGBA8), n === o.UNSIGNED_SHORT && c && (l = c.RGBA16_EXT), n === o.SHORT && c && (l = c.RGBA16_SNORM_EXT), n === o.UNSIGNED_SHORT_4_4_4_4 && (l = o.RGBA4), n === o.UNSIGNED_SHORT_5_5_5_1 && (l = o.RGB5_A1);
		}
		return (l === o.R16F || l === o.R32F || l === o.RG16F || l === o.RG32F || l === o.RGBA16F || l === o.RGBA32F) && s.get("EXT_color_buffer_float"), l;
	}
	function O(e, t) {
		let n;
		return e ? t === null || t === 1014 || t === 1020 ? n = o.DEPTH24_STENCIL8 : t === 1015 ? n = o.DEPTH32F_STENCIL8 : t === 1012 && (n = o.DEPTH24_STENCIL8, L("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : t === null || t === 1014 || t === 1020 ? n = o.DEPTH_COMPONENT24 : t === 1015 ? n = o.DEPTH_COMPONENT32F : t === 1012 && (n = o.DEPTH_COMPONENT16), n;
	}
	function k(e, t) {
		return w(e) === !0 || e.isFramebufferTexture && e.minFilter !== 1003 && e.minFilter !== 1006 ? Math.log2(Math.max(t.width, t.height)) + 1 : e.mipmaps !== void 0 && e.mipmaps.length > 0 ? e.mipmaps.length : e.isCompressedTexture && Array.isArray(e.image) ? t.mipmaps.length : 1;
	}
	function j(e) {
		let t = e.target;
		t.removeEventListener("dispose", j), N(t), t.isVideoTexture && _.delete(t), t.isHTMLTexture && v.delete(t);
	}
	function M(e) {
		let t = e.target;
		t.removeEventListener("dispose", M), P(t);
	}
	function N(e) {
		let t = l.get(e);
		if (t.__webglInit === void 0) return;
		let n = e.source, r = b.get(n);
		if (r) {
			let i = r[t.__cacheKey];
			i.usedTimes--, i.usedTimes === 0 && ee(e), Object.keys(r).length === 0 && b.delete(n);
		}
		l.remove(e);
	}
	function ee(e) {
		let t = l.get(e);
		o.deleteTexture(t.__webglTexture);
		let n = e.source, r = b.get(n);
		delete r[t.__cacheKey], f.memory.textures--;
	}
	function P(e) {
		let t = l.get(e);
		if (e.depthTexture && (e.depthTexture.dispose(), l.remove(e.depthTexture)), e.isWebGLCubeRenderTarget) for (let e = 0; e < 6; e++) {
			if (Array.isArray(t.__webglFramebuffer[e])) for (let n = 0; n < t.__webglFramebuffer[e].length; n++) o.deleteFramebuffer(t.__webglFramebuffer[e][n]);
			else o.deleteFramebuffer(t.__webglFramebuffer[e]);
			t.__webglDepthbuffer && o.deleteRenderbuffer(t.__webglDepthbuffer[e]);
		}
		else {
			if (Array.isArray(t.__webglFramebuffer)) for (let e = 0; e < t.__webglFramebuffer.length; e++) o.deleteFramebuffer(t.__webglFramebuffer[e]);
			else o.deleteFramebuffer(t.__webglFramebuffer);
			if (t.__webglDepthbuffer && o.deleteRenderbuffer(t.__webglDepthbuffer), t.__webglMultisampledFramebuffer && o.deleteFramebuffer(t.__webglMultisampledFramebuffer), t.__webglColorRenderbuffer) for (let e = 0; e < t.__webglColorRenderbuffer.length; e++) t.__webglColorRenderbuffer[e] && o.deleteRenderbuffer(t.__webglColorRenderbuffer[e]);
			t.__webglDepthRenderbuffer && o.deleteRenderbuffer(t.__webglDepthRenderbuffer);
		}
		let n = e.textures;
		for (let e = 0, t = n.length; e < t; e++) {
			let t = l.get(n[e]);
			t.__webglTexture && (o.deleteTexture(t.__webglTexture), f.memory.textures--), l.remove(n[e]);
		}
		l.remove(e);
	}
	let F = 0;
	function ne() {
		F = 0;
	}
	function I() {
		return F;
	}
	function re(e) {
		F = e;
	}
	function ie() {
		let e = F;
		return e >= u.maxTextures && L("WebGLTextures: Trying to use " + e + " texture units while this GPU supports only " + u.maxTextures), F += 1, e;
	}
	function ae(e) {
		let t = [];
		return t.push(e.wrapS), t.push(e.wrapT), t.push(e.wrapR || 0), t.push(e.magFilter), t.push(e.minFilter), t.push(e.anisotropy), t.push(e.internalFormat), t.push(e.format), t.push(e.type), t.push(e.generateMipmaps), t.push(e.premultiplyAlpha), t.push(e.flipY), t.push(e.unpackAlignment), t.push(e.colorSpace), t.join();
	}
	function oe(e, t) {
		let n = l.get(e);
		if (e.isVideoTexture && Oe(e), e.isRenderTargetTexture === !1 && e.isExternalTexture !== !0 && e.version > 0 && n.__version !== e.version) {
			let r = e.image;
			if (r === null) L("WebGLRenderer: Texture marked for update but no image data found.");
			else if (r.complete === !1) L("WebGLRenderer: Texture marked for update but image is incomplete");
			else {
				me(n, e, t);
				return;
			}
		} else e.isExternalTexture && (n.__webglTexture = e.sourceTexture ? e.sourceTexture : null);
		c.bindTexture(o.TEXTURE_2D, n.__webglTexture, o.TEXTURE0 + t);
	}
	function se(e, t) {
		let n = l.get(e);
		if (e.isRenderTargetTexture === !1 && e.version > 0 && n.__version !== e.version) {
			me(n, e, t);
			return;
		} else e.isExternalTexture && (n.__webglTexture = e.sourceTexture ? e.sourceTexture : null);
		c.bindTexture(o.TEXTURE_2D_ARRAY, n.__webglTexture, o.TEXTURE0 + t);
	}
	function ce(e, t) {
		let n = l.get(e);
		if (e.isRenderTargetTexture === !1 && e.version > 0 && n.__version !== e.version) {
			me(n, e, t);
			return;
		}
		c.bindTexture(o.TEXTURE_3D, n.__webglTexture, o.TEXTURE0 + t);
	}
	function le(e, t) {
		let n = l.get(e);
		if (e.isCubeDepthTexture !== !0 && e.version > 0 && n.__version !== e.version) {
			he(n, e, t);
			return;
		}
		c.bindTexture(o.TEXTURE_CUBE_MAP, n.__webglTexture, o.TEXTURE0 + t);
	}
	let ue = {
		[e]: o.REPEAT,
		[t]: o.CLAMP_TO_EDGE,
		[n]: o.MIRRORED_REPEAT
	}, de = {
		[r]: o.NEAREST,
		1004: o.NEAREST_MIPMAP_NEAREST,
		1005: o.NEAREST_MIPMAP_LINEAR,
		[i]: o.LINEAR,
		1007: o.LINEAR_MIPMAP_NEAREST,
		[a]: o.LINEAR_MIPMAP_LINEAR
	}, z = {
		512: o.NEVER,
		519: o.ALWAYS,
		513: o.LESS,
		515: o.LEQUAL,
		514: o.EQUAL,
		518: o.GEQUAL,
		516: o.GREATER,
		517: o.NOTEQUAL
	};
	function B(e, t) {
		if (t.type === 1015 && s.has("OES_texture_float_linear") === !1 && (t.magFilter === 1006 || t.magFilter === 1007 || t.magFilter === 1005 || t.magFilter === 1008 || t.minFilter === 1006 || t.minFilter === 1007 || t.minFilter === 1005 || t.minFilter === 1008) && L("WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), o.texParameteri(e, o.TEXTURE_WRAP_S, ue[t.wrapS]), o.texParameteri(e, o.TEXTURE_WRAP_T, ue[t.wrapT]), (e === o.TEXTURE_3D || e === o.TEXTURE_2D_ARRAY) && o.texParameteri(e, o.TEXTURE_WRAP_R, ue[t.wrapR]), o.texParameteri(e, o.TEXTURE_MAG_FILTER, de[t.magFilter]), o.texParameteri(e, o.TEXTURE_MIN_FILTER, de[t.minFilter]), t.compareFunction && (o.texParameteri(e, o.TEXTURE_COMPARE_MODE, o.COMPARE_REF_TO_TEXTURE), o.texParameteri(e, o.TEXTURE_COMPARE_FUNC, z[t.compareFunction])), s.has("EXT_texture_filter_anisotropic") === !0) {
			if (t.magFilter === 1003 || t.minFilter !== 1005 && t.minFilter !== 1008 || t.type === 1015 && s.has("OES_texture_float_linear") === !1) return;
			if (t.anisotropy > 1 || l.get(t).__currentAnisotropy) {
				let n = s.get("EXT_texture_filter_anisotropic");
				o.texParameterf(e, n.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(t.anisotropy, u.getMaxAnisotropy())), l.get(t).__currentAnisotropy = t.anisotropy;
			}
		}
	}
	function V(e, t) {
		let n = !1;
		e.__webglInit === void 0 && (e.__webglInit = !0, t.addEventListener("dispose", j));
		let r = t.source, i = b.get(r);
		i === void 0 && (i = {}, b.set(r, i));
		let a = ae(t);
		if (a !== e.__cacheKey) {
			i[a] === void 0 && (i[a] = {
				texture: o.createTexture(),
				usedTimes: 0
			}, f.memory.textures++, n = !0), i[a].usedTimes++;
			let r = i[e.__cacheKey];
			r !== void 0 && (i[e.__cacheKey].usedTimes--, r.usedTimes === 0 && ee(t)), e.__cacheKey = a, e.__webglTexture = i[a].texture;
		}
		return n;
	}
	function fe(e, t, n) {
		return Math.floor(Math.floor(e / n) / t);
	}
	function pe(e, t, n, r) {
		let i = e.updateRanges;
		if (i.length === 0) c.texSubImage2D(o.TEXTURE_2D, 0, 0, 0, t.width, t.height, n, r, t.data);
		else {
			i.sort((e, t) => e.start - t.start);
			let a = 0;
			for (let e = 1; e < i.length; e++) {
				let n = i[a], r = i[e], o = n.start + n.count, s = fe(r.start, t.width, 4), c = fe(n.start, t.width, 4);
				r.start <= o + 1 && s === c && fe(r.start + r.count - 1, t.width, 4) === s ? n.count = Math.max(n.count, r.start + r.count - n.start) : (++a, i[a] = r);
			}
			i.length = a + 1;
			let s = c.getParameter(o.UNPACK_ROW_LENGTH), l = c.getParameter(o.UNPACK_SKIP_PIXELS), u = c.getParameter(o.UNPACK_SKIP_ROWS);
			c.pixelStorei(o.UNPACK_ROW_LENGTH, t.width);
			for (let e = 0, a = i.length; e < a; e++) {
				let a = i[e], s = Math.floor(a.start / 4), l = Math.ceil(a.count / 4), u = s % t.width, d = Math.floor(s / t.width), f = l;
				c.pixelStorei(o.UNPACK_SKIP_PIXELS, u), c.pixelStorei(o.UNPACK_SKIP_ROWS, d), c.texSubImage2D(o.TEXTURE_2D, 0, u, d, f, 1, n, r, t.data);
			}
			e.clearUpdateRanges(), c.pixelStorei(o.UNPACK_ROW_LENGTH, s), c.pixelStorei(o.UNPACK_SKIP_PIXELS, l), c.pixelStorei(o.UNPACK_SKIP_ROWS, u);
		}
	}
	function me(e, t, n) {
		let r = o.TEXTURE_2D;
		(t.isDataArrayTexture || t.isCompressedArrayTexture) && (r = o.TEXTURE_2D_ARRAY), t.isData3DTexture && (r = o.TEXTURE_3D);
		let i = V(e, t), a = t.source;
		c.bindTexture(r, e.__webglTexture, o.TEXTURE0 + n);
		let s = l.get(a);
		if (a.version !== s.__version || i === !0) {
			if (c.activeTexture(o.TEXTURE0 + n), !(typeof ImageBitmap < "u" && t.image instanceof ImageBitmap)) {
				let e = X.getPrimaries(X.workingColorSpace), n = t.colorSpace === "" ? null : X.getPrimaries(t.colorSpace), r = t.colorSpace === "" || e === n ? o.NONE : o.BROWSER_DEFAULT_WEBGL;
				c.pixelStorei(o.UNPACK_FLIP_Y_WEBGL, t.flipY), c.pixelStorei(o.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), c.pixelStorei(o.UNPACK_COLORSPACE_CONVERSION_WEBGL, r);
			}
			c.pixelStorei(o.UNPACK_ALIGNMENT, t.unpackAlignment);
			let e = C(t.image, !1, u.maxTextureSize);
			e = ke(t, e);
			let l = d.convert(t.format, t.colorSpace), f = d.convert(t.type), p = D(t.internalFormat, l, f, t.normalized, t.colorSpace, t.isVideoTexture);
			B(r, t);
			let m, h = t.mipmaps, _ = t.isVideoTexture !== !0, y = s.__version === void 0 || i === !0, b = a.dataReady, x = k(t, e);
			if (t.isDepthTexture) p = O(t.format === g, t.type), y && (_ ? c.texStorage2D(o.TEXTURE_2D, 1, p, e.width, e.height) : c.texImage2D(o.TEXTURE_2D, 0, p, e.width, e.height, 0, l, f, null));
			else if (t.isDataTexture) if (h.length > 0) {
				_ && y && c.texStorage2D(o.TEXTURE_2D, x, p, h[0].width, h[0].height);
				for (let e = 0, t = h.length; e < t; e++) m = h[e], _ ? b && c.texSubImage2D(o.TEXTURE_2D, e, 0, 0, m.width, m.height, l, f, m.data) : c.texImage2D(o.TEXTURE_2D, e, p, m.width, m.height, 0, l, f, m.data);
				t.generateMipmaps = !1;
			} else _ ? (y && c.texStorage2D(o.TEXTURE_2D, x, p, e.width, e.height), b && pe(t, e, l, f)) : c.texImage2D(o.TEXTURE_2D, 0, p, e.width, e.height, 0, l, f, e.data);
			else if (t.isCompressedTexture) if (t.isCompressedArrayTexture) {
				_ && y && c.texStorage3D(o.TEXTURE_2D_ARRAY, x, p, h[0].width, h[0].height, e.depth);
				for (let n = 0, r = h.length; n < r; n++) if (m = h[n], t.format !== 1023) if (l !== null) if (_) {
					if (b) if (t.layerUpdates.size > 0) {
						let e = vo(m.width, m.height, t.format, t.type);
						for (let r of t.layerUpdates) {
							let t = m.data.subarray(r * e / m.data.BYTES_PER_ELEMENT, (r + 1) * e / m.data.BYTES_PER_ELEMENT);
							c.compressedTexSubImage3D(o.TEXTURE_2D_ARRAY, n, 0, 0, r, m.width, m.height, 1, l, t);
						}
						t.clearLayerUpdates();
					} else c.compressedTexSubImage3D(o.TEXTURE_2D_ARRAY, n, 0, 0, 0, m.width, m.height, e.depth, l, m.data);
				} else c.compressedTexImage3D(o.TEXTURE_2D_ARRAY, n, p, m.width, m.height, e.depth, 0, m.data, 0, 0);
				else L("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
				else _ ? b && c.texSubImage3D(o.TEXTURE_2D_ARRAY, n, 0, 0, 0, m.width, m.height, e.depth, l, f, m.data) : c.texImage3D(o.TEXTURE_2D_ARRAY, n, p, m.width, m.height, e.depth, 0, l, f, m.data);
			} else {
				_ && y && c.texStorage2D(o.TEXTURE_2D, x, p, h[0].width, h[0].height);
				for (let e = 0, n = h.length; e < n; e++) m = h[e], t.format === 1023 ? _ ? b && c.texSubImage2D(o.TEXTURE_2D, e, 0, 0, m.width, m.height, l, f, m.data) : c.texImage2D(o.TEXTURE_2D, e, p, m.width, m.height, 0, l, f, m.data) : l === null ? L("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : _ ? b && c.compressedTexSubImage2D(o.TEXTURE_2D, e, 0, 0, m.width, m.height, l, m.data) : c.compressedTexImage2D(o.TEXTURE_2D, e, p, m.width, m.height, 0, m.data);
			}
			else if (t.isDataArrayTexture) if (_) {
				if (y && c.texStorage3D(o.TEXTURE_2D_ARRAY, x, p, e.width, e.height, e.depth), b) if (t.layerUpdates.size > 0) {
					let n = vo(e.width, e.height, t.format, t.type);
					for (let r of t.layerUpdates) {
						let t = e.data.subarray(r * n / e.data.BYTES_PER_ELEMENT, (r + 1) * n / e.data.BYTES_PER_ELEMENT);
						c.texSubImage3D(o.TEXTURE_2D_ARRAY, 0, 0, 0, r, e.width, e.height, 1, l, f, t);
					}
					t.clearLayerUpdates();
				} else c.texSubImage3D(o.TEXTURE_2D_ARRAY, 0, 0, 0, 0, e.width, e.height, e.depth, l, f, e.data);
			} else c.texImage3D(o.TEXTURE_2D_ARRAY, 0, p, e.width, e.height, e.depth, 0, l, f, e.data);
			else if (t.isData3DTexture) _ ? (y && c.texStorage3D(o.TEXTURE_3D, x, p, e.width, e.height, e.depth), b && c.texSubImage3D(o.TEXTURE_3D, 0, 0, 0, 0, e.width, e.height, e.depth, l, f, e.data)) : c.texImage3D(o.TEXTURE_3D, 0, p, e.width, e.height, e.depth, 0, l, f, e.data);
			else if (t.isFramebufferTexture) {
				if (y) if (_) c.texStorage2D(o.TEXTURE_2D, x, p, e.width, e.height);
				else {
					let t = e.width, n = e.height;
					for (let e = 0; e < x; e++) c.texImage2D(o.TEXTURE_2D, e, p, t, n, 0, l, f, null), t >>= 1, n >>= 1;
				}
			} else if (t.isHTMLTexture) {
				if ("texElementImage2D" in o) {
					let n = o.canvas;
					if (n.hasAttribute("layoutsubtree") || n.setAttribute("layoutsubtree", "true"), e.parentNode !== n) {
						n.appendChild(e), v.add(t), n.onpaint = (e) => {
							let t = e.changedElements;
							for (let e of v) t.includes(e.image) && (e.needsUpdate = !0);
						}, n.requestPaint();
						return;
					}
					if (o.texElementImage2D.length === 3) o.texElementImage2D(o.TEXTURE_2D, o.RGBA8, e);
					else {
						let t = o.RGBA, n = o.RGBA, r = o.UNSIGNED_BYTE;
						o.texElementImage2D(o.TEXTURE_2D, 0, t, n, r, e);
					}
					o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE);
				}
			} else if (h.length > 0) {
				if (_ && y) {
					let e = Ae(h[0]);
					c.texStorage2D(o.TEXTURE_2D, x, p, e.width, e.height);
				}
				for (let e = 0, t = h.length; e < t; e++) m = h[e], _ ? b && c.texSubImage2D(o.TEXTURE_2D, e, 0, 0, l, f, m) : c.texImage2D(o.TEXTURE_2D, e, p, l, f, m);
				t.generateMipmaps = !1;
			} else if (_) {
				if (y) {
					let t = Ae(e);
					c.texStorage2D(o.TEXTURE_2D, x, p, t.width, t.height);
				}
				b && c.texSubImage2D(o.TEXTURE_2D, 0, 0, 0, l, f, e);
			} else c.texImage2D(o.TEXTURE_2D, 0, p, l, f, e);
			w(t) && T(r), s.__version = a.version, t.onUpdate && t.onUpdate(t);
		}
		e.__version = t.version;
	}
	function he(e, t, n) {
		if (t.image.length !== 6) return;
		let r = V(e, t), i = t.source;
		c.bindTexture(o.TEXTURE_CUBE_MAP, e.__webglTexture, o.TEXTURE0 + n);
		let a = l.get(i);
		if (i.version !== a.__version || r === !0) {
			c.activeTexture(o.TEXTURE0 + n);
			let e = X.getPrimaries(X.workingColorSpace), s = t.colorSpace === "" ? null : X.getPrimaries(t.colorSpace), l = t.colorSpace === "" || e === s ? o.NONE : o.BROWSER_DEFAULT_WEBGL;
			c.pixelStorei(o.UNPACK_FLIP_Y_WEBGL, t.flipY), c.pixelStorei(o.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), c.pixelStorei(o.UNPACK_ALIGNMENT, t.unpackAlignment), c.pixelStorei(o.UNPACK_COLORSPACE_CONVERSION_WEBGL, l);
			let f = t.isCompressedTexture || t.image[0].isCompressedTexture, p = t.image[0] && t.image[0].isDataTexture, m = [];
			for (let e = 0; e < 6; e++) !f && !p ? m[e] = C(t.image[e], !0, u.maxCubemapSize) : m[e] = p ? t.image[e].image : t.image[e], m[e] = ke(t, m[e]);
			let h = m[0], g = d.convert(t.format, t.colorSpace), _ = d.convert(t.type), v = D(t.internalFormat, g, _, t.normalized, t.colorSpace), y = t.isVideoTexture !== !0, b = a.__version === void 0 || r === !0, x = i.dataReady, S = k(t, h);
			B(o.TEXTURE_CUBE_MAP, t);
			let E;
			if (f) {
				y && b && c.texStorage2D(o.TEXTURE_CUBE_MAP, S, v, h.width, h.height);
				for (let e = 0; e < 6; e++) {
					E = m[e].mipmaps;
					for (let n = 0; n < E.length; n++) {
						let r = E[n];
						t.format === 1023 ? y ? x && c.texSubImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, 0, 0, r.width, r.height, g, _, r.data) : c.texImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, v, r.width, r.height, 0, g, _, r.data) : g === null ? L("WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : y ? x && c.compressedTexSubImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, 0, 0, r.width, r.height, g, r.data) : c.compressedTexImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, v, r.width, r.height, 0, r.data);
					}
				}
			} else {
				if (E = t.mipmaps, y && b) {
					E.length > 0 && S++;
					let e = Ae(m[0]);
					c.texStorage2D(o.TEXTURE_CUBE_MAP, S, v, e.width, e.height);
				}
				for (let e = 0; e < 6; e++) if (p) {
					y ? x && c.texSubImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, m[e].width, m[e].height, g, _, m[e].data) : c.texImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, v, m[e].width, m[e].height, 0, g, _, m[e].data);
					for (let t = 0; t < E.length; t++) {
						let n = E[t].image[e].image;
						y ? x && c.texSubImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, t + 1, 0, 0, n.width, n.height, g, _, n.data) : c.texImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, t + 1, v, n.width, n.height, 0, g, _, n.data);
					}
				} else {
					y ? x && c.texSubImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, g, _, m[e]) : c.texImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, v, g, _, m[e]);
					for (let t = 0; t < E.length; t++) {
						let n = E[t];
						y ? x && c.texSubImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, t + 1, 0, 0, g, _, n.image[e]) : c.texImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e, t + 1, v, g, _, n.image[e]);
					}
				}
			}
			w(t) && T(o.TEXTURE_CUBE_MAP), a.__version = i.version, t.onUpdate && t.onUpdate(t);
		}
		e.__version = t.version;
	}
	function ge(e, t, n, r, i, a) {
		let s = d.convert(n.format, n.colorSpace), u = d.convert(n.type), f = D(n.internalFormat, s, u, n.normalized, n.colorSpace), m = l.get(t), h = l.get(n);
		if (h.__renderTarget = t, !m.__hasExternalTextures) {
			let e = Math.max(1, t.width >> a), n = Math.max(1, t.height >> a);
			i === o.TEXTURE_3D || i === o.TEXTURE_2D_ARRAY ? c.texImage3D(i, a, f, e, n, t.depth, 0, s, u, null) : c.texImage2D(i, a, f, e, n, 0, s, u, null);
		}
		c.bindFramebuffer(o.FRAMEBUFFER, e), De(t) ? p.framebufferTexture2DMultisampleEXT(o.FRAMEBUFFER, r, i, h.__webglTexture, 0, Ee(t)) : (i === o.TEXTURE_2D || i >= o.TEXTURE_CUBE_MAP_POSITIVE_X && i <= o.TEXTURE_CUBE_MAP_NEGATIVE_Z) && o.framebufferTexture2D(o.FRAMEBUFFER, r, i, h.__webglTexture, a), c.bindFramebuffer(o.FRAMEBUFFER, null);
	}
	function _e(e, t, n) {
		if (o.bindRenderbuffer(o.RENDERBUFFER, e), t.depthBuffer) {
			let r = t.depthTexture, i = r && r.isDepthTexture ? r.type : null, a = O(t.stencilBuffer, i), s = t.stencilBuffer ? o.DEPTH_STENCIL_ATTACHMENT : o.DEPTH_ATTACHMENT;
			De(t) ? p.renderbufferStorageMultisampleEXT(o.RENDERBUFFER, Ee(t), a, t.width, t.height) : n ? o.renderbufferStorageMultisample(o.RENDERBUFFER, Ee(t), a, t.width, t.height) : o.renderbufferStorage(o.RENDERBUFFER, a, t.width, t.height), o.framebufferRenderbuffer(o.FRAMEBUFFER, s, o.RENDERBUFFER, e);
		} else {
			let e = t.textures;
			for (let r = 0; r < e.length; r++) {
				let i = e[r], a = d.convert(i.format, i.colorSpace), s = d.convert(i.type), c = D(i.internalFormat, a, s, i.normalized, i.colorSpace);
				De(t) ? p.renderbufferStorageMultisampleEXT(o.RENDERBUFFER, Ee(t), c, t.width, t.height) : n ? o.renderbufferStorageMultisample(o.RENDERBUFFER, Ee(t), c, t.width, t.height) : o.renderbufferStorage(o.RENDERBUFFER, c, t.width, t.height);
			}
		}
		o.bindRenderbuffer(o.RENDERBUFFER, null);
	}
	function ve(e, t, n) {
		let r = t.isWebGLCubeRenderTarget === !0;
		if (c.bindFramebuffer(o.FRAMEBUFFER, e), !(t.depthTexture && t.depthTexture.isDepthTexture)) throw Error("THREE.WebGLTextures: renderTarget.depthTexture must be an instance of THREE.DepthTexture.");
		let i = l.get(t.depthTexture);
		if (i.__renderTarget = t, (!i.__webglTexture || t.depthTexture.image.width !== t.width || t.depthTexture.image.height !== t.height) && (t.depthTexture.image.width = t.width, t.depthTexture.image.height = t.height, t.depthTexture.needsUpdate = !0), r) {
			if (i.__webglInit === void 0 && (i.__webglInit = !0, t.depthTexture.addEventListener("dispose", j)), i.__webglTexture === void 0) {
				i.__webglTexture = o.createTexture(), c.bindTexture(o.TEXTURE_CUBE_MAP, i.__webglTexture), B(o.TEXTURE_CUBE_MAP, t.depthTexture);
				let e = d.convert(t.depthTexture.format), n = d.convert(t.depthTexture.type), r;
				t.depthTexture.format === 1026 ? r = o.DEPTH_COMPONENT24 : t.depthTexture.format === 1027 && (r = o.DEPTH24_STENCIL8);
				for (let i = 0; i < 6; i++) o.texImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, r, t.width, t.height, 0, e, n, null);
			}
		} else oe(t.depthTexture, 0);
		let a = i.__webglTexture, s = Ee(t), u = r ? o.TEXTURE_CUBE_MAP_POSITIVE_X + n : o.TEXTURE_2D, f = t.depthTexture.format === 1027 ? o.DEPTH_STENCIL_ATTACHMENT : o.DEPTH_ATTACHMENT;
		if (t.depthTexture.format === 1026) De(t) ? p.framebufferTexture2DMultisampleEXT(o.FRAMEBUFFER, f, u, a, 0, s) : o.framebufferTexture2D(o.FRAMEBUFFER, f, u, a, 0);
		else if (t.depthTexture.format === 1027) De(t) ? p.framebufferTexture2DMultisampleEXT(o.FRAMEBUFFER, f, u, a, 0, s) : o.framebufferTexture2D(o.FRAMEBUFFER, f, u, a, 0);
		else throw Error("THREE.WebGLTextures: Unknown depthTexture format.");
	}
	function ye(e) {
		let t = l.get(e), n = e.isWebGLCubeRenderTarget === !0;
		if (t.__boundDepthTexture !== e.depthTexture) {
			let n = e.depthTexture;
			if (t.__depthDisposeCallback && t.__depthDisposeCallback(), n) {
				let e = () => {
					delete t.__boundDepthTexture, delete t.__depthDisposeCallback, n.removeEventListener("dispose", e);
				};
				n.addEventListener("dispose", e), t.__depthDisposeCallback = e;
			}
			t.__boundDepthTexture = n;
		}
		if (e.depthTexture && !t.__autoAllocateDepthBuffer) if (n) for (let n = 0; n < 6; n++) ve(t.__webglFramebuffer[n], e, n);
		else {
			let n = e.texture.mipmaps;
			n && n.length > 0 ? ve(t.__webglFramebuffer[0], e, 0) : ve(t.__webglFramebuffer, e, 0);
		}
		else if (n) {
			t.__webglDepthbuffer = [];
			for (let n = 0; n < 6; n++) if (c.bindFramebuffer(o.FRAMEBUFFER, t.__webglFramebuffer[n]), t.__webglDepthbuffer[n] === void 0) t.__webglDepthbuffer[n] = o.createRenderbuffer(), _e(t.__webglDepthbuffer[n], e, !1);
			else {
				let r = e.stencilBuffer ? o.DEPTH_STENCIL_ATTACHMENT : o.DEPTH_ATTACHMENT, i = t.__webglDepthbuffer[n];
				o.bindRenderbuffer(o.RENDERBUFFER, i), o.framebufferRenderbuffer(o.FRAMEBUFFER, r, o.RENDERBUFFER, i);
			}
		} else {
			let n = e.texture.mipmaps;
			if (n && n.length > 0 ? c.bindFramebuffer(o.FRAMEBUFFER, t.__webglFramebuffer[0]) : c.bindFramebuffer(o.FRAMEBUFFER, t.__webglFramebuffer), t.__webglDepthbuffer === void 0) t.__webglDepthbuffer = o.createRenderbuffer(), _e(t.__webglDepthbuffer, e, !1);
			else {
				let n = e.stencilBuffer ? o.DEPTH_STENCIL_ATTACHMENT : o.DEPTH_ATTACHMENT, r = t.__webglDepthbuffer;
				o.bindRenderbuffer(o.RENDERBUFFER, r), o.framebufferRenderbuffer(o.FRAMEBUFFER, n, o.RENDERBUFFER, r);
			}
		}
		c.bindFramebuffer(o.FRAMEBUFFER, null);
	}
	function be(e, t, n) {
		let r = l.get(e);
		t !== void 0 && ge(r.__webglFramebuffer, e, e.texture, o.COLOR_ATTACHMENT0, o.TEXTURE_2D, 0), n !== void 0 && ye(e);
	}
	function xe(e) {
		let t = e.texture, n = l.get(e), r = l.get(t);
		e.addEventListener("dispose", M);
		let i = e.textures, a = e.isWebGLCubeRenderTarget === !0, s = i.length > 1;
		if (s || (r.__webglTexture === void 0 && (r.__webglTexture = o.createTexture()), r.__version = t.version, f.memory.textures++), a) {
			n.__webglFramebuffer = [];
			for (let e = 0; e < 6; e++) if (t.mipmaps && t.mipmaps.length > 0) {
				n.__webglFramebuffer[e] = [];
				for (let r = 0; r < t.mipmaps.length; r++) n.__webglFramebuffer[e][r] = o.createFramebuffer();
			} else n.__webglFramebuffer[e] = o.createFramebuffer();
		} else {
			if (t.mipmaps && t.mipmaps.length > 0) {
				n.__webglFramebuffer = [];
				for (let e = 0; e < t.mipmaps.length; e++) n.__webglFramebuffer[e] = o.createFramebuffer();
			} else n.__webglFramebuffer = o.createFramebuffer();
			if (s) for (let e = 0, t = i.length; e < t; e++) {
				let t = l.get(i[e]);
				t.__webglTexture === void 0 && (t.__webglTexture = o.createTexture(), f.memory.textures++);
			}
			if (e.samples > 0 && De(e) === !1) {
				n.__webglMultisampledFramebuffer = o.createFramebuffer(), n.__webglColorRenderbuffer = [], c.bindFramebuffer(o.FRAMEBUFFER, n.__webglMultisampledFramebuffer);
				for (let t = 0; t < i.length; t++) {
					let r = i[t];
					n.__webglColorRenderbuffer[t] = o.createRenderbuffer(), o.bindRenderbuffer(o.RENDERBUFFER, n.__webglColorRenderbuffer[t]);
					let a = d.convert(r.format, r.colorSpace), s = d.convert(r.type), c = D(r.internalFormat, a, s, r.normalized, r.colorSpace, e.isXRRenderTarget === !0), l = Ee(e);
					o.renderbufferStorageMultisample(o.RENDERBUFFER, l, c, e.width, e.height), o.framebufferRenderbuffer(o.FRAMEBUFFER, o.COLOR_ATTACHMENT0 + t, o.RENDERBUFFER, n.__webglColorRenderbuffer[t]);
				}
				o.bindRenderbuffer(o.RENDERBUFFER, null), e.depthBuffer && (n.__webglDepthRenderbuffer = o.createRenderbuffer(), _e(n.__webglDepthRenderbuffer, e, !0)), c.bindFramebuffer(o.FRAMEBUFFER, null);
			}
		}
		if (a) {
			c.bindTexture(o.TEXTURE_CUBE_MAP, r.__webglTexture), B(o.TEXTURE_CUBE_MAP, t);
			for (let r = 0; r < 6; r++) if (t.mipmaps && t.mipmaps.length > 0) for (let i = 0; i < t.mipmaps.length; i++) ge(n.__webglFramebuffer[r][i], e, t, o.COLOR_ATTACHMENT0, o.TEXTURE_CUBE_MAP_POSITIVE_X + r, i);
			else ge(n.__webglFramebuffer[r], e, t, o.COLOR_ATTACHMENT0, o.TEXTURE_CUBE_MAP_POSITIVE_X + r, 0);
			w(t) && T(o.TEXTURE_CUBE_MAP), c.unbindTexture();
		} else if (s) {
			for (let t = 0, r = i.length; t < r; t++) {
				let r = i[t], a = l.get(r), s = o.TEXTURE_2D;
				(e.isWebGL3DRenderTarget || e.isWebGLArrayRenderTarget) && (s = e.isWebGL3DRenderTarget ? o.TEXTURE_3D : o.TEXTURE_2D_ARRAY), c.bindTexture(s, a.__webglTexture), B(s, r), ge(n.__webglFramebuffer, e, r, o.COLOR_ATTACHMENT0 + t, s, 0), w(r) && T(s);
			}
			c.unbindTexture();
		} else {
			let i = o.TEXTURE_2D;
			if ((e.isWebGL3DRenderTarget || e.isWebGLArrayRenderTarget) && (i = e.isWebGL3DRenderTarget ? o.TEXTURE_3D : o.TEXTURE_2D_ARRAY), c.bindTexture(i, r.__webglTexture), B(i, t), t.mipmaps && t.mipmaps.length > 0) for (let r = 0; r < t.mipmaps.length; r++) ge(n.__webglFramebuffer[r], e, t, o.COLOR_ATTACHMENT0, i, r);
			else ge(n.__webglFramebuffer, e, t, o.COLOR_ATTACHMENT0, i, 0);
			w(t) && T(i), c.unbindTexture();
		}
		e.depthBuffer && ye(e);
	}
	function Se(e) {
		let t = e.textures;
		for (let n = 0, r = t.length; n < r; n++) {
			let r = t[n];
			if (w(r)) {
				let t = E(e), n = l.get(r).__webglTexture;
				c.bindTexture(t, n), T(t), c.unbindTexture();
			}
		}
	}
	let Ce = [], we = [];
	function Te(e) {
		if (e.samples > 0) {
			if (De(e) === !1) {
				let t = e.textures, n = e.width, r = e.height, i = o.COLOR_BUFFER_BIT, a = e.stencilBuffer ? o.DEPTH_STENCIL_ATTACHMENT : o.DEPTH_ATTACHMENT, s = l.get(e), u = t.length > 1;
				if (u) for (let e = 0; e < t.length; e++) c.bindFramebuffer(o.FRAMEBUFFER, s.__webglMultisampledFramebuffer), o.framebufferRenderbuffer(o.FRAMEBUFFER, o.COLOR_ATTACHMENT0 + e, o.RENDERBUFFER, null), c.bindFramebuffer(o.FRAMEBUFFER, s.__webglFramebuffer), o.framebufferTexture2D(o.DRAW_FRAMEBUFFER, o.COLOR_ATTACHMENT0 + e, o.TEXTURE_2D, null, 0);
				c.bindFramebuffer(o.READ_FRAMEBUFFER, s.__webglMultisampledFramebuffer);
				let d = e.texture.mipmaps;
				d && d.length > 0 ? c.bindFramebuffer(o.DRAW_FRAMEBUFFER, s.__webglFramebuffer[0]) : c.bindFramebuffer(o.DRAW_FRAMEBUFFER, s.__webglFramebuffer);
				for (let c = 0; c < t.length; c++) {
					if (e.resolveDepthBuffer && (e.depthBuffer && (i |= o.DEPTH_BUFFER_BIT), e.stencilBuffer && e.resolveStencilBuffer && (i |= o.STENCIL_BUFFER_BIT)), u) {
						o.framebufferRenderbuffer(o.READ_FRAMEBUFFER, o.COLOR_ATTACHMENT0, o.RENDERBUFFER, s.__webglColorRenderbuffer[c]);
						let e = l.get(t[c]).__webglTexture;
						o.framebufferTexture2D(o.DRAW_FRAMEBUFFER, o.COLOR_ATTACHMENT0, o.TEXTURE_2D, e, 0);
					}
					o.blitFramebuffer(0, 0, n, r, 0, 0, n, r, i, o.NEAREST), m === !0 && (Ce.length = 0, we.length = 0, Ce.push(o.COLOR_ATTACHMENT0 + c), e.depthBuffer && e.resolveDepthBuffer === !1 && (Ce.push(a), we.push(a), o.invalidateFramebuffer(o.DRAW_FRAMEBUFFER, we)), o.invalidateFramebuffer(o.READ_FRAMEBUFFER, Ce));
				}
				if (c.bindFramebuffer(o.READ_FRAMEBUFFER, null), c.bindFramebuffer(o.DRAW_FRAMEBUFFER, null), u) for (let e = 0; e < t.length; e++) {
					c.bindFramebuffer(o.FRAMEBUFFER, s.__webglMultisampledFramebuffer), o.framebufferRenderbuffer(o.FRAMEBUFFER, o.COLOR_ATTACHMENT0 + e, o.RENDERBUFFER, s.__webglColorRenderbuffer[e]);
					let n = l.get(t[e]).__webglTexture;
					c.bindFramebuffer(o.FRAMEBUFFER, s.__webglFramebuffer), o.framebufferTexture2D(o.DRAW_FRAMEBUFFER, o.COLOR_ATTACHMENT0 + e, o.TEXTURE_2D, n, 0);
				}
				c.bindFramebuffer(o.DRAW_FRAMEBUFFER, s.__webglMultisampledFramebuffer);
			} else if (e.depthBuffer && e.resolveDepthBuffer === !1 && m) {
				let t = e.stencilBuffer ? o.DEPTH_STENCIL_ATTACHMENT : o.DEPTH_ATTACHMENT;
				o.invalidateFramebuffer(o.DRAW_FRAMEBUFFER, [t]);
			}
		}
	}
	function Ee(e) {
		return Math.min(u.maxSamples, e.samples);
	}
	function De(e) {
		let t = l.get(e);
		return e.samples > 0 && s.has("WEBGL_multisampled_render_to_texture") === !0 && t.__useRenderToTexture !== !1;
	}
	function Oe(e) {
		let t = f.render.frame;
		_.get(e) !== t && (_.set(e, t), e.update());
	}
	function ke(e, t) {
		let n = e.colorSpace, r = e.format, i = e.type;
		return e.isCompressedTexture === !0 || e.isVideoTexture === !0 || n !== "srgb-linear" && n !== "" && (X.getTransfer(n) === "srgb" ? (r !== 1023 || i !== 1009) && L("WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : R("WebGLTextures: Unsupported texture color space:", n)), t;
	}
	function Ae(e) {
		return typeof HTMLImageElement < "u" && e instanceof HTMLImageElement ? (h.width = e.naturalWidth || e.width, h.height = e.naturalHeight || e.height) : typeof VideoFrame < "u" && e instanceof VideoFrame ? (h.width = e.displayWidth, h.height = e.displayHeight) : (h.width = e.width, h.height = e.height), h;
	}
	this.allocateTextureUnit = ie, this.resetTextureUnits = ne, this.getTextureUnits = I, this.setTextureUnits = re, this.setTexture2D = oe, this.setTexture2DArray = se, this.setTexture3D = ce, this.setTextureCube = le, this.rebindTextures = be, this.setupRenderTarget = xe, this.updateRenderTargetMipmap = Se, this.updateMultisampleRenderTarget = Te, this.setupDepthRenderbuffer = ye, this.setupFrameBufferTexture = ge, this.useMultisampledRTT = De, this.isReversedDepthBuffer = function() {
		return c.buffers.depth.getReversed();
	};
}
function Cl(e, t) {
	function n(n, r = "") {
		let i, a = X.getTransfer(r);
		if (n === 1009) return e.UNSIGNED_BYTE;
		if (n === 1017) return e.UNSIGNED_SHORT_4_4_4_4;
		if (n === 1018) return e.UNSIGNED_SHORT_5_5_5_1;
		if (n === 35902) return e.UNSIGNED_INT_5_9_9_9_REV;
		if (n === 35899) return e.UNSIGNED_INT_10F_11F_11F_REV;
		if (n === 1010) return e.BYTE;
		if (n === 1011) return e.SHORT;
		if (n === 1012) return e.UNSIGNED_SHORT;
		if (n === 1013) return e.INT;
		if (n === 1014) return e.UNSIGNED_INT;
		if (n === 1015) return e.FLOAT;
		if (n === 1016) return e.HALF_FLOAT;
		if (n === 1021) return e.ALPHA;
		if (n === 1022) return e.RGB;
		if (n === 1023) return e.RGBA;
		if (n === 1026) return e.DEPTH_COMPONENT;
		if (n === 1027) return e.DEPTH_STENCIL;
		if (n === 1028) return e.RED;
		if (n === 1029) return e.RED_INTEGER;
		if (n === 1030) return e.RG;
		if (n === 1031) return e.RG_INTEGER;
		if (n === 1033) return e.RGBA_INTEGER;
		if (n === 33776 || n === 33777 || n === 33778 || n === 33779) if (a === "srgb") if (i = t.get("WEBGL_compressed_texture_s3tc_srgb"), i !== null) {
			if (n === 33776) return i.COMPRESSED_SRGB_S3TC_DXT1_EXT;
			if (n === 33777) return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
			if (n === 33778) return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
			if (n === 33779) return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
		} else return null;
		else if (i = t.get("WEBGL_compressed_texture_s3tc"), i !== null) {
			if (n === 33776) return i.COMPRESSED_RGB_S3TC_DXT1_EXT;
			if (n === 33777) return i.COMPRESSED_RGBA_S3TC_DXT1_EXT;
			if (n === 33778) return i.COMPRESSED_RGBA_S3TC_DXT3_EXT;
			if (n === 33779) return i.COMPRESSED_RGBA_S3TC_DXT5_EXT;
		} else return null;
		if (n === 35840 || n === 35841 || n === 35842 || n === 35843) if (i = t.get("WEBGL_compressed_texture_pvrtc"), i !== null) {
			if (n === 35840) return i.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
			if (n === 35841) return i.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
			if (n === 35842) return i.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
			if (n === 35843) return i.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
		} else return null;
		if (n === 36196 || n === 37492 || n === 37496 || n === 37488 || n === 37489 || n === 37490 || n === 37491) if (i = t.get("WEBGL_compressed_texture_etc"), i !== null) {
			if (n === 36196 || n === 37492) return a === "srgb" ? i.COMPRESSED_SRGB8_ETC2 : i.COMPRESSED_RGB8_ETC2;
			if (n === 37496) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : i.COMPRESSED_RGBA8_ETC2_EAC;
			if (n === 37488) return i.COMPRESSED_R11_EAC;
			if (n === 37489) return i.COMPRESSED_SIGNED_R11_EAC;
			if (n === 37490) return i.COMPRESSED_RG11_EAC;
			if (n === 37491) return i.COMPRESSED_SIGNED_RG11_EAC;
		} else return null;
		if (n === 37808 || n === 37809 || n === 37810 || n === 37811 || n === 37812 || n === 37813 || n === 37814 || n === 37815 || n === 37816 || n === 37817 || n === 37818 || n === 37819 || n === 37820 || n === 37821) if (i = t.get("WEBGL_compressed_texture_astc"), i !== null) {
			if (n === 37808) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : i.COMPRESSED_RGBA_ASTC_4x4_KHR;
			if (n === 37809) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : i.COMPRESSED_RGBA_ASTC_5x4_KHR;
			if (n === 37810) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : i.COMPRESSED_RGBA_ASTC_5x5_KHR;
			if (n === 37811) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : i.COMPRESSED_RGBA_ASTC_6x5_KHR;
			if (n === 37812) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : i.COMPRESSED_RGBA_ASTC_6x6_KHR;
			if (n === 37813) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : i.COMPRESSED_RGBA_ASTC_8x5_KHR;
			if (n === 37814) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : i.COMPRESSED_RGBA_ASTC_8x6_KHR;
			if (n === 37815) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : i.COMPRESSED_RGBA_ASTC_8x8_KHR;
			if (n === 37816) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : i.COMPRESSED_RGBA_ASTC_10x5_KHR;
			if (n === 37817) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : i.COMPRESSED_RGBA_ASTC_10x6_KHR;
			if (n === 37818) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : i.COMPRESSED_RGBA_ASTC_10x8_KHR;
			if (n === 37819) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : i.COMPRESSED_RGBA_ASTC_10x10_KHR;
			if (n === 37820) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : i.COMPRESSED_RGBA_ASTC_12x10_KHR;
			if (n === 37821) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : i.COMPRESSED_RGBA_ASTC_12x12_KHR;
		} else return null;
		if (n === 36492 || n === 36494 || n === 36495) if (i = t.get("EXT_texture_compression_bptc"), i !== null) {
			if (n === 36492) return a === "srgb" ? i.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : i.COMPRESSED_RGBA_BPTC_UNORM_EXT;
			if (n === 36494) return i.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
			if (n === 36495) return i.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
		} else return null;
		if (n === 36283 || n === 36284 || n === 36285 || n === 36286) if (i = t.get("EXT_texture_compression_rgtc"), i !== null) {
			if (n === 36283) return i.COMPRESSED_RED_RGTC1_EXT;
			if (n === 36284) return i.COMPRESSED_SIGNED_RED_RGTC1_EXT;
			if (n === 36285) return i.COMPRESSED_RED_GREEN_RGTC2_EXT;
			if (n === 36286) return i.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
		} else return null;
		return n === 1020 ? e.UNSIGNED_INT_24_8 : e[n] === void 0 ? null : e[n];
	}
	return { convert: n };
}
var wl = "\nvoid main() {\n\n	gl_Position = vec4( position, 1.0 );\n\n}", Tl = "\nuniform sampler2DArray depthColor;\nuniform float depthWidth;\nuniform float depthHeight;\n\nvoid main() {\n\n	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );\n\n	if ( coord.x >= 1.0 ) {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;\n\n	} else {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;\n\n	}\n\n}", El = class {
	constructor() {
		this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
	}
	init(e, t) {
		if (this.texture === null) {
			let n = new jr(e.texture);
			(e.depthNear !== t.depthNear || e.depthFar !== t.depthFar) && (this.depthNear = e.depthNear, this.depthFar = e.depthFar), this.texture = n;
		}
	}
	getMesh(e) {
		if (this.texture !== null && this.mesh === null) {
			let t = e.cameras[0].viewport, n = new sa({
				vertexShader: wl,
				fragmentShader: Tl,
				uniforms: {
					depthColor: { value: this.texture },
					depthWidth: { value: t.z },
					depthHeight: { value: t.w }
				}
			});
			this.mesh = new hr(new Xi(20, 20), n);
		}
		return this.mesh;
	}
	reset() {
		this.texture = null, this.mesh = null;
	}
	getDepthTexture() {
		return this.texture;
	}
}, Dl = class extends ce {
	constructor(e, t) {
		super();
		let n = this, r = null, i = 1, a = null, s = "local-floor", l = 1, u = null, d = null, f = null, _ = null, v = null, y = null, b = typeof XRWebGLBinding < "u", x = new El(), S = {}, C = t.getContextAttributes(), w = null, T = null, E = [], D = [], O = new U(), k = null, A = new Ga();
		A.viewport = new Ge();
		let j = new Ga();
		j.viewport = new Ge();
		let M = [A, j], N = new Qa(), ee = null, P = null;
		this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(e) {
			let t = E[e];
			return t === void 0 && (t = new Et(), E[e] = t), t.getTargetRaySpace();
		}, this.getControllerGrip = function(e) {
			let t = E[e];
			return t === void 0 && (t = new Et(), E[e] = t), t.getGripSpace();
		}, this.getHand = function(e) {
			let t = E[e];
			return t === void 0 && (t = new Et(), E[e] = t), t.getHandSpace();
		};
		function F(e) {
			let t = D.indexOf(e.inputSource);
			if (t === -1) return;
			let n = E[t];
			n !== void 0 && (n.update(e.inputSource, e.frame, u || a), n.dispatchEvent({
				type: e.type,
				data: e.inputSource
			}));
		}
		function te() {
			r.removeEventListener("select", F), r.removeEventListener("selectstart", F), r.removeEventListener("selectend", F), r.removeEventListener("squeeze", F), r.removeEventListener("squeezestart", F), r.removeEventListener("squeezeend", F), r.removeEventListener("end", te), r.removeEventListener("inputsourceschange", ne);
			for (let e = 0; e < E.length; e++) {
				let t = D[e];
				t !== null && (D[e] = null, E[e].disconnect(t));
			}
			ee = null, P = null, x.reset();
			for (let e in S) delete S[e];
			e.setRenderTarget(w), v = null, _ = null, f = null, r = null, T = null, ce.stop(), n.isPresenting = !1, e.setPixelRatio(k), e.setSize(O.width, O.height, !1), n.dispatchEvent({ type: "sessionend" });
		}
		this.setFramebufferScaleFactor = function(e) {
			i = e, n.isPresenting === !0 && L("WebXRManager: Cannot change framebuffer scale while presenting.");
		}, this.setReferenceSpaceType = function(e) {
			s = e, n.isPresenting === !0 && L("WebXRManager: Cannot change reference space type while presenting.");
		}, this.getReferenceSpace = function() {
			return u || a;
		}, this.setReferenceSpace = function(e) {
			u = e;
		}, this.getBaseLayer = function() {
			return _ === null ? v : _;
		}, this.getBinding = function() {
			return f === null && b && (f = new XRWebGLBinding(r, t)), f;
		}, this.getFrame = function() {
			return y;
		}, this.getSession = function() {
			return r;
		}, this.setSession = async function(d) {
			if (r = d, r !== null) {
				if (w = e.getRenderTarget(), r.addEventListener("select", F), r.addEventListener("selectstart", F), r.addEventListener("selectend", F), r.addEventListener("squeeze", F), r.addEventListener("squeezestart", F), r.addEventListener("squeezeend", F), r.addEventListener("end", te), r.addEventListener("inputsourceschange", ne), C.xrCompatible !== !0 && await t.makeXRCompatible(), k = e.getPixelRatio(), e.getSize(O), b && "createProjectionLayer" in XRWebGLBinding.prototype) {
					let n = null, a = null, s = null;
					C.depth && (s = C.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, n = C.stencil ? g : h, a = C.stencil ? p : c);
					let l = {
						colorFormat: t.RGBA8,
						depthFormat: s,
						scaleFactor: i
					};
					f = this.getBinding(), _ = f.createProjectionLayer(l), r.updateRenderState({ layers: [_] }), e.setPixelRatio(1), e.setSize(_.textureWidth, _.textureHeight, !1), T = new qe(_.textureWidth, _.textureHeight, {
						format: m,
						type: o,
						depthTexture: new kr(_.textureWidth, _.textureHeight, a, void 0, void 0, void 0, void 0, void 0, void 0, n),
						stencilBuffer: C.stencil,
						colorSpace: e.outputColorSpace,
						samples: C.antialias ? 4 : 0,
						resolveDepthBuffer: _.ignoreDepthValues === !1,
						resolveStencilBuffer: _.ignoreDepthValues === !1
					});
				} else {
					let n = {
						antialias: C.antialias,
						alpha: !0,
						depth: C.depth,
						stencil: C.stencil,
						framebufferScaleFactor: i
					};
					v = new XRWebGLLayer(r, t, n), r.updateRenderState({ baseLayer: v }), e.setPixelRatio(1), e.setSize(v.framebufferWidth, v.framebufferHeight, !1), T = new qe(v.framebufferWidth, v.framebufferHeight, {
						format: m,
						type: o,
						colorSpace: e.outputColorSpace,
						stencilBuffer: C.stencil,
						resolveDepthBuffer: v.ignoreDepthValues === !1,
						resolveStencilBuffer: v.ignoreDepthValues === !1
					});
				}
				T.isXRRenderTarget = !0, this.setFoveation(l), u = null, a = await r.requestReferenceSpace(s), ce.setContext(r), ce.start(), n.isPresenting = !0, n.dispatchEvent({ type: "sessionstart" });
			}
		}, this.getEnvironmentBlendMode = function() {
			if (r !== null) return r.environmentBlendMode;
		}, this.getDepthTexture = function() {
			return x.getDepthTexture();
		};
		function ne(e) {
			for (let t = 0; t < e.removed.length; t++) {
				let n = e.removed[t], r = D.indexOf(n);
				r >= 0 && (D[r] = null, E[r].disconnect(n));
			}
			for (let t = 0; t < e.added.length; t++) {
				let n = e.added[t], r = D.indexOf(n);
				if (r === -1) {
					for (let e = 0; e < E.length; e++) if (e >= D.length) {
						D.push(n), r = e;
						break;
					} else if (D[e] === null) {
						D[e] = n, r = e;
						break;
					}
					if (r === -1) break;
				}
				let i = E[r];
				i && i.connect(n);
			}
		}
		let I = new G(), re = new G();
		function ie(e, t, n) {
			I.setFromMatrixPosition(t.matrixWorld), re.setFromMatrixPosition(n.matrixWorld);
			let r = I.distanceTo(re), i = t.projectionMatrix.elements, a = n.projectionMatrix.elements, o = i[14] / (i[10] - 1), s = i[14] / (i[10] + 1), c = (i[9] + 1) / i[5], l = (i[9] - 1) / i[5], u = (i[8] - 1) / i[0], d = (a[8] + 1) / a[0], f = o * u, p = o * d, m = r / (-u + d), h = m * -u;
			if (t.matrixWorld.decompose(e.position, e.quaternion, e.scale), e.translateX(h), e.translateZ(m), e.matrixWorld.compose(e.position, e.quaternion, e.scale), e.matrixWorldInverse.copy(e.matrixWorld).invert(), i[10] === -1) e.projectionMatrix.copy(t.projectionMatrix), e.projectionMatrixInverse.copy(t.projectionMatrixInverse);
			else {
				let t = o + m, n = s + m, i = f - h, a = p + (r - h), u = c * s / n * t, d = l * s / n * t;
				e.projectionMatrix.makePerspective(i, a, u, d, t, n), e.projectionMatrixInverse.copy(e.projectionMatrix).invert();
			}
		}
		function R(e, t) {
			t === null ? e.matrixWorld.copy(e.matrix) : e.matrixWorld.multiplyMatrices(t.matrixWorld, e.matrix), e.matrixWorldInverse.copy(e.matrixWorld).invert();
		}
		this.updateCamera = function(e) {
			if (r === null) return;
			let t = e.near, n = e.far;
			x.texture !== null && (x.depthNear > 0 && (t = x.depthNear), x.depthFar > 0 && (n = x.depthFar)), N.near = j.near = A.near = t, N.far = j.far = A.far = n, (ee !== N.near || P !== N.far) && (r.updateRenderState({
				depthNear: N.near,
				depthFar: N.far
			}), ee = N.near, P = N.far), N.layers.mask = e.layers.mask | 6, A.layers.mask = N.layers.mask & -5, j.layers.mask = N.layers.mask & -3;
			let i = e.parent, a = N.cameras;
			R(N, i);
			for (let e = 0; e < a.length; e++) R(a[e], i);
			a.length === 2 ? ie(N, A, j) : N.projectionMatrix.copy(A.projectionMatrix), ae(e, N, i);
		};
		function ae(e, t, n) {
			n === null ? e.matrix.copy(t.matrixWorld) : (e.matrix.copy(n.matrixWorld), e.matrix.invert(), e.matrix.multiply(t.matrixWorld)), e.matrix.decompose(e.position, e.quaternion, e.scale), e.updateMatrixWorld(!0), e.projectionMatrix.copy(t.projectionMatrix), e.projectionMatrixInverse.copy(t.projectionMatrixInverse), e.isPerspectiveCamera && (e.fov = z * 2 * Math.atan(1 / e.projectionMatrix.elements[5]), e.zoom = 1);
		}
		this.getCamera = function() {
			return N;
		}, this.getFoveation = function() {
			if (!(_ === null && v === null)) return l;
		}, this.setFoveation = function(e) {
			l = e, _ !== null && (_.fixedFoveation = e), v !== null && v.fixedFoveation !== void 0 && (v.fixedFoveation = e);
		}, this.hasDepthSensing = function() {
			return x.texture !== null;
		}, this.getDepthSensingMesh = function() {
			return x.getMesh(N);
		}, this.getCameraTexture = function(e) {
			return S[e];
		};
		let oe = null;
		function se(t, i) {
			if (d = i.getViewerPose(u || a), y = i, d !== null) {
				let t = d.views;
				v !== null && (e.setRenderTargetFramebuffer(T, v.framebuffer), e.setRenderTarget(T));
				let i = !1;
				t.length !== N.cameras.length && (N.cameras.length = 0, i = !0);
				for (let n = 0; n < t.length; n++) {
					let r = t[n], a = null;
					if (v !== null) a = v.getViewport(r);
					else {
						let t = f.getViewSubImage(_, r);
						a = t.viewport, n === 0 && (e.setRenderTargetTextures(T, t.colorTexture, t.depthStencilTexture), e.setRenderTarget(T));
					}
					let o = M[n];
					o === void 0 && (o = new Ga(), o.layers.enable(n), o.viewport = new Ge(), M[n] = o), o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.quaternion, o.scale), o.projectionMatrix.fromArray(r.projectionMatrix), o.projectionMatrixInverse.copy(o.projectionMatrix).invert(), o.viewport.set(a.x, a.y, a.width, a.height), n === 0 && (N.matrix.copy(o.matrix), N.matrix.decompose(N.position, N.quaternion, N.scale)), i === !0 && N.cameras.push(o);
				}
				let a = r.enabledFeatures;
				if (a && a.includes("depth-sensing") && r.depthUsage == "gpu-optimized" && b) {
					f = n.getBinding();
					let e = f.getDepthInformation(t[0]);
					e && e.isValid && e.texture && x.init(e, r.renderState);
				}
				if (a && a.includes("camera-access") && b) {
					e.state.unbindTexture(), f = n.getBinding();
					for (let e = 0; e < t.length; e++) {
						let n = t[e].camera;
						if (n) {
							let e = S[n];
							e || (e = new jr(), S[n] = e);
							let t = f.getCameraImage(n);
							e.sourceTexture = t;
						}
					}
				}
			}
			for (let e = 0; e < E.length; e++) {
				let t = D[e], n = E[e];
				t !== null && n !== void 0 && n.update(t, i, u || a);
			}
			oe && oe(t, i), i.detectedPlanes && n.dispatchEvent({
				type: "planesdetected",
				data: i
			}), y = null;
		}
		let ce = new bo();
		ce.setAnimationLoop(se), this.setAnimationLoop = function(e) {
			oe = e;
		}, this.dispose = function() {};
	}
}, Ol = /*@__PURE__*/ new Xe(), kl = /*@__PURE__*/ new K();
kl.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
function Al(e, t) {
	function n(e, t) {
		e.matrixAutoUpdate === !0 && e.updateMatrix(), t.value.copy(e.matrix);
	}
	function r(t, n) {
		n.color.getRGB(t.fogColor.value, ra(e)), n.isFog ? (t.fogNear.value = n.near, t.fogFar.value = n.far) : n.isFogExp2 && (t.fogDensity.value = n.density);
	}
	function i(e, t, n, r, i) {
		t.isNodeMaterial ? t.uniformsNeedUpdate = !1 : t.isMeshBasicMaterial ? a(e, t) : t.isMeshLambertMaterial ? (a(e, t), t.envMap && (e.envMapIntensity.value = t.envMapIntensity)) : t.isMeshToonMaterial ? (a(e, t), d(e, t)) : t.isMeshPhongMaterial ? (a(e, t), u(e, t), t.envMap && (e.envMapIntensity.value = t.envMapIntensity)) : t.isMeshStandardMaterial ? (a(e, t), f(e, t), t.isMeshPhysicalMaterial && p(e, t, i)) : t.isMeshMatcapMaterial ? (a(e, t), m(e, t)) : t.isMeshDepthMaterial ? a(e, t) : t.isMeshDistanceMaterial ? (a(e, t), h(e, t)) : t.isMeshNormalMaterial ? a(e, t) : t.isLineBasicMaterial ? (o(e, t), t.isLineDashedMaterial && s(e, t)) : t.isPointsMaterial ? c(e, t, n, r) : t.isSpriteMaterial ? l(e, t) : t.isShadowMaterial ? (e.color.value.copy(t.color), e.opacity.value = t.opacity) : t.isShaderMaterial && (t.uniformsNeedUpdate = !1);
	}
	function a(e, r) {
		e.opacity.value = r.opacity, r.color && e.diffuse.value.copy(r.color), r.emissive && e.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity), r.map && (e.map.value = r.map, n(r.map, e.mapTransform)), r.alphaMap && (e.alphaMap.value = r.alphaMap, n(r.alphaMap, e.alphaMapTransform)), r.bumpMap && (e.bumpMap.value = r.bumpMap, n(r.bumpMap, e.bumpMapTransform), e.bumpScale.value = r.bumpScale, r.side === 1 && (e.bumpScale.value *= -1)), r.normalMap && (e.normalMap.value = r.normalMap, n(r.normalMap, e.normalMapTransform), e.normalScale.value.copy(r.normalScale), r.side === 1 && e.normalScale.value.negate()), r.displacementMap && (e.displacementMap.value = r.displacementMap, n(r.displacementMap, e.displacementMapTransform), e.displacementScale.value = r.displacementScale, e.displacementBias.value = r.displacementBias), r.emissiveMap && (e.emissiveMap.value = r.emissiveMap, n(r.emissiveMap, e.emissiveMapTransform)), r.specularMap && (e.specularMap.value = r.specularMap, n(r.specularMap, e.specularMapTransform)), r.alphaTest > 0 && (e.alphaTest.value = r.alphaTest);
		let i = t.get(r), a = i.envMap, o = i.envMapRotation;
		a && (e.envMap.value = a, e.envMapRotation.value.setFromMatrix4(Ol.makeRotationFromEuler(o)).transpose(), a.isCubeTexture && a.isRenderTargetTexture === !1 && e.envMapRotation.value.premultiply(kl), e.reflectivity.value = r.reflectivity, e.ior.value = r.ior, e.refractionRatio.value = r.refractionRatio), r.lightMap && (e.lightMap.value = r.lightMap, e.lightMapIntensity.value = r.lightMapIntensity, n(r.lightMap, e.lightMapTransform)), r.aoMap && (e.aoMap.value = r.aoMap, e.aoMapIntensity.value = r.aoMapIntensity, n(r.aoMap, e.aoMapTransform));
	}
	function o(e, t) {
		e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, t.map && (e.map.value = t.map, n(t.map, e.mapTransform));
	}
	function s(e, t) {
		e.dashSize.value = t.dashSize, e.totalSize.value = t.dashSize + t.gapSize, e.scale.value = t.scale;
	}
	function c(e, t, r, i) {
		e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, e.size.value = t.size * r, e.scale.value = i * .5, t.map && (e.map.value = t.map, n(t.map, e.uvTransform)), t.alphaMap && (e.alphaMap.value = t.alphaMap, n(t.alphaMap, e.alphaMapTransform)), t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
	}
	function l(e, t) {
		e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, e.rotation.value = t.rotation, t.map && (e.map.value = t.map, n(t.map, e.mapTransform)), t.alphaMap && (e.alphaMap.value = t.alphaMap, n(t.alphaMap, e.alphaMapTransform)), t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
	}
	function u(e, t) {
		e.specular.value.copy(t.specular), e.shininess.value = Math.max(t.shininess, 1e-4);
	}
	function d(e, t) {
		t.gradientMap && (e.gradientMap.value = t.gradientMap);
	}
	function f(e, t) {
		e.metalness.value = t.metalness, t.metalnessMap && (e.metalnessMap.value = t.metalnessMap, n(t.metalnessMap, e.metalnessMapTransform)), e.roughness.value = t.roughness, t.roughnessMap && (e.roughnessMap.value = t.roughnessMap, n(t.roughnessMap, e.roughnessMapTransform)), t.envMap && (e.envMapIntensity.value = t.envMapIntensity);
	}
	function p(e, t, r) {
		e.ior.value = t.ior, t.sheen > 0 && (e.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen), e.sheenRoughness.value = t.sheenRoughness, t.sheenColorMap && (e.sheenColorMap.value = t.sheenColorMap, n(t.sheenColorMap, e.sheenColorMapTransform)), t.sheenRoughnessMap && (e.sheenRoughnessMap.value = t.sheenRoughnessMap, n(t.sheenRoughnessMap, e.sheenRoughnessMapTransform))), t.clearcoat > 0 && (e.clearcoat.value = t.clearcoat, e.clearcoatRoughness.value = t.clearcoatRoughness, t.clearcoatMap && (e.clearcoatMap.value = t.clearcoatMap, n(t.clearcoatMap, e.clearcoatMapTransform)), t.clearcoatRoughnessMap && (e.clearcoatRoughnessMap.value = t.clearcoatRoughnessMap, n(t.clearcoatRoughnessMap, e.clearcoatRoughnessMapTransform)), t.clearcoatNormalMap && (e.clearcoatNormalMap.value = t.clearcoatNormalMap, n(t.clearcoatNormalMap, e.clearcoatNormalMapTransform), e.clearcoatNormalScale.value.copy(t.clearcoatNormalScale), t.side === 1 && e.clearcoatNormalScale.value.negate())), t.dispersion > 0 && (e.dispersion.value = t.dispersion), t.iridescence > 0 && (e.iridescence.value = t.iridescence, e.iridescenceIOR.value = t.iridescenceIOR, e.iridescenceThicknessMinimum.value = t.iridescenceThicknessRange[0], e.iridescenceThicknessMaximum.value = t.iridescenceThicknessRange[1], t.iridescenceMap && (e.iridescenceMap.value = t.iridescenceMap, n(t.iridescenceMap, e.iridescenceMapTransform)), t.iridescenceThicknessMap && (e.iridescenceThicknessMap.value = t.iridescenceThicknessMap, n(t.iridescenceThicknessMap, e.iridescenceThicknessMapTransform))), t.transmission > 0 && (e.transmission.value = t.transmission, e.transmissionSamplerMap.value = r.texture, e.transmissionSamplerSize.value.set(r.width, r.height), t.transmissionMap && (e.transmissionMap.value = t.transmissionMap, n(t.transmissionMap, e.transmissionMapTransform)), e.thickness.value = t.thickness, t.thicknessMap && (e.thicknessMap.value = t.thicknessMap, n(t.thicknessMap, e.thicknessMapTransform)), e.attenuationDistance.value = t.attenuationDistance, e.attenuationColor.value.copy(t.attenuationColor)), t.anisotropy > 0 && (e.anisotropyVector.value.set(t.anisotropy * Math.cos(t.anisotropyRotation), t.anisotropy * Math.sin(t.anisotropyRotation)), t.anisotropyMap && (e.anisotropyMap.value = t.anisotropyMap, n(t.anisotropyMap, e.anisotropyMapTransform))), e.specularIntensity.value = t.specularIntensity, e.specularColor.value.copy(t.specularColor), t.specularColorMap && (e.specularColorMap.value = t.specularColorMap, n(t.specularColorMap, e.specularColorMapTransform)), t.specularIntensityMap && (e.specularIntensityMap.value = t.specularIntensityMap, n(t.specularIntensityMap, e.specularIntensityMapTransform));
	}
	function m(e, t) {
		t.matcap && (e.matcap.value = t.matcap);
	}
	function h(e, n) {
		let r = t.get(n).light;
		e.referencePosition.value.setFromMatrixPosition(r.matrixWorld), e.nearDistance.value = r.shadow.camera.near, e.farDistance.value = r.shadow.camera.far;
	}
	return {
		refreshFogUniforms: r,
		refreshMaterialUniforms: i
	};
}
function jl(e, t, n, r) {
	let i = {}, a = {}, o = [], s = e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS);
	function c(e, t) {
		let n = t.program;
		r.uniformBlockBinding(e, n);
	}
	function l(e, n) {
		let o = i[e.id];
		o === void 0 && (g(e), o = u(e), i[e.id] = o, e.addEventListener("dispose", v));
		let s = n.program;
		r.updateUBOMapping(e, s);
		let c = t.render.frame;
		a[e.id] !== c && (f(e), a[e.id] = c);
	}
	function u(t) {
		let n = d();
		t.__bindingPointIndex = n;
		let r = e.createBuffer(), i = t.__size, a = t.usage;
		return e.bindBuffer(e.UNIFORM_BUFFER, r), e.bufferData(e.UNIFORM_BUFFER, i, a), e.bindBuffer(e.UNIFORM_BUFFER, null), e.bindBufferBase(e.UNIFORM_BUFFER, n, r), r;
	}
	function d() {
		for (let e = 0; e < s; e++) if (o.indexOf(e) === -1) return o.push(e), e;
		return R("WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
	}
	function f(t) {
		let n = i[t.id], r = t.uniforms, a = t.__cache;
		e.bindBuffer(e.UNIFORM_BUFFER, n);
		for (let e = 0, t = r.length; e < t; e++) {
			let t = r[e];
			if (Array.isArray(t)) for (let n = 0, r = t.length; n < r; n++) p(t[n], e, n, a);
			else p(t, e, 0, a);
		}
		e.bindBuffer(e.UNIFORM_BUFFER, null);
	}
	function p(t, n, r, i) {
		if (h(t, n, r, i) === !0) {
			let n = t.__offset, r = t.value;
			if (Array.isArray(r)) {
				let e = 0;
				for (let n = 0; n < r.length; n++) {
					let i = r[n], a = _(i);
					m(i, t.__data, e), typeof i != "number" && typeof i != "boolean" && !i.isMatrix3 && !ArrayBuffer.isView(i) && (e += a.storage / Float32Array.BYTES_PER_ELEMENT);
				}
			} else m(r, t.__data, 0);
			e.bufferSubData(e.UNIFORM_BUFFER, n, t.__data);
		}
	}
	function m(e, t, n) {
		typeof e == "number" || typeof e == "boolean" ? t[0] = e : e.isMatrix3 ? (t[0] = e.elements[0], t[1] = e.elements[1], t[2] = e.elements[2], t[3] = 0, t[4] = e.elements[3], t[5] = e.elements[4], t[6] = e.elements[5], t[7] = 0, t[8] = e.elements[6], t[9] = e.elements[7], t[10] = e.elements[8], t[11] = 0) : ArrayBuffer.isView(e) ? t.set(new e.constructor(e.buffer, e.byteOffset, t.length)) : e.toArray(t, n);
	}
	function h(e, t, n, r) {
		let i = e.value, a = t + "_" + n;
		if (r[a] === void 0) return typeof i == "number" || typeof i == "boolean" ? r[a] = i : ArrayBuffer.isView(i) ? r[a] = i.slice() : r[a] = i.clone(), !0;
		{
			let e = r[a];
			if (typeof i == "number" || typeof i == "boolean") {
				if (e !== i) return r[a] = i, !0;
			} else if (ArrayBuffer.isView(i)) return !0;
			else if (e.equals(i) === !1) return e.copy(i), !0;
		}
		return !1;
	}
	function g(e) {
		let t = e.uniforms, n = 0;
		for (let e = 0, r = t.length; e < r; e++) {
			let r = Array.isArray(t[e]) ? t[e] : [t[e]];
			for (let e = 0, t = r.length; e < t; e++) {
				let t = r[e], i = Array.isArray(t.value) ? t.value : [t.value];
				for (let e = 0, r = i.length; e < r; e++) {
					let r = i[e], a = _(r), o = n % 16, s = o % a.boundary, c = o + s;
					n += s, c !== 0 && 16 - c < a.storage && (n += 16 - c), t.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT), t.__offset = n, n += a.storage;
				}
			}
		}
		let r = n % 16;
		return r > 0 && (n += 16 - r), e.__size = n, e.__cache = {}, this;
	}
	function _(e) {
		let t = {
			boundary: 0,
			storage: 0
		};
		return typeof e == "number" || typeof e == "boolean" ? (t.boundary = 4, t.storage = 4) : e.isVector2 ? (t.boundary = 8, t.storage = 8) : e.isVector3 || e.isColor ? (t.boundary = 16, t.storage = 12) : e.isVector4 ? (t.boundary = 16, t.storage = 16) : e.isMatrix3 ? (t.boundary = 48, t.storage = 48) : e.isMatrix4 ? (t.boundary = 64, t.storage = 64) : e.isTexture ? L("WebGLRenderer: Texture samplers can not be part of an uniforms group.") : ArrayBuffer.isView(e) ? (t.boundary = 16, t.storage = e.byteLength) : L("WebGLRenderer: Unsupported uniform value type.", e), t;
	}
	function v(t) {
		let n = t.target;
		n.removeEventListener("dispose", v);
		let r = o.indexOf(n.__bindingPointIndex);
		o.splice(r, 1), e.deleteBuffer(i[n.id]), delete i[n.id], delete a[n.id];
	}
	function y() {
		for (let t in i) e.deleteBuffer(i[t]);
		o = [], i = {}, a = {};
	}
	return {
		bind: c,
		update: l,
		dispose: y
	};
}
var Ml = new Uint16Array([
	12469,
	15057,
	12620,
	14925,
	13266,
	14620,
	13807,
	14376,
	14323,
	13990,
	14545,
	13625,
	14713,
	13328,
	14840,
	12882,
	14931,
	12528,
	14996,
	12233,
	15039,
	11829,
	15066,
	11525,
	15080,
	11295,
	15085,
	10976,
	15082,
	10705,
	15073,
	10495,
	13880,
	14564,
	13898,
	14542,
	13977,
	14430,
	14158,
	14124,
	14393,
	13732,
	14556,
	13410,
	14702,
	12996,
	14814,
	12596,
	14891,
	12291,
	14937,
	11834,
	14957,
	11489,
	14958,
	11194,
	14943,
	10803,
	14921,
	10506,
	14893,
	10278,
	14858,
	9960,
	14484,
	14039,
	14487,
	14025,
	14499,
	13941,
	14524,
	13740,
	14574,
	13468,
	14654,
	13106,
	14743,
	12678,
	14818,
	12344,
	14867,
	11893,
	14889,
	11509,
	14893,
	11180,
	14881,
	10751,
	14852,
	10428,
	14812,
	10128,
	14765,
	9754,
	14712,
	9466,
	14764,
	13480,
	14764,
	13475,
	14766,
	13440,
	14766,
	13347,
	14769,
	13070,
	14786,
	12713,
	14816,
	12387,
	14844,
	11957,
	14860,
	11549,
	14868,
	11215,
	14855,
	10751,
	14825,
	10403,
	14782,
	10044,
	14729,
	9651,
	14666,
	9352,
	14599,
	9029,
	14967,
	12835,
	14966,
	12831,
	14963,
	12804,
	14954,
	12723,
	14936,
	12564,
	14917,
	12347,
	14900,
	11958,
	14886,
	11569,
	14878,
	11247,
	14859,
	10765,
	14828,
	10401,
	14784,
	10011,
	14727,
	9600,
	14660,
	9289,
	14586,
	8893,
	14508,
	8533,
	15111,
	12234,
	15110,
	12234,
	15104,
	12216,
	15092,
	12156,
	15067,
	12010,
	15028,
	11776,
	14981,
	11500,
	14942,
	11205,
	14902,
	10752,
	14861,
	10393,
	14812,
	9991,
	14752,
	9570,
	14682,
	9252,
	14603,
	8808,
	14519,
	8445,
	14431,
	8145,
	15209,
	11449,
	15208,
	11451,
	15202,
	11451,
	15190,
	11438,
	15163,
	11384,
	15117,
	11274,
	15055,
	10979,
	14994,
	10648,
	14932,
	10343,
	14871,
	9936,
	14803,
	9532,
	14729,
	9218,
	14645,
	8742,
	14556,
	8381,
	14461,
	8020,
	14365,
	7603,
	15273,
	10603,
	15272,
	10607,
	15267,
	10619,
	15256,
	10631,
	15231,
	10614,
	15182,
	10535,
	15118,
	10389,
	15042,
	10167,
	14963,
	9787,
	14883,
	9447,
	14800,
	9115,
	14710,
	8665,
	14615,
	8318,
	14514,
	7911,
	14411,
	7507,
	14279,
	7198,
	15314,
	9675,
	15313,
	9683,
	15309,
	9712,
	15298,
	9759,
	15277,
	9797,
	15229,
	9773,
	15166,
	9668,
	15084,
	9487,
	14995,
	9274,
	14898,
	8910,
	14800,
	8539,
	14697,
	8234,
	14590,
	7790,
	14479,
	7409,
	14367,
	7067,
	14178,
	6621,
	15337,
	8619,
	15337,
	8631,
	15333,
	8677,
	15325,
	8769,
	15305,
	8871,
	15264,
	8940,
	15202,
	8909,
	15119,
	8775,
	15022,
	8565,
	14916,
	8328,
	14804,
	8009,
	14688,
	7614,
	14569,
	7287,
	14448,
	6888,
	14321,
	6483,
	14088,
	6171,
	15350,
	7402,
	15350,
	7419,
	15347,
	7480,
	15340,
	7613,
	15322,
	7804,
	15287,
	7973,
	15229,
	8057,
	15148,
	8012,
	15046,
	7846,
	14933,
	7611,
	14810,
	7357,
	14682,
	7069,
	14552,
	6656,
	14421,
	6316,
	14251,
	5948,
	14007,
	5528,
	15356,
	5942,
	15356,
	5977,
	15353,
	6119,
	15348,
	6294,
	15332,
	6551,
	15302,
	6824,
	15249,
	7044,
	15171,
	7122,
	15070,
	7050,
	14949,
	6861,
	14818,
	6611,
	14679,
	6349,
	14538,
	6067,
	14398,
	5651,
	14189,
	5311,
	13935,
	4958,
	15359,
	4123,
	15359,
	4153,
	15356,
	4296,
	15353,
	4646,
	15338,
	5160,
	15311,
	5508,
	15263,
	5829,
	15188,
	6042,
	15088,
	6094,
	14966,
	6001,
	14826,
	5796,
	14678,
	5543,
	14527,
	5287,
	14377,
	4985,
	14133,
	4586,
	13869,
	4257,
	15360,
	1563,
	15360,
	1642,
	15358,
	2076,
	15354,
	2636,
	15341,
	3350,
	15317,
	4019,
	15273,
	4429,
	15203,
	4732,
	15105,
	4911,
	14981,
	4932,
	14836,
	4818,
	14679,
	4621,
	14517,
	4386,
	14359,
	4156,
	14083,
	3795,
	13808,
	3437,
	15360,
	122,
	15360,
	137,
	15358,
	285,
	15355,
	636,
	15344,
	1274,
	15322,
	2177,
	15281,
	2765,
	15215,
	3223,
	15120,
	3451,
	14995,
	3569,
	14846,
	3567,
	14681,
	3466,
	14511,
	3305,
	14344,
	3121,
	14037,
	2800,
	13753,
	2467,
	15360,
	0,
	15360,
	1,
	15359,
	21,
	15355,
	89,
	15346,
	253,
	15325,
	479,
	15287,
	796,
	15225,
	1148,
	15133,
	1492,
	15008,
	1749,
	14856,
	1882,
	14685,
	1886,
	14506,
	1783,
	14324,
	1608,
	13996,
	1398,
	13702,
	1183
]), Nl = null;
function Pl() {
	return Nl === null && (Nl = new vr(Ml, 16, 16, v, u), Nl.name = "DFG_LUT", Nl.minFilter = i, Nl.magFilter = i, Nl.wrapS = t, Nl.wrapT = t, Nl.generateMipmaps = !1, Nl.needsUpdate = !0), Nl;
}
var Fl = class {
	constructor(e = {}) {
		let { canvas: t = ne(), context: n = null, depth: r = !0, stencil: i = !1, alpha: l = !1, antialias: m = !1, premultipliedAlpha: h = !0, preserveDrawingBuffer: g = !1, powerPreference: v = "default", failIfMajorPerformanceCaveat: x = !1, reversedDepthBuffer: S = !1, outputBufferType: C = o } = e;
		this.isWebGLRenderer = !0;
		let w;
		if (n !== null) {
			if (typeof WebGLRenderingContext < "u" && n instanceof WebGLRenderingContext) throw Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
			w = n.getContextAttributes().alpha;
		} else w = l;
		let T = C, E = /* @__PURE__ */ new Set([
			b,
			y,
			_
		]), D = /* @__PURE__ */ new Set([
			o,
			c,
			s,
			p,
			d,
			f
		]), k = /* @__PURE__ */ new Uint32Array(4), A = /* @__PURE__ */ new Int32Array(4), j = new G(), M = null, N = null, P = [], F = [], te = null;
		this.domElement = t, this.debug = {
			checkShaderErrors: !0,
			onShaderError: null
		}, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = 0, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
		let I = this, ie = !1, ae = null, se = null, ce = null, le = null;
		this._outputColorSpace = O;
		let ue = 0, de = 0, z = null, B = -1, V = null, fe = new Ge(), pe = new Ge(), me = null, he = new Z(0), ge = 0, _e = t.width, ve = t.height, ye = 1, be = null, xe = null, Se = new Ge(0, 0, _e, ve), Ce = new Ge(0, 0, _e, ve), we = !1, Te = new Er(), Ee = !1, De = !1, Oe = new Xe(), ke = new G(), Ae = new Ge(), H = {
			background: null,
			fog: null,
			environment: null,
			overrideMaterial: null,
			isScene: !0
		}, je = !1;
		function U() {
			return z === null ? ye : 1;
		}
		let W = n;
		function Me(e, n) {
			return t.getContext(e, n);
		}
		try {
			let e = {
				alpha: !0,
				depth: r,
				stencil: i,
				antialias: m,
				premultipliedAlpha: h,
				preserveDrawingBuffer: g,
				powerPreference: v,
				failIfMajorPerformanceCaveat: x
			};
			if ("setAttribute" in t && t.setAttribute("data-engine", "three.js r185"), t.addEventListener("webglcontextlost", rt, !1), t.addEventListener("webglcontextrestored", it, !1), t.addEventListener("webglcontextcreationerror", at, !1), W === null) {
				let t = "webgl2";
				if (W = Me(t, e), W === null) throw Me(t) ? Error("THREE.WebGLRenderer: Error creating WebGL context with your selected attributes.") : Error("THREE.WebGLRenderer: Error creating WebGL context.");
			}
		} catch (e) {
			throw R("WebGLRenderer: " + e.message), e;
		}
		let Ne, K, q, Pe, J, Y, Fe, Ie, Le, Re, ze, Be, Ve, He, Ue, We, Ke, Je, Ye, Ze, Qe, $e, et;
		function tt() {
			Ne = new $o(W), Ne.init(), Qe = new Cl(W, Ne), K = new ko(W, Ne, e, Qe), q = new xl(W, Ne), K.reversedDepthBuffer && S && q.buffers.depth.setReversed(!0), se = W.createFramebuffer(), ce = W.createFramebuffer(), le = W.createFramebuffer(), Pe = new ns(W), J = new tl(), Y = new Sl(W, Ne, q, J, K, Qe, Pe), Fe = new Qo(I), Ie = new xo(W), $e = new Do(W, Ie), Le = new es(W, Ie, Pe, $e), Re = new is(W, Le, Ie, $e, Pe), Je = new rs(W, K, Y), Ue = new Ao(J), ze = new el(I, Fe, Ne, K, $e, Ue), Be = new Al(I, J), Ve = new al(), He = new fl(Ne), Ke = new Eo(I, Fe, q, Re, w, h), We = new bl(I, Re, K), et = new jl(W, Pe, K, q), Ye = new Oo(W, Ne, Pe), Ze = new ts(W, Ne, Pe), Pe.programs = ze.programs, I.capabilities = K, I.extensions = Ne, I.properties = J, I.renderLists = Ve, I.shadowMap = We, I.state = q, I.info = Pe;
		}
		tt(), T !== 1009 && (te = new os(T, t.width, t.height, m, r, i));
		let nt = new Dl(I, W);
		this.xr = nt, this.getContext = function() {
			return W;
		}, this.getContextAttributes = function() {
			return W.getContextAttributes();
		}, this.forceContextLoss = function() {
			let e = Ne.get("WEBGL_lose_context");
			e && e.loseContext();
		}, this.forceContextRestore = function() {
			let e = Ne.get("WEBGL_lose_context");
			e && e.restoreContext();
		}, this.getPixelRatio = function() {
			return ye;
		}, this.setPixelRatio = function(e) {
			e !== void 0 && (ye = e, this.setSize(_e, ve, !1));
		}, this.getSize = function(e) {
			return e.set(_e, ve);
		}, this.setSize = function(e, n, r = !0) {
			if (nt.isPresenting) {
				L("WebGLRenderer: Can't change size while VR device is presenting.");
				return;
			}
			_e = e, ve = n, t.width = Math.floor(e * ye), t.height = Math.floor(n * ye), r === !0 && (t.style.width = e + "px", t.style.height = n + "px"), te !== null && te.setSize(t.width, t.height), this.setViewport(0, 0, e, n);
		}, this.getDrawingBufferSize = function(e) {
			return e.set(_e * ye, ve * ye).floor();
		}, this.setDrawingBufferSize = function(e, n, r) {
			_e = e, ve = n, ye = r, t.width = Math.floor(e * r), t.height = Math.floor(n * r), this.setViewport(0, 0, e, n);
		}, this.setEffects = function(e) {
			if (T === 1009) {
				R("WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.");
				return;
			}
			if (e) {
				for (let t = 0; t < e.length; t++) if (e[t].isOutputPass === !0) {
					L("WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.");
					break;
				}
			}
			te.setEffects(e || []);
		}, this.getCurrentViewport = function(e) {
			return e.copy(fe);
		}, this.getViewport = function(e) {
			return e.copy(Se);
		}, this.setViewport = function(e, t, n, r) {
			e.isVector4 ? Se.set(e.x, e.y, e.z, e.w) : Se.set(e, t, n, r), q.viewport(fe.copy(Se).multiplyScalar(ye).round());
		}, this.getScissor = function(e) {
			return e.copy(Ce);
		}, this.setScissor = function(e, t, n, r) {
			e.isVector4 ? Ce.set(e.x, e.y, e.z, e.w) : Ce.set(e, t, n, r), q.scissor(pe.copy(Ce).multiplyScalar(ye).round());
		}, this.getScissorTest = function() {
			return we;
		}, this.setScissorTest = function(e) {
			q.setScissorTest(we = e);
		}, this.setOpaqueSort = function(e) {
			be = e;
		}, this.setTransparentSort = function(e) {
			xe = e;
		}, this.getClearColor = function(e) {
			return e.copy(Ke.getClearColor());
		}, this.setClearColor = function() {
			Ke.setClearColor(...arguments);
		}, this.getClearAlpha = function() {
			return Ke.getClearAlpha();
		}, this.setClearAlpha = function() {
			Ke.setClearAlpha(...arguments);
		}, this.clear = function(e = !0, t = !0, n = !0) {
			let r = 0;
			if (e) {
				let e = !1;
				if (z !== null) {
					let t = z.texture.format;
					e = E.has(t);
				}
				if (e) {
					let e = z.texture.type, t = D.has(e), n = Ke.getClearColor(), r = Ke.getClearAlpha(), i = n.r, a = n.g, o = n.b;
					t ? (k[0] = i, k[1] = a, k[2] = o, k[3] = r, W.clearBufferuiv(W.COLOR, 0, k)) : (A[0] = i, A[1] = a, A[2] = o, A[3] = r, W.clearBufferiv(W.COLOR, 0, A));
				} else r |= W.COLOR_BUFFER_BIT;
			}
			t && (r |= W.DEPTH_BUFFER_BIT, this.state.buffers.depth.setMask(!0)), n && (r |= W.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), r !== 0 && W.clear(r);
		}, this.clearColor = function() {
			this.clear(!0, !1, !1);
		}, this.clearDepth = function() {
			this.clear(!1, !0, !1);
		}, this.clearStencil = function() {
			this.clear(!1, !1, !0);
		}, this.setNodesHandler = function(e) {
			e.setRenderer(this), ae = e;
		}, this.dispose = function() {
			t.removeEventListener("webglcontextlost", rt, !1), t.removeEventListener("webglcontextrestored", it, !1), t.removeEventListener("webglcontextcreationerror", at, !1), Ke.dispose(), Ve.dispose(), He.dispose(), J.dispose(), Fe.dispose(), Re.dispose(), $e.dispose(), et.dispose(), ze.dispose(), nt.dispose(), nt.removeEventListener("sessionstart", ft), nt.removeEventListener("sessionend", pt), mt.stop();
		};
		function rt(e) {
			e.preventDefault(), re("WebGLRenderer: Context Lost."), ie = !0;
		}
		function it() {
			re("WebGLRenderer: Context Restored."), ie = !1;
			let e = Pe.autoReset, t = We.enabled, n = We.autoUpdate, r = We.needsUpdate, i = We.type;
			tt(), Pe.autoReset = e, We.enabled = t, We.autoUpdate = n, We.needsUpdate = r, We.type = i;
		}
		function at(e) {
			R("WebGLRenderer: A WebGL context could not be created. Reason: ", e.statusMessage);
		}
		function ot(e) {
			let t = e.target;
			t.removeEventListener("dispose", ot), st(t);
		}
		function st(e) {
			ct(e), J.remove(e);
		}
		function ct(e) {
			let t = J.get(e).programs;
			t !== void 0 && (t.forEach(function(e) {
				ze.releaseProgram(e);
			}), e.isShaderMaterial && ze.releaseShaderCache(e));
		}
		this.renderBufferDirect = function(e, t, n, r, i, a) {
			t === null && (t = H);
			let o = i.isMesh && i.matrixWorld.determinantAffine() < 0, s = wt(e, t, n, r, i);
			q.setMaterial(r, o);
			let c = n.index, l = 1;
			if (r.wireframe === !0) {
				if (c = Le.getWireframeAttribute(n), c === void 0) return;
				l = 2;
			}
			let u = n.drawRange, d = n.attributes.position, f = u.start * l, p = (u.start + u.count) * l;
			a !== null && (f = Math.max(f, a.start * l), p = Math.min(p, (a.start + a.count) * l)), c === null ? d != null && (f = Math.max(f, 0), p = Math.min(p, d.count)) : (f = Math.max(f, 0), p = Math.min(p, c.count));
			let m = p - f;
			if (m < 0 || m === Infinity) return;
			$e.setup(i, r, s, n, c);
			let h, g = Ye;
			if (c !== null && (h = Ie.get(c), g = Ze, g.setIndex(h)), i.isMesh) r.wireframe === !0 ? (q.setLineWidth(r.wireframeLinewidth * U()), g.setMode(W.LINES)) : g.setMode(W.TRIANGLES);
			else if (i.isLine) {
				let e = r.linewidth;
				e === void 0 && (e = 1), q.setLineWidth(e * U()), i.isLineSegments ? g.setMode(W.LINES) : i.isLineLoop ? g.setMode(W.LINE_LOOP) : g.setMode(W.LINE_STRIP);
			} else i.isPoints ? g.setMode(W.POINTS) : i.isSprite && g.setMode(W.TRIANGLES);
			if (i.isBatchedMesh) if (Ne.get("WEBGL_multi_draw")) g.renderMultiDraw(i._multiDrawStarts, i._multiDrawCounts, i._multiDrawCount);
			else {
				let e = i._multiDrawStarts, t = i._multiDrawCounts, n = i._multiDrawCount, a = c ? Ie.get(c).bytesPerElement : 1, o = J.get(r).currentProgram.getUniforms();
				for (let r = 0; r < n; r++) o.setValue(W, "_gl_DrawID", r), g.render(e[r] / a, t[r]);
			}
			else if (i.isInstancedMesh) g.renderInstances(f, m, i.count);
			else if (n.isInstancedBufferGeometry) {
				let e = n._maxInstanceCount === void 0 ? Infinity : n._maxInstanceCount, t = Math.min(n.instanceCount, e);
				g.renderInstances(f, m, t);
			} else g.render(f, m);
		};
		function lt(e, t, n) {
			e.transparent === !0 && e.side === 2 && e.forceSinglePass === !1 ? (e.side = 1, e.needsUpdate = !0, bt(e, t, n), e.side = 0, e.needsUpdate = !0, bt(e, t, n), e.side = 2) : bt(e, t, n);
		}
		this.compile = function(e, t, n = null) {
			n === null && (n = e), N = He.get(n), N.init(t), F.push(N), n.traverseVisible(function(e) {
				e.isLight && e.layers.test(t.layers) && (N.pushLight(e), e.castShadow && N.pushShadow(e));
			}), e !== n && e.traverseVisible(function(e) {
				e.isLight && e.layers.test(t.layers) && (N.pushLight(e), e.castShadow && N.pushShadow(e));
			}), N.setupLights();
			let r = /* @__PURE__ */ new Set();
			return e.traverse(function(e) {
				if (!(e.isMesh || e.isPoints || e.isLine || e.isSprite)) return;
				let t = e.material;
				if (t) if (Array.isArray(t)) for (let i = 0; i < t.length; i++) {
					let a = t[i];
					lt(a, n, e), r.add(a);
				}
				else lt(t, n, e), r.add(t);
			}), N = F.pop(), r;
		}, this.compileAsync = function(e, t, n = null) {
			let r = this.compile(e, t, n);
			return new Promise((t) => {
				function n() {
					if (r.forEach(function(e) {
						J.get(e).currentProgram.isReady() && r.delete(e);
					}), r.size === 0) {
						t(e);
						return;
					}
					setTimeout(n, 10);
				}
				Ne.get("KHR_parallel_shader_compile") === null ? setTimeout(n, 10) : n();
			});
		};
		let ut = null;
		function dt(e) {
			ut && ut(e);
		}
		function ft() {
			mt.stop();
		}
		function pt() {
			mt.start();
		}
		let mt = new bo();
		mt.setAnimationLoop(dt), typeof self < "u" && mt.setContext(self), this.setAnimationLoop = function(e) {
			ut = e, nt.setAnimationLoop(e), e === null ? mt.stop() : mt.start();
		}, nt.addEventListener("sessionstart", ft), nt.addEventListener("sessionend", pt), this.render = function(e, t) {
			if (t !== void 0 && t.isCamera !== !0) {
				R("WebGLRenderer.render: camera is not an instance of THREE.Camera.");
				return;
			}
			if (ie === !0) return;
			ae !== null && ae.renderStart(e, t);
			let n = nt.enabled === !0 && nt.isPresenting === !0, r = te !== null && (z === null || n) && te.begin(I, z);
			if (e.matrixWorldAutoUpdate === !0 && e.updateMatrixWorld(), t.parent === null && t.matrixWorldAutoUpdate === !0 && t.updateMatrixWorld(), nt.enabled === !0 && nt.isPresenting === !0 && (te === null || te.isCompositing() === !1) && (nt.cameraAutoUpdate === !0 && nt.updateCamera(t), t = nt.getCamera()), e.isScene === !0 && e.onBeforeRender(I, e, t, z), N = He.get(e, F.length), N.init(t), N.state.textureUnits = Y.getTextureUnits(), F.push(N), Oe.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), Te.setFromProjectionMatrix(Oe, ee, t.reversedDepth), De = this.localClippingEnabled, Ee = Ue.init(this.clippingPlanes, De), M = Ve.get(e, P.length), M.init(), P.push(M), nt.enabled === !0 && nt.isPresenting === !0) {
				let e = I.xr.getDepthSensingMesh();
				e !== null && ht(e, t, -Infinity, I.sortObjects);
			}
			ht(e, t, 0, I.sortObjects), M.finish(), I.sortObjects === !0 && M.sort(be, xe, t.reversedDepth), je = nt.enabled === !1 || nt.isPresenting === !1 || nt.hasDepthSensing() === !1, je && Ke.addToRenderList(M, e), this.info.render.frame++, this.info.autoReset === !0 && this.info.reset(), Ee === !0 && Ue.beginShadows();
			let i = N.state.shadowsArray;
			if (We.render(i, e, t), Ee === !0 && Ue.endShadows(), (r && te.hasRenderPass()) === !1) {
				let n = M.opaque, r = M.transmissive;
				if (N.setupLights(), t.isArrayCamera) {
					let i = t.cameras;
					if (r.length > 0) for (let t = 0, a = i.length; t < a; t++) {
						let a = i[t];
						_t(n, r, e, a);
					}
					je && Ke.render(e);
					for (let t = 0, n = i.length; t < n; t++) {
						let n = i[t];
						gt(M, e, n, n.viewport);
					}
				} else r.length > 0 && _t(n, r, e, t), je && Ke.render(e), gt(M, e, t);
			}
			z !== null && de === 0 && (Y.updateMultisampleRenderTarget(z), Y.updateRenderTargetMipmap(z)), r && te.end(I), e.isScene === !0 && e.onAfterRender(I, e, t), $e.resetDefaultState(), B = -1, V = null, F.pop(), F.length > 0 ? (N = F[F.length - 1], Y.setTextureUnits(N.state.textureUnits), Ee === !0 && Ue.setGlobalState(I.clippingPlanes, N.state.camera)) : N = null, P.pop(), M = P.length > 0 ? P[P.length - 1] : null, ae !== null && ae.renderEnd();
		};
		function ht(e, t, n, r) {
			if (e.visible === !1) return;
			if (e.layers.test(t.layers)) {
				if (e.isGroup) n = e.renderOrder;
				else if (e.isLOD) e.autoUpdate === !0 && e.update(t);
				else if (e.isLightProbeGrid) N.pushLightProbeGrid(e);
				else if (e.isLight) N.pushLight(e), e.castShadow && N.pushShadow(e);
				else if (e.isSprite) {
					if (!e.frustumCulled || Te.intersectsSprite(e)) {
						r && Ae.setFromMatrixPosition(e.matrixWorld).applyMatrix4(Oe);
						let t = Re.update(e), i = e.material;
						i.visible && M.push(e, t, i, n, Ae.z, null);
					}
				} else if ((e.isMesh || e.isLine || e.isPoints) && (!e.frustumCulled || Te.intersectsObject(e))) {
					let t = Re.update(e), i = e.material;
					if (r && (e.boundingSphere === void 0 ? (t.boundingSphere === null && t.computeBoundingSphere(), Ae.copy(t.boundingSphere.center)) : (e.boundingSphere === null && e.computeBoundingSphere(), Ae.copy(e.boundingSphere.center)), Ae.applyMatrix4(e.matrixWorld).applyMatrix4(Oe)), Array.isArray(i)) {
						let r = t.groups;
						for (let a = 0, o = r.length; a < o; a++) {
							let o = r[a], s = i[o.materialIndex];
							s && s.visible && M.push(e, t, s, n, Ae.z, o);
						}
					} else i.visible && M.push(e, t, i, n, Ae.z, null);
				}
			}
			let i = e.children;
			for (let e = 0, a = i.length; e < a; e++) ht(i[e], t, n, r);
		}
		function gt(e, t, n, r) {
			let { opaque: i, transmissive: a, transparent: o } = e;
			N.setupLightsView(n), Ee === !0 && Ue.setGlobalState(I.clippingPlanes, n), r && q.viewport(fe.copy(r)), i.length > 0 && vt(i, t, n), a.length > 0 && vt(a, t, n), o.length > 0 && vt(o, t, n), q.buffers.depth.setTest(!0), q.buffers.depth.setMask(!0), q.buffers.color.setMask(!0), q.setPolygonOffset(!1);
		}
		function _t(e, t, n, r) {
			if ((n.isScene === !0 ? n.overrideMaterial : null) !== null) return;
			if (N.state.transmissionRenderTarget[r.id] === void 0) {
				let e = Ne.has("EXT_color_buffer_half_float") || Ne.has("EXT_color_buffer_float");
				N.state.transmissionRenderTarget[r.id] = new qe(1, 1, {
					generateMipmaps: !0,
					type: e ? u : o,
					minFilter: a,
					samples: Math.max(4, K.samples),
					stencilBuffer: i,
					resolveDepthBuffer: !1,
					resolveStencilBuffer: !1,
					colorSpace: X.workingColorSpace
				});
			}
			let s = N.state.transmissionRenderTarget[r.id], c = r.viewport || fe;
			s.setSize(c.z * I.transmissionResolutionScale, c.w * I.transmissionResolutionScale);
			let l = I.getRenderTarget(), d = I.getActiveCubeFace(), f = I.getActiveMipmapLevel();
			I.setRenderTarget(s), I.getClearColor(he), ge = I.getClearAlpha(), ge < 1 && I.setClearColor(16777215, .5), I.clear(), je && Ke.render(n);
			let p = I.toneMapping;
			I.toneMapping = 0;
			let m = r.viewport;
			if (r.viewport !== void 0 && (r.viewport = void 0), N.setupLightsView(r), Ee === !0 && Ue.setGlobalState(I.clippingPlanes, r), vt(e, n, r), Y.updateMultisampleRenderTarget(s), Y.updateRenderTargetMipmap(s), Ne.has("WEBGL_multisampled_render_to_texture") === !1) {
				let e = !1;
				for (let i = 0, a = t.length; i < a; i++) {
					let { object: a, geometry: o, material: s, group: c } = t[i];
					if (s.side === 2 && a.layers.test(r.layers)) {
						let t = s.side;
						s.side = 1, s.needsUpdate = !0, yt(a, n, r, o, s, c), s.side = t, s.needsUpdate = !0, e = !0;
					}
				}
				e === !0 && (Y.updateMultisampleRenderTarget(s), Y.updateRenderTargetMipmap(s));
			}
			I.setRenderTarget(l, d, f), I.setClearColor(he, ge), m !== void 0 && (r.viewport = m), I.toneMapping = p;
		}
		function vt(e, t, n) {
			let r = t.isScene === !0 ? t.overrideMaterial : null;
			for (let i = 0, a = e.length; i < a; i++) {
				let a = e[i], { object: o, geometry: s, group: c } = a, l = a.material;
				l.allowOverride === !0 && r !== null && (l = r), o.layers.test(n.layers) && yt(o, t, n, s, l, c);
			}
		}
		function yt(e, t, n, r, i, a) {
			e.onBeforeRender(I, t, n, r, i, a), e.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, e.matrixWorld), e.normalMatrix.getNormalMatrix(e.modelViewMatrix), i.onBeforeRender(I, t, n, r, e, a), i.transparent === !0 && i.side === 2 && i.forceSinglePass === !1 ? (i.side = 1, i.needsUpdate = !0, I.renderBufferDirect(n, t, r, i, e, a), i.side = 0, i.needsUpdate = !0, I.renderBufferDirect(n, t, r, i, e, a), i.side = 2) : I.renderBufferDirect(n, t, r, i, e, a), e.onAfterRender(I, t, n, r, i, a);
		}
		function bt(e, t, n) {
			t.isScene !== !0 && (t = H);
			let r = J.get(e), i = N.state.lights, a = N.state.shadowsArray, o = i.state.version, s = ze.getParameters(e, i.state, a, t, n, N.state.lightProbeGridArray), c = ze.getProgramCacheKey(s), l = r.programs;
			r.environment = e.isMeshStandardMaterial || e.isMeshLambertMaterial || e.isMeshPhongMaterial ? t.environment : null, r.fog = t.fog;
			let u = e.isMeshStandardMaterial || e.isMeshLambertMaterial && !e.envMap || e.isMeshPhongMaterial && !e.envMap;
			r.envMap = Fe.get(e.envMap || r.environment, u), r.envMapRotation = r.environment !== null && e.envMap === null ? t.environmentRotation : e.envMapRotation, l === void 0 && (e.addEventListener("dispose", ot), l = /* @__PURE__ */ new Map(), r.programs = l);
			let d = l.get(c);
			if (d !== void 0) {
				if (r.currentProgram === d && r.lightsStateVersion === o) return St(e, s), d;
			} else s.uniforms = ze.getUniforms(e), ae !== null && e.isNodeMaterial && ae.build(e, n, s), e.onBeforeCompile(s, I), d = ze.acquireProgram(s, c), l.set(c, d), r.uniforms = s.uniforms;
			let f = r.uniforms;
			return (!e.isShaderMaterial && !e.isRawShaderMaterial || e.clipping === !0) && (f.clippingPlanes = Ue.uniform), St(e, s), r.needsLights = Et(e), r.lightsStateVersion = o, r.needsLights && (f.ambientLightColor.value = i.state.ambient, f.lightProbe.value = i.state.probe, f.directionalLights.value = i.state.directional, f.directionalLightShadows.value = i.state.directionalShadow, f.spotLights.value = i.state.spot, f.spotLightShadows.value = i.state.spotShadow, f.rectAreaLights.value = i.state.rectArea, f.ltc_1.value = i.state.rectAreaLTC1, f.ltc_2.value = i.state.rectAreaLTC2, f.pointLights.value = i.state.point, f.pointLightShadows.value = i.state.pointShadow, f.hemisphereLights.value = i.state.hemi, f.directionalShadowMatrix.value = i.state.directionalShadowMatrix, f.spotLightMatrix.value = i.state.spotLightMatrix, f.spotLightMap.value = i.state.spotLightMap, f.pointShadowMatrix.value = i.state.pointShadowMatrix), r.lightProbeGrid = N.state.lightProbeGridArray.length > 0, r.currentProgram = d, r.uniformsList = null, d;
		}
		function xt(e) {
			if (e.uniformsList === null) {
				let t = e.currentProgram.getUniforms();
				e.uniformsList = pc.seqWithValue(t.seq, e.uniforms);
			}
			return e.uniformsList;
		}
		function St(e, t) {
			let n = J.get(e);
			n.outputColorSpace = t.outputColorSpace, n.batching = t.batching, n.batchingColor = t.batchingColor, n.instancing = t.instancing, n.instancingColor = t.instancingColor, n.instancingMorph = t.instancingMorph, n.skinning = t.skinning, n.morphTargets = t.morphTargets, n.morphNormals = t.morphNormals, n.morphColors = t.morphColors, n.morphTargetsCount = t.morphTargetsCount, n.numClippingPlanes = t.numClippingPlanes, n.numIntersection = t.numClipIntersection, n.vertexAlphas = t.vertexAlphas, n.vertexTangents = t.vertexTangents, n.toneMapping = t.toneMapping;
		}
		function Ct(e, t) {
			if (e.length === 0) return null;
			if (e.length === 1) return e[0].texture === null ? null : e[0];
			j.setFromMatrixPosition(t.matrixWorld);
			for (let t = 0, n = e.length; t < n; t++) {
				let n = e[t];
				if (n.texture !== null && n.boundingBox.containsPoint(j)) return n;
			}
			return null;
		}
		function wt(e, t, n, r, i) {
			t.isScene !== !0 && (t = H), Y.resetTextureUnits();
			let a = t.fog, o = r.isMeshStandardMaterial || r.isMeshLambertMaterial || r.isMeshPhongMaterial ? t.environment : null, s = z === null ? I.outputColorSpace : z.isXRRenderTarget === !0 ? z.texture.colorSpace : X.workingColorSpace, c = r.isMeshStandardMaterial || r.isMeshLambertMaterial && !r.envMap || r.isMeshPhongMaterial && !r.envMap, l = Fe.get(r.envMap || o, c), u = r.vertexColors === !0 && !!n.attributes.color && n.attributes.color.itemSize === 4, d = !!n.attributes.tangent && (!!r.normalMap || r.anisotropy > 0), f = !!n.morphAttributes.position, p = !!n.morphAttributes.normal, m = !!n.morphAttributes.color, h = 0;
			r.toneMapped && (z === null || z.isXRRenderTarget === !0) && (h = I.toneMapping);
			let g = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color, _ = g === void 0 ? 0 : g.length, v = J.get(r), y = N.state.lights;
			if (Ee === !0 && (De === !0 || e !== V)) {
				let t = e === V && r.id === B;
				Ue.setState(r, e, t);
			}
			let b = !1;
			r.version === v.__version ? v.needsLights && v.lightsStateVersion !== y.state.version ? b = !0 : v.outputColorSpace === s ? i.isBatchedMesh && v.batching === !1 || !i.isBatchedMesh && v.batching === !0 || i.isBatchedMesh && v.batchingColor === !0 && i.colorTexture === null || i.isBatchedMesh && v.batchingColor === !1 && i.colorTexture !== null || i.isInstancedMesh && v.instancing === !1 || !i.isInstancedMesh && v.instancing === !0 || i.isSkinnedMesh && v.skinning === !1 || !i.isSkinnedMesh && v.skinning === !0 || i.isInstancedMesh && v.instancingColor === !0 && i.instanceColor === null || i.isInstancedMesh && v.instancingColor === !1 && i.instanceColor !== null || i.isInstancedMesh && v.instancingMorph === !0 && i.morphTexture === null || i.isInstancedMesh && v.instancingMorph === !1 && i.morphTexture !== null ? b = !0 : v.envMap === l ? r.fog === !0 && v.fog !== a || v.numClippingPlanes !== void 0 && (v.numClippingPlanes !== Ue.numPlanes || v.numIntersection !== Ue.numIntersection) ? b = !0 : v.vertexAlphas === u && v.vertexTangents === d && v.morphTargets === f && v.morphNormals === p && v.morphColors === m && v.toneMapping === h && v.morphTargetsCount === _ ? !!v.lightProbeGrid != N.state.lightProbeGridArray.length > 0 && (b = !0) : b = !0 : b = !0 : b = !0 : (b = !0, v.__version = r.version);
			let x = v.currentProgram;
			b === !0 && (x = bt(r, t, i), ae && r.isNodeMaterial && ae.onUpdateProgram(r, x, v));
			let S = !1, C = !1, w = !1, T = x.getUniforms(), E = v.uniforms;
			if (q.useProgram(x.program) && (S = !0, C = !0, w = !0), r.id !== B && (B = r.id, C = !0), v.needsLights) {
				let e = Ct(N.state.lightProbeGridArray, i);
				v.lightProbeGrid !== e && (v.lightProbeGrid = e, C = !0);
			}
			if (S || V !== e) {
				q.buffers.depth.getReversed() && e.reversedDepth !== !0 && (e._reversedDepth = !0, e.updateProjectionMatrix()), T.setValue(W, "projectionMatrix", e.projectionMatrix), T.setValue(W, "viewMatrix", e.matrixWorldInverse);
				let t = T.map.cameraPosition;
				t !== void 0 && t.setValue(W, ke.setFromMatrixPosition(e.matrixWorld)), K.logarithmicDepthBuffer && T.setValue(W, "logDepthBufFC", 2 / (Math.log(e.far + 1) / Math.LN2)), (r.isMeshPhongMaterial || r.isMeshToonMaterial || r.isMeshLambertMaterial || r.isMeshBasicMaterial || r.isMeshStandardMaterial || r.isShaderMaterial) && T.setValue(W, "isOrthographic", e.isOrthographicCamera === !0), V !== e && (V = e, C = !0, w = !0);
			}
			if (v.needsLights && (y.state.directionalShadowMap.length > 0 && T.setValue(W, "directionalShadowMap", y.state.directionalShadowMap, Y), y.state.spotShadowMap.length > 0 && T.setValue(W, "spotShadowMap", y.state.spotShadowMap, Y), y.state.pointShadowMap.length > 0 && T.setValue(W, "pointShadowMap", y.state.pointShadowMap, Y)), i.isSkinnedMesh) {
				T.setOptional(W, i, "bindMatrix"), T.setOptional(W, i, "bindMatrixInverse");
				let e = i.skeleton;
				e && (e.boneTexture === null && e.computeBoneTexture(), T.setValue(W, "boneTexture", e.boneTexture, Y));
			}
			i.isBatchedMesh && (T.setOptional(W, i, "batchingTexture"), T.setValue(W, "batchingTexture", i._matricesTexture, Y), T.setOptional(W, i, "batchingIdTexture"), T.setValue(W, "batchingIdTexture", i._indirectTexture, Y), T.setOptional(W, i, "batchingColorTexture"), i._colorsTexture !== null && T.setValue(W, "batchingColorTexture", i._colorsTexture, Y));
			let D = n.morphAttributes;
			if ((D.position !== void 0 || D.normal !== void 0 || D.color !== void 0) && Je.update(i, n, x), (C || v.receiveShadow !== i.receiveShadow) && (v.receiveShadow = i.receiveShadow, T.setValue(W, "receiveShadow", i.receiveShadow)), (r.isMeshStandardMaterial || r.isMeshLambertMaterial || r.isMeshPhongMaterial) && r.envMap === null && t.environment !== null && (E.envMapIntensity.value = t.environmentIntensity), E.dfgLUT !== void 0 && (E.dfgLUT.value = Pl()), C) {
				if (T.setValue(W, "toneMappingExposure", I.toneMappingExposure), v.needsLights && Tt(E, w), a && r.fog === !0 && Be.refreshFogUniforms(E, a), Be.refreshMaterialUniforms(E, r, ye, ve, N.state.transmissionRenderTarget[e.id]), v.needsLights && v.lightProbeGrid) {
					let e = v.lightProbeGrid;
					E.probesSH.value = e.texture, E.probesMin.value.copy(e.boundingBox.min), E.probesMax.value.copy(e.boundingBox.max), E.probesResolution.value.copy(e.resolution);
				}
				pc.upload(W, xt(v), E, Y);
			}
			if (r.isShaderMaterial && r.uniformsNeedUpdate === !0 && (pc.upload(W, xt(v), E, Y), r.uniformsNeedUpdate = !1), r.isSpriteMaterial && T.setValue(W, "center", i.center), T.setValue(W, "modelViewMatrix", i.modelViewMatrix), T.setValue(W, "normalMatrix", i.normalMatrix), T.setValue(W, "modelMatrix", i.matrixWorld), r.uniformsGroups !== void 0) {
				let e = r.uniformsGroups;
				for (let t = 0, n = e.length; t < n; t++) {
					let n = e[t];
					et.update(n, x), et.bind(n, x);
				}
			}
			return x;
		}
		function Tt(e, t) {
			e.ambientLightColor.needsUpdate = t, e.lightProbe.needsUpdate = t, e.directionalLights.needsUpdate = t, e.directionalLightShadows.needsUpdate = t, e.pointLights.needsUpdate = t, e.pointLightShadows.needsUpdate = t, e.spotLights.needsUpdate = t, e.spotLightShadows.needsUpdate = t, e.rectAreaLights.needsUpdate = t, e.hemisphereLights.needsUpdate = t;
		}
		function Et(e) {
			return e.isMeshLambertMaterial || e.isMeshToonMaterial || e.isMeshPhongMaterial || e.isMeshStandardMaterial || e.isShadowMaterial || e.isShaderMaterial && e.lights === !0;
		}
		this.getActiveCubeFace = function() {
			return ue;
		}, this.getActiveMipmapLevel = function() {
			return de;
		}, this.getRenderTarget = function() {
			return z;
		}, this.setRenderTargetTextures = function(e, t, n) {
			let r = J.get(e);
			r.__autoAllocateDepthBuffer = e.resolveDepthBuffer === !1, r.__autoAllocateDepthBuffer === !1 && (r.__useRenderToTexture = !1), J.get(e.texture).__webglTexture = t, J.get(e.depthTexture).__webglTexture = r.__autoAllocateDepthBuffer ? void 0 : n, r.__hasExternalTextures = !0;
		}, this.setRenderTargetFramebuffer = function(e, t) {
			let n = J.get(e);
			n.__webglFramebuffer = t, n.__useDefaultFramebuffer = t === void 0;
		}, this.setRenderTarget = function(e, t = 0, n = 0) {
			z = e, ue = t, de = n;
			let r = null, i = !1, a = !1;
			if (e) {
				let o = J.get(e);
				if (o.__useDefaultFramebuffer !== void 0) {
					q.bindFramebuffer(W.FRAMEBUFFER, o.__webglFramebuffer), fe.copy(e.viewport), pe.copy(e.scissor), me = e.scissorTest, q.viewport(fe), q.scissor(pe), q.setScissorTest(me), B = -1;
					return;
				} else if (o.__webglFramebuffer === void 0) Y.setupRenderTarget(e);
				else if (o.__hasExternalTextures) Y.rebindTextures(e, J.get(e.texture).__webglTexture, J.get(e.depthTexture).__webglTexture);
				else if (e.depthBuffer) {
					let t = e.depthTexture;
					if (o.__boundDepthTexture !== t) {
						if (t !== null && J.has(t) && (e.width !== t.image.width || e.height !== t.image.height)) throw Error("THREE.WebGLRenderer: Attached DepthTexture is initialized to the incorrect size.");
						Y.setupDepthRenderbuffer(e);
					}
				}
				let s = e.texture;
				(s.isData3DTexture || s.isDataArrayTexture || s.isCompressedArrayTexture) && (a = !0);
				let c = J.get(e).__webglFramebuffer;
				e.isWebGLCubeRenderTarget ? (r = Array.isArray(c[t]) ? c[t][n] : c[t], i = !0) : r = e.samples > 0 && Y.useMultisampledRTT(e) === !1 ? J.get(e).__webglMultisampledFramebuffer : Array.isArray(c) ? c[n] : c, fe.copy(e.viewport), pe.copy(e.scissor), me = e.scissorTest;
			} else fe.copy(Se).multiplyScalar(ye).floor(), pe.copy(Ce).multiplyScalar(ye).floor(), me = we;
			if (n !== 0 && (r = se), q.bindFramebuffer(W.FRAMEBUFFER, r) && q.drawBuffers(e, r), q.viewport(fe), q.scissor(pe), q.setScissorTest(me), i) {
				let r = J.get(e.texture);
				W.framebufferTexture2D(W.FRAMEBUFFER, W.COLOR_ATTACHMENT0, W.TEXTURE_CUBE_MAP_POSITIVE_X + t, r.__webglTexture, n);
			} else if (a) {
				let r = t;
				for (let t = 0; t < e.textures.length; t++) {
					let i = J.get(e.textures[t]);
					W.framebufferTextureLayer(W.FRAMEBUFFER, W.COLOR_ATTACHMENT0 + t, i.__webglTexture, n, r);
				}
			} else if (e !== null && n !== 0) {
				let t = J.get(e.texture);
				W.framebufferTexture2D(W.FRAMEBUFFER, W.COLOR_ATTACHMENT0, W.TEXTURE_2D, t.__webglTexture, n);
			}
			B = -1;
		}, this.readRenderTargetPixels = function(e, t, n, r, i, a, o, s = 0) {
			if (!(e && e.isWebGLRenderTarget)) {
				R("WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
				return;
			}
			let c = J.get(e).__webglFramebuffer;
			if (e.isWebGLCubeRenderTarget && o !== void 0 && (c = c[o]), c) {
				q.bindFramebuffer(W.FRAMEBUFFER, c);
				try {
					let o = e.textures[s], c = o.format, l = o.type;
					if (e.textures.length > 1 && W.readBuffer(W.COLOR_ATTACHMENT0 + s), !K.textureFormatReadable(c)) {
						R("WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
						return;
					}
					if (!K.textureTypeReadable(l)) {
						R("WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
						return;
					}
					t >= 0 && t <= e.width - r && n >= 0 && n <= e.height - i && W.readPixels(t, n, r, i, Qe.convert(c), Qe.convert(l), a);
				} finally {
					let e = z === null ? null : J.get(z).__webglFramebuffer;
					q.bindFramebuffer(W.FRAMEBUFFER, e);
				}
			}
		}, this.readRenderTargetPixelsAsync = async function(e, t, n, r, i, a, o, s = 0) {
			if (!(e && e.isWebGLRenderTarget)) throw Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
			let c = J.get(e).__webglFramebuffer;
			if (e.isWebGLCubeRenderTarget && o !== void 0 && (c = c[o]), c) if (t >= 0 && t <= e.width - r && n >= 0 && n <= e.height - i) {
				q.bindFramebuffer(W.FRAMEBUFFER, c);
				let o = e.textures[s], l = o.format, u = o.type;
				if (e.textures.length > 1 && W.readBuffer(W.COLOR_ATTACHMENT0 + s), !K.textureFormatReadable(l)) throw Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
				if (!K.textureTypeReadable(u)) throw Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
				let d = W.createBuffer();
				W.bindBuffer(W.PIXEL_PACK_BUFFER, d), W.bufferData(W.PIXEL_PACK_BUFFER, a.byteLength, W.STREAM_READ), W.readPixels(t, n, r, i, Qe.convert(l), Qe.convert(u), 0);
				let f = z === null ? null : J.get(z).__webglFramebuffer;
				q.bindFramebuffer(W.FRAMEBUFFER, f);
				let p = W.fenceSync(W.SYNC_GPU_COMMANDS_COMPLETE, 0);
				return W.flush(), await oe(W, p, 4), W.bindBuffer(W.PIXEL_PACK_BUFFER, d), W.getBufferSubData(W.PIXEL_PACK_BUFFER, 0, a), W.deleteBuffer(d), W.deleteSync(p), a;
			} else throw Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
		}, this.copyFramebufferToTexture = function(e, t = null, n = 0) {
			let r = 2 ** -n, i = Math.floor(e.image.width * r), a = Math.floor(e.image.height * r), o = t === null ? 0 : t.x, s = t === null ? 0 : t.y;
			Y.setTexture2D(e, 0), W.copyTexSubImage2D(W.TEXTURE_2D, n, 0, 0, o, s, i, a), q.unbindTexture();
		}, this.copyTextureToTexture = function(e, t, n = null, r = null, i = 0, a = 0) {
			let o, s, c, l, u, d, f, p, m, h = e.isCompressedTexture ? e.mipmaps[a] : e.image;
			if (n !== null) o = n.max.x - n.min.x, s = n.max.y - n.min.y, c = n.isBox3 ? n.max.z - n.min.z : 1, l = n.min.x, u = n.min.y, d = n.isBox3 ? n.min.z : 0;
			else {
				let t = 2 ** -i;
				o = Math.floor(h.width * t), s = Math.floor(h.height * t), c = e.isDataArrayTexture ? h.depth : e.isData3DTexture ? Math.floor(h.depth * t) : 1, l = 0, u = 0, d = 0;
			}
			r === null ? (f = 0, p = 0, m = 0) : (f = r.x, p = r.y, m = r.z);
			let g = Qe.convert(t.format), _ = Qe.convert(t.type), v;
			t.isData3DTexture ? (Y.setTexture3D(t, 0), v = W.TEXTURE_3D) : t.isDataArrayTexture || t.isCompressedArrayTexture ? (Y.setTexture2DArray(t, 0), v = W.TEXTURE_2D_ARRAY) : (Y.setTexture2D(t, 0), v = W.TEXTURE_2D), q.activeTexture(W.TEXTURE0), q.pixelStorei(W.UNPACK_FLIP_Y_WEBGL, t.flipY), q.pixelStorei(W.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), q.pixelStorei(W.UNPACK_ALIGNMENT, t.unpackAlignment);
			let y = q.getParameter(W.UNPACK_ROW_LENGTH), b = q.getParameter(W.UNPACK_IMAGE_HEIGHT), x = q.getParameter(W.UNPACK_SKIP_PIXELS), S = q.getParameter(W.UNPACK_SKIP_ROWS), C = q.getParameter(W.UNPACK_SKIP_IMAGES);
			q.pixelStorei(W.UNPACK_ROW_LENGTH, h.width), q.pixelStorei(W.UNPACK_IMAGE_HEIGHT, h.height), q.pixelStorei(W.UNPACK_SKIP_PIXELS, l), q.pixelStorei(W.UNPACK_SKIP_ROWS, u), q.pixelStorei(W.UNPACK_SKIP_IMAGES, d);
			let w = e.isDataArrayTexture || e.isData3DTexture, T = t.isDataArrayTexture || t.isData3DTexture;
			if (e.isDepthTexture) {
				let n = J.get(e), r = J.get(t), h = J.get(n.__renderTarget), g = J.get(r.__renderTarget);
				q.bindFramebuffer(W.READ_FRAMEBUFFER, h.__webglFramebuffer), q.bindFramebuffer(W.DRAW_FRAMEBUFFER, g.__webglFramebuffer);
				for (let n = 0; n < c; n++) w && (W.framebufferTextureLayer(W.READ_FRAMEBUFFER, W.COLOR_ATTACHMENT0, J.get(e).__webglTexture, i, d + n), W.framebufferTextureLayer(W.DRAW_FRAMEBUFFER, W.COLOR_ATTACHMENT0, J.get(t).__webglTexture, a, m + n)), W.blitFramebuffer(l, u, o, s, f, p, o, s, W.DEPTH_BUFFER_BIT, W.NEAREST);
				q.bindFramebuffer(W.READ_FRAMEBUFFER, null), q.bindFramebuffer(W.DRAW_FRAMEBUFFER, null);
			} else if (i !== 0 || e.isRenderTargetTexture || J.has(e)) {
				let n = J.get(e), r = J.get(t);
				q.bindFramebuffer(W.READ_FRAMEBUFFER, ce), q.bindFramebuffer(W.DRAW_FRAMEBUFFER, le);
				for (let e = 0; e < c; e++) w ? W.framebufferTextureLayer(W.READ_FRAMEBUFFER, W.COLOR_ATTACHMENT0, n.__webglTexture, i, d + e) : W.framebufferTexture2D(W.READ_FRAMEBUFFER, W.COLOR_ATTACHMENT0, W.TEXTURE_2D, n.__webglTexture, i), T ? W.framebufferTextureLayer(W.DRAW_FRAMEBUFFER, W.COLOR_ATTACHMENT0, r.__webglTexture, a, m + e) : W.framebufferTexture2D(W.DRAW_FRAMEBUFFER, W.COLOR_ATTACHMENT0, W.TEXTURE_2D, r.__webglTexture, a), i === 0 ? T ? W.copyTexSubImage3D(v, a, f, p, m + e, l, u, o, s) : W.copyTexSubImage2D(v, a, f, p, l, u, o, s) : W.blitFramebuffer(l, u, o, s, f, p, o, s, W.COLOR_BUFFER_BIT, W.NEAREST);
				q.bindFramebuffer(W.READ_FRAMEBUFFER, null), q.bindFramebuffer(W.DRAW_FRAMEBUFFER, null);
			} else T ? e.isDataTexture || e.isData3DTexture ? W.texSubImage3D(v, a, f, p, m, o, s, c, g, _, h.data) : t.isCompressedArrayTexture ? W.compressedTexSubImage3D(v, a, f, p, m, o, s, c, g, h.data) : W.texSubImage3D(v, a, f, p, m, o, s, c, g, _, h) : e.isDataTexture ? W.texSubImage2D(W.TEXTURE_2D, a, f, p, o, s, g, _, h.data) : e.isCompressedTexture ? W.compressedTexSubImage2D(W.TEXTURE_2D, a, f, p, h.width, h.height, g, h.data) : W.texSubImage2D(W.TEXTURE_2D, a, f, p, o, s, g, _, h);
			q.pixelStorei(W.UNPACK_ROW_LENGTH, y), q.pixelStorei(W.UNPACK_IMAGE_HEIGHT, b), q.pixelStorei(W.UNPACK_SKIP_PIXELS, x), q.pixelStorei(W.UNPACK_SKIP_ROWS, S), q.pixelStorei(W.UNPACK_SKIP_IMAGES, C), a === 0 && t.generateMipmaps && W.generateMipmap(v), q.unbindTexture();
		}, this.initRenderTarget = function(e) {
			J.get(e).__webglFramebuffer === void 0 && Y.setupRenderTarget(e);
		}, this.initTexture = function(e) {
			e.isCubeTexture ? Y.setTextureCube(e, 0) : e.isData3DTexture ? Y.setTexture3D(e, 0) : e.isDataArrayTexture || e.isCompressedArrayTexture ? Y.setTexture2DArray(e, 0) : Y.setTexture2D(e, 0), q.unbindTexture();
		}, this.resetState = function() {
			ue = 0, de = 0, z = null, q.reset(), $e.reset();
		}, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
	}
	get coordinateSystem() {
		return ee;
	}
	get outputColorSpace() {
		return this._outputColorSpace;
	}
	set outputColorSpace(e) {
		this._outputColorSpace = e;
		let t = this.getContext();
		t.drawingBufferColorSpace = X._getDrawingBufferColorSpace(e), t.unpackColorSpace = X._getUnpackColorSpace();
	}
}, Il = 744 / 1039, Ll = {
	base: "/card/card-base.jpg",
	holoMask: "/card/holo-mask.jpg",
	goldMask: "/card/gold-mask.jpg",
	foilPattern: "/card/foil-pattern.jpg?v=20260717-121856",
	holoShardId: "/card/holo-shard-id.png",
	holoShardIdDerived: "/card/holo-shard-id-derived.png",
	holoFacetNormal: "/card/holo-facet-normal.png",
	materialNoise: "/card/generated/material-noise.png",
	glossMask: null,
	roughness: null,
	normal: null,
	foilNoise: null,
	back: null
}, Rl = Object.freeze({
	maxTilt: 20,
	rotationSmoothing: 16,
	idleMovement: 1.5,
	holoIntensity: 1.5,
	holoSaturation: .96,
	holoContrast: 7.5,
	holoSharpness: 3.5,
	holoFragmentation: 0,
	holoScale: .97,
	holoLightIntensity: 1.9,
	facetNormalTilt: 28,
	holoBroadStrength: .75,
	holoSparkleStrength: 0,
	holoSparkleSharpness: 24,
	holoActiveFacetDensity: .05,
	holoSpectralScale: .7,
	holoTemporalVariation: 0,
	holoBasePreservation: 1,
	holoToneCompression: 1.07,
	holoArtBlendMode: 1,
	holoArtOpacity: 96,
	baseLightIntensity: 2,
	lightDispersion: 3,
	hoverLightContrast: 2.31,
	lightContrast: 1.59,
	goldTexture: 1,
	goldTextureOpacity: 1,
	goldTextureScale: 4,
	goldIntensity: 1.4,
	goldSharpness: 4,
	goldContrast: .91,
	goldEmbossDepth: .85,
	glossIntensity: 0,
	lightStrength: .25,
	shadowStrength: .1,
	cardThickness: .025,
	cameraPerspective: 46,
	debugView: 0
}), zl = "sacred-legacy-card:control-defaults:v1";
function Bl() {
	try {
		return window.localStorage;
	} catch {
		return null;
	}
}
function Vl(e) {
	return !e || typeof e != "object" ? {} : Object.fromEntries(Object.keys(Rl).filter((t) => Number.isFinite(e[t])).map((t) => [t, e[t]]));
}
function Hl() {
	let e = Bl();
	if (!e) return { ...Rl };
	try {
		let t = JSON.parse(e.getItem(zl));
		return {
			...Rl,
			...Vl(t)
		};
	} catch {
		return { ...Rl };
	}
}
var Ul = 4 * Il, Wl = .12;
function Gl() {
	let e = Ul / 2, t = Wl, n = new li();
	return n.moveTo(-e + t, -2), n.lineTo(e - t, -2), n.quadraticCurveTo(e, -2, e, -1.88), n.lineTo(e, 2 - t), n.quadraticCurveTo(e, 2, e - t, 2), n.lineTo(-e + t, 2), n.quadraticCurveTo(-e, 2, -e, 2 - t), n.lineTo(-e, -1.88), n.quadraticCurveTo(-e, -2, -e + t, -2), n;
}
function Kl(e) {
	let t = e.getAttribute("position"), n = new Float32Array(t.count * 2);
	for (let e = 0; e < t.count; e += 1) n[e * 2] = t.getX(e) / Ul + .5, n[e * 2 + 1] = t.getY(e) / 4 + .5;
	return e.setAttribute("uv", new fn(n, 2)), e;
}
function ql() {
	return Kl(new Zi(Gl(), 40));
}
function Jl(e) {
	let t = Math.min(.022, e * .32), n = new qi(Gl(), {
		depth: e,
		bevelEnabled: !0,
		bevelSegments: 5,
		bevelSize: t,
		bevelThickness: t,
		curveSegments: 40,
		steps: 1
	});
	return n.translate(0, 0, -e / 2), n;
}
//#endregion
//#region src/card/loadCardTextures.js
function Yl(e, t, n, r = 255) {
	let i = new vr(new Uint8Array([
		e,
		t,
		n,
		r
	]), 1, 1);
	return i.needsUpdate = !0, i;
}
function Xl(e, n = !1) {
	return e.flipY = !0, e.wrapS = t, e.wrapT = t, e.minFilter = a, e.magFilter = i, e.anisotropy = 4, n && (e.colorSpace = O), e;
}
function Zl(e) {
	return e.flipY = !0, e.wrapS = t, e.wrapT = t, e.minFilter = r, e.magFilter = r, e.generateMipmaps = !1, e.anisotropy = 1, e.colorSpace = "", e;
}
function Ql(e) {
	return e.flipY = !0, e.wrapS = t, e.wrapT = t, e.minFilter = r, e.magFilter = r, e.generateMipmaps = !1, e.anisotropy = 1, e.colorSpace = "", e;
}
function $l(t) {
	return t.flipY = !0, t.wrapS = e, t.wrapT = e, t.minFilter = a, t.magFilter = i, t.anisotropy = 2, t.colorSpace = "", t;
}
function eu() {
	let e = document.createElement("canvas");
	e.width = 512, e.height = 716;
	let t = e.getContext("2d"), n = t.createRadialGradient(256, 330, 30, 256, 358, 400);
	n.addColorStop(0, "#263563"), n.addColorStop(.48, "#101938"), n.addColorStop(1, "#060a18"), t.fillStyle = n, t.fillRect(0, 0, e.width, e.height);
	function r(e, n, r, i, a) {
		let o = e + r, s = n + i;
		t.beginPath(), t.moveTo(e + a, n), t.lineTo(o - a, n), t.quadraticCurveTo(o, n, o, n + a), t.lineTo(o, s - a), t.quadraticCurveTo(o, s, o - a, s), t.lineTo(e + a, s), t.quadraticCurveTo(e, s, e, s - a), t.lineTo(e, n + a), t.quadraticCurveTo(e, n, e + a, n), t.closePath();
	}
	t.strokeStyle = "rgba(222, 184, 79, 0.72)", t.lineWidth = 5, r(20, 20, 472, 676, 26), t.stroke(), t.lineWidth = 1.5, r(32, 32, 448, 652, 20), t.stroke(), t.save(), t.translate(256, 350), t.rotate(Math.PI / 4), t.strokeStyle = "rgba(222, 184, 79, 0.34)", t.lineWidth = 3, t.strokeRect(-104, -104, 208, 208), t.strokeRect(-76, -76, 152, 152), t.restore(), t.fillStyle = "#e4c46b", t.textAlign = "center", t.font = "600 31px Georgia, serif", t.fillText("SACRED", 256, 340), t.fillText("LEGACY", 256, 382), t.font = "15px Georgia, serif", t.fillStyle = "rgba(244, 225, 163, 0.82)", t.fillText("COLLECT • REMEMBER • BELIEVE", 256, 414);
	let i = new Or(e);
	return i.colorSpace = O, i.anisotropy = 4, i;
}
async function tu(e, t, n = !1) {
	return Xl(await e.loadAsync(t), n);
}
async function nu(e, t) {
	return $l(await e.loadAsync(t));
}
async function ru(e, t, n) {
	let r = Zl(await e.loadAsync(t)), i = 1039;
	if (744 > n || i > n) throw r.dispose(), Error(`Derived shard ID texture exceeds GPU limit of ${n}px.`);
	let a = document.createElement("canvas");
	a.width = 744, a.height = i;
	let s = a.getContext("2d", { willReadFrequently: !0 });
	s.imageSmoothingEnabled = !1, s.drawImage(r.image, 0, 0, 744, i);
	let c = s.getImageData(0, 0, 744, i).data, l = 744 * i, u = /* @__PURE__ */ new Map();
	for (let e = 0; e < l; e += 1) {
		let t = e * 4, n = c[t] << 16 | c[t + 1] << 8 | c[t + 2];
		u.set(n, (u.get(n) ?? 0) + 1);
	}
	let d = [...u.entries()].sort((e, t) => t[1] - e[1]).slice(0, 4), f = d.reduce((e, t) => e + t[1], 0) / l > .8, p = d.map(([e]) => [
		e >> 16 & 255,
		e >> 8 & 255,
		e & 255
	]), h = new Uint32Array(l);
	for (let e = 0; e < l; e += 1) {
		let t = e * 4;
		if (!f) {
			h[e] = c[t] << 16 | c[t + 1] << 8 | c[t + 2];
			continue;
		}
		let n = 0, r = Infinity;
		for (let e = 0; e < p.length; e += 1) {
			let i = p[e], a = c[t] - i[0], o = c[t + 1] - i[1], s = c[t + 2] - i[2], l = a * a + o * o + s * s;
			l < r && (r = l, n = e);
		}
		h[e] = n;
	}
	let g = new Uint8Array(744 * i * 4), _ = new Uint8Array(744 * i), v = new Int32Array(744 * i), y = 0;
	for (let e = 0; e < _.length; e += 1) {
		if (_[e]) continue;
		y += 1;
		let t = h[e], n = y & 255, r = y >> 8 & 255, a = y >> 16 & 255, o = 0, s = 1;
		v[0] = e, _[e] = 1;
		let c = (e) => {
			_[e] || h[e] === t && (_[e] = 1, v[s] = e, s += 1);
		};
		for (; o < s;) {
			let e = v[o];
			o += 1;
			let t = e * 4;
			g[t] = n, g[t + 1] = r, g[t + 2] = a, g[t + 3] = 255;
			let s = e % 744, l = Math.floor(e / 744);
			s > 0 && c(e - 1), s < 743 && c(e + 1), l > 0 && c(e - 744), l < i - 1 && c(e + 744);
		}
	}
	r.dispose();
	let b = Zl(new vr(g, 744, i, m, o));
	return b.needsUpdate = !0, b.userData.shardCount = y, console.info(`Prepared ${y} unique holographic shard IDs` + (f ? " after dominant-palette edge cleanup." : ".")), b;
}
async function iu(e, t, n) {
	let r = Zl(await e.loadAsync(t));
	if (r.image.width > n || r.image.height > n) throw r.dispose(), Error(`Precomputed shard ID texture exceeds GPU limit of ${n}px.`);
	return r.userData.precomputed = !0, r;
}
async function au(e, t, n, r = !1) {
	if (!t) return n;
	try {
		return Xl(await e.loadAsync(t), r);
	} catch {
		return console.info(`Optional card texture unavailable: ${t}`), n;
	}
}
async function ou(e, t = Ll) {
	let n = new ja(), r = Math.min(8, e.capabilities.getMaxAnisotropy()), i = {
		black: Yl(0, 0, 0),
		midGray: Yl(128, 128, 128),
		normal: Yl(128, 128, 255)
	};
	{
		let [a, o, s, c, l] = await Promise.all([
			tu(n, t.base, !0),
			tu(n, t.holoMask),
			tu(n, t.goldMask),
			iu(n, t.holoShardIdDerived, e.capabilities.maxTextureSize),
			nu(n, t.materialNoise)
		]), u = {
			base: a,
			holoMask: o,
			goldMask: s,
			holoShardId: c,
			materialNoise: l,
			back: eu(),
			foilPattern: i.midGray,
			foilNoise: i.midGray,
			holoFacetNormal: i.normal,
			hasHoloFacetNormal: !1,
			glossMask: i.black,
			roughness: i.midGray,
			normal: i.normal,
			...i
		};
		return a.anisotropy = r, o.anisotropy = r, s.anisotropy = r, u;
	}
	let a = t.holoShardIdDerived ? iu(n, t.holoShardIdDerived, e.capabilities.maxTextureSize).catch((r) => {
		if (!t.holoShardId) throw r;
		return console.info("Precomputed shard IDs unavailable; deriving them in-browser.", r), ru(n, t.holoShardId, e.capabilities.maxTextureSize);
	}) : ru(n, t.holoShardId, e.capabilities.maxTextureSize), [o, s, c, l, u, d] = await Promise.all([
		tu(n, t.base, !0),
		tu(n, t.holoMask),
		tu(n, t.goldMask),
		au(n, t.foilPattern, i.midGray, !0),
		a,
		nu(n, t.materialNoise)
	]), [f, p, m, h, g] = await Promise.all([
		au(n, t.glossMask, i.black),
		au(n, t.roughness, i.midGray),
		au(n, t.normal, i.normal),
		au(n, t.foilNoise, i.midGray),
		au(n, t.back, null, !0)
	]), _ = g ?? eu(), v = i.normal, y = !1;
	if (t.holoFacetNormal) try {
		v = Ql(await n.loadAsync(t.holoFacetNormal)), y = !0;
	} catch {
		console.info(`Optional facet-normal texture unavailable: ${t.holoFacetNormal}`);
	}
	let b = {
		base: o,
		holoMask: s,
		goldMask: c,
		foilPattern: l,
		materialNoise: d,
		holoShardId: u,
		holoFacetNormal: v,
		hasHoloFacetNormal: y,
		glossMask: f,
		roughness: p,
		normal: m,
		foilNoise: h,
		back: _,
		...i
	};
	return Object.values(b).forEach((e) => {
		e?.isTexture && e !== u && e !== v && (e.anisotropy = r);
	}), b;
}
//#endregion
//#region src/shaders/card.vert.glsl?raw
var su = "varying vec2 vUv;\nvarying vec3 vWorldPosition;\nvarying vec3 vWorldNormal;\nvarying vec3 vWorldTangent;\nvarying vec3 vWorldBitangent;\n\nvoid main() {\n  vUv = uv;\n\n  // The card face is planar, so its local X/Y axes form a stable tangent basis\n  // for aligned normal maps without requiring per-vertex tangent attributes.\n  mat3 worldMatrix = mat3(modelMatrix);\n  vWorldNormal = normalize(worldMatrix * normal);\n  vWorldTangent = normalize(worldMatrix * vec3(1.0, 0.0, 0.0));\n  vWorldBitangent = normalize(worldMatrix * vec3(0.0, 1.0, 0.0));\n\n  vec4 worldPosition = modelMatrix * vec4(position, 1.0);\n  vWorldPosition = worldPosition.xyz;\n  gl_Position = projectionMatrix * viewMatrix * worldPosition;\n}\n", cu = "precision highp float;\n\nuniform sampler2D uBaseMap;\nuniform sampler2D uHoloMask;\nuniform sampler2D uGoldMask;\nuniform sampler2D uMaterialNoiseMap;\nuniform sampler2D uHoloShardIdMap;\n\nuniform float uHoloIntensity;\nuniform float uHoloSaturation;\nuniform float uHoloContrast;\nuniform float uHoloSharpness;\nuniform float uHoloLightIntensity;\nuniform float uFacetNormalTilt;\nuniform float uHoloBroadStrength;\nuniform float uHoloActiveFacetDensity;\nuniform float uHoloSpectralScale;\nuniform float uHoloBasePreservation;\nuniform float uHoloToneCompression;\nuniform float uHoloArtOpacity;\nuniform float uBaseLightIntensity;\nuniform float uLightDispersion;\nuniform float uHoverLightContrast;\nuniform float uLightContrast;\nuniform float uGoldTextureOpacity;\nuniform float uGoldTextureScale;\nuniform float uGoldIntensity;\nuniform float uGoldSharpness;\nuniform float uGoldContrast;\nuniform float uGoldEmbossDepth;\nuniform float uLightStrength;\nuniform float uInteraction;\nuniform vec2 uRotation;\nuniform vec3 uLightPosition;\n\nvarying vec2 vUv;\nvarying vec3 vWorldPosition;\nvarying vec3 vWorldNormal;\nvarying vec3 vWorldTangent;\nvarying vec3 vWorldBitangent;\n\nfloat maskValue(sampler2D map, vec2 uv) {\n  return dot(texture2D(map, uv).rgb, vec3(0.299, 0.587, 0.114));\n}\n\nfloat shardHash(vec3 shardId, float salt) {\n  vec3 bytes = floor(shardId * 255.0 + 0.5);\n  return fract(sin(dot(bytes, vec3(12.9898, 78.233, 37.719)) + salt) * 43758.5453);\n}\n\nvec3 spectral(float phase) {\n  float position = fract(phase);\n  vec3 teal = vec3(0.015, 0.72, 0.68);\n  vec3 white = vec3(0.96, 1.0, 0.97);\n  vec3 yellow = vec3(1.0, 0.82, 0.12);\n  vec3 colour = position < 0.5\n    ? mix(teal, white, smoothstep(0.0, 0.5, position))\n    : mix(white, yellow, smoothstep(0.5, 1.0, position));\n  float luminance = dot(colour, vec3(0.299, 0.587, 0.114));\n  return mix(vec3(luminance), colour, clamp(uHoloSaturation / 1.4, 0.0, 1.0));\n}\n\nfloat goldGradient(float position) {\n  if (position < 0.5) return mix(1.0, 0.04, smoothstep(0.0, 0.5, position));\n  return mix(0.04, 1.0, smoothstep(0.5, 1.0, position));\n}\n\nvoid main() {\n  vec4 baseSample = texture2D(uBaseMap, vUv);\n  float goldMask = smoothstep(0.18, 0.82, maskValue(uGoldMask, vUv));\n  float holoMask = smoothstep(0.18, 0.82, maskValue(uHoloMask, vUv)) * (1.0 - goldMask);\n\n  vec3 normal = normalize(vWorldNormal);\n  vec3 viewDirection = normalize(cameraPosition - vWorldPosition);\n  vec3 lightDirection = normalize(uLightPosition - vWorldPosition);\n  vec3 halfDirection = normalize(viewDirection + lightDirection);\n  mat3 tangentToWorld = mat3(vWorldTangent, vWorldBitangent, vWorldNormal);\n\n  vec2 lightUv = vec2(uLightPosition.x / 8.4 + 0.5, uLightPosition.y / 8.8 + 0.5);\n  vec2 lightDelta = (vUv - lightUv) * vec2(0.82, 1.0);\n  float lightRadius = max(0.31 * uLightDispersion, 0.08);\n  float localLight = exp(-dot(lightDelta, lightDelta) / (lightRadius * lightRadius * 1.45));\n  localLight = pow(localLight, uHoverLightContrast);\n\n  float diffuse = max(dot(normal, lightDirection), 0.0);\n  float broadLight = 0.78 + 0.23 * diffuse * uLightStrength * uBaseLightIntensity;\n  broadLight *= mix(0.9, 1.12, localLight);\n  broadLight = clamp(1.0 + (broadLight - 1.0) * uLightContrast, 0.3, 1.3);\n  float paper = texture2D(uMaterialNoiseMap, vUv * vec2(3.28, 4.53)).r - 0.5;\n  vec3 matte = baseSample.rgb * (broadLight + paper * 0.025);\n  float matteSpecular = pow(max(dot(normal, halfDirection), 0.0), 12.0);\n  matte += vec3(1.0, 0.94, 0.84) * matteSpecular * localLight\n    * 0.018 * uLightStrength * uBaseLightIntensity;\n\n  // Four hashes provide stable orientation, tilt, colour and activation for\n  // every shard. The full editor shader uses nine; the reduced set keeps the\n  // independent shattered response at substantially lower fragment cost.\n  vec3 shardId = floor(texture2D(uHoloShardIdMap, vUv).rgb * 255.0 + 0.5) / 255.0;\n  float shardAzimuth = shardHash(shardId, 9.31);\n  float shardTilt = shardHash(shardId, 17.73);\n  float shardColour = shardHash(shardId, 31.91);\n  float shardEnergy = shardHash(shardId, 61.43);\n\n  float tilt = radians(uFacetNormalTilt) * mix(0.3, 1.0, shardTilt);\n  float angle = shardAzimuth * 6.2831853;\n  vec3 facetTangentNormal = normalize(vec3(\n    cos(angle) * sin(tilt),\n    sin(angle) * sin(tilt),\n    cos(tilt)\n  ));\n  vec3 facetNormal = normalize(tangentToWorld * facetTangentNormal);\n  float alignment = max(dot(facetNormal, normalize(viewDirection + lightDirection)), 0.0);\n  float densityThreshold = mix(0.995, 0.82, uHoloActiveFacetDensity);\n  float activation = smoothstep(\n    densityThreshold - 0.09,\n    densityThreshold + 0.025,\n    alignment + (shardEnergy - 0.5) * 0.045\n  );\n  float broadPower = mix(8.0, 22.0, shardEnergy) * mix(0.72, 1.35, uHoloSharpness / 3.5);\n  float broadReflection = pow(alignment, broadPower) * activation * uHoloBroadStrength;\n\n  vec3 reflected = reflect(-viewDirection, facetNormal);\n  float spectralPhase = dot(reflected, normalize(vec3(0.71, 0.42, 0.56)))\n    * uHoloSpectralScale + shardColour;\n  vec3 spectralColour = spectral(spectralPhase);\n  spectralColour = clamp((spectralColour - 0.5) * uHoloContrast + 0.5, 0.0, 1.0);\n  float hoverResponse = mix(0.3, 1.0, smoothstep(0.03, 0.78, localLight));\n  float reflectionEnergy = broadReflection * uHoloLightIntensity * hoverResponse;\n  vec3 holographicLight = spectralColour * reflectionEnergy;\n  holographicLight /= vec3(1.0) + holographicLight * uHoloToneCompression;\n\n  // Lightweight multi-band silver substrate. It retains the moving metallic\n  // sheet response without the full shader's additional procedural layers.\n  vec2 silverAxis = normalize(vec2(0.72, 0.69));\n  float silverCoordinate = dot(vUv - 0.5, silverAxis);\n  float silverOffset = dot(uRotation, vec2(0.78, -0.58)) * 0.72;\n  silverOffset += mix(0.08, dot(lightUv - 0.5, silverAxis) * 0.62, uInteraction);\n  float silverPosition = clamp((silverCoordinate - silverOffset * 0.68) / 1.34 + 0.5, 0.0, 1.0);\n  float silverProfile = 0.46\n    + sin(silverPosition * 31.4159) * 0.18\n    + sin(silverPosition * 62.8318 + 1.1) * 0.1;\n  silverProfile = clamp(silverProfile, 0.08, 0.92);\n  float silverBandDelta = (silverCoordinate - silverOffset) / 0.13;\n  float silverReflection = exp(-silverBandDelta * silverBandDelta)\n    * mix(0.32, 0.62, localLight);\n  float silverValue = clamp(0.28 + silverProfile * 0.4 + silverReflection * 0.42, 0.16, 1.0);\n  vec3 bareSilver = mix(vec3(0.12, 0.15, 0.18), vec3(0.94, 0.975, 1.0), silverValue);\n  vec3 printedSilver = matte * bareSilver;\n  vec3 silverBase = mix(matte, mix(bareSilver, printedSilver, uHoloArtOpacity), holoMask);\n\n  float foilAmount = holoMask * uHoloIntensity * clamp(reflectionEnergy, 0.0, 1.0);\n  float replacement = foilAmount * mix(0.9, 0.22, uHoloBasePreservation);\n  vec3 composite = mix(silverBase, holographicLight, clamp(replacement, 0.0, 0.88));\n  composite += holographicLight * foilAmount * uHoloBasePreservation * 0.14;\n\n  vec3 goldLightDirection = normalize(vec3(\n    0.58 + lightDirection.x * 0.34,\n    0.72 + lightDirection.y * 0.28,\n    0.72\n  ));\n  vec3 goldHalfDirection = normalize(viewDirection + goldLightDirection);\n\n  vec2 leafUv = vUv * max(uGoldTextureScale, 0.01);\n  vec4 leafData = texture2D(uMaterialNoiseMap, leafUv);\n  vec2 leafGradient = (leafData.ba - 0.5) / 4.0;\n  vec3 leafNormal = normalize(\n    normal - vWorldTangent * leafGradient.x * 1.9 - vWorldBitangent * leafGradient.y * 1.9\n  );\n  vec3 goldNormal = normalize(mix(normal, leafNormal, uGoldTextureOpacity));\n\n  vec2 goldAxis = normalize(vec2(0.84, 0.54));\n  float goldCoordinate = dot(vUv - 0.5, goldAxis);\n  float bandCentre = dot(uRotation, vec2(0.82, -0.62)) * 0.88\n    + mix(lightDirection.x * 0.18 + lightDirection.y * 0.1,\n      dot(lightUv - 0.5, goldAxis) * 1.08, uInteraction);\n  float bandWidth = mix(0.075, 0.032, clamp((uGoldSharpness - 4.0) / 36.0, 0.0, 1.0));\n  float bandDistance = (goldCoordinate - bandCentre) / bandWidth;\n  float directionalBand = exp(-bandDistance * bandDistance);\n  float angularSpecular = pow(max(dot(goldNormal, goldHalfDirection), 0.0), uGoldSharpness * 1.45);\n  float gradientPosition = clamp((goldCoordinate - bandCentre * 0.82) / 1.38 + 0.5, 0.0, 1.0);\n  float gradientProfile = goldGradient(gradientPosition);\n  float goldReflection = gradientProfile * mix(0.28, 1.0, angularSpecular) * 0.82;\n  goldReflection += directionalBand * angularSpecular * mix(0.82, 1.6, uInteraction);\n  goldReflection = clamp(goldReflection * uGoldContrast, 0.0, 1.0);\n\n  vec3 bronze = vec3(0.052, 0.016, 0.001);\n  vec3 amber = vec3(0.38, 0.12, 0.004);\n  vec3 richGold = vec3(0.88, 0.43, 0.018);\n  vec3 champagne = vec3(1.0, 0.82, 0.4);\n  vec3 nearWhite = vec3(1.0, 0.98, 0.84);\n  vec3 goldColour = mix(bronze, amber, smoothstep(0.02, 0.2, gradientProfile * 0.2));\n  goldColour = mix(goldColour, richGold, smoothstep(0.05, 0.42, goldReflection));\n  goldColour = mix(goldColour, champagne, smoothstep(0.3, 0.68, goldReflection));\n  goldColour = mix(goldColour, nearWhite, smoothstep(0.66, 0.94, goldReflection));\n  goldColour *= mix(0.52, 1.0, gradientProfile);\n\n  // Derivatives provide a restrained embossed rim without four additional\n  // gold-mask samples. Negative depth reverses the highlight direction.\n  float embossEdge = clamp(fwidth(goldMask) * 3.2 * abs(uGoldEmbossDepth), 0.0, 1.0);\n  float embossFacing = sign(uGoldEmbossDepth) * dot(normalize(vec2(dFdx(goldMask), dFdy(goldMask)) + 0.0001),\n    normalize(goldLightDirection.xy));\n  float embossHighlight = embossEdge * smoothstep(-0.1, 0.8, embossFacing);\n  goldColour = mix(goldColour, champagne, embossHighlight * 0.22);\n\n  composite = mix(composite, goldColour, clamp(goldMask * uGoldIntensity, 0.0, 0.96));\n  gl_FragColor = vec4(max(composite, vec3(0.0)), baseSample.a);\n  #include <tonemapping_fragment>\n  #include <colorspace_fragment>\n}\n", lu = class {
	constructor(e, t, { locked: n = !1 } = {}) {
		this.textures = e, this.group = new wt(), this.uniforms = {
			uBaseMap: { value: e.base },
			uHoloMask: { value: e.holoMask },
			uGoldMask: { value: e.goldMask },
			uGlossMask: { value: e.glossMask },
			uRoughnessMap: { value: e.roughness },
			uNormalMap: { value: e.normal },
			uFoilPattern: { value: e.foilPattern },
			uFoilNoise: { value: e.foilNoise },
			uMaterialNoiseMap: { value: e.materialNoise },
			uHoloShardIdMap: { value: e.holoShardId },
			uHoloFacetNormalMap: { value: e.holoFacetNormal },
			uHasHoloFacetNormal: { value: +!!e.hasHoloFacetNormal },
			uTime: { value: 0 },
			uHoloIntensity: { value: t.holoIntensity },
			uHoloSaturation: { value: t.holoSaturation },
			uHoloContrast: { value: t.holoContrast },
			uHoloSharpness: { value: t.holoSharpness },
			uHoloFragmentation: { value: t.holoFragmentation },
			uHoloScale: { value: t.holoScale },
			uHoloLightIntensity: { value: t.holoLightIntensity },
			uFacetNormalTilt: { value: t.facetNormalTilt },
			uHoloBroadStrength: { value: t.holoBroadStrength },
			uHoloSparkleStrength: { value: t.holoSparkleStrength },
			uHoloSparkleSharpness: { value: t.holoSparkleSharpness },
			uHoloActiveFacetDensity: { value: t.holoActiveFacetDensity },
			uHoloSpectralScale: { value: t.holoSpectralScale },
			uHoloTemporalVariation: { value: t.holoTemporalVariation },
			uHoloBasePreservation: { value: t.holoBasePreservation },
			uHoloToneCompression: { value: t.holoToneCompression },
			uHoloArtBlendMode: { value: t.holoArtBlendMode },
			uHoloArtOpacity: { value: t.holoArtOpacity / 100 },
			uBaseLightIntensity: { value: t.baseLightIntensity },
			uLightDispersion: { value: t.lightDispersion },
			uHoverLightContrast: { value: t.hoverLightContrast },
			uLightContrast: { value: t.lightContrast },
			uGoldTexture: { value: t.goldTexture },
			uGoldTextureOpacity: { value: t.goldTextureOpacity },
			uGoldTextureScale: { value: t.goldTextureScale },
			uGoldIntensity: { value: t.goldIntensity },
			uGoldSharpness: { value: t.goldSharpness },
			uGoldContrast: { value: t.goldContrast },
			uGoldEmbossDepth: { value: t.goldEmbossDepth },
			uGlossIntensity: { value: t.glossIntensity },
			uLightStrength: { value: t.lightStrength },
			uInteraction: { value: 0 },
			uRotation: { value: new U() },
			uLightPosition: { value: new G(2.5, 3, 5) },
			uDebugView: { value: t.debugView }
		}, this.frontMaterial = new sa({
			uniforms: this.uniforms,
			vertexShader: su,
			fragmentShader: cu,
			defines: n ? { SHOPIFY_LOCKED: 1 } : {},
			toneMapped: !0
		}), this.backMaterial = new rr({
			map: e.back,
			color: 16777215
		}), this.edgeMaterial = new rr({ color: 7165218 }), this.front = new hr(ql(), this.frontMaterial), this.back = new hr(ql(), this.backMaterial), this.body = new hr(Jl(t.cardThickness), this.edgeMaterial), this.back.rotation.y = Math.PI, this.group.add(this.body, this.front, this.back), this.setThickness(t.cardThickness);
	}
	setThickness(e) {
		let t = Math.min(.022, e * .32), n = e / 2 + t + .001;
		this.front.position.z = n, this.back.position.z = -n;
		let r = this.body.geometry;
		this.body.geometry = Jl(e), r.dispose();
	}
	applySettings(e, t) {
		this.uniforms.uHoloIntensity.value = e.holoIntensity, this.uniforms.uHoloSaturation.value = e.holoSaturation, this.uniforms.uHoloContrast.value = e.holoContrast, this.uniforms.uHoloSharpness.value = e.holoSharpness, this.uniforms.uHoloFragmentation.value = e.holoFragmentation, this.uniforms.uHoloScale.value = e.holoScale, this.uniforms.uHoloLightIntensity.value = e.holoLightIntensity, this.uniforms.uFacetNormalTilt.value = e.facetNormalTilt, this.uniforms.uHoloBroadStrength.value = e.holoBroadStrength, this.uniforms.uHoloSparkleStrength.value = e.holoSparkleStrength, this.uniforms.uHoloSparkleSharpness.value = e.holoSparkleSharpness, this.uniforms.uHoloActiveFacetDensity.value = e.holoActiveFacetDensity, this.uniforms.uHoloSpectralScale.value = e.holoSpectralScale, this.uniforms.uHoloTemporalVariation.value = e.holoTemporalVariation, this.uniforms.uHoloBasePreservation.value = e.holoBasePreservation, this.uniforms.uHoloToneCompression.value = e.holoToneCompression, this.uniforms.uHoloArtBlendMode.value = e.holoArtBlendMode, this.uniforms.uHoloArtOpacity.value = e.holoArtOpacity / 100, this.uniforms.uBaseLightIntensity.value = e.baseLightIntensity, this.uniforms.uLightDispersion.value = e.lightDispersion, this.uniforms.uHoverLightContrast.value = e.hoverLightContrast, this.uniforms.uLightContrast.value = e.lightContrast, this.uniforms.uGoldTexture.value = e.goldTexture, this.uniforms.uGoldTextureOpacity.value = e.goldTextureOpacity, this.uniforms.uGoldTextureScale.value = e.goldTextureScale, this.uniforms.uGoldIntensity.value = e.goldIntensity, this.uniforms.uGoldSharpness.value = e.goldSharpness, this.uniforms.uGoldContrast.value = e.goldContrast, this.uniforms.uGoldEmbossDepth.value = e.goldEmbossDepth, this.uniforms.uGlossIntensity.value = e.glossIntensity, this.uniforms.uLightStrength.value = e.lightStrength, this.uniforms.uDebugView.value = Number(e.debugView), t === "cardThickness" && this.setThickness(e.cardThickness);
	}
	update(e, t, n, r, i, a = 0, o = 0) {
		this.group.rotation.x = t, this.group.rotation.y = n, this.group.rotation.z = a, this.group.position.y = o, this.uniforms.uTime.value = e, this.uniforms.uRotation.value.set(t, n), this.uniforms.uLightPosition.value.copy(r), this.uniforms.uInteraction.value = i;
	}
	dispose() {
		this.front.geometry.dispose(), this.back.geometry.dispose(), this.body.geometry.dispose(), this.frontMaterial.dispose(), this.backMaterial.dispose(), this.edgeMaterial.dispose(), new Set(Object.values(this.textures)).forEach((e) => e?.dispose?.());
	}
};
//#endregion
//#region src/createSacredCardExperience.js
function uu(e, t = {}) {
	let n = Hl(), r = {
		...Ll,
		...t.assets
	};
	function i(t) {
		e.innerHTML = `
    <main class="static-fallback">
      <img src="${r.base}" alt="Sacred Legacy — Jesus Christ, The Messiah trading card">
      <p>${t}</p>
    </main>
  `;
	}
	function a() {
		let e = document.createElement("canvas");
		e.width = 256, e.height = 256;
		let t = e.getContext("2d"), n = t.createRadialGradient(128, 128, 8, 128, 128, 122);
		return n.addColorStop(0, "rgba(0, 0, 0, 0.72)"), n.addColorStop(.5, "rgba(0, 0, 0, 0.36)"), n.addColorStop(1, "rgba(0, 0, 0, 0)"), t.fillStyle = n, t.fillRect(0, 0, 256, 256), new Or(e);
	}
	async function o() {
		let o = window.matchMedia("(pointer: coarse)"), s = 0, c = 0, l = () => {
			let n = o.matches || window.innerWidth <= 768, r;
			if (t.lightweight) {
				let t = Math.max(e.clientWidth, 1), n = Math.max(e.clientHeight, 1), i = s > 0 && c > 0 ? Math.min(s / t, c / n) : 2;
				r = Math.min(2, Math.max(1, i));
			} else r = n ? 1.25 : 1.5;
			return Math.min(window.devicePixelRatio || 1, r);
		}, u;
		try {
			u = new Fl({
				antialias: !0,
				alpha: !0,
				powerPreference: "high-performance"
			});
		} catch {
			i("Interactive rendering is unavailable in this browser.");
			return;
		}
		let d = l(), f = d;
		u.setPixelRatio(f), u.outputColorSpace = O, u.toneMapping = 4, u.toneMappingExposure = 1, u.setClearColor(460813, 0), u.domElement.setAttribute("aria-label", "Interactive Sacred Legacy trading card"), e.append(u.domElement);
		let p = e.querySelector(".loading-state"), m;
		try {
			m = await ou(u, r), s = m.base.image?.naturalWidth || m.base.image?.width || 0, c = m.base.image?.naturalHeight || m.base.image?.height || 0;
		} catch (e) {
			console.error("Unable to load required card textures.", e), u.dispose(), i("The interactive card could not load all required artwork.");
			return;
		}
		let h = new Mt(), g = new Ga(n.cameraPerspective, 1, .1, 100);
		if (!t.lightweight) {
			let e = new Na(14476799, 1511451, 1.65), t = new Ja(16773838, 2.4);
			t.position.set(3.5, 4.5, 6);
			let n = new Ja(8097279, 1.2);
			n.position.set(-4, 1, 3), h.add(e, t, n);
		}
		let _ = new lu(m, n, { locked: t.locked });
		h.add(_.group);
		let v = a(), y = new Nn({
			map: v,
			color: 0,
			transparent: !0,
			opacity: n.shadowStrength,
			depthWrite: !1
		}), b = new qn(y);
		b.position.set(0, -.1, -.32), b.scale.set(Ul * 1.55, 4 * 1.38, 1), h.add(b), u.compileAsync ? await u.compileAsync(h, g) : u.compile(h, g), p?.remove();
		let x = new AbortController(), S = { signal: x.signal }, C = {
			signal: x.signal,
			passive: !1
		}, w = new URLSearchParams(window.location.search), T = window.matchMedia("(prefers-reduced-motion: reduce)"), E = () => T.matches || w.get("motion") === "reduce", D = new $a();
		D.connect(document);
		let k = new ho(), A = new U(), j = new nr(), M = new Xe(), N = new G(2.5, 3, 5), ee = new G(2.5, 3, 5), P = new G(2.5, 3, 5), F = u.domElement.getBoundingClientRect(), te = 0, ne = 0, I = 0, re = 0, ie = 0, L = 0, R = null, ae = null, oe = null, se = !0, ce = !document.hidden, le = !1, ue = null, de = !1, z = 0, B = !1, V = 0, fe = 0, pe = -1, me = "", he = 0, ge = 0, _e = 0;
		function ve() {
			F = u.domElement.getBoundingClientRect();
		}
		function ye(e, t) {
			let n = (e - F.left) / F.width, r = (t - F.top) / F.height;
			A.set(n * 2 - 1, -(r * 2 - 1));
		}
		function be() {
			if (k.setFromCamera(A, g), t.lightweight) {
				_.group.updateMatrixWorld(!0), M.copy(_.group.matrixWorld).invert(), j.copy(k.ray).applyMatrix4(M);
				let e = j.direction.z;
				if (Math.abs(e) < 1e-5) return !1;
				let t = (_.front.position.z - j.origin.z) / e;
				if (t < 0) return !1;
				let n = j.origin.x + j.direction.x * t, r = j.origin.y + j.direction.y * t, i = Ul * .5;
				return Math.abs(n) > i || Math.abs(r) > 2 ? !1 : (A.set(je.clamp(n / i, -1, 1), je.clamp(r / 2, -1, 1)), !0);
			}
			return k.intersectObjects([_.front, _.body], !1)[0] ?? null;
		}
		function xe(e) {
			t.lightweight || !e?.uv || A.set(je.clamp(e.uv.x * 2 - 1, -1, 1), je.clamp(e.uv.y * 2 - 1, -1, 1));
		}
		function Se(e, t) {
			ue !== null && (window.clearTimeout(ue), ue = null), de = !1;
			let r = je.degToRad(n.maxTilt);
			te = -t * r, ne = e * r, ee.set(e * 4.2, t * 4.4, 5), L = 1, W();
		}
		function Ce() {
			ue = null, de = !0, te = 0, ne = 0, ee.set(2.5, 3, 5), L = 0, W();
		}
		function we(e = 360) {
			if (t.lightweight) {
				Ce();
				return;
			}
			ue !== null || de || (ue = window.setTimeout(Ce, e));
		}
		function Te(e) {
			if (R !== null || e.pointerType === "mouse" && e.button !== 0) return;
			ye(e.clientX, e.clientY);
			let t = be();
			if (t) {
				e.preventDefault(), R = e.pointerId, ae = e.pointerType, u.domElement.classList.add("is-interacting");
				try {
					u.domElement.setPointerCapture?.(e.pointerId);
				} catch {}
				xe(t), Se(A.x, A.y);
			}
		}
		function Ee(e) {
			if (!(e.pointerType === "touch" && e.pointerId !== R)) {
				if (R !== null) {
					if (e.pointerId !== R) return;
					e.preventDefault();
				}
				V = e.clientX, fe = e.clientY, pe = e.pointerId, me = e.pointerType, B = !0, W();
			}
		}
		function De() {
			if (!B || (B = !1, R !== null && pe !== R)) return;
			ye(V, fe);
			let e = be();
			xe(e), R !== null || me !== "touch" && e ? Se(A.x, A.y) : we();
		}
		function Oe(e) {
			e.pointerId === R && (R = null, ae = null, B = !1, u.domElement.classList.remove("is-interacting"), u.domElement.hasPointerCapture?.(e.pointerId) && u.domElement.releasePointerCapture?.(e.pointerId), we(280));
		}
		function ke(e) {
			e.preventDefault();
		}
		function Ae() {
			let t = e.clientWidth, r = e.clientHeight;
			if (t < 2 || r < 2) return;
			g.fov = n.cameraPerspective, g.aspect = t / r;
			let i = Math.tan(je.degToRad(g.fov / 2)), a = 4 / 2 / i * 1.18, o = Ul / 2 / (i * g.aspect) * 1.16;
			g.position.z = Math.max(a, o), g.updateProjectionMatrix(), d = l(), f = d, u.setPixelRatio(f), u.setSize(t, r, !1), ve(), W();
		}
		function H() {
			return !le && se && ce;
		}
		function W() {
			oe === null && H() && (oe = requestAnimationFrame(Me));
		}
		function Me(e) {
			if (oe = null, !H()) return;
			De();
			let r = R !== null || L > .01 || ie > .01 || de, i = ge ? Math.min(e - ge, 50) : 1e3 / 60;
			ge = e;
			let a = r ? t.lightweight ? 1e3 / 60 : 0 : 1e3 / 30;
			if (_e += i, a > 0 && _e < a - .5) {
				W();
				return;
			}
			_e = a > 0 ? _e % a : 0, he && e - he, he = e, D.update(e);
			let o = Math.min(D.getDelta(), .05), s = D.getElapsed(), c = R !== null && (ae === "touch" || ae === "pen"), l = t.lightweight ? 1.35 : 1, d = n.rotationSmoothing * (c ? 2.35 : l), f = de ? Math.min(n.rotationSmoothing, 2.15) : d, p = 1 - Math.exp(-f * o), m = t.lightweight ? 12 : 5.5, v = t.lightweight ? 10 : 4.5, y = 1 - Math.exp(-(de ? 1.9 : c ? 13 : m) * o), x = 1 - Math.exp(-(de ? 1.55 : c ? 10 : v) * o), S = E(), C = !t.lightweight && !S && L < .01 && !de, w = 1 - Math.exp(-2.2 * o);
			z += (+!!C - z) * w;
			let T = 0, O = 0, k = 0, A = 0, j = 0;
			t.lightweight || (T = n.idleMovement * z, O = (Math.sin(s * .54) * .018 + Math.sin(s * 1.21 + 1.4) * .004) * T, k = (Math.sin(s * .37 + .8) * .026 + Math.sin(s * .91 + 2.2) * .006) * T, A = (Math.sin(s * .31 + 2.6) * .006 + Math.sin(s * .73) * .002) * T, j = Math.sin(s * .46 + .35) * .014 * T), I += (te + O - I) * p, re += (ne + k - re) * p, N.lerp(ee, y), ie += (L - ie) * x, P.copy(N), P.x += Math.sin(s * .29 + .6) * .2 * T, P.y += Math.sin(s * .41 + 1.8) * .18 * T, de && Math.abs(I) < .0015 && Math.abs(re) < .0015 && ie < .01 && (de = !1), _.update(S ? 0 : s, I, re, P, ie, A, j), b.position.x = -re * 2.3, b.position.y = -.12 + I * 1.7 - j * .3, b.material.opacity = n.shadowStrength * (.8 + ie * .2), b.scale.x = Ul * (1.52 + Math.abs(re) * .7), u.render(h, g), !(!t.lightweight && !S && n.idleMovement > .001) && !r && z < .001 && Math.abs(I) < .0015 && Math.abs(re) < .0015 || W();
		}
		u.domElement.addEventListener("pointerdown", Te, S), u.domElement.addEventListener("pointermove", Ee, C), u.domElement.addEventListener("pointerup", Oe, S), u.domElement.addEventListener("pointercancel", Oe, S), u.domElement.addEventListener("lostpointercapture", Oe, S), u.domElement.addEventListener("contextmenu", ke, S), u.domElement.addEventListener("dragstart", ke, S), u.domElement.addEventListener("pointerleave", (e) => {
			B = !1, (R === null || e.pointerId !== R) && we();
		}, S), window.addEventListener("resize", Ae, S), o.addEventListener("change", Ae, S), T.addEventListener("change", W, S), document.addEventListener("visibilitychange", () => {
			ce = !document.hidden, ce && D.reset(), W();
		}, S);
		let Ne = new IntersectionObserver(([e]) => {
			se = e.isIntersecting, se && D.reset(), W();
		}, { threshold: .01 });
		Ne.observe(u.domElement);
		let K = typeof ResizeObserver == "function" ? new ResizeObserver(() => Ae()) : null;
		K?.observe(e);
		function q() {
			le || (le = !0, oe !== null && cancelAnimationFrame(oe), ue !== null && window.clearTimeout(ue), x.abort(), Ne.disconnect(), K?.disconnect(), D.dispose(), _.dispose(), b.geometry.dispose(), y.dispose(), v.dispose(), u.dispose());
		}
		return window.addEventListener("pagehide", q, { once: !0 }), Ae(), W(), q;
	}
	return o();
}
//#endregion
//#region \0virtual:sacred-card-shard-id
var du = "data:image/png;base64,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", fu = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAADeEElEQVR42hTY13IkiYEo1v4IfcB9udLualdXy3XkcIZj2gLdDQ8UUEB57yu99z6zMquyvPcooOCB9t3jyaEbiktqY41CoQdJEboK6ScUOp9x7s0rMaxtfoETZMRCoJywUzheruE9JcRFeRBPDlzQtDiEZCzIi1jpMF+NPAVqe59nhUd+hPgFg3OflMDqZ0q+9vlhsfHTWqPzyQcNejZMJHdulS+CPfxvEzzys4SW/1kKT24mkoeJ8N8dZtb3wOCDMHPwyftu4OkA2NvmCoHt5wnw0T/S6N8PLxs/r3XffKZ2//CFUv/xPmR995lU+/3nmPbh06x+/dHZqPawWYqt3i6f7hHc3+yy5S92B82HR6K870OVvDfTz+9OX2b9kg0EHNUXvhWAwpJniG+MovFBJtrfWvbp8GB+U/LMXki+m5cG8+51NfnyAxA8fxNEJ9cPSX6CYKkhcfBRP+r7m4ZifNqqyJu9RNrTYGPxxnmKGF3ElueU77fLkvpfL3n3f7mERv92ttP5fhRgL1sS1W81cWZQlKFOXoIbjhRtM1K8HYVwlwN1txNjW9M8PCrJ0Iyy4EkeSQ6OoHT9C5RTEkKdY9gm25ZNeerodhxF1DVGIsN2CfKqJ6lM/110r/7Wu9p7/zww+u5hrfrPK0Phd5so+mo907xcTR3XH/C39oMv3yLbJ7Wir2cmo4sanJtaENor5RjJgFjdLPFtY6pOpUlZhe9NnUSqru/CLLNv4XCzGyH4foholmOcKAD8LoEgtE3AYFYF4tt8enu1Fni039xcjRn3Q0r7Y8y0PjK09sdaafILvtz/hTroftprMY++NI5258ov/G36b2ME8NOIIH4cyQBP/SkwcLAK7D0NkjsPODJw31WCT3rOwTqWBZ6Hw/jDhEN/WvrQ/KL27sVjfv6rx7T9wyNa+PohZn5/H3euP5evF1+0/pV58uJXoV3t8tGe8frnB8rXn3itNw990njDb3/whaS3+TD1qhiiR/mgocciN0a+cDeH6Q8TxvzeVXp2Xhv2nzUW1S9aZzNP5wWcGd+YifMXWvD0VSTUv7of1Yd7R8k6c/CgVsn+pM1nV9towdcM58KOmCTKp4DamSeX01nk9+et2P91Wxb/7VWu8uebn0m3w6NKv8lbWnNqscM8TXVzBth0qsVODi7UozBuAwRvThWs9hYGJ3UGWETR4igr57oBHag+10Ul2quz0qzOTUeWbmplK6uoakCxmUO1BRfbs2Kk+SLls29Ca4vvdrduv1mRTr5drY5/s96s3e6QzOk20qttaN9CW+2v0vuDq3Rw9iKTGo2DxVk9TnT0HCfbiKA5vFjtlLSaPijpqXs9AzjUlWxO4RO6SLarLA9pKUbv5jiymmVT+Rh+CGGFA5iP+zKaL+Sr7+54Z6up4uBhojj9FBqe/9yZXX9qlpdf2MrwId9vPbTPiJW3b488vf5jn6N/EjKNz6NF42EwW9o5TPa9u9vt3dXQ3f4X5nT/YVc7fEqQkdVcjnzoVIiVulteM3rzDfbkzUZy+HK1OL59JE8/PKEabx51j2+fL7/uedTv+IP+b/eC5a+fR6svnqbY3sMk3PDEhu39nDn1F4WbZDF2jqaidjhssrHYjxyAX9OofC5r5ZHYbmWRZrWKmc2TYH38Oli/AvbaZ9Lh+FwPOJfxPfvk56uF5vaB16wAzxyXXq9Juf06nM65/iSlm0rJGnHt2jA96i3A381fpv7ldhD57btg9Ob2UbQ39ZDlNt8VO7W6PKTyWh+zmW7RpppZVXbT5XyJcQuW28tVvutkxyUxMwPl1BgYEH3/mKgH3zql7JuKxo0FzWqRpt4wSlm6owXFKpdrWmSuVkYPnUYOPT5PeyuXoSf2y23Kud1S+y93+LOTnfai5O2OgKDUy4eMmjc6nUazbiME1KoxpGV7qKHlkRTZL7tI0hAg1UASdVU/umfwcsYRdNiRijWRsyeYqPKkzNMFeS8TJ/OCDznCoewGD4fWZWrHX2SfpUOVx6nk2ecN/vIRVpk9IN9O7vPvzu7PJ4NnTrG10ScMT9/2+jXnedBRH0RM4WkcEncjNJoIR0z4MDcu7m12D57mz4OPbcW3mg0HHrqZ3EoZwJ4PdWa3UW56Ea25n+73tsBaex0vd55bd4uNu++7vvNlJWHP1UxtHCzKrX2AbH9exK2HeUxcyZ62PGjb2KZpwUc9BlO5XTUctvrx2G9LCewNyCrLtF5xiUY9z80rVGXgnFSq7cuQNUd/Zk60eHfGFauzwz23u/ozrpSJprWe7ncEZMcR8JADkphFWZYp12zLKPWdE7zfGqReja7yvzwbRt7dBXcuzg6L9gTPsSMyJg9zHr3TS/fHqK87TInlNtKjGtkFUlGnhWqlkm8urfSkLEbmZil6AivxOVoVpoGK1N2VhTLakG29Vi8Xe20LmPR0mNCVNKtySYUmwTKHhlw273EH0VX3xmOMzg7q1tRPGz2fe8uFG61CgqpE4u3z3WyzHgbtSRJx7iJEoxZnW/ahjHKHYtnIKQgCSWmUZ/TcPYm0GZtdiF2NBStaFqFEyUalAkdyWZciY8sUFO0VcztMIfxzKL25DmMPAKv6udBbfH58PF8dzQdb1EV7M3nWfwrZ509a/HLthrW8fTod4tBIyOQ2omZqNZ4seEIVPhMjRCaSsBlfpJ3de2IfPEnb3vtwIfJZu+B/tCCy68csfmAr2JFlU4GQqHnyXWm7f8t4ey/ZYOe0nFgsbcColyFTglCF3sJyxApYkB/l7foa2JE8uJuJ0dm9Xexoay+fSRVTVAlIXk8R+BpE+Df7ltNecevcwbRORvpVPKFWlKxenYFWr7LfHsW2q+1fgI4Os4ZSNguGJiQtRdgrSXjaljjRkUi9zLQaDtKZldr2qDoFpt0Z/3JWBhcn9GF/cRCsDoqm2MkqSp0Hu3Un8qrVC10NxeJwxAHaKEmTHVhQm5amdsYCMemAiVMpG1nyPLxENHKx0+B6sbrWgG2zWqk0m6jYrK+odZUYKjJ4yglgP89Cp14yPEShvamT2l9UAsj16Kh6VQrN+3IaMxLJcjmQbbb3AL7tBWbXQXK4TImFEco6TVQ0hLDMGx6ZLB1J2BDmQw5JqPY9kqzKDNsqlWWBUhUZE1SEMSVB0SWZ4eQ9SiMfQXx2FcQCH+fItRhhPBZ094mpzVbn5ZOdU6npx5Hp0VNpsh6X508a9nDtynEPmlYqoKPeEIz7/RUpFCaIQqjaEGJyiYqDai7iaQQOnoy9T59Xd38BD7wfTyreB+dWav3CCXobjXiAtxIBop/1y8d4YPQSSDidQqan0UDFFVGixMKSBiACn0VwbB/iHC9EVbZBUY5CVD4FpmKxLAjGUg6czro2CnAdBGi0eHQZM/lTz9g0tqs2d9Qs0QhTsjimbKCSa6W1uhwwGqtZQ+cUQddIwdBSpEXlc6aZQW0modtjoNzgqFYjLYzLlFx3bkuDbqM8GROV5VBgxkMJUUZplO96uUqlqMxsO39VOQve9CTvac8K1ofZSLNDsXpbUeWOazDDGkvM2gV0qSXBcwnjzrcofuxvMm1sKDfFitUkxUojpNCOtBScuJvWWSetp7QjMV720Yc6BAbLVAYe6EnONpOug2cZLZFty3GwySSxVt3HDDqQ0liAZnxUkMgTSnTbGVVyQa1URcy4AcvBAUGj9XsM1f0tJCoDRWJ4XjSxksIkWzKOVSWR16S1ook9zPLJRyjmXWGsZ3C3ssJXGyu1cnutzXd3OvHqoXZU9z1/1t0oCO1nzaa+eT7SjwQF9pl6PsBquYA6LYQaF3bc6EpJ7jifFBqpVLgRC31EhDf2K9FHidHOZ/0X/sdXl0fbd5ONgCU/CVfs53Gxf5ioLcJZuRrJMeZubi4dohabImAMRekCguBFDirzPCYEIKxw3wdlN8k8mJIzSIZPwSoWP+mIxYGpY4wkoZGqVejWK+gxPuHcXFVuc6Kp5fGSWEyXGJ4t8Wmj5G4YlehjykAOZRUFW3Ipb2l4QVe0IK9puYpxjvXrytqgkX3aqkhM03152Rs29Ok8Jp4OyOasL2GNAYwr3UCwXvVmlzrXudbnyAvX2L6tO+mTlsbPOmKr09Vmjb7WMoeSxIxciZk1E/BSDZNnuaK4SIjsKNWXu0hJazEVoaleAe1ME6pFrFAJVYsGoGFqoBxgw+oumtNyYJTmM4JEZkw1nqcayZzbzAKXaoHuIwn5LA04DktVc2XeThuabrqmpQhuSTJImzRSlkcqCImLe2k7P8obyaEiwW6Np+gaV0r3RSHWl6Boj3/6zAHXt9rx5/naQVwcbGfk/hqDjJ4ryPE6q52vlanFFpbrbQhwZ0OWW5ujVuXA7Yh+2SACRlUNdSZ6sjIRs5JdzdUtESz0obzwKpR/LAeDm43sTvwEXqMn4efNlm9r2l4/bPZWQzXl8/iI+mmuxP0C4KEvABpfLaKFx7kxuYdIPi+aSydBpiAA+pEE5Y+4QjQsJ1mISEpBIYVEuLhLiGmN47Nt2wSbgIuXghYVQ5owV3fhbr1EzYSyrCV1xYjkdReKlZJFWo0HWF7fUkXskcOX/FUJjA75EnohpRITpo6ORDc90MTnHU3cOddHqVHlhdMblJudcfl6OSeuh7PDQa0r92u9I2JWzeDntjZ84Rx1r1WhdaxOKsfOTF60RuPGyBnbM2puT6G+PpIm4gjhiIFrEJO6gi84iF0IhHByUKcGRE/o9XrFac4Ah4FKsul3gzZmRy2ynzT3rCQXKXvxcMUPZFUkK7NArqPGINoNg4Llg3o0QFZ9NPs1oTlDUW8mhUoFtNwSWbItW687crpehgG6xCtISWrc8zfyacw9Ai3dT024VGpB6qkFzYcv6cPoDNqM2Ym0fxYOeYbeJDjaOYI6Txmo9bQljjZA4tVz3rh6zuGXz11qutnSFp4x0Q+IaDVot6xI+7iV7swrRbpuFsSeUjweYIQmJqh1MFnYnwRikZuYP3Rd3AOuctutV7H945NnYb7387Dh/EN0Zv1Vjmf+Pidb9wsw/I9ZHv00KwLPcm7eC0CZSD4NIkk9z6Rh3EyiuhjLKGRQ47CwlRairTiVboBKkcacgtyqFyf1Lq7oNZKlNEIVLcoUdVYyZLbDgYqdTuueQ5Q9EEiEIhSoDBpYFRvSEnnDMOAHhsDfUxr7mkHYCWmIE6bpnom/7E5qXw4m09Pu9KLsLm4SzuzMW2pNgv1Z57A+rLi9i7pUfdE4qE8tYnxuNrrD8jeV7mhUtk6qbvMC0vUlYdsnITE34sr+kV3DZ5IrzGRbPu6rxkUwRc8JC5sacmaOVMFpsJ3pet1sRavFqkk5XvLSMSla8tEeax+M8pGsZeYLMymOYfEgAgI7IC0VgCvVZX6tN5whXmsCmFmFeKeMlht2wegallItaYTjlEPpqh29d1hBsnk7Fu9ozwJjMuW7gPmdM1jcXCJH28fZ1ZVhILLW36cjN55U5mzzKNh/YsU7T8t4d13QT9eLzN1TAe8+G5D2toG09wbFmm+GdOO9UjPXajiQYdcQqaSi0ojBzIFI4loOZ5kAFq8EgfD7Qjr4fS6Mf4sEjTexcPf9fgq8fBbTJl8kGo2f5hz0k2I+/7Msin6WogIrSc6/lbRTgSwJBNNxFotWDS4la2YabLPxWAMIAgJ1pCG8f4YXE10Bzw0MExHKFtI4rpK4qxKKZpJqSaWrpsDjBMXKNMqz2QJHxzPsJiFBcLlUbDSbSIMZULTeIyX3mOLABamlpjQBLKjOcCqMpl3j13eD7vtuZznSBrc2NXkZy/QvU7h9esD3h2H5sqXrrztK+bobL0/r0HjuWqeD2tcvW7NJqXNuMu4VhugXeZw9zcvgTO7F51YdP+G65AnTExc8RS8EIHMCFsKzlpBaUjh8esAVhkclsIHXwFqQiJXSelqNyGHueSoG5VOBvAzGC2ohDIjBBChjXohvcdDNwuJe243SQGjXqUStJlCVGkCWyhm+ZXKUZhaKrFqLx63a0b2klQ9CWiDisquxSyDke5uiI7cpZec2vfVoGVj/+HgL/+9fb8gf3Wz5dpYrEaTzxUCxVkaivImi1fVM3lmVku7TNsJsKgVra4JY3vdUOTXXx2C5X0H1qYw3X4qs0JNZaKpT+YGIVQc5uqIX+LSTI/3nIFj4I5K3/vcCUPoqDCfqqTx5E8qh7kZaVVayqPLTtB/4LETlN4Jm+iDSdH1JlY2nQa0Qr9wQmfpCKRZbdHYTjQdjcsFrnOWOLo6ziQlbLM5wBW8JPVZwLC5fUkjDwhilTLECWuSobZRBvAkKR5NEWY8ziayG0VQJpYUxMsGHjOJvstGogaH5MlK2psTCfSkOSmPzelluXp1WJycn7nl1WLph6cY1mK9eADnj1Hc4HMWIWadsXA0U/HiIWrM+1XvTaw3n4+Zxb1FdNM/FDn9OOtYZ6RJL5Qw4owfg0m3kr3iBufIJ6WNU9M84385UhtbnjhA9EUvJ03g1MYmOc13fMlctWlEnjke0FRAhnzGJHIZvZER0J4MJ2VTHzhZnIkCUNZZudmvieZu3xazilOOGK2SZKkYSlTjAGzBNqjFK4nUnLs71e2kJwHE+xNXwL5hOKg6eh/PxpR9FXh2uJH619kno60+0xDefDr3Xj9n9/iMQc+733OZq1VHWCzKzGqPFBxWJfFJFjWcWKqyfqsbBb/RG5q1VJxpaj+vyHYXBSorRKGn5PiPlhzTLNGi2WaUkzZIU/o2iiL+11eQvFT7yoUhIdxnyaJAEUuehrHryJBemvogfEns+zD44vK2HElIunSzzqWxPzUOqUoSVBoxuVNJpfz8VsmZoVBkAMeWYTfTaWv4cMYi52RI5vSTmZZuxHUHI4hDtRyhITKXhSiSDmwGcgvYhHA3qqJBroJBvBmnAArGQHp5TG1D1tIo3TufMpHOqvFdP6ldSY3zJVs+HYP1FkZleFwrjcwBsn/ihyoiCykMEcHssMui1xe5EbTRn3GA+HQzbZ+2pdaOY5i1GU9dMy7iqdbkXeAe7hbXENWMkr/hq8srvBBeb5VS33tgbVQc78/bF4Zkxwi7ganqZ60SOP6tFGkcnoVKwm5O3mxjxeBjOIO/2k867WFYap3JOmyqezlVy2pCluiXqnFbQaSSnNbmcXY6jlfwuUSqmaB2GCQVLcZLEAjJN3IMELC1xgYyJ/ZTsxbzG4Ihxzg8T5svd+6VfP7pf+f0/kdaP/9h3Lz8Z1sYPSuPS4/awuqaT5Y1EkVnNmpmHUg1+5B6XVnvX7ObZl+zR766E/Eu1TDnSlHOxrtRNDs0KWHOKGcWMFWmZcHWxUmHVF6N6zR0s28xxtxV6ZZe9t7ia76WENO2l43gI9arr2aD6IFpUngdZIRE0rP1wkwwnG3Au141G4GYwTvBZD3kE+4GYjKYVs5C1BV8Bj8M5PN/PfMu0qClYlal0W8J9TQEDRC6F4cSmS+XpSiFXkumiVOQB6pAvyqAIANI4p3deFazZDdjvTQhHaTK1dkdUJ8eyPVhob42zxik2G038k9Pl3vIuvLI4BwOLExAczQPtSZ/su13CsDpWTe6f1e1FuaqdceXW2aRWuuN59AUm4zeuLL/iUepVlcDfxyOZF2hx91bF9l5QoO8uyEbP9mrh0eD9xsnkfPXaujy4o7vILdUt3MTl5NkOdjBa7+/XjsageTiW+Mj3NAH/cxpDfkzA1C+LUPdbnei8c/j2WUWtHBNm3k4qih3UGLKgMiFIFbeKKrUHKEm/xJeKgsSmUZFO3yNo4ggn8/kG+hibJAPGXZA4/tKfqn69/0T77eqnwz9/xHX++NGw/f6Ls2btmTlX1hFBfMYC/DOBTD9DTiKrjbv8eu+U3jv9dz3Y/62cmL5Ri7f1Pi3JM0YkR+wcWWpGbmSgCVdV0z0dByrqUO44t+xxtysPJqXr/tw3Hffv27K9ZsN8AomSEOrFDhNreX9jM55VjkJ6yR/BmWDIdcMxRQolGqwnO4PXER3fxjJUAswk4jkGz2aBcCLFZ4iUFjTTr3gX72XaXP5ZhyxtOgzzhGOkdJHdZAWwKGh5nDey+bSQrMatbCPbALXKJezWrnGxfUFowwU1mTakfr1rSvWeRdgLY9Gb1Cqps1YHHw76hdYc3x7MlHR/3gJ6ZxHamiVOzYE4Fwf2hJ0sh8i5hRFXMk9dO2r2To6lX2Jk4E5iYncS7XtBE+svYPz5DS08vRbJZ9ca9fktzK1csdXdK+fVw7vZt8/e46PNd3Q9/DbWiN4eKP4TEggvtmmw53PVKj003cK1ZRd/xRv5P3EK9ktRqv2+q5uvW2btpVLG7zA7N4sbYNmvRp0ElxezpIYkaCmTZMgjiFYLHMNmJYZK31MhM86i2IYBH/gXaZJ5m0ok30T8mX/xBtj/2PrI/vFzdvY/f9brfnj81uzvJvaY9RiBrahj8unlcWJPWPj3rF9FD37/WyrbMWTQsi2Em7SRydeXDGFfUOzonOqPF6JkXUq4cy44zRO51D3WW+W587bT6f/gVi/5WOdyxVMe3fdhlX/yZdgEksBj+Sig5w+gdWQ/AanBKIGlwhaVikn1RJy/PIpbLwOpk+k2ZDJr6H56P0sbsUyyn4sRr2IR5AoNnXSIzLioQPTHXRD82C1IfqMwSuWw1h7M7PxMAfP37Xxkq55I++1wq6gm3mtD1Kz2iObdiNWvRrw1nkv1+rHe4wdlmp86mtypQELDHnXHjbLa6fDFQaec7Q7sYHk8harLiihfhklpwZXthdHDTsV2YVkvZ6/MfOom5/VcdPIbd2Tw8a2IP77jO/9wRw///pap/5cb1PrvLqXu/3BlGX9xq7kPXkyOH33Znj38Xqx/+n1O93xN06Gvdnd37x4mI3OlBB4nMXGUtp2ufdscyJetId3SB0G30eRGtQbXdRvaYNCquEY/xUab3lrUBvt+Y1884kJsDKerQQxWfbAjYriYZ3AalPF86F41Bx/U03JsmMHj3VQcvoukndd+wPxnb47+j91N9t9Xkda/PLasr1blyPipuS2vlXLcZqkD7VxfFYLDN2Ci/LtixnqbyQ/OWWTcNZheoyID6lQwW0uJdU4ltXyhKPpCFeCZ5pIvLAG6LU3h0/qN0R132MYCgO3ZWpFp3k/y2jrop4KAD4qlPLlyeB8IhHeSUSAWZqSD0LG5k+531kD1Zhcijg9BSfOAKLlRxMi9fLniAwUzAIL1ZCFwCSW4KzyRrVhhulgPNXZKcXuTTJcS+RzpT2T9O2yE3WhHCiuDABV1/deRWuoHfEydMSdKtbQ0CWOic2RP51JtvZfvlXmsVZG5llvi3bolaS1Clho03a1L+KQxxhaDu8ToTA/ULjDWPrMmxqWqQ1cEdXQJEeEzNOY9EeKbp5bv6Vkt+en1VP/oraL91TvQ+cvX8OIvXyjHf/kSbPy3t/XqX7zumT/5alT77FdG74vfoOrKD6HC7le70aO7VMBzmcynTwq6MmPR1tTR+wvDrJ0WzP4c5RvTgtQZksyoL6mNAeWafaaF9VgT6EVMT32fD5k7RJBDzAOmSMWIIg8gRIuE1IaIZLNaEcrfq0d4vRZVlGFMFcZxXjxLxNUXwbDyy4Oi/OvdFPrH9RT8x9Wo8PY+LHQ+O87rK2+LkmeM44G3Gpu/aXEk24AIppMlShWA7im4VAJIVcyZmigONE5saBww1EDoVFLhY8WiTnXROjHeSIvmMXEydpjWLJ91Ro9YtrJWL8prbhT32Ht5f2stVikfpfJYOIaIB2HF2Yy+HG4Dd+JDlgYPmUMqDmFiEkC5w0LJ3gaNmgcuUTuYJe+SQSkKhcpY5plp+4Nye69qaoczRolKYDYKcGDoQOU8uNreNfnpPklO937FniZ+Xzwm34NLw0m/LGXSEy0fnEvy4UCex6u2EaiXFcxyy2alUULFNlCs1nGhWhW541oFfd06g8+ni9jkvMuYd5CmXxMueYlikfPA/vYMK25PCHht1EAezV+i/3Q7yfz0fSn3F18Zuf/0DZT7qy9h6G/eFfL/6ZWF/zdv5+Y/fnfCfPwjbK/8NoA//3Yvt/d6A3p6hqvbp6IMLn2QPXax8XEZri8NonUeJapzkunNkkprILntoaMwE57MTIvZ/JDNp4YHhWB9E9jRY7RPjNcPKViKEprOkLiqET5XKearzayfvafHWKUWE6rHMa19nJCEbjK29zYciv3KG8b/vJ3A/vAMjf+4GkMX90NS8+MTovTwm5iwexOBQ7/NMtCVn+LEIs0jMM0ImsCoRZjTi2Wh+f/P2dFSzz89k8RnJzLoGQpO61TuVpYWGZ+bl+x1Y4mejhj/bMSDndFRSm6uooS+2gpRofdBeHfhSRGTeIIwgbjQP4w3ujuZdvkBMBUfkXL+ORWCvTC0OACUszBYO/djAOaDGsQuYUJeKgfGsaMEmX/sGoH4zDxQeqq3VcGCLpaNYmoqfDDBD8C+uytRnT0WqO29wmqRP2DH2B01lRx0qYWil1wqOicraJ8dVGbKBGnZbX5Sp5qtqjqz6uJIbqBNq0r0Bq5TPa73uOPe1+DwfB7rvmQixosgSJx7Yv4JFt8dkSHPkES2+012ZbqM/fxi9ukXr0p//dFb4+O//YA//sm7wqO/eUV+9E8v+8//8kM7+tF3b9Sn/xwwV3+zU9348ojafxHBti/Q9tFZsR9bhCxl6HTsaX3YOzFK/WUSH8/EyWCOjIYTbN4cSdfMGDSwAYgVOrwd6xzmdypH4hONaW5ru2U/Tb6AKfkaoaUbnvFXdOSgYmeS2j09YXU6aU1dZIr5VvIAHPphdX4IC6/3Q6lvNvfA7x8p6JsnANh64DGqH9V6pU+/Kllr77KI732cz3znoyn1ucZo+zKXeSCT6rZEic+HtP7ggi3+YkkV7k/RUnRMvnAvNBWe6MV4Xa5hC2OOnVdd5brlKi97KNrppMhqLVNXnfwsbq69KzIbLxJAuJtOW+VsjtOjOVPfLJiNn4Nl52PUbK7gtcEKg1tHtNrNMP5KGIFqEbA8iiFmLYOHyzigXBfBAwVN+utokJjm/FwD9I9kIF5Fg5ntGBzcIsEdAtW2ZULZeVWvhv4sjJDL0FCg10/44MoSp1NdbMkORRE6Fi9mc+dqfNbRq52eMBz1CUfvUo7UKVhKg65rddtstO8YZz6NlC+tdO1mO8XOD/ZSPXBrv1U+2u2JT6N9ZjfUE6PrfTe1Me4feE4a26uX+OO988jfeealT/ZOXuxsvXzv2fj+y7Dnz4m498dPIuEPHjVzq1jkHQkCt0ESXRZOyePanbIUF40z5EXvxL2bXfCj8QW5GJ0LrfK5j+BnAR7oGnZsEBK3G4XBmlvsPrOxyopF9EIGWiloSoPXI64i+DWT2JAqubhxz8jhcilTFKsJuNCMZrFuoAjXjo4Sve1UevbcCwwfCHz1gaFLj1Nm/XO51vhiqBord5S7d4NY4duEUnA3yxDkHReJ5+284GsWiGgnJ0bbeXTNzJaflYrvt3W2edSX8bgmismSWMva2q0wqrvKuC1yFx0SmbYluN4mQbclE3r7CamY/yhiuMfN5OV2osBVjgrN1lNEbvwEbU3+mnJ7P+XF9gqvjsMibReFkACSXLtASJcMqcxFWmxT9GEvDSUNMJcVgsms7o/mhXTApZJRkUpFk2jG/5whthhO3BxR+sFUVcI3+Va+72kh6NMayPkmoGstsdHyjHtxNrdOT5fN8fJ82OjOZoDZHhFWfUjwah8X2C4oFVp8iWy1Y9Rg+Vw7MY+cs0+PlO7uIVyhfeky6w06djDuWn66riegpuAvtBqHUN/YxEeR+1A79/NibfYF2H/zaeHsh62jD9/sx3+MPor8KhjPf3mESC8zaOVKKhrXDlV7QUj1W9XqvyjXR29gY/GSrd6+1FoXr7LS9DZCNJfRAjHLceiQFY8GtOsZZJp7rfjwwBVPdqt5J2CTJaIkmCX7QKpKh/SI3IWbBUy4V8ujBSHrI+0ILdXC6UzPF0lzuwFv8XkxTq+mssYDo6k8srrECnimPMLm1Qe1XufJxWy2PV2Wj/olKdLJNtPx/YuIAS/iRvEqScSn8WzCDMN5KNAK56Lf+zlkslJmiAONVgsIexp39FfRQcPa77eJ7XmT/Kzb4B/IDWGl11AC7dYGaFsPJJb2d9MwPdqF1MtNpH79iCyf/49s5eK/iE7zE9Wwn+uwllIBgBNxRuDrLVshT02ZaDRERdSkFR+EBhNgHoKSmRh7GE1KMb/bC0UYORsu2AX/uoZsERVh41yvHpqA5evE+Gg5ZSZ1gU9fnbSQ63djYfSua9y+ajeXr3pjt92dK+3mAqjWpnnDHpJFok9Esj16N949eOZz+WeQ+3aDHJn3xckvHirufl7RcJRXZAJSLZgyGrjusEnLYeMVp+StuuRar3z4cU+FnznyeLNS+v0GN/zDJnl7uQd9JX+Cfl1Y59/705XbGH587rCXVw3l9UtRnb4s57pvZc/JO+Zw8U4KvngHJe9eh1PL64Pw6Bgp8rOChg5tOzYVaO8UEkOjQivbSx8fNDNXsQo+ZsuUrdtbZF3crg6xcNMtEtS9alrYldIxnxWNqmVfUqt5dgzjWYbFHqN69mGtC67aUvF5zxJ3shV7vfDGfdr9cr559+7Wr1xfBWhx6lfCL4JS/k1IKb4Kc/GbMLl3HoRA25dMGJ5ajDu6DOmJ27AIVx7xOLNZxBY5Qjj93La0v3fs+Gecyj5UVHUN1Voh1m4f6bXwAVw6BMJSxEjS1iLK6ZZHcNvrSmX+xCB7K7ri7hmyEzZ9CioyjiW4kqQuRko5YUlGnC9JgfUytfMpWcxmCxmWTqbTSC7GabEYlY5HFU8hlvIkg550bA+oy1v1sehhWNwzcAj/aVdKXg0p+NuRLF9P7Urv1GjenpVmpXFp4XbNM07QzlIVYb5bYrt5LNLIbCUr8JOQffAkJctRXDnPUpXST41a4iclO+itKRQoyxxtSA4gaMpB2WCKEx2M1mVucyKnHoy4zD9NSWJnho/kLv8j0qz92aOd1D5zLpr37Ttzvfwyu35znUncntUP3t00fa9fpZJX14Tv6spYO7sRP/vq1nr+zUvE+/XtIfT2NM6cT0pGeY6C1pTGsYkeB2canT5mdN8cqsUmPjfbiV1K1cSlW8q4Hc0Tn9OP94b5/Pa9WcBgKmEnUY7FdtuBTKzjfZJXniENdEUfJp4ylejTxhWwMW5w+7WW4YNPRG/rth887bxLe9gfgr75jx738vtDZfGVj67fHeXNY0/THvkSRM+TELqbjtPeuR5IwYYLxntKLtuJpyBiHwL6cRqv5jJMOu7HNSpMdogoX4UiSh0OmATs0aHYpiKEA0qBiAgNOKH1M4eOnl6rFIFoSdABm5KZUgI1FJDqipftql3FzerhnmD8ww6HbmSFNA/pGTpLpdE0mWBwNBHOIcGkH/cqO+QhsxPxCpHYIVsoeAHU8Tgs413K+diFWihelwj6+0am9LoBdgdDaXJSlc8VU7zAJePcceirKICcfgbE20/QXTOkeEW4EOEQX4QphVgeO4RZJYZy5UNHIg77ghLtSJBQ51G5ygzMmQKAfcGfXBJQ4hQ5Kp7ndP6ssKSuiQoxYy7ppvEOd1qtvcZgutdbmD8/O1Xuf1j6Pv7dpLP55cnEc3Pt9y1O0vnTCUVdjSvlX85bjfdnzvD7q2jlyxPw+GKOlM4mlNkdp4l+b0g40xoPn+hcallEgGMSYeYxxB48TdQqn6Ub/GP0FHyQmUcKwL1xAMpfHjG5/iEcbO3D8cZuARE22YvUJvnV0Xrv24096uXB7vQd5J+VmQRj6XGudhm3Z9+m2Pq/puLX/zVs/sufYtB334XB13d+4N3JofjV4rBwOfPAF+7O4F3laHaixIwhn6BK8bjFB1JaKJ6ZJY9gK7aJ8oU1TGmu4bWmj6lVnoh16YmWJh6Lxcx9tp3YltPefa4EesUeeGCU49slPRhx2CTiZLOqkQmbcjnV0B28VSrgju4NUezzMAt4ADpBonicJOWYbJJxUGfC27zo8YvcuipkN0rR9LadyHtkP7JPBJG9egE6OoNS8btiGnoTiwjfg4XqNwowcWliMcSlKy7CX0oEdgVAufNYOjR/FI83PcqOtdraZyPiFoZDfkRNHWCCJ4xRawm0HOBJMVWjptBAwpihQJeGvEycCQnqjvLjP0AU9BWYVUc5qTbIn9T6WB3q0cvQTGtHju1mYlLVk/O6G7ntMNsf2qDnz41R/LvBIjw9KWRbU8yZj8vHw3nz5N3Z6Pj7O2Hxuzvi/dubg9nbE8i4mafpt8MMMuzM8dG0GmdP2IPCCbAtz8hdYeJ5VGmtrejWs6Me+zF9l1uFL4MUcW/mBVdeeYqpl9tUurYlofr2cZc4Kg9zQWZ0ECiPPovwnd0IbuXDI1VJK0E3U1YvC+zxr/Pts/9AzOV/xbD5/4Ek598VkPcfcsjL8zT4TSeRP++GhdtGxHonxbu/drLoQEoXe8l4loiFHOIgNlK2ck15DTxhPLRMeFmbCAgq/7lkkZ8oR55P6SzwCC+hu5QQ91M2vM068LZoZDxKBY4ZIgIb4aguglSVHTGm6oiO6eHL/GGTwo6qcv5IpWLsSS5m9IGEOOST6bkU3h0B+745sJ6a5lYql/RzyebW1C65obeSWx2ncHBCopETJJv9AThk/9Wbqr0ugBM7LswNb/Wkvm9csFvKeSKaPg7ldofR/E4r5dt3/3Fni9tWt+C8/KwACw9yeHQ7U9ov5DvPRbiUa+IXylJSyaWcQq9YLfmGj6Q+EAfY74oO+yuICF2BUr4PqrQOi6SLnAXGXP/RXGvtNkuSd2qL0LUjUF87fPyX5Z70oXGDLaaV0Hjh8OOzSn961bj+8sVo+esPjfGfvwsrb999Cr5fxpXrWYS96Of5easqT/oKpQzwHNmDD6h25kmp5v0n2wytlsRMYMj8w/7L9NrRuR/w37t+Xt243gS8J2tqvr5+wtgHZxwfrWDJJENvJwxzJQ0WA3HISUWIHhU+P2vkrpxjXIK+Jlr0nzhV/F8FTPoTy4i/ZovVVyT/YkT6fzcB4T/2C8Z3DaBz7WDFuQ3Dtzqw/hqJZn+VDvZeh+KD2+f5yttdcDrfpBTMS9etTYEz94Qk8pxCiIcEIK8hdHMHLl/6cVvdo1R2g3ERn+hGDlUgCohkQRdgwGRnsq2VqKqZR2l1r4pRGzxbZHS6AJWzWesbsaB/ZwKxN0b6YKGFDmfsPnzG7BYnyKb7LbEr9ag9ro/uKe8gz/RFIDjre1OXtAf+fyqR8tUW2BUeEz1tnx2Uf0FOyp8U58X7hUlkK9XZDuWcEBNXE4Cf38Q8SKbiKXoynng2EQoJIBV6B2nF42cuMdkcC8Jnp+Lh528J3fsVBRx+wIKBHwtA5pusCp3k3KMqKAdNKJEe5FzfDDhfO6X7WwOp//GZaa6e29nUC31YeVmuuHe1rvOqey00FudQ+XbKdN9XsIuvm8ybX1LqN9+vC29eb8nvzoPut7Mo9X0fjC/aBtDvYZDdifJ4NaIpljejCtmiTmOISkagOvSz9UVoY+ti7/Dw3uzzPnP8RMk2Vpr8YH3ZqB1MFSlcz2cSFhpLFwRf3C0X07wEprWela28dIu1q1OkNHuFD2p/4DXz9yKi/Iaza+9Fd7TUmm+HpfAPjpL8V55D/6QzzqnJM5rFE5rO+qok6lsiucbXSej45Q5NO4cU4oSItuXhasihnArG2JwnQvJxDynnvVRV2OeTYoxUKk8pxviC5ItbZDXo4ehAkaXDFKOlLa6LlFWNZHQTz5oPQzi9L0Cg0sKh2bFIlxY4x44tbrdpw3tDMx2+KYfTLzVf+Q4IZW+PjqTrvG8wQaJ8ORW1StsJidlLfkd58PO4T5olU6XqWsrN/12u5Px1qtL8i1iD+8+pBvgzopqPFJ0dJSrl3AKb1lLEYyaa2SayQUzDfaLZ9FetduQs1s1VPj8GxJXXIBx+WzDwlyCSfFvIHPyQJo7eJAvPzqL10CjtbLZzh486UXGvEbvZXQLKoyvwLHjOLHfGWi3cKI1cs14ajFrOdNEbz1qzV7RxM/Drb5rh8lcjbPQDCg2+3yIXb/zA++tV8OvJOv91g27fNKz6aVuxa52MaNQfC7LiFy0GRHASLpLYZ3418fHGcM8bHjzfAO+1PzMd+35Hqa+cYYudNt3xWpLr61NGrInJaYYR0kqHzLTrFWDcVQizXaaNuwlLT66Y+vhrURz8uyQNf5A7x6/Ns85xY/ahMYTeV3qRP9C1tfeKlhsgIkMSotIUJbiq8uCpwFivAJ67PeBp3cNB7DYtlg9oNuung89iMJUuQDpwiLTCm1St+JRHi49YFnvCRFOfY4XCM8gtPMe4ZBaTERJ3Gyo9EkhZUQUVqvNSDKbpvMhi1a5AzxuaonVlDe5q8lHHolPXEhp/pxSSSyHtzOFcqptOooNAzGrHkjS6n6AYT1xkkokLpwhepQqMkU/zKB1iEjsJzHoWJ6ufRrn6alTu+QGrUoTKITirRfQ0H0Rz+BcFJBWiuBAJu0FJLYeyYOdI84797c3TaO/wOmNmbnJ48k024fs2lve8CqWevD6UD+98SuLUL6VOA2nPwCskpt7J5iI83rpLD7El+CbT4H+Z0ytnVbZXrYnjcq89J47705auno6jtZtzf+dDLz38ns0Ov1spnL8MFC/P9w/fThPQd31cfd2VyU6PlPudNNCoP/GL6iZKkLk4ioYPwMJPAsrh81R5PU3UV464e8oDES09sITB45vpfHt00j6UFq2j9rgc7rca6Y5VL/KVenE4MfDRqMHN51UDn0w08vhUcftfm9L8T5a5+I3t1F+4f7iezycN90JRq1cbCWz6E6vgrJ5CQvdW0PiRopuXksndyqY+J0p7iaQIYLusTD7mglEP7ueTBdagCmIzXiRbB/l5dRursY9oRvmYLkqf4unGU7A4WMub3DZQMjLwvIczjEYyx+eYWp0S1rZO8eCCp9Wly9qTpnhml0uqXnJgV7eggaVDA03edXQyYtKQbENwlgAKABHIpPGjuGRsJGjbH69WgYzGq9kXOko0c1FuLZwHgzKeZsViuk8GgFM+Tl0KSa0eTpeQXdLYfJxkD7YK8Po+nzzMdwNWqRcu5Cq+ndx0m6VOt6bA9PA8Mo5rK/Nk7vFpJLS/PPTn32/T6M1WhfjSo4Ze7APBq11KO99Jp8/WJuqt5wf9LOludHPvsjL1f5dzjXO8OO410ZM21rg8elybQwQ76fbGp2+al68GseuvhODVV0/TpzeryvG0wLweUuSXg0zxpF3ONvqJYLnp2WuVgkeG/Pk6AQcj+WwSzcc/ptQ9f7PyvFCzVtLUPfdzm20+vFDaG6/Zrm9odmLMsBQtD8ikO2Wzg4kGV4cs3ptx3Hwg65OF5TKjTgU4v7I7v7mrKe9/rGPzb6rLs2n/blpdVhX1Ks7Yp4gsH68ZYHt7RNvaH6Gy8xKvlRtaCxDE2lMYVRNslod3E0xhb5egAyk8kRLBEowgEg8g8DgGuaVDrAs9Yyn2GSOWnzEA9YDcqjzL118FoOE5RVX6DjeZdPTe2ahMLBy7WG8ZaG+kseOaSs56yvGg65SVYZV3x1Wo0ihHqgN9a+LS8VMWLbZ1MFticsVqJkVZR0nNzaQFB8lwNSpTVsR8S+LgkpDHizIE+2w2g9pYatoGgGWHpss1htMyrJBYp6ijv8XAwEMoHV2RI0RKCWf1hq+g6wdhuLEFC9frdXq04+a7+4pncMDunh5g4aknIU83uelsE28t1hW4v9EB2h4/PFpTO+ONWXd24CCzo0vATv5vFsn92YVqv2sCC6qIHycyxqgc1KZ1unTaHI0v1drZdUt7+cpKXb2Npa5u70O306xxPihy550k0K5JQrfuy5VKvlBd2t4s4bsbVA7K5NO5SDrmKeCHh3Zpy6NWnsSle7PP65PRo2N1sP59yQneck6OBoRsXc0BZRpEujJMtcyU0HTj2uVxsdoZyR3DqfacymBktReTQuv1gDk+G0x60nGdF85MFrjMw9ySEISTKEqORRef5Jq5fqHBt0lCbsVycmUXsJVfpHkEThRBfDVcVO8TIBjWC20EQmZ6nA2iMRTTYvCiHGRK6X0+n9ijVWSTxcQobV4W2MpvLLHxu4p+9va82h5/aCeEqyqmLyqUeFYWqpMyrF+WSvXXlV71qxab+2UTjl7VwPiycqC2tD2uTsd0HQF7OpissFnBLuZkE8urnF0AqXrWtp1CU7eQMioRBMJiPofJCwOmMOvo+FQx+ERRJzN4DVnZ15LFDS0aCZE+JYn72wQRzcpq4LCq7RWm5a1CZbSmYrN1Mjlak4uDdSs52erA031F6Huh6qlnt9d7Jh3Xnve7+o7U6e9q1ZM91u7vmVLt4DeKmvk/JVH6N5PrzCxhiqLK+AjQW+fV9vQN0L02k8d3JPjqlgS+vbYKd3eF/NXVAfhmHiauBmH8pIFzpXpBKFc2AU1+ltWwrYSQLaboZDpQiBBQMQQrmH+32djZ6c9Xgt17r1aIzt2T88Z4+xXQDs4iQsqFmZwZixVbSS862Uuwg0RIXTqByskQ6eoDsW8Z5VHTrh2b7cEJI1+fQNnhXAXl42qEOhOymTMyl13mo9Axl8seaxx2kk1npttPC61ChKsmvab9fLfOf5wQC544FQMQLHQcQzPyHpw9lwCsmk1QAJHDOTWNC3wUN8KHJL2/SdQzm9xELGjzmlipvmw1pLc3zeqLb7t4/587BeNNHaBfuKZ4W8OTX7p87oeqWfu+jlr/UxWW/6WMIb+zq+br6lbihRogrlk816UTVA+Nm2aR0eQCIRk5qaTmFb1c0IkyIJka6BQFtBoHqCwLoEwPRsonFuEMy0wBnOBPM/PM58HukRDEjtIp1NMU2KOZrsRIXYlmynjAV9X3dl33KVZprwjwySp1OFlpe/rri+zgoClN/XTlxOe/mOziv6xud29EL91yDgR74IWptqeESN4fKDnz/zK2+u/JSt/es0dgQeszA71n9kvDK2x8VkvdXhPZm0u8+OW5Wfj6CpS+PgupX85C1m0v6SwbFNGqB4q10rNChXsMmMD/R7F7LsmSGNaZ9x32v7QhMRQb2liJpCCSAAhg/Fxv2ndVl/eVlZWV3nvvs7K8N+3N7b7d183cMcDAEGBQpBg0Wv7diH2QXbzEOSfifN9W1SuXET4rgmTWJRoFPZSKSS1IbjqvnlWG9/71OX70qyfm4O7Zaae3/4ZGykpFqAS1el0HqsCdsEH9ltmzPwip4cmwusIO4UV07h0uj8xLMuyclaTTNQOMlmRTm09s5lgBqydwBloTzeoyFlpH6H5z9eTzeg/4tByWn+t2ccdSMoU+85PGoFYRrXyuRSf7KpS9HRXBHpdD5q0aIzyt0fROgyrspGGxtgOH8lPsYrIh3q1Q73cX8qzvLA4F/fyQ5X6zKjd/P8lVvumQwHft1sYPPl/5g3+i/b6vNP9h0GL/sVMC/9X38f8VQfd/6xUf/0rf3H3HGNYlS1CHdF5oI7TeaylOuyVoVouwlOZQ47FaI4C0rtq6mEOM7Rd424NEg5flfKtDV5oT9KP6VeGTcn/L5fBdGS7vzgb19FHHq0iqWIFUppDUpcS2LT1Pcu0vq/zZx2T18BdX9Prhd/jZ/iH4Jj8k11UCPiuXjEFGmTtZxApSLWe6Dy5HW/Gttv/7PwTA/3p5LP1W8eOTijVZ4tYhRynrEjeerkbzo77w8oInr89J7JenC/LXNxjxw1VZeXVS7N0sNrXbLoIvo3RuYj1j5tzPrTGQvugW8rGatNps6simygyolrLpYSqbf7VT4+/9br9Wfr+pGHdbQXu0uw7srMqQubYFlQZOFrgOk+Qf9E37X6j8/LYBXdCwee6S8pUrDK6r6vz8GXEx49nDaQwPVyLHLTGcnktFbG6A6KIBlCeZYqHzsALrVAFTG5u0gORstnKg4k8hp7YrKmlMFg+uaLrSZZGGxeJNHoNAI1WE6DoAEnAGGFj78Fk7wd4OMuY3Q6F/bBrLmOwf4eLlGmTezjLl3/dK0G+CdO61oTW+McfmL4PI+10cEt/18+B3IQh/72TZbxWUeC9C+Q+syt5wpLGmWalP1cUeKmghyrEOohocgpg6JF1xUDwPsODQJkdrSrBMRGKjhkg7KJ/h23jB6jf/uj9O7fa6m5Irbp6OoNTQaBV6kVYVPb2KcEwpw8mp+4r57MAafLGlj35qiYOfnROnX75ljrdf8mfZWFqUXHJS5dW40vDtPOZ4GSOc5YTeNHtxEQOXbzziah3L52LHfVPzRmsqWkmpcKWkw7VRvzgKkdszhnpzwgRvj+fx6yuZ+/olzb2/3EQ/LD/lL9tpc2qR6tJIkRMhE/rEFx21kgvUrOQLWVNj8g3eSBXBkx2W/HY7pO+92bT0q+2gu95z+92k32mn2x210I1y1WmUg478MvUNWTX/liiM3qaIU3HXPu00epfhTnxz8NH8ZKt8NkGxs+FMWi0pWpoXJHHgmPJII9RxqVHvFui8/yVeESotlGLAFtnYaCBsogWnMmx1nxAzgCQkrttUuQdIgAzCQJk5KMVmuSbJmXowqoPLVwB+fZeT744I/zJwhj2jMx8Hs6OWMlvuYTeDaup9e+/+O7OWeiMvvUt7Mf+qzcy/jgz7pl0mLl2SubYT1LGUIc9JUz+iA+GGR+xDhjHbVMvGMLzfRIyXLVS7JrHB9wqDXLtk/8bg/UNKEoaS1MZtDS9icgODOEA1SXhioz+dxPkna3MnOGX2OxMsfahTlYhxgJbNVmACLZYAPPUUNl7sY8GXTyX3p8I4/unLePXFV+751itlkrW5WWFgGjUz1uq1gVei9XHBk9vl2IiB13FAjTVXtCVe7rC+8RuvOzCr/kipGaOg4M381HTZ21mdtAvfXPC11+cm8PZSbvxwBXEfztLhN4sn1FEnQR7ZDS3ScEZXCqjNfMKaQJYVCgSk5aSGkksawV5TO93i2683+c69o63BdJ2IIi9tzsys37YLYYuudNhWY4jjSAhDxNckp70qKu1XRXvWyQZrvjla0aXRQnkyW+az85HAroZ9LZqLqjqvi9CQHpMDxmP6CITH6WrD+QSosgUNQLN8uYGLuzUJOahhpXy5ICIZzkPTlk1mByhWDoBSHc0nK76xWx+db7eOvt2g1+9Syupuz5lMoPah7Y3n5fbKV46P8+L5/GP4KtjMrlSwfisMOyfaHXvVXljXo1L7OEajWVgXzxy8MTT3a2MexOa0JE3pkdIVW6LJcgOH5Zc0456WebNfFHtHqGZeGwb6KlSdK0dXloGRXAS8NAx5fUsS2BLEK5IsILbDfGxawOaRmZUv6KzgqdlhIJcXHaOZKqulcovONFAq8QLAn5ZA5ssqQ39MDO1fnHwYP3j1drJ9cXyR7UjD4uFFH3TPpdbezCjjPb/YNrzqXLVbJ4FJ919Sohrx0pEm2wvYa9u82+HoQWxhva5RiPvrynTRz3x9JMG/P7K4/3Harn5/qcDfXn0pXc0eq9ftsrBw8magNkNSAGSK/oSH6pt4K4OFwsHY0Qv7jLvP+cM9MZrttfx7i6RjG+mZhZZYBCqCCpUZL6iyr5i1LstAPVXGjp2AvzU951Ls99ZsOMOq3XFekTvdYTTkg8nA7ASjHttdcOXqXKu/WABkZZzymm3AA7yckNSTZIE7sHE0PyoClfh5CXUO8oGyUW5Z5Tzll7Io1UwFZSKn14B8381VX432sKt5QpyfPTbnZ09DR33atnW0K7as7tegs3b+onO8/afz8Z9+vjRSJZfvS4eqRF6q37vTzll1PituH/bz1VG4m1jrKHYsF4kRQxsarZoh0+8rovWSlfUbRlVflTTmLq30vq5YCw+PrDIfQ1kvEMAwkAEz2KJU9a9lE+m9Vah+H+VdR5RassulOw6232frBZMvSLO4MJupAMLwlXKez9VT2kGhiG1vcNgDxIe+MFbV+8OJ8HQ1sHeWo0FaP55nv7saQCtzQokti3oOko2yh5f8lVQ7v6XR3611nQZUldQEuT2x9QtrEOlQ0CaLw5BsWb4TCNHYXPTPvQ8rR/rbQwz/x9Wk/ZvTtn529XD/Zv4l8ypqaWOvFjhm1gbFipqkf6KVKuB5qgD18YwzUnONrpkSTs0Dvt9PCv49M2V/xWbNMZr36HrJaTYqPI9WDMetTgcmNA1s8lD3xDPHdk5VsxtixsCv6hMKlkZOKEwVn55CPWooBchQRpKjtrAzk/Vns5S130sHm95+uKeCYVJoDFJ0cvGilZntVRsvE4Xuy90qPquWij04nROx3TaLJ0/xfOnISTbfnue4d9f79vxor007idCTkh2sUY54mg3lghtpP2236z9qu88/8yWqaQg+3Za7vG9MMN/v5uKYetGLNvdiHS4PFKy5FjG1x7G0xsa2Kb4MedeZUb6x4kNjXIzk4V67Nqy4tErbSlV2uB3C5tOuFWKalyJotdURJeIY551jTlJ4W5axQM5BEf0Q6TRoxgMkow2wglVLtNxsrqjuwfvUNpsRtwo09cSY0E+lBfi0d0lsHR7TqavrdtW7ngDDr3uwO4gxDlfQFl2DWE9ozl5L+PiM5AKVEuMko/mwbwle14xXRx4jzxxVbrs9adlWe/14cXY0mrUvV6LzbhWF3x6H5tvzEjpdAweL2Qs4ajNGEJUExE4IFalKZpkstY/sd3aqyAlQMrpIRYzhCtgu5bFjPsO8uXfQaPxbtlJ6D2XlUTk7apUq9guk1qn5zS5jox1Bp85asrLa95zhc7utVZW4T8KDAV2bWa2DhUNsrKvS/rTYzvR8ZXM47H0+19wvlwX202E6fBjt97cMPHqiYdTn8r6cIKF+DgXGxaYel1sNlgaeYkY6Jdg7bsTufzusVH8jpOhvqIp5Gddj3cp3IbgaUd1iIPcqQRlFrP2iIvBpTWCKOsewGqvgIdcWecm1ANXiGF1DA1PMOkYuy4u0E/K2uJTqSMy4DZcf1HT1G0KPA5ntiVO0p103+/I4OdgiS166X1dbbUjS9Jbc0Wp6OxIcZgJaylXDJvq8mZMdkQk7Ak+4fLF8QmyQx4AuHjYoYFkHMyflJ+Xz/d1c/Iwos0/6GX1DL4abTlfa8a+B/eBXeOrlGVW9OlPQ/lFIkxOfrK0iWDzkYfVVC1nfYmx85or4hOHLMUucy6J8Bvpuh1xHiHbj0dHEVcyFe+Fc9Pvzb6ZW92Lej+NDTesfW9rVKUuMT55WuyORV0dlhekgHSgqsXv2hpMXqguIYsd5Egx3kVx/o67F24BQewrIyHNAsTYbwvt7L5THrx7iXx4/KO/FeymGSyfXSKN4iHDgUJBQjbGwNhVQA9QVXuV4t1tpRgO52Qu1FyM/fDTroA/X9M7T5VbqWW9ZeTIPy09WWOXzBcH8xbSk/ay/BW67Keyhwvd/LkPWQx71k0yhV0GbTq1ZLvjVvYNeGqLsRGdiZdYzq/Jd2yD/pU97a7jaAyuZKOZ3enRxq5Mppt29IixvRTSh9lGy7QMsBmKUp8vcWIcUkd1TxFJdQSo1UQQ50YNjBTQnPBefc8VwjlvHM/K47cm/C4z4nOZn7TGyajmNWVqt9dAe0N6XU1ZR3pEVY1OZt/fsmVJqu2ij22jUwhzaMluyp2alOQs6LwmCvMMSie8AOPmq0qh/yGPQXeY+cPPiwOzdb1H05xNEePTWNPcPBTq/0KgaQeOVl10FOWND3qf6Eh+1ReA4YrxzjtdGFWG8bOr6CDcaE17eDkWyt3K5W9uxV+SgLZBX7ZZ26ev2Ivg+vp17wrcrQzhem5h/pBe1EyYvH4EZZVnIq0MNoMdkoThMAOUAWxbc6qpsFLp5AQrLDDb+jDqYfgwdtD8tG53/Wh2YPwZvO58w88G9vww+3vmZ8CPqE+Bj5YuDVpTfW/eR7E2fa/zR71AEGfHpHm6QLvmWYbRrDI9GZGYwpnZmMPLzMUl8NJAqnw7T9c1woWwNosrWxDz4Yia/+KvZ00eft5OFLy2h8tdWs/ITFaO3JdYpintmDf9CZitp0svgRHwQk+tcrz0v9+Nl49dBn7shBWtYSwXq1tOQ3n0R0JUtL0PlNc0p6AkU42gHZGC/QvoxxXgOz0dcTa4r25yspjjSzDCqS7Gr4VSlgyOFId5KNHok4tKQW6mudqu12n9roYeyUjqskdV5i62MM3Qp3vfSVi1+rPrjHSNk95ygXg20VCVEc3UPgmgTKnfVem0uJIBbbA+6BZKtr/NS/pd5uPi7dCv5IVEsfb35uDL8os4aH9942pMrRN47z1OF7gFXjQt+o1Nw4BN+wh47Ha3tdmxIdzRuSaveZd2Io5Zr+oCfFWi94qoiP5GE5ZVsLkez0PVfxkR4EgbBRecC/3bmVb9eseXxkixaM+0pOyf/vDFt/RgZAltKh9+mO2K52QlrpT6eTHeTrQM37ZQUZrUvE8MH4kb7Z2h6+mOAOfzz+vrr/468W/9Eei/ee6gWap9yP2M/azwfbmWJ9m5q7QLls1hsqaEN854PO6qD2rxH3KiyfNtkgkmh0uuCB2MceTqo1u63FfBZTGK7kaY9beuNX8Rs5XGbTX8UVR5/7qRTHytC+Zks7T9TNGRDpY2M/CKoEj/jkFJaClOEECUu2aA04LpATA+hS9Jhli1G1dKIZmyndBt5bDnijoPoNbPhIQrM8wLnowI5qrHaUYMTHITrayUF4Cu8ITcEVkf5qM3IQz02s/S5SIrXvImeiyQ34w8tTX+rsJ1f88gRCTVXIFeeNbnSELWzvYy26cOrPad5uKEL7bQutwq6VWmacqZulgsNGSlYArAX0elHh639zFXlCfFDQuF+maxWvt6mc7/dLG/dPsk+H37OQepnfZV4OMXhF+sSkRiTQja25NJLjm29llz+RIhNV5ccW9Y80+CClk04kUeGFCf6oApZpMYZgc85/kD0u2s39sJBDzeWHRw9jWb1r4fOg/djOjcd5ZN6u/KIdoUvBNd9hgXgC9T2S7inboO+vAH67n4twhoJHxf3XaSdMlvuC/VA+yum1P9zLFr+F8qd/QUbX/xcCt17SQE3H7EJZwd5MEwVWxfF7PkVAxx3HUyObAzjHFhDfDSEDXJc5fljizKPK0Q0zm0PgKdP40bjke8UHobms2y7sbvlSc37HoJt2HVpTyOxLblSeMLCrT1qDFaFYbmmS5WS/osahX8cCKWDG+YAObH2X3bVYpd1alHHBI96AhkIEsOmm/QhnFP64qYVKfseVWs46RqpSAqt2IcNTR5V9brSEskA4MNZXm6Nq7x9pYim1ZFVyFQ8UjLKCUsE6j0mioaCMo7F2als3M6g+I2FLjStsQKVgynnJidgdqfP8Y97KLcVHzBVO9XLyOQkK8piWdQhSirnWkyl2sLSoN5AgKjaAs+KW9hv98HuL7dz7LsnIP+b+3n49ccSN/g41LTPLbb5pR8VH71ZVvYu3yIF8wou3p6l4dtxg39ptSxjH3GCPBk4INNG63QgAUYgJp2giZC2uGLs0YkYDTyjr5BaXz3wB/nsMGokly7/eOmsc70O8qNRuPFffC3/U5Oz0pLo7auKcr+pcFuUIj6uKvYzXJvlSNcsp3yDfxo23MdOzdzQmuvPJWj9l5z/6oE4nD3W0TCtgNo9UqKniFA5Aank9xiEvqMbkcG3VpFANdgmWofIpibDkGEy8Ie2LmpVW16UCctM7TtO4yM/f/ATnah9oQZgxlT3dy09t2ML2Rd2ZjcjV7b2GOzhfbL5ZAvtFLPUWEZERSbEEq9TeQWBN9tYObcA0p0uULgKtGYs+6iPGwQEkkjgVfDbyY4yCjctSnpuUJW6RoKAsuIbjtSuuPVFVif8omoKoO4iNUsRMasU+zLUHvFu4EmtosIRiMJEJCmMKVEPW77dkSR/Sja7r2R0pSSKKyKzu3hee95x42d9VnrSg9VEm3TxMK81rQO/IbYcmCUhnAarTazRKEMHO3QZ2xAL5MEgh6G3mS3x77YK1D89zjX+/nMQu/nIEqJPDKL52QxrPpq5+c0/rPZL60WuqZ5lmodXWXIxzosi2RRDFlXHNGVbTdNFWdeC/yiiNxxnVmNjjQE7oo90VM7qlluOb4FqmMryxgHiCTGmK/hjRmr81GAzP5FRLWlhGmzjbEvDgqRAYp+5uPKAwydZhlvnW/q8WfS78n5cVZKedtzym33A5qcHFtOtmo4D2FW+pbXa93xTneiWODSsTcvnPp0r4HhJYp5UIHNYCeKoraZtoHDEMHgbi2gV7DN9Spb6RFFnkF9oUOXHElv5TGQS+7xXzEtaaUPGK2kxebBBpHZegERyG9CRrcYrLEmNcpwo1C2xBik0jLN4Fi82d1pPCwGXr8yrWtPIeS29HMMBouIzuMYdE5uGTT63MvV9SSDrkgnByhuoHAZ4K95rHVgVrqqwWEYe8UWrC+N+sWEaDa4n54AuLYgizQw4MvZgLjYReW5wtosS7jHP9Ry6ODCBzEiCt0Z0c2dIU4m+gKR6NA91W2UxAnKcu59F5a08QsJVCG3VmtBuDi3tpfkkD7iJsB6kRfIy/UT67cYu+n/fr4n/9AlJvPpIst2PNKn58RsffPo6BpJ/006Al/ZjytR26bZbFTizyqthQ/CChhwagt7TXQfh2mZRHkkdKNJflhvRsFbpN4vNmASEqFAlLZZmzKbcUNMSzNbbZbzE1yAgjdelNFsfN6OWmgvhcrILkOWgxpS8ykgNmjOBwq/5knzLVv1ePhd7NbSHE1QH49AI50m/JTM236ZtPrAsNr6nB+J0HEDKwKlRfe0LwSaYLo+JSg0r1XZAp/+ixY8OWk7MII5i4j6iU90mw3f4ugLBTwSIesA0c09wLZcgPLxKG+ABW8cKxA5SBXLQdtFXdysWcVCb6UX4MIfT2q7GQLRCwEkcTXy2Vy9sbuXpZD43yMIVNyvW25zY9PIEfNjIMCelJxr/+Jna2N4SiIcNznxUEz6QsGcjSFhotKwMAYkq2ZJ8BdFCCbawmqMnUw6Hoy7dG4oi5DRYr18T4mlFcV1G77KIu6q1OlwFin021xP0nZ6iP++jxouOPU708mY2AGLQqrcINVkVmCTNwDBPgLUEUd18wR6UIXOHK8TbU3l8YGnv0h8T3z4rtH5/P4v+7iN7ff4JeTv6qH2kfvZhBG7ezYDs92cb0En7MR3oCc7HEpJOZ2TFrSuqBKqBzxt+zbXJ+6G50TI5W1eFW7Dldu4nQ/yzuo/ulxws0zRVqmSBeEVt6Xlxp5PEv8By5Tqay0VcveTDQo1LK1UkoRSJhpUf2lq1O5DA2a2EXd3UpOFiz5j0d/wRle0wVSzGITykGp4vqWHAQoYnC46vOvfMXjlwg1J7bDUNVz3AdbYi0HiZ3G/Gzi7qs1sEuchhzCmI0mMYdkQQO2Qx3uRLAjEucnt8HmmajebQa2GaUMd9aY+qoiC6ieAVnKqVpNpGaYAUAKrZqo1aGHRSkujnWRZMIpVivZLK1Mu7+wJd3h8oQOZUq9VItlYZqJnGVN5BfXKLNKBNKreRh4kG0nxDEtzbQslWd1EH3Eb1XBHlA4OQXVfSKA5XqrDGwUOHntwIommUZK6VkjpiUpeYlM6W6prKsfqCwfwoBbcHIDrgC+W+xmwNjDg/IpTsAKTq8YNSRc+5MA8sLSo7c1pPRbeYBaMDmIv2Ej3v2Xjqby/jwxTNnB38lHv/qCxffxbqd/dHxtWzurZ+YHzdefT9L/XEd1f1+ulyExubTxieeUTH7U1hoGQ0Ss0rUb9q1HJNGchy7KLGqOXHKI+UC4xXKfLBxoHkbG+q9N4jOcC3dBlL6TyW1gX4ufYXqU3kc6RRQKlcVi818szjRpZ6iKTVL6FMZ5cunnBK8/rQoKfvCWlyg5vh3bbLLz937fOHvhyUAjTQnNA8CUCw69ijthcMjbDXvtcd1qR+J+lNnZQrySVTZLJODqXtBKwaD5Db6GNBlDYFMCzRmWkR1tcJ9HiIcEc2pe9BDJsnBQxFGdimRdRoo7hkAHilVYf2c5VyuVTM2PVcvrOdKTP5ZingoNqyJcCFLFZ/JjXS1V5rT7CJPcPN74/tbHYe5Koiv1PpWTmw7W/CmriP1sgCyBL5howVGkuvgp2PiqIStERWYgU1JYkdZKRxqqWCiipEck81dVuHdVWGuQzvIk8kH3mgAfDnYhztqIoCaDIraEuZ9XysFXXhYm9qbU8JNjNuoIleAgA8qI5ZBM3qNWsqfdxftX52NM1Aq2XSHi/Suf5yJxxPE9b85IDtHCU/at4+qlNXX0Tk5cMB8fL5wr3d8+bL5MWtVLodNJAQz+G+84DuKF8ICvJcHIoJ3eUBKwlCYhUo0fhGkZATVUIGqiRykEEpJAe3wW3Cr+zQPfCB6FuPFLmTUpjuhlwff8k9ir+EHnU3cjkplWgwuW0qBW9idfh5h4e3v5KRwt9zGPmDgpjdXsObT+GuYG11jdGXPTDcbMsB0G40TA8nTp1h9yKynGFsqqNuHNzrj/BSu5+Ah96+y6k1HeMzWgYnjOdooP6CWPV/IfrwlwqDZeSSnWHYD/t0/3VTcGJNzlI2nWZmMM13oLWuUhwDkXWkDO+h1UoaKWQAPJfA0undRbOY6TFwUamApTZC1lQEqZda5cKBCiVFl0xoRutgwSaKXildcZvp+sjca2lqGea8QqtKgABtZ2ujIAu9xHPsnDhQMKAs7iMoMRQD7ogd6Rw10IB2IHZjX7PkwKj9ESwGcoxnPeU9479JjvyZqnXua+ygopqxpHcN0nHcknc5KAxCdnPShBODIpiK9luwIZCooZOaSRam+jPklP6J86Zaff8hr31/XSj156lub5Ln2HluFz/efYi8fFBz338Whu+/vNI+bL6mbjJzNqxEnAiEEQoderuUwT9hNP0+G7JfCn1zU2MbgJqo5plnWA7krBzYMUAYRqtNq/K8he5tgg663eqSCfyV/VAejtOmvNw2pZtHVv7859KT+RfYX3bv55LR9t5zufBY92pPTYt5Pjxq7rw+bBb+udcg/0Ur+JNWruPgxX6I7I252vaogW53syXAIwHTifGzMMDexDKz6HSU+VDF7q1iuTqNUdYPNx1Wq3hNIU/WSZTbQVfuc46jH7OR+FQMjZTaW23b2HDDwG9LKnzJiXlPonJB0JJZDu5zMoHxTRQgoOaOUCrmourBFlXZ0IzW5iVTSiubWNpDwFwbrZTlZrNM1UvFIl5KMQJ/QNPZhMMcpHr0Xv5IPgB68T4cuBWsHFearEGCgpwFJTgLXjeSVPwizbMvqlwZw/GuYbKrZqT2cMtqiLaqjj2tHttiS8NYlShxjveZaHY/kab9B6bl7zmEWDc5kTGGI97v2/U4hA/6RqU+qAOpuNrKeRmC1ASb0RDNlwxpolSwE67cXxDQ4hA5WC1qpcE4T7ODHNlapLeo4818+/QxGL75Uru8fbC8+erFu/FVemEdlo8YFXL5JtJzd0h/+Jhl3T1mzD2T2DAtkmqOL1XrZIGvQ6zebIpuo1mWSlVa3ikHRq4eEtXmsZMkf4iem/P2XhhFex22m4532hvWZ7Pn9H+bJMuP1/v7yXn2mTwGnh8Nsvt9O5M+DrHqr4cQ/SsBsJeNRtvEUx2T2esa6l4/LWwGJR425Z5jtrVLr8sft21m1dGYVQ8r3nvlda+P22rcibc93twc1LnyVY5QrkAiHGQZhUuwA3tLvnCeuL78IvTn2zFk5IIXrbxSJOrcEwOE1AXcGowxAsQoGIWIZg0hqg9YLJEX0E1Kh17oPrC5GhWTPpNNe2Iix4nJnMql8k0WSOERnaRn1X3b3UnOOgeFt73dVgBnsR5QpRN1qEU4LNj0kRrrVqodJw92Wml4Xk3SZBIh+YRAnAWWtAhFy2Rxh5Vg+yBBSvlslR5xaTHWdjXb2jbiXsplA9TBfd7se65vt+RQqNOhjmGRrVfjFlEJQKvqIK5k0HRXb/JjmemPRGvelVuRK8A9k9kINehBrOSar7iU+FX7ABy92svq75/bg683bO/VtuOud49uTrLtybR0uuCh0aqEr7s5XoISQqOYp6+YvAYRu1Iq2iCZIEcANAFLdhXGIrJZ8aGq4KFVoYNXDl9zrcujCvtrLeXNKuVOtwEOqXSjny8R4aciIP14Xmt+uapm9y53d/iz9Hb//cPk7DKXf3mMN8+6EnU9lrVzsxl4ytN2NNjuKaOdfmqQ9flRy4eUwHbDQ7fduYps9yJu2hcB1bn3Zkhpqz4fmr3sQPCrh3WzPCrLoJXnMJGkQx3gh3RRXWEZ70JI97FGubvfzDi7Qk7C6T2+7D0lhfMKAU9ItDrmQcIjATjAKo/5RqIWgFuiV9tqT6v7ai+daDuJtOekc3SnmFWDdFaR4ZyiQPlqABy0V83soktU2xrTsAUc6pANjKVQhI4YuDFCGswZBVADvObQDaBdyrWIVAu8E1HmTDI1BzBNr9xwtostMV+oUGKjSq2ipjToQkbvkHDdWyJgrxQfG80dxruwVaXvWBTt9RmozYhAJPvVqOXoflYJdL57rJnx0FBHA5NZKQY+51RgzAvbfQ4t3+kg+Y8skP0bvbC/HOwj8XqHj/+Y0ae7N45TiPyg0ltJ4PkhSroLgOFHBRqPE6Qq1qmzblNx7D0tQVfZMlfEWA1GzR6EwyaElHUW0KcaOL+IsO4yol1f5Y7jlrHmmoHeAiIxAURcgg9zCGv+DJHIFxEMbE9KWe9ks+Dc/bg8/OZZY3oGotdDWpy4hn7ksOGS2B10nI2p6G1MMrP9TvkD5fMXgRes5pFtnnXM3rxLRW863c69q5G6eTjWq+4EaML9NJEKtg6yaqkEcEyBYzVc4joyJl2KNXfYKMVECQzrGOBsgAeCJW5LqvBEbsVJvjWC6eQx1SKvM83cBCynjkrp8kVxLxymD5z2dpo6+uggPnme6/X2yxgHFwhPzKkdJh/ozRIr8UV1LZWic6Hm9LoNRVbA7rqBdI5IUglBkj3hieqt0kqeQBViQZRsHqoMrTz4+g3OdHqBaDR82YFIdauOU/VuAz38us4dv8X14zd6ePRaHhoX+qh6OuqUT8/81vCtTZ8uLWelOZMYattmtiPITKfm93xkeOiw7ks78MeeOzBCcqL7cKA4lTGrIue0pL1jZPBNk/tppACPJnYauXGSjatwp/2mn7h7p1UOI6o1WGP4yaIs6hEsEXFFyM0yxPBNjZ8dgxpznFNTfZyBVIhwV0WabhMkpICoQPBIR5+RXWvIyfiUj1BDDnlJ74uoAwGQIZUlo5uQ3PwzQUsiOpv0CCTbadYH0y9andv/jOvjnxGeuUev5JYykg2rTVDeW6Iw7tYfLKLGl4cctb3eDdghemn2sOkgHli9oULGI1ZaDvTyvcNgsL/uutvcAHlY6ny+n9FTUZXLiyTuOigVuSQXnfHSqEubbQZx9UTJy7/I6sVSWjDJ+9Jg+KlBDnc1dkGpxQuIK50X8NqbSqtw9qK29fpF2v7+aXY23q4wo42y/PZRmV2/KGlapcw7Yhl3tYLdtUvzsQY6otviohAix11wPVPxviyzAkGwozYjGyqkpmGO2UJwaMslit3Tau03lzDTtVtSXVQZu01y+hIShBXMhytOXrzj7aN/1OLj2/Z0fOOu1Tezw8rF29me+01HPP6hgx5dROxJEEaHeEft013HEPso1u6UpbnPOStvOFzFYWT167HY5r8iI+KED8Q1GijXSvDgjpU//6WAZL41681rs4z9c6fQ+X+jqvdrCXj3LwDVvc7zw9OGarZbujzN6pSxp9py2pi/rgTAKWI99GDW0wSBYyW+DotUvhG0fN/D+viCltkpI9pLZhL3pHZroMt7tl7PMBKWcXg7aYn6Y03Gc5SQFzCytkzAV1/9iOOH/wcL9/6c0ns79DqqK4HQ1Ntm0zmTgW6/+Ww8LT1Yxaknx3itclh0iGluoHaNldt36ONRPr1sI9V7p1qnPLGlJmbLXsvhhLT9pN7gmg5BeX2JfXmKG3yE6aJK6K0EJPOPN2R8/7lAqM+5s9tdYzDc8QQ/5xojzi/4TaN1U1TSPzxjmv/wEZ75p/8OFn/7Z+Xprx43+4sS2lTzUMpOlt0RXeNDsSZ4nWpoTBsKNQCnlQFmbK5wJjXGjMcd3NuX6RGHi269pGBlVMxIHAn2G0irCzeHJoGtTIx3jZzIqQVxOMzrhpQweBc3jk+V8Ouv+nP91eHi8NX4bG72bmh6df1A+maJDH6YCaN/nGLuN2O6fzdUZp0ROrb61PtuVzztdaFoELrr0zjq9PrtI24SrsQFMGbG6LE0cN+TI+PXwmTnvdr+5FeS/PzXBtH9nxKrfxdw8G8Eav7/kFL4N03Nf5835auUFV9XPWC+a6LTTe2bo+1ObOwPnqmQ+4lpcJo+4BEwZEr1Gapmxxi+PYanjSEV1K45C74WaPiUp1pr1mIWPNAcUC08xOjGABlhAh2zhKBhCVHG74te+z8otPO/y7D7f/Gy95iPuvvKQMmZLlB1ehQU+bntTq+aGs6g58t++NkxbB+sAbc+S6tmF2oOogZ44hageyNhAgf6AhI8VEzZVT2lgq2USEtNfmaxel+rOxBZN3YggCu0krgrbJCLeEc8Cp5bwaTueT0kdOZMzEZoW3fLsTxJxMDokY9efeY8P/nPQnb+7wi2/5c46ycwjC3BoECDsquDDNlvkPBhXebXdQSdVMz6WS1KvwRryZtKp7xs3HBtyqQJxqxnOb8BizhNcsBhgywoUGtoVomlWBQsNCFF1mNdUjf1trFvj3U+emcHs9vJ5YXefXvJmOcXkTq/lhuH11ng9gTzvzmElG8WkvzVQmQuFiI9W0TR5LB6NJ5Xl4dDqT8e8nE8WAXBMgiIQ8vmTwhcO9Qi7ai3dC+4l/Z5+tZdfX4mx6nblq28BRz3BPXDE7CtvmNicdqKlbNCrB4fdNRBulvtPwjY9Rf+LHjUDeyd4ZZE+B+ZJg90AqqpzLCD2hFAE1c1FzptjNgTtE9fUlbjHUNBt7RKnjKceE7DzACvWFNIbrdbS1akHLbA6vQLbs78RNOVf68z1v+moer/KVnRQ0Xs7SgiUVWGrYolYkWrw+77U2ar+527c9S2n5yh0sZxQdqeP0CACJQ6bhNsm8nyvYgZIY5800I8Gs66G9oziV8nRPkKFEc3LcPpNa0KDyg78QsKHiax+c1zbrI8UG9PdkLrEIu7X/UG3JncJ9blbu9udyRZj0e8sDMEyUfdB6X/aOw2/h2H0P+JrnvbKDmowrSnQ81wCmD0vKpK6xrJHVdqlZscSx5lffCugAnvcufxGriy+gTdQjHbqpFjFeIXDqE/VBpUtVNDolGZ6A5T7HTwSPGCL3St/akR9nPO/EaM/zDsHF3AVzdU7u1Lwr28oLtvz6Xg7Fw5Xl7U/LsjqP12SXXfzMXO8XzQf3V0RN29LDQvTjLNyYyTuzMK9iYr3Tq0GfcEM8PDdt8+7QWDl2t59FZC2m+3RenyKdua521ogDj5rnuU6y++qc9rc2zkjYipeJye4GfpkdJ+MMbMnw0q1KftEfrxwNh7NkwmgfBRzlQSSo/eEUdQdXBcQ+aHpUE0B4bWJWyH56g3eE3I4Zp01DOaqp6SYu2SbFUPMUCImqsBTlpUhTbETfYk/InmYv/JJMg/0ST+zzRfu29l5ZxEnzaF6WvEMLolM36T9K6PNgYf9Ccnlpw8Q0obx9vNj8Y7YjZK1iWzTAykSuOeTA5qNn/TIGwvUfBgctMyJhlH+6bsSh8gF1lAFhdWzVS3KpivACn6tqYtbwDv+kN1ODuVl/rAXBEGtjBieAloxQnB7Q2J6kY/WfrIf079qVzk/4TRlZ9yeHuDblh/pDlCdA8Y1FhhWBXby2rBXuVoZ56BG/2DmXJesM2Xpfn1Idgd+kibRkhts0ItKzVpcCAYyWc83+QBKlxmuM5FRu6svzTC8V87trrpnZ2W++ZbZ7jqjZdj/Pp0Rbx8JZKHr7DB8mX/6uVdnXn1EtTOz5D49pjsXR/K/qtDGnuzHu/fnRV/9GaFPL+Yg7Q/8mJ/2mfNdZ/UT1UzPrPZ8NLi3ZddanLnNfpvX2xbFwcUsSpQ9bEng7NVhByrPnBSbNcXg1P4WDmtn6Tv9mb07PNpKfmTXr78V75AfOrbYCLM7uEWuBeoux8N6CYdYNBw1SoeL2rB9RE4l07xNnJJq/w5g1NXFMSfY5R4hAjYNWLsn6Da0y6mVDQ8hAC6r6cE1/+F7Pt/pbOZ/6CZ+//VcIgXlmGUHP2m6fLfZdyTb1501fONXnj9YvT+5PEpUHi2YvPpZbmYHn+SabgVWdIPMIkDi/doeLz1/3dYDhfPWhWnx6TD01l9pC7AcelVvZN/nXHlt5hHv7KczvdiqH3HR1dvqMlkTa39KX6M9ZFDZQEd0m59lVez47ye7qBGIoSij9yt8GOpfvRztnO4JzWoMpsiSARS3SZg+LXAs0CS84GCOC0k+X7CDIyDw75denVowNbaRglTh+swDgw5EOlhPOm2HMaWDC6OGWkUQaYbAo7T2/So+Y579Srbf3cqHlbi7kzpz+dj++R4bRy+XOizt7be+aooTW4x7PiaU9YvcXJ+AeGnJ9Xa+2X64MMQz7zric+ve5Ps8VSvx3MCUyexbi+Phdk5hcWnbhhdKEx8aXFHL3Hi6BKVO2cpVVw0utXx5LS+mo/Qc3OOXTBT+HxwCd34Ue7uAZc+/kt1owOZLwIEue9i0FMLKxb13AEnbJemaFQZk36jx3JchwGVGM+SQ7DN/nEHrGghsaKY4hkJI6co2DiCivhJla2dVqaNQdOpqfAxDDDzVlVxiIKeRX7B4+hfMEfWp+pI/dK56WT7sUWPuVFh3Ok/nFuj5yuDfrbGiBeLOpcd82p5lJOguGirbgI1lEcpCUdy98DyaaLVukrB3B1Ztd538/2LLrjqHtdPKhfFZfG2NWLf1obWb/lx+/fOnPnGm42/sY96DnNu8tAlLwEXTat2Ancr66KbneTZ7a4gPek2+xthzd1zamNAq05rQp0g6BpooogftWCz3RCsfoMxQiDXjQvAvJMOz+38zY3VvL5TGbDL41lfA3EbAEIPgGKMQMeyx0x0R44UUR9OBbcdkWE8r3add9XB4Q2+XJ1HZw1neIj3B8vBbHay8rs3C3v4Xvetr/Yi81qxuzctcXyJtqZnhe2LVfLpm2Gu8jdRufqtHRY++CfUV4Ow0ZuYRDjz3N5y0pyexNDyknDjc82+vFCjm0s5XFzi8fSsqVlHYkQdBZPG6eEx8EoPc3eOU3/D6uXXDJO+fZ6qnfwULHYTHu42g6pZo1symIb5GmqTu/wA7Gk2MgM0RsFjJs900SLcbsh0B3QaHmRttmE7OceAF2cQUT9t7OYu82LjVX7EnlZjcggeAwZxVIYlYyshZ0tf0K50n1twG9o5mw+PTXJ4yKkrmmYW/emL45p5f6G6Hy8Z/umi5ZUmzFAb1Y/c7rNxaH3WFOnnNQQs5e7tpy6IfPVvaIT+n07T/yqAJx/m5MXIoV41jepVtdc8cafIueODV0YHe8mo0lWtY55YsXnm0oVLndm7YujCZVUvH29ZiXFllOl217lRninE1EyMGrHlfiLxXK5dx2yaJxtsjCBWp8n1DNA66raAQVAnF7Nq77LffH0hs9GUEyt9iU6GPESFrSalw42Fp6JzN2aHzki+5DXPJY1wYVqDi466VpeV9fxOvlBWnUvq1fCcO2yfmZ53MTWU28MR88Fy7W9f6NorKiRucl3ndLfdm6XIWRfjr9v5ym+dXPlflSP8H91x/at4zC6HE7a7gJjeZGqfrK/F9TWG9i+d6OZaCd/caEerVxU3umBm/TNn0LkcGPSt7x68kXXgjU7Cb1vlym3aT59nesgq6arDJKKHiQajP+UUWhEcBm36RBqymrzvgieBS1qwQO9hLgQqGoChYRWp2cWwrlWFvUFVz9zUwK2LUmHnq1TQeJvrcZdlQz6qLpm4FT818MEXeZb98jljEhl2Tuypb9lCNEacwVJcLKYSeyIXkqcg9mSNt58t7G5izQXoyhw5h9mxO/mPnqX9whfR+ypcTmn3csmXvVL530SY+2eaaf+hDh+egPhVn6re8XLtFpKhl9wUvGpr2C2ek68djrutHCiXECieelTzQqMzl4afuQL04mmJKqyg3sEMHKeHxqg6bmhcL+G23Y2BLj0wVMQ9cnDaP8REt4s5s5jklmMCPYkQZRaj3bVPHQ9IxdZRLSsJXEIHUcjFIXFMQ7OlRMwmhuAObel4HDuT9bh92bWnX+n6RU8hb7yOchf73vu6ZNyVdP1SduTLVzL1vmfVvlNc4LtkALzhA/BNmjMvf46OJnnyuJtiL9wc9wetRfyDNPL+2bi0f2iPuueD8eB0Lqzm8/j01Xo9ur1s9y5unPnt3WDx7ivgaHlHD3q3mDm+pqPh1ZTjX5sc+xZFiDtM1m76sve2BHHX21X/6FNg3N3mZk6dHGkvGlMatmMc5yOE9XRYHLOw7YioaxNEGeNbaRSr1hAijzaJjACJab2gZdn0NNPMrBK0dbI/X15kR8RlRdxfl7GD46Jb7peHgA5ewCJpJmH6KIsrVxnZP8n2BqvC2UJ6YS/ahcaRU82cUtzesRoVjk0ZODUx+Xyz2J7/SUozf4RY2AO1XHmm34OygzVV/qeYZH5TF9y/y1jz20+Ey8UX+Tv+ceXOKdTeFGvkNUhp5xGlvqwj1hnNMies0Dr2R82zwZC4Ftz8dVoqnyj67gmupg6BDjSHJ/wEXcjD8ptu+5MPkVJ52eew+JSmujdku79mfXkpKtJSrOlDxlrYnN1ThK6oqhqka2WSELJyi+C7DKGPRHK4lvjxlaX5Z0Pz+rLX8eWwPx2Fs7eOcXGKaG+MtPhOQ5j3UAN/DXDYNUUjV++lxochk/6VziV+SKLZrxpK/fW2LZx9THRGlfI4ztRfOknpB9kY/Kva7/2b9db/H/0Z9t3syLg+0fzzM619dz67+OHVePj79970hw/T6MMPKXX+Vd3tvRb6o7ui0b+cRvFrToruFHV8h2HHNzp8fJtO3Jzt7VwvNrdedl5k3lrp1ksJRM/YcqOPa5hI2C2QgpDqHz9nAocxtCTCYDqCi+UhnMaW9STsH+xKDL3LyfLO8LB70J7Nc6g/SnPgYUrdOk4LjZtUyL/MLaJprRtNmi6jw2vBZ142+vpF+SgKd9bdeDsY9rfo+byEnnhE9RwTSycMAh+Re8L68Rdy78clR/scEfBHFlTNDO+hVdPU6xejEP86kNTrmh2+SYnT453SSTeZvozQzA2abFyBEHHq6OYFilmnXNk96QnipWdz165P3aJR9brgQaeSi51qbeEM5bRjwtUOrbF63LjWl/99qfiP3bGEW+cCo5xzHHPKetUL0dofyGomUgTNk1HGFTRSFL0KpbSarIAgDqtaERf4gbSOBlb/Igyiu6NYI886x83l1Gek5WwsnnYG/NU4pu8EhryT7MJdhd6/EuXnV7frh1+N8J/8kqv/xfd16uOvkfb+20884eTPpE5cx458XLxzEPVfTHX4b1bg/L035b/p3EBHi0vs5sJOXF7NnXev3c7v382nf/u9JH7/fWB99esSefQN3h981TTab5rN8JXX8F4L1dFrFJq8guHTqyb+4TSZ/pf5TvXvu+nWL938wW+1HPd3XMX5AwGCa0RyOcSRqhhKH8CqXkY0HEEJVIfLPbQOntfKuclmOj14tmOOgb35zMzER2ZRHkyKm/JyvyhONibWYj+srlPr7lVpHp2AYjgAw/Ecbnsj/JQ8EceNKz14cWq3M3P/tPD/UWyfS5IkhoGY51EUcaHQhXghkkcejiTMYrFufM+07y7vbVZWVnrvbWWW976qy1f77pnpsTvrsCAAAgQg8qgfCl3oSRT63uMrNy+ixEkdTq2iqdQkcJjtRvb5WjIJFb8UGMHdQHFXPZdJVO8xyfZGgYbtMlETbO6E1rQzg6ms+VDvNO5eEHu7c4PyLBUwsSITyiKaK41qhDYfIdh5CaWuC7j5AoRyV0EGWGskcZrhjYVk1pYq3Vp1peKlF9KW/wtPlR5IlpTVFxyE39LJ6BpjoTFaoKrkUhZkxFURsj6FQY4pshqPcEiIpo1UnjWDI76caSjvoGF14O129vbXJVq+K17rJ90z2Zy3MfSskFQu5QR15SDZ26w7eJml9s5GjU9fKOp/eVl0/vNri/nf3snZn7wHkN27nyTg+f+arxXR04VDdt/ldecHBxX+Iy/Of5MvTm6Lt+NBr2yPR3fi8HwBje7q4e8/iNSfPhjqbz+y1OVHBZt/E4Fmb/YI5yLN5TcGWThT1dE5ivRO0eBmdbD3L8Ow6/9ueSN/KT2C/iSLxv8jZ8f/L//w7t9z+d+tEeyEy8ltN8wrPhi2s1lJ4rMt3cQogUF9lQPA09wLB8r7HrPq9836ZFyp2MnUsBV+3qgdAcXJLt1u7rxpToOD+DTRz02hvDhEhGkLoRcNuLcZUHx5SnU712Ldnmtr0ym/T2ZHzn5iurMbaPuOgRJxyBTEx3jR/QmquUI59ijBwh75HonqGodrhEQWAZG5sChjWspUqka62cLc/T7hmbJYeMqyyROJYabpTHlYorSTsUBsKgXx0uCpa8oQLn06vLQ1ckPw+hox7IXNqWsLYM/SWW35n/BS+andVvyFLuPX1ijCT3JaaQA3RxVSMFWS8IpE6hmXk/cx2IlCOJNkMT5qY/V0ia4mO8Iq1bQarnZJjE9KPDMrnTfGvaFcmDolbeHQxqYgiedoBjgtpKMXeWHvurj+1cv88r+/5pS/veN9f3+n7zx8E3T5bg6i2OpLttyJLAe11NlFka7+wek0/keNK/++ViheNQd0a6jxk/FSGm068dnVxn31zo6/+poNffs1lbp8z4cH79Pu5p0roF7EEWNVY0rnKNQ6DSXq00R0OfTs/tDI+H5bSWb/Lzso/Fltz/+Q12f/5rh//LUS+u6STb+RiUwVQjQhiyUZNKsVwFxZgDDbAsmIdggfmI/iodZBoLIORrtTASiXZChoa8mH9ZIHq1eOSatxZPMd94o9iW70E+i812aVzZrjr3ucNF1yRmcqFLpdpVLLm/k+m18KuUYegNrHKbjogVgtzSASDCO8AMN8IEHicBJHVPqehRMRBaWDGHKakPkXOcLpcUhNlKK1juzq9rKRiYJ5Thg2MkE0eIgnmH7DEE4uRviF3BMuyy3+lqgQ194avVZtcSPkmdOkoMzpKjZzaGwF88L8Hxi99kzuG4dyjzt2uqgybmCN0x4jNEVmD1agVBhJQ1k0XsEIoILTEBGisipMQNWsgNUglm5TunjCOFadZkqtmtjo9rT+aclZEoXRvKrMNxTdXsMsvZg44MVLI/De4fc/xrgHbw7Jx5cwsX1WRHaugPDeaUbJLKECPE2yxeG2flFjq3fVOvfbFgO8a1H4uDGhWkMzVh8Xo41ZYftm+fLJ1Uv94eJODZ6/ye1vXuJ75VvIi15lWOwUosmlCRU2aXA+9/PDwUF+VovnLwq8/bZAFr+3jcbHQrv7bX01Wg8Piy/qx+2h/UW1zroGMiJWEZTJgwhphXJd00Pq6SAdT7rRKL0HorWttD0CQL0rQU6jiqZMC3zYrATTpbwnw6tHpmm7rq1G/GNhSHwoTQxLmltQ/krH20vVlBu6Lihm11JKGRix6xZStmSk5uOFfILJayFC4mGFo3GBIYOUkFMMAi5R94Qs6tYyck4EX2RrzDcezR55iJp0lK3rgUBzwm4N84JnorLp6UGM6DQqyvCig282A+4l34m/tObpO9pBXx0Yypl6Q52jrHXKguwmzKDTskWvIFaefQI69S25boYqqgRMNbZ0KomSpUvuAEV+ccQkcYCI4+lItKoDKY7zJA0hmZYwEKihYK5PR6luFhAmAGleUOn6uJjoF8/x8XpWOs2Q00VeW6xptrpSOG3dU8CrMzD03nbtfQw+fXZ3EA2eg8Xkmu/F1vY0cEbm/ad+KjKF0/zYl8q3Y8aoqtRWNT22qLPuq3oRXLeN3KhL3291DE+7dxOorka7rSvS07mAjqunok86LdHEZUrLbKIDeqZPCnNGqc0B1h7vU+VmQjLKUq9eEeadipNv1Qdqp9/WhieB7KC3q9XKzwot9XlZI6lTkqD7BI53QghX8yAat40R8D7CE8eIJEQRnaIxSdNxwTZwUnXQz1J21MXJHsJWXZbqeF8t1PR3xTZz4dsYNfHG4flbJ8heamqxq5czlq1imqOU4EIRwisaYFXdhGFF7JoC8rYA0lUGwgoEGCEQDCMgGr8nxPMpISWEO6kx14O/IYdKz23mrUTcmTJPGtPcFyMDO5qAADCQEGEwsND5TRW/WYjw+7wZ/xqSXO8wOfNa1KA3W7B6HisrS8surHOMsFCcwjLEieMdwGx4c46DCmgezSEGQOWUo4RM7cI4eGRko9g0HaqceuPm9GlSmOwn+fJRUuilk51pAKp2DrFm8ZC5KMSM78Tj9sfq5ytNDW1Yq7qm7dZKrg3XjFRZWay60UnirEX4b3hX9IY8il6LMfiaAYkrgwRvkHT4Mr77dL19/GSYY909Okt3EbDS2vdVHUY5cUrlYblstetec+IU7/Sy07dqc1MYrNDCEgP1OcqQJ309telkg9dKJnWTJJJniSa6xDriLMFTI5/MNuUV0rJnWjfSFet6j2kO89JA0s0hIRh9N6XWdhDOTOdlJVnDeMJkWQh3UXHsGUJrvhw72MkZFzhCn1pw5VYkjA5FURmN8B6p2YMwFY3LqB9q5dynAy0+bOlgpWAgfy4uzDK4cNjUlY0c3Frhw47ctlvmsCCUIypk5eusU9LLZSijFw6EvJLS23ySXJJ+sAuJjJHDUjQYCN6rB9WDTriTaid74Co3S9foVaKo9tMJuw0+q67Sv+rz4IM+hh92W3RuvDBimxGXubmw4l8rDPARxn3vCQF8CzLxVwCYvA7y9IYi2ZUMyWuEoRfbaKZ3yMGVdEZ2YhChsziou2MAFyZoPKGBEFrPgmwnmrGmXkhfPIfB/j5oTR5DxmgbLle3CJ05pJqqW5hwEePfzGf9G/rROq/6zwRFP5OZ0nlWGq6JfG+pycZaZZQNnafWrJ1eG5D71ExmzjWAvaQB6sIdDc4z/uAYjR8Momqg9f8PlzBklmjNLJpGvWxN6rXSqdIqnBld5FpqkTOhWSkz3UmKnirezEyMAjMNPVy0EoGzwtH2lRkN3QBo6vxYoWeZLjNWGviEX2ETeSpMIu1cD1uFOt1JYkRr+DCnQL19VqwkKctG8aLlYzkxyiN0FgvhRPwIrYJ7VME64pRihlfajECcEJzbltAwXQQTgJnAok6MQ4UoXrHCi0ElU9PycLU4IK7VueqAV0bCfSqhhzOhnehqXb3oNOpWBakZJXbiFHHbcWSsUfCSVdUj1tgAPkXT9CSbRbppIFmJJ4/vTQ/bral3qE+jbWwKTMg+egoKwjANGA3yceGM/bKtwZ91KfrzzszZPuljD9ZnZODlKAl+EIKZD7Q/9R5xR98E/fs3bMh37cF8qxwbmTtCegX4EzO339e7v5csZGDcAihUBXK0COAJJtdJkUQlglNWADXGR7jTc9Nc2UMhnT3cePecoicPCUq5j5eEr+hSaos/iz63fgzv9t6ntk+tcPQcx4VTkzHPqXT1LJuorninuKqdFM+ZKnMWctJz8Sa0sLXoWkWiG4SILfcz4QFmeLoV1TMKM752rBWtkqdymT1XyidLvl1bIcPyOHdSPYGWcTk5CXNoFxDBRj0b6NkPo8PSVuCE/tXOWM9+ddLNPls3PduXzNPQBZTOnibkwLxZCZ9SZWiDz/AVOgDmYPdgwlf3JyR9PEqBx91dESnFNNui0LoZTGiixxsig6EdSAjuQWdRH1t9GJUKh1m1QKFmECKkR7yGHPB2MqgWQyrfDHelfEpWSukiO8r2mS5uoWuyd/hRJB9/4CP7t4SWuKZeltfGWl1U6oVSS8rXW/GuUwksRnlt2LOjRlPbrRTocMVAov5hJhIbxry5c1/UvPet12A/+h3zbbhX3qRaxgBa9Q36zMD1NuF2TkqPGgV9u+Pw2/0C/WA84p6uBtzOZTMde8lFgi/xzNEtQUSvo2DotNiOXIRZYIUy2TlApcdAPNx/ngDKMRLMowhjRFVEylkSV6YZOSHEWYhOkmUJ4mTlkJNWB7y+2hIb3fta5uRnkqf2EwqTf4pT4OeYVX9EbloHyh+Er5ov1S9mfWz3lDlENgRmrQjJWVYN47TR5a+VoXaDN60r08rd7GaDS0p+tjCRR6tk/Mk0q22NYPR+3+I/HfLkkyFN+QYMk+3jTbI7/QGZ2mNwUS2kTnP1vWWoHB3HbaDrAuMV0OMtlMF4VUruVVfETt/wPxwZnq8mZuDJtBPa2RjPnpwRge1NU3ZdFRqJW8jBL3M2dBbj3It4YmecThz12NxB75ADKvtJXQdTmrwfx8lAOgsF0HBSoQ9TZTEIjtkMcYnKihoTVVAui4+EPuLmuylPrBLS5WKkr/bSjNVMFaQq2IAGCBC8zJYOf0Bk148ocfQn+IL8A78WvzNvoNtGBTnvVrqLIVxf9I7kSTVTnBaySsHarTrCfy3m00ChF8uaqzCqvAqg3L1vvDXjTahWehWvOkvgzJ4SNbTE9UlIvVbj5XbS1dKg/Y6ROu6VkQejkb2ztPXtTVndvjTk42tB3rnOKv7zYjl8jVjQRahPLZEZMXPVoj1AjzWDJagUKKOG1ketVFdRQxcGW/9alcOTHIOfZanqOssvWyFTsrYtoviZMWh/UvQZP9MfO/+FDpb/Bh71fkIX9Md8pf5A+Utlr73Qnkx41DXpZNIrBSisudR4Pdf1mzYsvGHg/OtkzLoB4dxFjD1apbNbUyb1+YkR/nLmg7b6LPtpT8b/ri+Cvxgw0Fa/kU2ezEDyVCDxUwLMrjtM8CoT2jrzhl3TR1G4+ZDKWAIJWDYQd4r4UbmMf9XQhK2mTe91rNyTvpZ5NGxnP5114PunK/z+SzUQfwWF5dsQQ59tY/5xXA71UM3bNslA9ws2aR8YnJSmKPZYopEkh4Fx1pOwsJ2UQ6bANiOhE7nIjYWqlk61xEfoCfI5PIgQTClkscXoJNcCEZeTZiEpZZgjIAi/jFb5f0mJwR9TrfS/QC/9/yffif6ovqR/qL6OXU/s56NZIDbuR5OnjVBuXOST1eIzd0n+26idTSD9ZIr+JgIKbwIIfe/c31Pexcr263Rl0M027BLWCuvMCgxoTfC5PSJ2a0LYVasEdturwM5Jh3i8tsytswJ5cGkkfDdi1nvDFn3Xhp251Yvgy1QJvAoOouunZ4k+fgJ1g6NsDVhiReUdU+JPnRI8tBziDs+DV6yOXidVcZ1VO7OErWsBRyp5CoXuo0p49CT/rPZLHmh+Qln1f2J7+q+UYnXf+M1mq9NQno9IJDBop8Gp9NSadcLOprrPXLa3hVfgY/EGfS5dknvExXEwOYv5t4ZoeLdXjz2bpBJbfRz8ZYfO/aotuX7VodG9diObG15EqA32GF+qHt9KcvnXmSPP3P/geOCLRhoP5KCBVHNqA43mi9GdYof5qiHazxuys9XUhU/aZvrn3b7480mfeLKqhl3nRjp8aQLAjTcNrH0l/yTV8/Vj3LNmgTzqboXA4gORE9GiyO0TJJIoU5kAC8XsPJQsqVBmZDvY0OQ5R1ZFlC7xD6g29KTYClPNdogrdEP5iBOxXHa8nskDEN9LgszLKJb7LpTP/jGaj/5r4h3yz8SF/7fKifuNc7L3sTH5u5tB+J/OW5nEuupm5lY229OOj8vsJ8cDAGQWiWzxRSRZufRJ+XubwLRwljxBVrCQLcOZsgZOqmliBfukkfeBZR9vO2z4uVNJRMofAff4FPScUYGDDZfc2RTF4MUIw1/RyfRLi4buDDz4hqRTryEx9eLzUmqOfKRPkh/JgXgpDZAXhV5umm/ZG60LbYqt7J1dA74li/TXeIF+TTvl76GK/TVcry5TncOav7Q7j6ip0aHAjO7zy+qhuXT2q2Nnv6vlHvQh/36b9rtbTRAZOG55XAgxs9pOao38N3RBPpJn2i6/OPz7TD+1F20Rx/uNZtjVy375tEW5HzbD8a9KfX6vhX+erlt+qNXEtIHuz4zkZ96R4POOveknLc6712Ii+82jQMDZh2BZN8LqbPa0sF4+bYuNSBvrbTVzlZ/X+uY/dWvW/ZFJHJ70PLG1eZw61ZHwuUSlLlJAdPVE8vWD+ed1QgzWAFMrHuTyqocQmSyrE3sKnQGbWELrkqnW2ID6doNsFVVeExQBzqmsFxuge1YrCRUGsT1Pzy3ivHtgk+EZiAOZ541EZHsTRKBv/aL2jb+tfR1dMm+zG/iW7j16IQs//V5ebX10qk++rgjAm8oz5LV2rMzY40IL8bfXabkzB2DlJBnKjYO0dK8VsSqz+FA/AcdUl8iKFUQ6IdBaK0r1Cm6xwe3oInusN7iw8y2K9AdhbKbs5eb1Y2KjxNHTGohf2zDxQsPBl7ace83z8GuhRr9GxuRLZE7fHl/aa+2P6mnot+qM+kP1xP5Qn3OnnTm1bM2Sr1tD9NtOX3tRHtgv5An2HTnkfo0NExO0vTUBnNQpZGTtnDIuZ+1lM93QZHcL8bjr2fvBsrUVrKlPvPWqO9zhngU72F6gae1FOpI31Y3GMjUymqlmn4aKUihapMBIQcvEirrPW6ZS+6XgYcCsClFnlE7WxSdIAz9I18rPQy3n4Vbv2We/KimJR2UieVRMRiMWgIbVacFdWFY9rXb/aKj3fSOg7uslur7GcOYaSNr2ADD3Op2+f3QiulaOL3iG7rrW/HZ6vfc8PTzy+hsCTDcO/KbtYQ05yJUZTNbJOFKBETGftbMlWM46yJCoMWagyBN+h8UDJg0BXfwo1838MjX0gvjguI7RPsmI+3U7EARztFcBFZ+FdQJidhgsJkeRUfQGkF0fMg70Mlejf4svYn8UbmLfOsbed0X/0Vs9zNwIEalNBeRaDmg1MgFqGs1Ri5CevzdNCL1+sjw6ySxrXaLSbLF4W6PzY4i1q0Gx3tvS5H5Ad+SwdZUmGsXHUsc4cHpT3J7l0/KyqUHnJRK/KWPQKyMjvq6J+Q+2wX1L8sRHzhY+kg39g/jS+RCbSneJbxs31A+tK+rt4tK+Xt7A51eX8eXNWpv1T7tz+5poW1fHXXKRnBKTwyrUethQ84hdMhYGXqmTuaYvHSv6wjEdf+5TjWhYr6UObC34qCCHnhYx37Fdi/nK9n68HnkaLAQOwpqaTBsFiMmTAcHCfbBeTUXteO5Ys6SoyRdjpqASph2L2dBx1rCepPLapzs29vRXlhZ/biNiwiRHQV0fJMzVJFi9KodG7Wx0zudSc7hIneQG9FCYJIdqJTGWjMCYzUfGIhIfS0H3BE66hpwXGISeI00gBlQBmi0gUi3vwXQ5RjpszNXA0FAfCXlnQD41Am3vAjaCc9TI9nHqoIbKeyaGeYvIdqqbeCIu3Bmlf7jo0AGVioQy6ANvmgwf5ynELbOkhyYlt4U4vnpoGG7FLpLN+MesEPkOWkC/p8bx38v5xL9pcu5bPZn7RoyKXRozbeKZOAQCVjsi93rRwuLeOKs2ljlltoBPzydcrTiS+XJNZvKK1NARo66lnEQHN7COppbhotX50iot/E6ngwzHU8pZ5xX+zJHYS4vjbrru6psu0Pkok843GiN+ZziNH9qD7u/BdutHtVD8Z6C+/B7cXH+EOmfv9c7t10Dt45tI+8ONvly9KLS6rym+8CpUNy+PusLCbRmDX3JGIWsrVovjS3qIrhx6csYT3MvkU8d8wbUt5TGfqme3dT53oHPmY03O+HTlKGdkniQVOB4Q81lY4TKsjMdhUfbAUhuATAJC9KaddRBKtoImL/MCIYcDOMOGQ3R12yuU/FvKKOezK1awjM89RetNpNzaRJply93rcomTHoqsRUFZ45awzNq5KV2On6giMI2GvIMM5OvkRW8vlgs2IBGqkiRcFjmygshYMd5WzECJFe+zFpyhm2AW2qSyuVmMjc9jpcRJqhlYQxlgDBDZasrWqxkZVsA4wSeeEYxHMQivLuf8Irfvz0W/9KSR7cMCG3fzKurGGOKIgvHDVtr0dtK1SC08SDrQFTBI3qET6ANbQ76XZOm9TILvpQxywmbsHnlYGIFwf5QunI+y0vLeCVa7vaCd4h3vCBdSQzvVSaWnkbWaUqvlzVWOryUeOIWt7aIUth369rJlvLWazWFmODzXmxszY5+ZSecyHq+sz9jpi/nh/GvtSelj0yv/uiM0/6UGL/4chie/c87Gf5Cmd3/0Ga9/hIzvvpMuv/4evnr5DXLx4gPWun6Ltsavy+XC+zigvLoPcqtnKaW/ldLKIV62GNMwJUO2IDOjfcqGcbq4h66MHUHNuUWzBSiNntcMio+kTCPGEXmGMWGIo7fdrBVJ82QgzaVDWbIKJrhBhFarPs7SfHxe2co7h/dNOZDk6BihoOlGPDuuJ4kxB4h3WqB4nkh38sd7fQZ82sN1V0cth7oVCRrNQX1tJ7Uz0lvYoFFqmUKYkxiS7MN5X4fXQx3Get7GSp5mIn9U5vuhssZlK2YsW/elYWcrQwtfSmIuUuums/YsHrUnQb61Cpjtq/CksU5D+Vmi+LICEF06ZcyyQNwOxvy818fruz6Z3PbH8U+OBem/H6OJTw6asS0P9onPBfx9eh9+Ftpph/CjSlb2jgUlqlHD+Aw/h2bJU2riW8rgo2ueY694XTgTQPQFEyNeYIpwRZjWBZWd3pvIGeqU5zuv+GrzjVKzbkxT2ORJaWZC+kATqa6WO+jLJtRTDbWmF3qF/NDqVF+bxXGdaC40qLPUA6014+msjPBg03WfX7eS07vXTP9HB5r+tore/XGQXf27Qg//I8q9/ZNP+e0/t6Tf/VF23v8rNH73e0/5xfdY/u6bjDV5D3D5u1TcuPn8iJ8+A5VWCBfLgMHaTN3KSyJkR+IpbTftpWHnkKiWdplT2qfbXC5PVQETL3j08Cwh+MokEadicBEIYlo6QFB4DieQLGqgLN4KNtjKg6GEfdXhmfstnrpvsmBQI5WWRqXKLGpNUGI1zEk9FjWHqUB5FA21q+DeQMw+H2D8cY9vEr2x7kz5cGUqhrWZnDZmqZg84mF4BGYyPUkP9iX7qA8ZwQ5d8LT8c185Y4XtIuUrBeCYETRo8cjicc/IBqH2JpVTruKCdhHXrFeJ1vwM7C0cHJnlEOkqhoDdaPaY34nFmS8DEPKlR8R+6UUif+2KRf9uF479/Dno3n6S2nffN4/9D9WI7/EsHd6b8IC3i8MRiSxFW3Al3cn1coVgB5sEzjghccUzzB0H01/TIP0KL8LvqUn+TBaJeyupkHqhMpk3qoa906zMtZmPz2wO2eTDuY7qUYeMLY/5frmmjzpOka6VCoO+WV8IlWExVz5Bk6WRnC2N5WBtIhCjyZIfnK3561fn1PV35fDpjwXm9e/WzuLftOPR/wCeffizZ//jb09y3/6lGfr4HwHvD386wN78iGg33wepk/f7QPnaTarrYxgbHaJIA2HUKoUalXhWshPhjJaIu0Qk4+ewwlcMZx/SF1paH3NICRVBp1AAys9YSH2Qz+AuG8gUqGSuDKUwHMoiJAblUFIE+egYLEWuYPz5BGITDlSLdrA50OHZrMWzvMNpI1vQr1XJdEClo2byK9Fdr2mBTpkKDQpgdALm4AEnW32BMgaGw464BjvEC0SfYpSezsMDw8BHHAkMceSoXxWPJ59jkaq3tpM38gkHI+l8GEYVsKTy+wMHdaunaVi5Sijqm+Tk6gZuTVtkp2oIgpES0rUkvau4s/vy46jf+NwLc79wgYm/OkCTP9tNeP/6aSz76f0k/+yzTPXpL2qV3c8dZeurO+twr2343YM6FGLqcrBZzsctu5UqUL3MChyQVfmKo813LGJcUlH8Fbzg79hC5laUoXt9tuw6E9WHdxLnOpWU3FJu0muTSdwaBLjRXNSG7RSbyrxdc9rn3ZryqlSXBuNGuzjqafB0QJOdPgq0Om1uMjKC08mSPz2b8mcvW/D83Sq9+PXwYPUH/Mn098zW5e/gX9z8hnz87tfVh69/V/ny9b+ST1/9IZZ8/5uEffPdXnh6F8oVrvY5eu42+b6P4uoAxpcRgCm4k4SaIQARVL1MDT2WkLyLJ6sRdsFA+lSFSnIZKLMtsuRNp4wHmTT1gMXTaj2TKVtojsEZiFG5bBAREhzbTzDmIF7E62kaLSc7SAlaQjXa3q/xAzOvtXqiHTrhVHFMqY02mD/r+JuGL9RWA0edcsw1FALQEEGEXrVUGpfL1gwblk8iut5jukavPMNGpJEcUHl/X5G3Bjp5MArGw629dLiARQL5bCKkS1nMYGVW/3mziB+PewDaPE9drm/w+vKc0akVV8Iqkk0yqluMMzutAORuPojvy8+83s5Xe9nCr54n8P/2mCZ+8giL/fQ+Zz66D4yff6ZND76oNg4evqgDB4tMLDDgpQRhyLHyupUiuicJudNPvtemVAe/EijwHR+MX+Ng8lu4Qbwjy5kpyx7cK8LC8xOkkXhH1uEL3sE2koJcyRL5UpHFWxWUXorT5sR6K03aE6Y9SZO1PmyN26x11baJVz2QeNXS8HmHDS3aM34+WQ46p61W46YsjF/Vwcq7mt/+hnww/Zj68uKt+GTxFn96/br44MX77uHq+1ro7T9bsfe//2Xi/F0IW70AueJl0CZXj7tSzzU3q6EeYueqsJm0EjItRyQfH6TWjbDCWBk5RFPMRQ83Lot4zZSR5nMBy/unCfmoH6f8BpOjsRrEZa2sxTTgFGVkUt1m3HpdSyVX+ajdUBN0wo43IBUoEAL0dccQr5SyM6Kdup9kHVIl7CbFVmBXrGgd7JTzz921vOe4WWMCvVI5M6oZ3GwoFs88WGNGEo0TXXJmCGpNmHBunEsGBmToqIfvPuhEXa7q01BGp5iAhpMBpc7lzJJiOPf1Av/M7sJ6foFeSO/E2O4tLcXXdC3REaqAqMKZuLQtxPD7lcNE+oUn/PzGe3T8Ymcr+erLh0n58ect+stHDeCrZ1nz8DHRcT+sdqJbhR6788o0AwummupqrZzEd3K4PsuC0mX6rHGDV5DXDPzoDRn+/CrH+d/m8uBLhD5ewMLRvXK8Fa1kxqkR1oLHjM2c8GbiVsqj54qsv1RV6UYvmjf5F9pJa5iYjNhcbwjT015SvmrawttORnjVgPDLSoe5aH/PldYTwrgRGeNGyKo3qp+8Zb8EbrHPuSv4k9G5eHx2AT9bnfb9Vzfz7bP3rQfvv8t73vz6aXDzOonObtmsdpsl4MsDjplvY9nOMe8rJzBvPoQFFVyEJRSB+AGu6kBWlGSakyeEYs8Qva4DShOFxNqRBuQ/y2PMU0sAkeYIsKQpqNf7kN0YIeZJF6fmBfSw46S9dSYky2x4gDvpS1klluWStJQ0ewDStTSqFDOoZBFR0ASzLkXJ+rVm8CC/Bn2NFQSM9Ag+cVLivBatb/yB4YkMradksDcJekpd+TjTS7kzzSQKlLkgWM4coHYskNRwPKcwLCR3RNSqpirFJ49r0rNoA2OpOSbm7jA6NEeVxABrxk+YOpwX1ZAmRUSESVVhLLlCoN1bKOp+H/T8ZLT/KDA5+swqbn15zXp2RNy/QxZ8z+tTeJ8eMHvrZtt/aS3SdXydM9PvEDj3G0jW3kG28h2aCH8Hpl3XSSF1mbQDswwWWqaoSCNJhO41A712IbESbXhMDGmCu6ZqxJjvc2uNA99qtvi96Yhv7Xb+bXXhjPpaeTKgnUk/Jk2bdulNJ0q+rmH2+3JPuW1/oKzl/Ei4Rr4iL8D78U3K75sz6YMZlMiMHSI/IzzjEyn9YlrkzpeDxOTiLPzhTemT7z4Efnb1KvqscKl61WssSlw888VPjp8HOts/f1qMf+U2M64jJfk0yRPbCtvyF2RixxKFXUMccLo5oGvlPCVXLYZveGG48Cs7y7lPS6jvbgoMzhaoWdrg7fYJa0tTISO2mR3YgR4jfJhQ1eCa5YEP4TzTjktyLS0bs6xYTsO47TNgRbIgFaRSIoYEuSmR0E+zkUp/L9dx/g+kb/xEGRYfVE6y7tYQAbo9NDHt+ECjokJEVQkxtf1jykKiio4fSyqb1BQ2iytCOqsoR5KKPO1Ksc9aTPizBoq4Jrlc+hwU6QEosb3spFQhVbVNTUxNxvOOKJ5WRXRlcu6bPPbJAon8w+99O1v/4v2K+CHxxekP1PNmCz4o6MnjogV4Ya3kGoyXoYF2mbTgd0AR/x2kwb/Jifi3cJr8c8aX/V2UKb2P4NVVqDiYRAmhFcGNYpCu3TPjSsNIjPoWtCzZNKy2ic5kwjv8iVTCrjXb+N5sdr8vdoq3jdPCZiyXFxOwvBigzLSLJZdtErlqZvKbSmU6bPZtZ1DLEVNsLzs2sukT/HB3TLo+H4qx/VGOTvV0SR3UtcEJJTYnbbG+NAKDtfPF6hz9T/MN8qm9dB4yG/CXwuLTT+HWl5/5Tc/f7YjMgz0h8Lf7BLifQDSaQa19jaAe8PjKr4rdgGb0Wb7opJiqEBGruKaUg7ZixlsDZbc4J8XXL8nK2Q+s2HjN5alz0a/2yF3VzngYOgLG0oFyLBX9NoBj/Ycg1/oCVRYuoCBBbCEQVPQcwMqJmMyRGsb0GFku+zUD+1zS6p9Y+d4/livjB5OOsDvtZt3nTRofNgJgt4AJeZtOcvngriQngmVO9/R42VMSiLjOZ7w2RXxZJRK/qMLRgwHAPmunVc8MEPdXGXlrmmnEikiTKVKmUGVmlYrW6rVtbtHM83ft/LO7Dh9+YZD/cGHEvvp39oj4QTjgX3MH+kY9rAwUj8Xm/QW5HJJj12FLeBcrlL9N5eV/Baz4r7Oy+9dQKPFNkte+TfLWRVLST5LZ7klM7AxjcrseFwb3TCBvGtlKiUL7HYop2YyIFy1OsRbCSemdMRS+LVnYh2qbuOtcIOuZlD2bu6BNPySvGsLJZaM0Pevo3U2PEgcdWSx0cVRvlyi+n8WibQo/bCnYV+268mhI5B71bSoyKorElK5zE4IWxqm40kvtWo3qF1qXfaR1pV2zCz0yWp89FMyfRJNYjvDDocRRWktGMrXQARx4Fk6xKTpZJlBwg6Dkq1xMz2MBS2cBeyyaNY4waxm6U/IVNjp3OteRqx8V+ts/yZE3XzPN708l/9ygHlVR4L6Q9oHFoCvfcHk35ONEK7IPnsef0+9RwIIBVE8RmpTiSqxJlXnQU6RFusug4IKE0BO0GKmSpzsr5XTnqmh+dVvJ/3xZh7+YlOEHlYL/QUELb1cEKDphwsk5qof7ePFwTmcOptje4346+3wUlx4NEr6n5YAVGIW40DREuy6Cnfg4vgl24V6sTXWVtni+PHFOmieNYvWuLQwv2k96S8e32qjezQnzk5thMv2dE8l9UIPkRvdDLd1dbhcCucrS0y+fRbqztynh7GMqO7mLc5XfxEraX1IC/vu0rFwCTPoq3UjNITAwBgRtBuj5Fkga94bZCt1Ae6LCFAmMr9GKmhMk0VJ6SlWfmHXwpuB4T8uN+Kq5Sd6Old3bEyD0eiDZLwfi9MVQm52NAWfSo5V2F6tMW0yl33I0tQtJYJPsHjQq3a86CvN5V/B/2q0m748menAVKMXHESrZPTzkym4Pa3TCcEE9ZEtkuFLIei3L+0tOuv80h4RySSCSC8b4nCsqJqIxOpmIWmwyXmCw9FIOY++IsFoBdy2LytptQa8KwXZVZPpVtripys2rqrr6up7b/FABX79zyLOe/aSk8v8g5YBDMxhCGzsBsLrvaXTuB7viTuKdtEW8yEU0PoOqEKZL8VCdScVLuO3rUSjUxWlwgwWRlyCDbDJn6RU52tqI/M+HYvXhVMO/WCjwg7aYeDKjCe+IRLEp5vWfZ5ijDeBsz7PhR2eJ48iNPxV94VKRU3cuvTyywYkbS54fG/Fv3XVmFbjE28BroUJ/LTn5vlGrDolZp5P5OGZzL8dH0odmcHNajM6W5peLCzr+oYf67jpA9MdCFHpjhqxrMwLdDINXrxaZk/NXOLK4Q/yrb9K5yR8TUu1PiYL1HkjRp3FamcYctJis5mqgAleyqlaBKPXeFGw5bbRS1qkqz3HtmKpifl1yYj2NToxVWd+oTX6Rb7KX5bqxalbhabchXo/b5uulFP1umUFvpmHtvG8q7SGeuupnjcu2IWhdKx4ckPx2D05vteO+r6om/aBxZd6fbEr3zx5rz0afqaGyh8saoRwmOqmcUv5SMpFnmra91aLTD8pY2i9CYRhIRtBUCAWiARlLBgsIHjF9cKxGYMAAjiA3skfsgztGCQ/YdIrOd1PFSjUxbKr4tNXQbgd66vVIiPxlFH5+2/YkqqVfxCjhEyKYjUjeRM7Zi2Kl7RBTfhLqM/vJDX2IXmspURNyspd0aAAvY0GyBw6BKQYfzGE+dA4HMq/SqHGVKEoLoMANoXy8gxRcC5x+NMLw7TVCPZvDxXAH9+1NMgeRizAC3wS0wDrEHZ2HXP63xyR5fcga5wdo42JPk2cHSObVbo/9V1dJe+d7rTWAt5TKfI8ojgM65QZx0RhA7wYO+/VYKvw4cXfetBOLy6rncmkFbidy5qrDHb1rocm/OKD1b/kc9ud+dvE/z8ne+bmIFa65I+oaDff+lCH6/zPNt75Lw5VFIt0ohq2pEq31xHSLqOeUahvOtu9pue6mQIpynqRFgigzKZb1SEwRbAhtaKzRpXO1/uoyfzJZVgWyXxuzo95APJ/izItxufB6zhfPZyHpfABqp53a9WqYYFudLM02xmhwEAltt6JHPy3Lx7+stPjnrVfq8/k4cXDx8CAw/hmULm1LWdWVTjOJBIx1yzSLpGzqUbgGyLSW4cNwJuoHYp542sdJOa8oQj7ShD0TJxEt6WDyDAHR4VGYne1ENWUL0imvrLWVsj2B+vWa+7RDbb9tC0+/awP3/1ijE++qruiVtZUyuYc4ms1yiTQaPUzi0ON4nD0K9pRHiZf2HrZBIyLvzYmeKEuCQh/ZE6ZJUx2lBWKWtrhXIM28zICB22Q+ugaIwCDFm70Ul5wmpcgshaY28QI0TQvBVhrcmcajR1eBoDA55qSzY9V65YKtV4dG+f1xXj33hKgX+1D+YluevNmZbt67S+VN4KwwSN+CefIjbJsNqFYsJqqVNbXuD4wXswJ/vUyIixMofzkM1N40vdx5kcyfOtlp3UrPBFW/tXVldWIgd+cqu3ijBJsvWab3IxNef0Dhm9/miPFtlphOM9S4D0iVaiYrFJLX5yZmsRUyzN1LsMglRXFznsK6EA63fUjBAIkyxTJ3ZD8/4S+qgjqukmWnomjF6swu9dpg68QkF7Ny/nyVE17MY7mzUVdaLbyZ8iCGwa0kCVWL2HbT5f2qEAf/q7GgfloZcM87vejRuHj/eBr+JDV4fJgo/zSeFI54ACtZGIWaDAEIJTgIC2mARWM0DUczfDaAmYiP67I+8yQXYNppf6+RjLEaGKtIcKqd5XKjEEnVdnF+GJV1LV0ybe/Ezj97WcQ+ubOpBz/mC0ffF/HD3zv+/Y+qy33KPA+UswcRNCrm9qNybi+WIZ6Gpp3P0gPjEVJjPaTBR2iMNUlQGiGu4iDFNOZJrTxLG+I848deRxH+NKSZy8hIWAL++EmEyC1CRvwiSrPTCI+3wxDUDaDs0GuL80A4N3JpYsetGqdeKv/azaivXKJ444aFN0dG+bXL7p55rdZlwOGX4YI+id/VhtgHtqEWIM0c0Ur5rlYfNqaDWak/XcGV6Zx2TqcP+dtmWn1bqRQumlCjUqVXTIW5MMvVaa8R6r4pAu2PVqz6B8U6+WcdGL+QgoMlTV+ekuhVB0/Nazmw2skMFzwqLnOY/QIhS5t7X5mJylMFbgYFJB/jgjyACRMcLxkE/TXLWUu/U7ddxVYmnq9autkwULU1hYrjbrS31OKDVSQ8PsHBzlijxEksy/WScrYZkw/KuPSzAoD9lQWTf6dvyj8t6+BPq2zcW9Wi4Rq7g9U8z3P57RgohJkQWRRgNp3GCX9GzqZBO5VipCiv0VGCzYVNB41qLTzON+QYWeGidi2bIAt4XNCFeD6ppCoJBJzHMXLmYyUyXBBZ/0SgXWteOLzjrcg3YiH0o4q6f5SiB79j/Pu3yJ6vlAzH1JCYSYVM+GmkRO0lKpXdTI3ZhhtsjNR5gKIkjmT0FRE0riC8+hLE5qs0Mz1JJ2oXUa55FWWVryM6dxFLJl4HM9nXnj52EcH4cZCUnACLaX5K7foYc+qFganLga68Jrn0I+xbL0FcugX1wq20bj1V4V3QcC7DOfUmUM+vo93qGBgX+ui1VZJabMN4LRcbv9GcZUEonGq90jlQna+A6s30WfZlC83fNdqNek/RjL44wgZQ0+hY000/UH1Rj62/LuLXv3aM6cdisn9uwaOlzozHWmrRFA5Pu7h82SSGZ6hQKLllafhEqffv/WMhg/3UjMmfy3HkmNV8NB99TpFqBqPGbE4+0dP5dh6p2LJUJxJyVdlTau2/rnT7fzOaiF/WT7L3zaEY4odsODegPGA/mQy3YuJ2OcX/rZ2V/8awrP89b8p/5Qjmf3UY0eXAEGLSQNzIPQfUWCDBJ6I+kk4kiMwuigTCVpqyi0lUleNoh4kY52Ss+ppPq7YG0FwhTbNkSpNxAI5SiVCsGMxzRKREI4m+Pw2tv8Bp9D9rJPEzByd2b1En9R1hHLyndPxbJiu9JyL4t7kEdJ72MN1QUia8GuLzl8in4YX2KMMCz4G6FIObSJCwXFmad4k0mzuhAP4Ss+SXJIKeY2myDwH4TToZeRcjQh8jOc83QSj60YvEfuOaW1cRUq6EgGrDZ9ecIKc3Az5hdYTXTg/qzp3bQW/8oPfSrZJrT5VbB9PgK8+oehkRmHcRgr0L97GvUw36RbavdYmZXBAHUMt8lzppfevrLNcu64ZNDK4B4eT8oXU+Sn646Arnw655WRgMPggzosNNuY5zQi2vJ4R9NwIXp73Eu5uG+NurBvD2soKcD4tSr1vMIh3bfdyQhZAsS15C6eM7eT72s3weufePeab4qXUofyrscF+iBHsMy3QQqbFZ8rSKKIs6VKgomWrukC+GtwnTe2QL7Se6fvuJUlP+Jl/P72ot0WO2sGiuoacSLZFMtsLWURksferg2hd5ZfypXej9tEToXxYA9tgEczHVi0QYmQiz6U99ROrTbTj21ANwjyHAPNDAXM5JWzUjYw7xbG3BY9EXDogPqgClOylJUtMJBIsihBCiODaoi3wYzeEBCWaDBT8dMffr8dJuP11EFlkSfJlZMN8Tlcjv2Yj3e8yXfp9BmHkqTDTDbhlz5dm4t494IgX6IFEh3RltZz/LPTgGrYfhXOMJQ1igRuXyPZxpXWNkdYEk9THoQs+jcejanwu/dNP771zw7o+HTeQb75B4HTXRcTyjDsJ8sxrCW/MAMlx6odWdi+HvjnHf8tBCz44ta+5R2mNvsTYPmsZpWExcR6DsWWDSeJscj1/lusMzsmKWuZbcVi7tZukDNxzepStnNXf9moCGl1x9eemaLhfSt9VF60X5jCyyp2SeXNtO4cxjbmbVzWKtTAcbfDZf5XpnM78y7Acxp3GMVZ19oCxFggWGdrF0L5KSbI9Htfd+ZjjMvUfFbPiz/E7ygbAN/xxF1Z/kNGcHWVcT3JkdsRpcuBglADOlZ5QUr/M7qIPkuQI+TXHC8ki2akmlaAnVCk1ypTpDN6qit5vEj+rhwvNipbNX5a1nVZJylTPCEycY3dGg9J4UTISpJ/6jTDp+kMB3tmLhf/D4DQ8ZnEaxdA1UobppYOWiTI07jrxVreL+RQdEZ3oa0ZUEQLIR0pBCrCIHSYALYADlBWH+WIF1l44Znkt2mrDS07QKXgAl4i2UZ39EkPT3EBh7CWSZk0TWNCL7BdglDX2uk4Y77MC78XRyO8QCW0Ee2Q46oityV43Dc4FiebTDYtaCTlfH2CE3TB9Ag6ArNzkKZy+2Sfbls4r+Ya+b/8bdM69DbfEqIVDzBF/sJ9jFOsFV3iW+Yu6O3cTHbYc62xtqPU/bGYX4QSukvBmEk62NzxjdBprFs9iZc5UbWj9QavmCtrkaN8Zb+gQeFje5dmcJ1Ger0OCih3VfOmzlNcErr7Ah/wKqq1eoIF7QeeNcLzuXPNe6tPONG4XWbjNa+/KYq8+3QaIbxNHqc4I1HjE27dNMWDVwpKYkSIU/om6cbX2E3XtkYFtfaO6tX7Jh/p8wdv4Jaq8PiZMLnzgsh82ysldAi8F8qM4ogRObcefrMNGt5yp9C3udb6prYliUeavEdrlSF880jGC0LaYibUhw1SXK2wBJf4UTPeXd7IGeCPjFzL6HOYJ98F7gIH5APPN6mJ09Cz44LGcj7nMiET8LZ+Cul6R6jCx2rJoRKs0Fb2FAHChGJmKwMabAxdAmEo4WAC+JQW7GE3WBkdyBLkFHDkG4R0Iz7IiteDHRSdXTG4iCb0Ew+yolM9M0a1VTmEYkokosRMpHAVHfCyiHe8HM00dexfnCZ08eB0dnoeSsDiA9k6OrmZLAGyX+oNhGH5X78UO77TsUBnu5/Oa5bH293ah+POxot96a/jJUKdzF68Ip0MRncIIcZuLS6/jniTdHnvwfnnWaVwczfenfmJ1URxrlgsqLZK7wPoaXbiN1bZHcCO/Qeeq3XC59Q6vKC2ZAnCsjvmEvktXGENIGb1PN0xN34UUxKr9uecSvU3H5jVs2rv4/it5z2ZEEMa+sV9mIDcUqJFHD5XCmOba6q7vM9RbAhfc+kYlEep+J9MgEkAnvgQtcb6vqlu/pnjbTHJJDSRGiQi72x+6TbPA5zjnfJ1LqK1FpvkLqzTurpb5icrVXDa35NmPW7tZN6fiIQQcJiHIPCUo7lMtMbEai4rKMNi6TpDsNcGNnU6nnHq0xmGeDsoo/Z2vG7wTReSw0327Kyiiltpah2mi16dCtVLPc4u3nzSoPEHWKogakYPfJ0+Np9dXlZWN2Puz5a2Rd7VcaTo5udTbBQeFxoi2E821iE3SB3Xj9KzzKh8wAVpN85NO9o0IR208Hi9uhfdK3p1uegwG+7x9g+dhZCy18YGnyEuXkOe1acWgm7/MuGWwZUGFGF5Q5ARQHRHZrAAWi7cJ+tXF0YOlJHzuJeDuXWHDRsFJI1oy3hEFmzPVKuHFToBf9vKPUQFLggArD5VNgLMHA4cRu1uOl5XXPDbIdG1BPsj0nWNKaEDQ4KWOCYWK3rispjlM9cl3q6aBb3BiNI4n6hQ8yvzmwGl97DfvT0RB/iI4Ll5lq/j5rwVeFYbEFw6lZaTt7G093vwvme3/xGM1PR2fji/hKmxfH6HWlWHlfQup/KQDtb9ON4X2+y30NneW/Jc3wDwxBPlAn/VeyVetot3rd7YNy/zqhLG+etO7UX8r3KxL9oMLIp4O8eF8T6q9N0HlLFjoPcU6/GR1bDy7Rfp/O8q9+C9CLLQLr5AWyGeNRHSqX5BSQ5nQkIVQZv6jQexJaWOMr0Uc7sJVaQy8Kn/Et5Il8qq/XUXW/Zkuxekfyt03J06WKwU4JRp2fhTUWpGXSFl2moznSjdW3762LgdTqD9Mq1fY2KgZGZzU9nTbMCGBBnpxOhzJaK5+tHalJ6fAuhgduwqX8VTgXm/tiuQtfIHWaPqycJfb6bsT3Fk+kXALJv3Qq2H3bqXZERy9zQzlDj7isKBAFTalwjlopOnTphQFEg/WIl2mUvItpPGKycJzEqSiFyRG7bMUdZJY+HdxBjfoVEpHui5bQBzGfXEyny+lsMhStBPZCABz0FfCD/df1/ei96S12tTg8HuRJViuThtKmb5y2qmKOHiPbwnN2CP/emsQj9NKPClc+E3npr5TfeevAWWBUPIvX8vcpNXGRbu2cFNBfneWYo6+zmfT3sYTyj/7O4lO01bpJus3j3NB4C2no1zBJ30MV+QNQMT/lJfl1fsR9Uz6BX9Nd8qXQq1+ohj0yOl27XoM7jhXuthc+e/LnNf1uvIe/5dL825yfuacD9p0K1F9aBPugAtKbcqn2SkrUXhWixs3zADvzQEgnJ9KNfakiF6sVAShk6Sae50Vxn0fLG2w+t4vnoo/2C46wAb1qPmbOiN+rq/hao/ylx6oH8o12qthGUmlXiBTdwB5sbPlpBq0oZEvUuKGsK7d8p/mOOpui+ckIQqz+F7iiRxlQEGlIFLG0iCf8vJ4PiLdszJakQn1/HK36PuyQ0T97y/mvc4X0STGVvihEwjdZD3uW87zrJZNXwzj4MK4wk2at6rQdrVQZVQGhxYEKQaEmT3CEjCcxDtqiwGSIgQOmTYUFlAjLESpCxqkwkiUDTd2OvKEvgFHlE1IFv0FChdfFJHacqgJGOrldjkSSGa9Z3vLDgYBHRDOe+/NE4maKlM5bCGG2IZpp6lRHm/AutpB18lRNo3PBC4ywv8o3Y0mj4c+ig0MdP/NCwPm+pa48g85lUMZOwxXvKz/rW/nb0cuIkX4XU9L/lOCr3yQ0+22q6X7ImfSHglp4BdjoO0hi3pbJ+iewZH5TYPgf843216Wb+Yq8clty15qZLfW6UU6Oa8RB11DjXbOFuY3/gorL+6hyXwkg17k8dlaPQJdOLHcn+Yt3WoZ9mfbKV3ymfpXe6axCO/o4A/KdPFBqHlC8csA3KZLlySGS4Muxbaa0/wyPrW1ApdKjncIxv40MQ7+nnfAmrxYPRS3okfrhjNEOo3XwUDQqAVxNHIp8JiSREkNSHUTgO1lDvmBWjTPlZsCDiwEccTvPU5QWGWI8M0S5Ep+guPI+NdLWxYexpz5m1jpl7IWTcdZqBzceYf9lAc23ASjPoHlvtxIFbsDgx/ep/O0qhZ3XYsJiyOlgh5Zpxa7CuipU2hKbaNAYc95Gs7IO7qBMAmwUI7ANBXN0xqNhqI+P0b42IIZk3ArfWItcj7oDefxrMAtf5wL0OJoq4n6yVPQVM8V9xCjsWI3MwcMQiJ2aZP4YJioXrMyqDYmvkFVGRupsJz+QlPRUDiEWfShUoQ1XSO42Sr48Z+5zwnjP6BwfjNz7AG2d+VPs6T7CDXYVeLw3zN4e6YffBo6hHxIm9FPain/MkXtvM1Tl67RDPuQ7uXdQq/oJRalv4XjunwvO4Edw2PoWm9XH3Gnb0BpqpwanV3p0uyUov2qJw9BQd7Wa/WnAja4p/kyKIGfhHDBrVopLE82cNPzgBXaAnuGZ5kl2qzdLr036zIbST6UNBxPpxhGhKXuURUGwjGkFiEhspcvJ7cO8WtopCMyjpwVB9xRG6nN4lt2kUI+fMP0eqr8dEWpfSlVkUxUAn8wU9i1c3eAJKkDhBqOTF/We/HI8bjravAPZc4dQ9Aaro/VIvqjGQJCLxlNYO+enXyI7egtZtzvtp66lPulUG9vdIzVr/UJHqL0OBsp3BQg8QYrESTZ/ehyvdAwf+W61r42cYj3aAVVuASv8BFNKJikyA0k46guYz1WL+ZGWAfpIPNYI+lPV6AEs53dqLrA/s8lAvy7GRvog24FOABK8KsJYL7uBS4GMVDqEsdhevVry0AJ80KNw/wrDE/Uil7nBRfgTxYsQIrOlukOSch13zA7TEiZiDtbpjEShL7hC5nEz5C3Oi/utAelVzfFR5/hlpHA886dHo/1s096k7fGGZi+3lsPvvcfUjxEm/3WEydyHR/7LJO+7S4rZP6Zu2TeQmXtZSYL/UHSV/1628j8iHeOBPKnVq/0EZ0BpUfEDLrOBGOBF3SB/wOrmSUpqjZL40Elkp1a2tMiShbHbis1BfHustxNT0yAXoUSjnyxcORlqUuvitiN6HQfwunYAqMlrkIBlYbmcJ8VCksKTVSedatt7+Wrj0ecA1/kKYIdrRUvfhig8UOKK2VI9ipTbaxrOPx9imY02lPqym++sG+AoamMjos++04a1cWfm9rVJP6O2XLqhOmGRNZJYVjpIQ3imVC7PKiHyZWVdeZCfu1p5u93Gng+o5GbfX47Un4gIX1zxNHWGktAtgSJXAFy/SGP397vS6iZSm62CrWI3VycfSlZxnNPZWUijF6C6rzB0fM5V0lMeSDp4+rDOBNKt4iHfSx2qvYJ3PsIjrkonqiibbGOdnID1cgjUSHtJNBjoBPb54+39WtPjQdjofltL+4ZYMtIHudR9RSu/KVc5E+qJKbFD8XqD0owuIwsuSx20mUSMQQNlvLDTyEfTA/hIXnH+6S0d77wyMqkLNRp4R3tTL9FdaiJud3ruYbU597i1b/yk8KejEvnDQb9y72/6v4l0S++Sw9jHgpO5AynqoUTg3xUvpfd4Tz5lWNFgRkxFwguYEINZMl3FYeeKwl+1oOqqiFiDQLDVJUL9ieCfS1Jwjru+aW24vmDnoXlyFB+mNKNV0SfNlHxs4OxIE6MLrZo61SP+Y2GdGVcgTQPznJBnjFyO70RznaudEjN69LRSVbaQQncbpPoeALQSOVgG0kSZTbqhbk7eOc5Hnk3jRf9N6AK+zLyOjpGLr0b8nwLdZiM7affYwRDS3S7QUpwDElcPlDwdtMowIORL01Yc/d7cUxdUsG5R+44EP3H1yuN2gTpopAVSB49RWTyrKMWbigDfIWzn25h0882WPfzTRtt5Heib5/5RTN5vg/Zmg29vNiJGXCsZpWp0gNNHDlWOWUbeP25E86/rAf5NLmAOi2ETB6MiAMXkXCLeFvgMJZgp1iBSlWk8nq1vBYHmEy85fHzI9r86lGt7Hree9I+NSuyuIwEPukyNkJZYLI1YgVqxHNlnfEkH1iJtBE41ypSkgEd5Mg2bxXj9GEwfX6dK1iQMw+eB0uHoMLnbivmQGnzYELkjLmz4VOXCDwvfeLOV17tC9dPuqved34Deh+aJ16lV5E0Jj82LVbpbvAZaRBvUWAKo0EYmxnL7QRaO5sk6lGVJJkmbQpxr59PVt6WwM20dDaar8LzVDZxw2vaJI69fEOnDsx3cP04P+A4o9p1wemAcAce8SlyIROSBFw7e8t7Pl2gm5oIoQf5rLlXqCBlEpXdRrPJoG2mJX5IAcISWkj4om0zkI1AmnooIQTncCNEHN4FK4MJXhW6PevhJpF89T30LztH/Gl+Yy2f11nGqNaYDzdH+M64R2aO1YKTA7xSTFQE/qnTyMeJ1xaPMSylbBj31anqr0QDWWmXA39DUgoN2ibr2gWuWPrCW9C+y1f5Lynn4ITAzJjsL1Qkcp7ln44K63cMqv2+j2IYboTZNbhUwvK0Ef2gKSHlhl8ujFQAcL7LJVTWeWVIB4WUhyLYzgdHQG2/38hlpmMq6o0QxqWymcvrnUaL2ZRi3vgyC3J5X64WO6k4mdM6DmYWigXNTJDq8xRLxLs2VZnQOWqD7qdO8bc6AhrYox2UpT1xhWfNbsNB7nyy754dY7/iASTf30c3mfu7F9HkgP/B7Ciqxc9I2/JJ26k+5Zwf4+c1e+9W1l5v/4GG0fz4c4e+Dp+A87cRGBSTuZG/ResX1WAS8yaNYIA7XEoeoFNvFhpltho3sMqh3k+wXAvz/Zre6t/D+sVN+firHN89oz+enlaPfLY39JyewN3a8TcHdfaxeSyWO5WTljAXKr8jixncI8PkPIL79AHAvRkDNQ0B0BCo1sWiFVfdhvfdoC+UbL9AktlUCqWAe8UcyW0cJfzJd2qcS3T0xutjTs8MDE5p5l8RxVIHuYq+0V6X38RPm+xctu/dvdTfzmWSFX9Ay4CvzuV2M8q9FoUr+KTB1/OiNdiQskLTB0HndZH1mI39UN+Go0yuWej0SmKg6MjWn2oLsyfPaCXhcfxU/ZXvhk4oSOi4h61Nv6bdtknjsksyzptE9aAGNWH3LjEnFHssWdJcg5ldYqbWAE6edPPr3VDZ5k4hVrwLxfteX7em+UrW6CTKSr5RJrmeKyO8TROVxLFd4HtDgVEgigDAjAaFbDcqeFnC4k2ZxokhiSoXGhVIbD+fnICF8BAzpLWjZJ7Dp2Kjdx4nqLEZqV4e0tdrllFFASNvPyEBtHfpSfx7zXge95HnF07+oB+3TfoSe98Pi7SQsnS8jKftHXxH7z/st9o2vD03DLaiZ0MqdVANs5PRQvSB4yQKb/ddhsDBg0NuQi3+GoOWflQ32C+SS2+L+i77h3nBbUyn7bErEtyfcxt+Ni+HP+nXoN6PObmK+8RXfenygyggyExPpO+p57FMxnvwpSSe+T0DQx4iFTuKtPJtxQaQ4p8NIHd0lKuKjQzLt7MM566i4VdiJVmL+UGAnexCLVDaIqLVmIK2NZqCz08otD0fUMjgmVgmbeJmZ5c7A48cWfvLXokj8G44HPqepdBhDErtQkQrFC0PqEG67XnyoRdhzOKZzTEbDrKDSMzw1GQlZK6nUOYPY2bignVaV6pnKKBd9FrxDyOh1gd49i4P7s2z2q0GU2HQ5c9Nx+zvdasPfy9J5J8DF9aBI8LI+EQruKS1OLmh5OGGCy3Il/pAuls7TGWPlz7vDcKk69YHhni+DV/dTRW49CoFPgmBxw2fndwJWKRAWgVTEwUuJBSEVRzRf4eEyLFTxCiOYMCKdgFTrrNRWF5Um3cIdQ6HbRlFodAqyYB/JVSOuEGKwmhD9jI89hLPEDrBf9cWoMRTt9N2U1p9mDPcux2iXuczgPr5d+84Dq3/Y17gPhz1i6u9wvagizmKsvYyJciPmFGqpWZkBaDZXVJhgyWL2y2Llcdm0XiCv3U3xJ27D7Re3+gy61otnHzebxd+2OeA3bbC83jDSMTfgIY1oqiem80sqHHgDr+/+kIqmvg0Z0ncRlHoZEhe90MAVE9MqWhiiAXioHxGi/uiQjTHb6DPKl/mKCRzFGsHdHJtdj1fhL2t15lkZxJ9MCub6SWR60A9f+scv+jH+aBVD0deRFucmh1E23wrJoJmn4KN4JgvyoWSvFci/wuOYwRySSvkF9Sq3r9mJbRORtzWpvam7jtd2z6PO8YAeviWH59SBdaontfM2CtygFe9VxLu5DAKbQ9zY7sN9f7smxHsm4R+CRLRbyKebYYrQk64s2u5Yxrg3Elc7l+zLiVLsMYLnGMBy13lI+FAqd/9YwJjTCro2ALLlH46SIfUgCKTXvKWD7X2H9XotIuA38WyohZdiSx7Pt6IA2IgjFVZEKxxhwgo6QABkCpp2H552GqQzFLh5I6PqRlmnubxGE0mFyEerkWSIPkgHynBlDygyz7KYkkq3x7WC5CyLXP26UG+8BH3gy9Qa+9qXb73bE09u9yfG0N8Hz6LNym0SMc/jucZdsDddxq8bDkBxUkFRYKDayZcGpwGkeeEnZuZXwgOyYy+8X3VB74aTRp7XnNpaQ6S9zSTtNUgrquUxVkplZownuiofZD6lw+n3YRa/Ckvkm/CY+5iqFKZxQ1STjRqRveEqyBD1Uiby6JCJ7KeQtUg07SuWgjtodBfkMxslI/W8aOefFKPo75zn6pNV2NyQo8PN68LQN4qeRLjEQxgrXgR7zCQ+p628FNLzWFDIykopRzeg7Dsli3LYPspJXyI36oZwa6zX5KLP4htH1sVFvCcpUK8qi31HtScmLs0GGHHqlLKX/q8KCySZnBIR71iFfNMAkGrLlWTHzAX70UiqSQtQA5ugdnLYVMnpiVw9f6NMXl1b9NWshn+wjOgFImLvEF77jhDpvy8J4Dcog3xKkT8/jqR/204dBhTvRq+c3bO80KHphX0mAvlHLTkmo9VEx09lb0MYgspUmR7xULUvlbWVWnFOVHx5LQnqMSkODERn2piGtUUFkEWhzFfZWJJD43SxRJ8Ei6h8kLfkKGC6KMRbHZA3lmDJaBXSWi0Vxc0QM+0GU3fdw+rpzDNuvg2d268y5PFtmji7Tuqrd+nR+BoQJBvoCAzcVgF8/DrGlZd52hgdsD01VF2g0ZoFxupsKVMXhUpdHJUbmFOyEvWc4ncFJlIfIiF+UtiHz6IQ2wnyrBVUuWHYQC+jBngVb0uDjMT3syvRKvdzAO6mHuXKeR9a9AZKsVil6Pfj0R2ikN+GS6n136ehXx8U4z871Yu/OiuJXzay8vMF3N2Z5kc+Fbo6UuHjQEc8iUq5eUwU2rGZZOXqmARANJE772UrZm8Pkzpr2N3sC8nRnqln6E6zzx32VNnXl9j8QNGkoSQ0RwZKT5wcssgeFEZklhxCaaBrxAr96lFqEPPmHCoebfLpbFPKBZs9rtBFKKaVdQZ2dXFTt+9eu503dz3jcjxMr6xW6b3eEO7VRv2SbZUvuAZwAZmBaUH8N1a28FftvPfZMPucndHPbU1bP2ONw8uiFWEhN5IrNo76iB35b7iNWpkaQYg0Vl+IlDEnmP4lJ/WXqF6yeXl1wdvMiWJl7i01e98WvPMFRhw7SO2uggceEiX0bbgwvIjA1W62wjRZmHcVuEhigFfKJVSZSNoVPhtI2xGAnfgH2nX0D/x7iMffQgj7ChCErwGR+wbg02NghFaR7wxQthRMy8MVCWERXm3khWEd1GokZjZVuj4e1jp4R2/BY72ZdWnTY0nCDjZHtrnjbJjrRyBcDogyEmS7jUC1fRMc828STfbrjAKdZy1oVGxXKmXh6JGQKSFqokRK4TTN+DZ5cJ2JFNby/txXX/kSvygrib+xTOgXc5v43cDWvhy0lPUV2TkwcitPO38eYMGTwLC2jEmOG2/1G5kWwxUtDAEvGnFSa2/Q1vVzrnd/IPPyuvxSOmhOQ4d9/uigX0NCQw4Uh0RS6bNZpsdk4S5TxLs4w7QKiFgXcKQuhqRGcVczOZ9oVLOY2c0JzXZS7NRC9T6B3nQd9x+Grcbfz8zJp+Pqy6sldTNZZM67I/KqPbRX0qTsSIP4UHHXaqryVx0G+nmHC61fV3ZSP1XX5NZsvaOPd27FXpBMzf1lqOMZWb3QT3UDPH1RJXoxirOruNRSWM2Z8zWpg1nmjKwvZmJPnWv9TH3h+noT/Wh4wSnnA8F5kOTg+zyde5fAtItDnF1mce4CwlJaDkKrGeBISCRRIB8T98UYfGCG8fx10GHuow/EG0DNfgfiG+8AbvNjMbv+faYeuMzfQjPsD0JDIUVaRnOiqIpCVekqslqT1T4qWkuK7PQ0fcRz5jBnW51Yz7EfF13WV61XtqFOxkuNQmxHC7n3eow+b0bBXjc4MK/jVfQ2oZSWyQbWy1JZLSMUHo2SsNOKQUsrlBvKvv/Ap57gN6XPs0Lm1zCT+gxjQ3/bIMJ/N6skPp9liy/4QupFG5a3DOx6dyDeeIftcXjeO0sbRjuL80raYrnciYlXbsQANy/tqo3IupkPeRW2HpEtKacN4Vx9CPs6qnTUhWmsRYNVlzsQXCHHu7Uo3wF3GaeUaFlpwFDRVK1aWXeFetSU5fRMcSojw4Ica2m/6nTE/zqsZ/9luqD/99mU+B+3PP7tLdZ7d507uzuFJ+MlpdQWVE+a7ztK56BXM/8D0UTXVTublo34/51tbpHm280683rHpe8OZeLMUxfn/nGjHhMNN/YNUSt/2DP5xmO2elMoN1SZatqG3DZdvLsQ5RnKdMZgcdkP7Dw0stpLo3l5ZndOdDe4kozgrCAIS0CozoticJYi4s2jMizGgadgLhIgsx4J0b066B4Z3EXAVr8Lr+Afsrmf/yFO/PLbKPO77yNE5FN4mf0m8032Gvum1FdjeYmztL44UlydAmsapMjVyZli3vf5bj3aHtrZ1rQCWsNfwA3de9vlvpr3QX9vmoatZqI/q+dMvVHIiWo6XlXD8ukgwrqriMUt42K2lWCRXtzQH93mlP7rfLbaTm6pqi/gFrbW+tnPUx3PryoV7y8hcv1vTPT5L9rZ7V8fo5Ev1Wzgab+AbbTl6e5Naxqc1E6TjniW5clFFs0rqSHBFsdSuTJU05TDeDgbfCqNwjG9TBQUxsjKI9tfu5ASHZ4NdNKcvxEr5zSXL1kEhJhMWTPEfMcggKEezk75QHWIGdqQaKE91slfS43EG+WCfNvsQX/pMNB/6yzk/zmZcv/vyVj5T9dz7d2Dyr55G1Wub/2MtbL46hmCKqsjYjj6ecPVfz2p4WtTO/+iMw3uo4vdovZhw1bfbzeq3+5byEfPmLkPd9GTBFSdRPojPXWuouCHCsj9vR1v1rhcq1ul+yRF9caoNE0BVm8fP7Ec+q5Zwz+2avDbbls8HXn5oROtCQY7JnSpWzI2GxvMnvrLckx7ntuxt0MeqbLP1eW9njTzNcX7EFn5x0Am/Q+HxYOfdgToh50x9ZNX4r/zrdwPsR/lN/DHXFtg4aZQ42tVlW3IDcHQXUawGxbv4Aba6FJGu83oA6w66ZVrvfYLY67+Rpuh29gip5B6XrSNQlWWigWYzSh9JQtp/WQOmUQwahy0i/Ook79OusajH0Eo+qaQT56m/UkhGIWpg2dQ4OmT6MYvSejxL4rMb/+au3z6s8XrF3/X6e/9zqj5H7/s5DdXYtOzagwjbWiVNJIXaah4nqiCamIFQcAcyaJNOUsqoodi5DXy7XFUk3oJjZ+HtebZkbU6y3b4abrj7+zXSq5Hq9aPdLIKqWjVlGWypyBQTyKQuRDJjAi8tsIM7Zgw7FPqxPiDPGv9ZPXcf3Sb/J+7I+P/mZw6/9/ppPq/brv5T6/rxct3nnjvJoSbKwlWTgisuYTk1uyJpDd+q2v8Y3UC/lv29VHKutvPC6dbpvr1jgD8uNPJ/OjpAN8GVsQ3SZ06T1dHw0x7jBX/ZZ4X35O5RtNfbNs+pod4q+12RRqA0LjjsV7W7JO7uoYdNweZN11367tRYmvULhN0E69ydVoD7S+5NW5f/utKpvoL4KvsejiGAh6Yk/e7yuJIYt8eFeH/eniA/GVNn/yPDfPuX7bnH3/ydhY/BLv9P8bPtbvij+KQNWFbMGpNydBbck2XtOOG0bTqRCs7YO3+pdIajZpDTp8MIfGk+ww+1f89Nq7sCYvsQHdLOEYUYZrIOlgFQIpMPpxwYyCxCGWwudcSj/335rv0HH70NoMcXSTz1DSSZVtHERre/WU497v9ZOBvFG3tbwenL36tff/kt+r3a783Xu197p6Fnk76yOargeNXiGnAyA9DztEoDm+3w3JWiJ7DZP5ltoxZGYQ0oDw9aAelq2naNgdHDW2VdpyzRHfUjY3RVnrobQeahb63RnRTBknzWkFWJVpri0TulC+sLynJs6ARbkQ03CGtNk/Z28k7Y+b82JS7/+gOp3/qLyv/adED/9eZQv9w3sdf38mF1X1h7/jSF+vPNbl7rIKTFQB2Zy/wuvurrCP8UpuX/o4/Dx1hd/tQ9XS7zH9cp/A/r42g97tz+NXRKXOauGjMAeVCLw1eFpHrVVoYmEW1voOa1hFpNwHdaUaaHSvY6IPpWTvMnluEem+KwNJ0s+cNK2a7bBJzqHC2CScP7DVpg9+1foZsKL/O7Om+QF5JeUiVPKy7Cx9R/uABob/sscKPuyP9z76O82NIv/oUse/fJJTuXfJ4fFt823aoY1ypqjVVNgRLbXG12sIg2l2iOqBks290taGxNMd4wx7G9HZrDVkpv6AGFT/Ry2uFRoEluALAa2lVMrMF3EzAcD8CMNeBCvLa1zm5DvX7d4kG8mgU6oyWcYA9CWeIju8Lmnv+2xr2GVZL/+3KDv7ujXawoXUOt9DFF+vcSWS9egFtTB/4fWeu+XBc8eAl40AP2h4raBzVcTk4RajkHUhAXT+F3hyB4nKLMk4Piq3ul8mBsZUfCUFi1E/nFngwOwt4S91cIt0MZXFdwgW9BLblcKJLHwVPYFx/CV1OryiNOmdsZcy32iv5ePjBXplvuxb93QDCvuvM1B8nS/q7UzH66dTav70s/OrliorcL2no7Licvpuq0vkcbS4mv2qeWEf9C+k/4leln1Vf+dMntwcFebadsx5eVGb/9HR69XHrcnbje78apr+f2bhFilTNBNhWA5MiJE31G7wwN6u6qFqGXbKtLuC4atFuZdCxHQbOFYYbyjWuoTVIvIajBUOohI1mec0+8D+R1ug1dNt4mtu2/KHiJOdTXheOgNv2Ad5/vcf1HvbU/tv9pfUheKe/zlruTaFye5Y1f5gWhh9H5cGpSbw9FlSakmR1bqjTe67eNHH3mOeGFqFOevXaEmHUOciq481Ku7lDWPLf+GrlzXgt2a42cnLFKEDZRoaGhun0v6rq7VU41bn0Ld+/jOknHxNIex6tdB5NkvisH8/2p8F8e+TdVUfrv7WUXxP95N9NezuPf+j4dluUx0NWw4fSJHtYv8WOzDdoMNuUPSWhsZuqaOta2d48xSVPjcKPBiwUHfFUupOgi4uNMnLxosD1HiPy7DeQ1f8l5JovuE49BPfh/UQns402gAxpFjOCSlbaciLbYT2oC6v0S8SyH3Dt5JZ0nQ/s2LpWhrW7mlP70Oxwnzoa+r4nCH/utdWvxzr+0xQpvBpVDl/1m3ufxmb29axMXI9s9X7WUWYrRGounmhj97NWS/i1PgP37NPkV4urQ+TkfI95eLXL/+P3u+4/vfbc/2kcf33TLY1P6ui0KbFOjRRZAxaRDsC1hkh1PGLNfK0mW2RT75R1u8G5ToScGqB0rTDKWNZanGLaMR0F9lUu/Uwh449lNPZU9OWf4nv958VodzMpDqNJsS+mPDPDj31Y+oSbpY86nXqn/WX4Q20OnKt93BjVSfHMpdQbhe6cy2K9hckLibS7FuES02JTriXccQUfLHL0QkEqxxhdmqdofLCXsOt/7aGp3+5K+ZJHS8mQmSbJdorQzhJN4ySD1gcpZjJO6neztHM+zeOzkyzaWqTJ6aNeEVqcZpN3q1hweunzNmdbLyzjc3zp+f1odPD0YvHlzrjv8bZMMNgalmLdZSmdvKajvrHsibedraQyeWYPO+sXw/ZhXeWPhmY5wjFkhIvTkSkCZOZrKOh+gVaGT2nqMsgo00PRkgOoDZRwgycJAwBAmQxT1VJ4yoHBKRUE2uUe8QY/0d+JsPo1a3e/F0fWG21gvKwr1NeNmvSj6zL/1NPI/zxQ2D8NGfCnQTj6nQMlXtmnzFV3mL2d8IXFxEIv5o7RO6EEY7ktaL3/sFCkx+c1OPNyWHxxNQ9Xv7+JOH/6Y1L449dJ67+9z/R/6ANXdx1Cc0Sqfy0L9QUqmy6oknZJabdws9ZybB8lVOU6Jx/XJduUWo2c0zXgzko1hyND6MhGHolUS+U1nsZ+xxGVpwwHP2VUeJfdpbfhxGCrIExjBd2tAlDTyuXvmwniZSdeVKshV9VjD0269I2hcR1WqmqiooiCrAh6RWFqBeW6X2qet/4V92ZaxVa27qqZ1jWGTWsHyAJLgLPNoOB+5dflf/d3DPjFCySip/iYjVVTGj3NkOx1qiueFhRiVKwLU0jkJ5ChnMEFdgoI9hlADR6NEJ6YIvvycW67fhHa73V3ozfVNfBt7qvjd3tb84dtT/0Hn3/5DkqML6j87KNSPjhtZnYeeoH9b+o75HfdLXs83O24Ha/bsQO23Y4khbqvqfJB1MceDRJ8pBvgUvdht7wMd6lV3qj2eNkgRFKrqKgcKUMMifNUETNQAWyj2eQCPJNPyCWzlCTtpFpdnciD0zPTNAe2bd43FeXOqdN/7NTK3/dx7PtuKfwnJ5Z5ZxrAmeWAl83J/rJveIbDBTo/1un2CYm1llBJnv38SLdejBp87LyHRy/HoPoPF2Xr4wPSuf1IkteXhHx/TNqrNnO8qin2gtZ5G9UVCTD5Stbo0EQDxvQaIOpatSnqvbli91uNFtBuNfB+25abaj0qUWqmFhQq0+cssfyCxvubJGcfEI3qJgMWDois5oErgxSoXkLl5jGLFsQ6tNmSE8VbMTyei6kbES6/FGl20GRkdYgrei2uVQWfbuh7tTNzrzMiY2O4EupHhGBTUrOOWcq0Rt7cEPxrtrv+fxHG//nvRfjXITYWgcWjoaxE3Fo3aRizNFdfpG35OGfFb4v12BTSkk5ZRCYwVZpBdmqEiIlHdbgGDtBwdAp4K6N4rqmF8j3WC12l92efQoHb03RGstOZjs4Ct65OmOqSjjeuEf/lm7znbBE9uO8eVnunnn5rHDTdk4ggLyN5cnAUL3f3BLyz1wxZnmHBCd0Ty9wdsEI/oGfVwZFjsJuqEd6hxCSDU0SdJ1IDroyeGiVdmZbnuQF5G+rK05JiKYRms5RqG4VJw/APHfrwqilv3zoN/5tO1PsHG4fe1zLZa6WWvNLRw1Nlnpzb5/Fm/2xXWlR/Xz2G9xozf9rt4qTV8ogNIz6yRf5uKeK9G15o3vKt9p3MkVcyaU0k+01fmf3YscmXsoUomIGVU5omxvUGA1ss5FoMrtZaA6xp0BV3IHD9ss52wDHjYEu4kWsBBnW9pxHfPFWBH74UC/9znUHe+0j8YxCvXWUoqo2QspKheDFIgQ6KsicKmrmtg+E7KsN+4NM3L3PlPy4T4kpJm7gW1ll1V69Zu7VaZ9/udvytDuDrc3vRfnoz6eZ2QhbizRro45ya/o+UsP0LDDkMqrmdlByGbNu/cO14g2ml7doyj9SGmYJ9Fa8Nb5OOPM51Y1aJ3qsD5Y2TvJl1gS76qF5i0CYAQascUltkoF4vwZ0wcf4lHjdfllLd00Ke1XO5WV8uH7cmVKu15NnhW87TukEi0/vir+dnAeH4PtCb38TozmUUc05DCf7Sky2e76RL1y+m4OXuWeoqsIq/S75DL+BJZknaB2NWOGJYMwcIOBBiq4MUB9dI+kCqQUVcK7TjFvRtWhXOg6ypZXirxJg6gbRVOT7Q0L2x3Ehe6Xb+mxpZfmWC5UslEbrhmNgJK0e73LTMqT1cttohyuluST3VY/QBmGpzEtcGMaqJ1TU72xppUG1VVUYDheh0q012rC0WF43JH656tYeT4dbIsaP9mqKKZU3SUb3a5AyZqZpThnJQtlJvuKC7aJdGSi8/xua7w/Qk1JLmmbbVjPXYWapbfRXqrV3GTfwO0HOrtIRcQHxBjVOCmqIaTpar2gSv3vFi9kajs28UFD2D4NlFlDp2D6qnitfC8odmFdystbHdZk09apXI3ToV37PJtTUrt72mQtGQFPRGyWQ4Dpd2syU0BRXC6WqCiPdiKD4PW8o4NiWWuTrSLWLIaR5nlllUWKZKshvTZDeBlcYxmxgm//VKuIk80op4t5mr2ZOioB0XOWlUNDirJKgCyC3TJfyiULRXEDiaGNjxscsP1Z6KlS+qcfAbJia/RH7bO01wf/8qYf35bRo7vUgmG/PQDnu7m9PebGSKf/yqxX23tkLeHbwL38cuCq+KZv4cdHG30nQwvK4c0svqmowAB2JOzNEvWLbkda1k36zlH4gO/hCuyuPPqrXMZ7KS2hlySPSM1uQu25Xm1Tb/VidK16pfOmcz6jVO567QdkSgV/6SzEWxqpIglClatY7DTIfdlDswATs6JbcoQ3Uj/aEprBYmd9Uzo69s6eEfh41vljeztvNmBVtXizVn1XoxkVV7WTXMsWiBOKvLpmbMhrxjOvlW0y32VsfQot4IrpDVk0VuuT2Ge5H+cAzNmjKwZMjS8XY90y0MMadkF6wdFhQLYpipnSS52iQpntTJmkKxFkSKul81eXyOsvooy3fsI7lWfa7RlT3VxHb0VXnf4R77He+v97TEzlOBi3zGk4XfcdnwAZHY8JW9O8GMBPgzGJBI+XNKwBbHkap4HeXs+8jw5DhdF0d5Th3kaPc4SyFWplSdxsv9y4gwOIkMjscpzTUybvNRtVwymoAyn5do+wSg9G7R6dWg8YrClRFBwhclVH2F4vP7Bq/Oh6JityVEOOMx5T2L6BcUwN6jfP8Kza9OoMh8mN2TekE/sdzfRi+ekfbdV+b85fP65G79x5Or4Ll4le6jd8CV2sBlgiEtMcrYJS+vFw/F1LMEHfYT8BYgpFXCyo7COmj/DQ5PfoOS3P8hkOhnA6wfGLEKOONcdFSt5m6qtn+hhT3H3Bo2K8NkF2gUhfKlCTBiM8/0apCkabTslCT9/BBrITtMs1cjuyZv9wtyt6WvVh31YtzDX/U79Y+T/tXru2Wjc3aG2ycnHup0tF0ZNdSG3UxrVVOa8Gb7utrouUrH7NP9xbw0d5al1fIucQM3ti5DvHeBN9KzageYyz1o4ZjF0yAYmYSnpXb4BLAOzmGx8S2gVFspldHiijvIGXIfqzE10kQMQoMHWJVaHEm1dlih2Q2ZZdarqrCpVGIJiYwGhSIZo2HJQ5jwIVXc2UM9G1uFTCyQQsvpuIhlEzCOR2BICNo5K9LIjRPdwkkOOxpkXHJQMMvzUghcpPShm6n22llYn6WM5kXGXAzySr9T6A0fWYhS6qEV9QpGzRlo1nV46ipkuypxbh6r0igsySW62qjIWiXXlIloT6JyE5EMjvl8/JTUC3dMDZxx6YRLfOF3ss/yjt+Ld3fS3GzNqs02NXO43a1dHc4Hy9C4s0yeu6vSFBlidUgmyVgWt7whOvHFQQU/jJfL3nLJH5GShbIeKYNmsBOiYtLnWLzzN2xmsGUB15khaUJTWqWaLAp1KCOtMtyhxWz8TgZTRTJ3wxWR+3pKYLAM75JJuZTHBKIkcSuK1e4UplWzhG695wxqem9s2VfzxvHlkp+sltrri5P64uJCvTu5TPW7q21+3C/YK5ez+y5NKo6jKx2qorbHujNyDX2+amAXk3bsvupmX8bN7CVAASdsvXQiN1OneD+8wq6Si9p9dJXSI9MYEejmhbSTUPImXovpdSdYc1xfE18hdaobt6qdqE0pGaukhbSKHpdpe6sqjjarGdbDwkqccliUQ5MgEwvlkGwgW8odFnP5UDKBpxIxisGjosBGC0o1UBSrHltW/S7YCMtJLdKL91NmapzVU9O8njsrKsQYQKBpntJWuUHnEhSbXUgbN2DNeLQAJ/oUx2pThFx0Ko1JDWuMRYqWBXJCwQJSTnBGpiSoR7SYz1GMkDSY4lqH4B8f45V/10as7QHO7wzx4ItOae9ITRwApC9CSzsVitm0UGNHx5t7K9IJjJlhfNBb5UxhWRjGejB3iJXB9SiAr/sL2M9COeqXxQz5GzxdfCHFcrAQiMDKPikZu2hA375LtAKvgHHmDd5D25kqxYA6mS8LCAFScHqNLtIbYB5LFbJ/4OJEHwpyApjkqgDAl/1lWqYg5raG6G9NpNszuDHP6yOnPpwvOrfnhrO66i5P79Hh1c344uUD2FnebzS6q5Dpjgp6r5vHnKaZV1tMmHUbFbs7EZ3pQHVWF4R1O0KlN1SeedhD0HNRwC74ZvbCXmWuzbPYHXO2c5sYek4PK55xnjnqgnDIzWMem9GSVrPubR4vcoPcMtoi73NO5SpXZ05ydZDyG2Qtoev1XTOh+6slOcUVYJQkFYkoJcVKOAIX4mEgWfbB0Uq0EqqH4BjnF6NKwYpn0VawJJo+olP3aGbTK8G2b0gqYbM8jlnsKtnjZnmWnOVq4VlRR2alzuQCsQZLHDXPkaL16PvyfHBLWvUpizYWVN0csjjapMsIR7TZJFsIvsBpPIR1GYhJxSg0zTFgotTM5p93471f1rL2v+8XiafTfHGtnUp/ZUTiHtAb9ma2S4fAmp3mtkyqtXPWN/3vWmZWhOu5Auom6gU3gyb5ZCkZioZCa17GE/AIzyIedRf0daJEKJfnfaDgHOxq7nO2v3j+kTn1fIKXqVNAA8deCOO+rKC5wzy0lwCTOTQUaRUKyUYkmb1LHiF9T4jiAkGyfESgTrhEdTwB/tabqD2EhL7tYUb1I2XWhyYnE/3mZqTeP9j46bsqcf9ed998zLUmD8/q/dPgrD7xKfVWRMBr7LBSc4poYxK1u8eh5qyWaR6f5gZXTnl0Lxvtl2GbuXA61E2LgF41+om3Zs33HlQCD78p7SzDlncUHR22Ku52kxa2G5IWaCwXYP9kFDvGGP8MGfnHwCTe32lGLWHst5juUU0C961INCkHCwDNCgx1ZFnl3KBWCLloPCRLfrLN+SBMOjBh09vEnECjNIwgqXFQgo9DQGLgAzHzQJdMj8srge5MidraMOna7WxcnsUW953cy+sZ5nZXFDN6QxLzj3jWefSS6Lw8ZS1nIEBokyXpDo1iEkFVcngFjiKqFUD5XhalnSIiVQnU67CF33It/xHa2rE4d/8s3Q4xLxrB9Avbgz8XDhI7+GYwBXzJkZEvF9XIxsUw5T1+gCPdDpCSBTIdI7SwhnBRNISGMnth72HocBPA156b3NF6B0J2ZvmaT4h0fNhR0xNPDLdiqfmze2y8/zZwGW0+7ySNJ1im/hlSwH8RzCXXffHo3jO/WvYE2tlwbBEL5SahA4jxJEDMBwN6Ig52Iyn0IVKQbkOlenMHdE8y2uheHJyN0dtbK3P3yi6/ejOhzr7WK8tvk8jova/Wvv28WZ8edJQWaSTdbTGsqrOSNhzQ9ZuBNrAS1vgmMDy/QOavdLL/kK4at5WhcvV6bryvktQHBSh/9PpD90fx9CmQSh9705F+rB5sSr0DZzw67E/08EwVMos2lzzFzeAqxiTGQc3XohpR99CIahWkJBe2ynyZxWlj5bLp2xYeH/agLa2RBAZWJNCeeoon891Gp3OoEQuvFln6xL2bI8Q79QjptofKNg9V0vS8NLQEl5XiLUbIGKyZr4+6wOS+jwxXA7o3OBdF5kHMKecM2H20lLGTqQTVTQ4TDBrBdRIu0CgpRxGrlcSdWpgmiRwFoCTaJAXyyzyb/3lZ98Y5cwcBmptmor7DbA22U1ud57xfe05s6k8hAPxC7x599WG8v//9ybNktbGTEtVAiuHTyRCDBiGK9uXz4B58FN6GAhvrCL/3nBkePGt0C+vtcmeHfDzfEvw328nY1XOYW37ZYe7Wlun3e7XN5SH/t/yh/euyz/o8HSjsvPDw8FMPC3zhsdnNo6m0F+ukD9JcJJ0Wg0BaSeYz3WgJeBVNkotEUToNFq1v/1UkJxon9frdeXd0f9uV7h962M0HA5x/TTPTTyGp+epZpbp6LlS65d6mCww36sJgqz44S7ZxB3YVimn9xLZO7kr3L1344g2Lnbyh+PvXlnL2Fvc7D/A6+zKyXr4I5eF5CQFGPJ0d5Qq+rqqnewaVGnZT2ZnsKy9mSOU8V8oui9X8NNn29yrNSPuxyMibjEgMFIIbKKTsNtrGvjPgttstONqr5TOdYbJovo8EWx895cbL/RL8YYsqXWyq5fvtqnCzIzGnO7Wyud+JV4+cPTHkhqh4q4Ckz3gWWooY2ZQsrilNJbI6E2rguEqxK9HsPprZkdpAiTkGV4IrZDYDV2pADtPUCCEPEYqnaBJPEHgZoyuiICHrPjnzOSR7d8j6er4gPEXC1Sdspv8EwtzfV8zRb/qV6heDEv683oxvfD/fDF43fpGlud+nKflpinAOEoEm5I9OM3u+cvI5AvqftkPh9UbVt407kc3CIPssQUuP21vdr7Sjt8/E1IdnUP77Jzz37ZNa5YenleLLJzLU/bLl41+MofSOlf9in6p/tmfbvzts8Qd+yfD660Y6TMNgyIinIwKViXTZYuoNmoOHMEp+LWb1n+TK8COlnQ/52R1XvbsznbuXTfPuTbf68pPIX3zaAsd3B6K0isDhMaKvD4r2Z+26/Ju+xGz2Y2bc0Zqp1jutOX9N39x0kD++Vv3//MBH/8tDLPaXm2zlzRkcOVtxG81lZkecoEJ5CNLJrkZm+4SQ6iIK0NIxuTMvCtNBkl5xQG7FMtAyQmZGKb3Q/g2vVg+VNjnsKcIxqeptsGp7WKe6Z2tE2HTA0P8fVQCq/42rZ3WKuWRYgL5aVX+1T2p0xkp9achJlYC7T36Is093gKlMfXSPTIZgj02cWndUoHtwXKeBdGapdXBxpXNvepBwdH6Qe4WCZW2YfJmQloKTj6eHmZ8KQgEgYQBKLgAAAABJRU5ErkJggg==", pu = /* @__PURE__ */ new WeakMap(), mu = /* @__PURE__ */ new WeakMap();
function hu(e) {
	return {
		base: e.dataset.cardBase,
		holoMask: e.dataset.holoMask,
		goldMask: e.dataset.goldMask,
		foilPattern: null,
		holoShardIdDerived: du,
		holoFacetNormal: e.dataset.holoFacetNormal || null,
		materialNoise: fu
	};
}
async function gu(e) {
	if (!(pu.has(e) || e.dataset.sacredCardMounting === "true")) {
		e.dataset.sacredCardMounting = "true";
		try {
			let t = await uu(e, {
				assets: hu(e),
				locked: !0,
				lightweight: !0
			});
			e.isConnected ? pu.set(e, t) : t?.();
		} finally {
			delete e.dataset.sacredCardMounting;
		}
	}
}
function _u(e) {
	if (pu.has(e) || mu.has(e)) return;
	if (!("IntersectionObserver" in window)) {
		gu(e);
		return;
	}
	let t = new IntersectionObserver(([n]) => {
		n.isIntersecting && (t.disconnect(), mu.delete(e), gu(e));
	}, {
		rootMargin: "500px 0px",
		threshold: .01
	});
	mu.set(e, t), t.observe(e);
}
function vu(e) {
	e instanceof Element && e.matches("[data-sacred-card]") && _u(e), e.querySelectorAll?.("[data-sacred-card]").forEach(_u);
}
function yu(e) {
	let t = [];
	e instanceof Element && e.matches("[data-sacred-card]") && t.push(e), e.querySelectorAll?.("[data-sacred-card]").forEach((e) => t.push(e)), t.forEach((e) => {
		mu.get(e)?.disconnect(), mu.delete(e), pu.get(e)?.(), pu.delete(e);
	});
}
function bu() {
	vu(document), document.addEventListener("shopify:section:load", (e) => vu(e.target)), document.addEventListener("shopify:section:unload", (e) => yu(e.target));
}
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", bu, { once: !0 }) : bu();
//#endregion
